import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { replaceLocHost, ACCOUNT, DOCS, DRIVE, TWPS, DC, PLUSSVR, PLUS, WEBOFFICE, KDOCS, STORE, WOA, FILECOLLECT, SECURITYDOC, PUB, YUNAPI, RILI, MSGCENTER, VIPAPI, WXBMC, PAYCONFIGAPI, PAYAPI, VAS, GEOACCOUNT, getOrigin, WPSPLUS, APIWPS } from '@kso/constants';
import axios, { Cancel } from '@kso/axios';
import Message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import csrftoken from '@kso/axios/interceptors/csrftoken';
import proxy2K3rd from '@kso/axios/interceptors/proxy2K3rd';
import exception from '@kso/axios/interceptors/exception';
import login from '@kso/axios/interceptors/login';
import get from 'lodash/get';
import { globalData } from '@kso/ui/lib/utils/globalData';
import { isServerRendering, getClientType, getUA, csrfToken as csrfToken$1, webPlatform } from '@kso/util';
import { PlugCtr } from '@ecis/plugctr';
import settle from 'axios/lib/core/settle';
import { mergeUrlQuery } from '@kso/ui/lib/utils/sideEffect';
import chunk from 'lodash/chunk';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { t } from '@kso/ui/lib/config/locale';
import { AsyncExportException } from '@kso/ui/lib/utils/error';
import _typeof from '@babel/runtime/helpers/typeof';
import Vue from 'vue';
import network from '@wps/wps_client_api/network';
import account$1 from '@wps/wps_client_api/account';
import cookie from 'cookie';
import { powerConfig } from '@kso/vue-shield-config';

// 不需要kso/axios默认错误toast提示的正则列表
var slientList = [/api\/report/, /contacts\/recommend/, /v5\/companies/, /v3\/groups\/\d+\/role_members/, /v3\/search\/company\/\d+\/members/, /v3\/search\/groups\/\d+\/members/, /company\/\d+\/detail/, /api\/\d+\/department\/curlevel/, /api\/\d+\/dept\/users/, /app\/job\/v1\/syncuser\/companies/, /api\/contact\/relation/, /api\/v5\/corpgroups\/corpindex/, /api\/user\/userinfo/, /api\/v3\/links\/\d+\?include=members/];

/* ECIS start */
var plugctr = new PlugCtr('kso');
/* ECIS end */

var account = {
  account: {
    '/api/certification': {
      methods: {
        get: function get() {
          return {
            certification: 1,
            need_verify: true,
            phone: '***',
            result: 'ok'
          };
        }
      }
    }
  }
};

var drive = {
  drive: {
    '/api/v3/groups/secret': {
      methods: {
        'get': function get() {
          return {};
        }
      }
    },
    '/api/v5/corpgroups/corpindex': {
      methods: {
        'get': function get() {
          return {
            id: 0
          };
        }
      }
    },
    '/api/v3/groups/0/members': {
      methods: {
        'get': function get() {
          return {};
        }
      }
    },
    '/api/v3/groups/special': {
      methods: {
        'get': function get() {
          return {
            corpid: 0,
            creator: {},
            ctime: 0,
            default_type: 'None',
            event_alert: 1,
            group_type: 'special',
            id: 0,
            member_count: 1,
            member_count_limit: 1,
            mtime: 0,
            name: '我的云文档',
            secure: false,
            type: 'special',
            user_role: 'creator'
          };
        }
      },
      version: ['oem']
    },
    '/api/v5/groups/special/files': {
      methods: {
        'get': function get() {
          return {
            next_filter: 'file',
            next_offset: 10,
            result: 'ok',
            files: []
          };
        }
      }
    }
  }
};

function kdocsResponse(data) {
  return {
    code: 0,
    data: data || {}
  };
}
var kdocs = {
  kdocs: {
    '/kd/api/user/config': {
      methods: {
        get: function get(params) {
          var _ref = params || {},
            key = _ref.key;
          var maps = {
            companyHelperGuide: {
              status: 1
            },
            corpIndexMemberGuide: {
              status: 0
            },
            teamMemberReadOnlyGuide: {
              status: 0
            },
            shareGuide: {
              status: 1
            },
            spaceFull: {
              value: ''
            },
            jinxiaomenghello: {
              status: 1
            }
          };
          return kdocsResponse(key ? maps[key] : {
            status: 0
          });
        },
        post: function post() {
          return kdocsResponse({
            result: 'ok'
          });
        }
      }
    },
    '/kdg/api/v1/cards/type/\\d+': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': null
          };
        }
      }
    },
    '/kdg/api/v1/user/setting': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'isShowedPcTeamGuide': false,
              'isShowedKnowledgeTreeSortGuide': false,
              'isShowedKnowledgeTreeGuide': false,
              'isShowedKnowledgeHistoryDataGuide': false,
              'isShowedTextSwitchGuide': true,
              'isShowedTextEntryClick': true,
              'isShowedTextOpenClick': true,
              'isEnabledFp': false,
              'isEnabledDBSheet': false,
              'isSaveOnTable': false,
              'isSaveOnPWA': true,
              'isEnabledPersonalTeam': true,
              'isShowedFulltextCommentCloseTip': false,
              'isShowChangeFrameworkEntNoviceGuidance': true,
              'isSettingCommonAsLabel': false,
              'isCommonUnfold': true,
              'isLabelUnfold': true,
              'isSkippedBindingMobile': false
            }
          };
        },
        'put': function put() {
          return {
            'code': 0,
            'result': 'OK'
          };
        }
      }
    },
    '/kdteam/api/v1/team/\\d+': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'sources': ['yundoc']
            }
          };
        }
      }
    },
    '/api/kdocs/file/\\d+/application/editing': {
      methods: {
        'get': function get() {
          return {
            'allow_apply_edit': 1
          };
        }
      }
    },
    '/kd/api/wenjuan/user': {
      methods: {
        'get': function get() {
          return kdocsResponse({
            'questionnaire': null
          });
        }
      }
    },
    '/kdg/api/v1/cards/king-skin': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'kingSkinCard': {
                'data': '',
                'id': 'jinxiaomeng',
                'name': 'jinxiaomeng',
                'type': 20
              }
            }
          };
        }
      }
    },
    '/kdg/api/v1/file/creator/\\d+': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'creator': 238660632,
              'ctime': 1627436854,
              'username': '超级管理员1',
              'avatar': 'https://imagebucket.test.wpscdn.cn/238660632_143685c0f7d3c42d6ae5b23672f35d8b?imageMogr2/thumbnail/180x180!'
            }
          };
        }
      }
    },
    '/kdg/api/v1/configure': {
      methods: {
        'get': function get(params) {
          var idList = '';
          if (typeof params === 'string') {
            idList = params.split('=')[1];
          } else {
            idList = params.idList;
          }
          var maps = {
            forbidSider: {
              forbidSider: 1
            },
            messagecenterv2: {
              messagecenterv2: 0
            },
            inboxSwitch: {
              inboxSwitch: null
            },
            fullTextCommentConfig: {
              fullTextCommentConfig: '{"supports": "wps,otl","autoOnWhenCreated": "","autoOnWhenShared": "wps,otl"}'
            },
            skippedBindingMobile: {
              skippedBindingMobile: false
            }
          };
          return {
            'code': 0,
            'result': 'OK',
            'data': maps[idList]
          };
        }
      }
    },
    '/wx_adapter/v1/mp/subscribe/vip_zcgl': {
      methods: {
        'get': function get() {
          return {
            'data': {
              'subscribe_time': '1626838792'
            },
            'msg': 'subscribed',
            'result': 'ok'
          };
        }
      }
    },
    '/kdg/api/v1/params/baseOperation/sub_keys': {
      methods: {
        'get': function get(params) {
          var subKeys = '';
          if (typeof params === 'string') {
            subKeys = params.split('=')[1];
          } else {
            subKeys = params.subKeys;
          }
          var maps = {
            keyboard_move: {
              'keyboard_move': {
                'keyboard_move': 1
              }
            }
          };
          return {
            'code': 0,
            'result': 'OK',
            'data': maps[subKeys]
          };
        }
      }
    },
    '/kdg/api/v1/params/square/sub_keys': {
      methods: {
        'get': function get(params) {
          var subKeys = '';
          if (typeof params === 'string') {
            subKeys = params.split('=')[1];
          } else {
            subKeys = params.subKeys;
          }
          var maps = {
            wechatApplyEdit: {}
          };
          return {
            'code': 0,
            'result': 'OK',
            'data': maps[subKeys]
          };
        }
      }
    },
    '/kdg/api/v1/square/event/check': {
      methods: {
        'get': function get() {
          return {
            'code': 0,
            'result': 'OK',
            'data': {
              'isSquareDoc': false
            }
          };
        }
      }
    }
  }
};

var plus = {
  plus: {
    "/ops/opsd/api/v1/policy": {
      methods: {
        get: function get() {
          return {
            data: [],
            debug: {
              entity_model: null
            },
            policy_id: 0,
            policy_name: "",
            task_id: 0,
            total: 0
          };
        }
      }
    },
    "/app/groupext/v1/template/groups": {
      methods: {
        get: function get() {
          return {
            data: []
          };
        }
      }
    }
  }
};

var plussvr = {
  plussvr: {
    "/compose/api/v1/companies/\\d+/enterprise_info": {
      methods: {
        get: function get() {
          return {};
        }
      }
    },
    "/api/company": {
      methods: {
        get: function get() {
          return {
            companies: [],
            result: "ok"
          };
        }
      },
      version: ["oversea"]
    },
    "/api/user/userinfo": {
      methods: {
        get: function get() {
          return {
            userinfo: {},
            result: "ok"
          };
        }
      },
      version: ["oversea"]
    },
    '/sysadmin/strategy/v1/sys/me/guides/positions': {
      methods: {
        'get': function get() {
          return {
            data: []
          };
        }
      }
    }
  }
};

function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var unsupportApis = _objectSpread$b(_objectSpread$b(_objectSpread$b(_objectSpread$b(_objectSpread$b({}, account), drive), kdocs), plus), plussvr);

/**
 * 创建通用的请求工厂函数
 *
 */
axios.defaults.withCredentials = true;
var target$2 = typeof window === 'undefined' ? global : window;
var envr$2 = target$2 && target$2.__KD_CONFIG__ && target$2.__KD_CONFIG__.props && target$2.__KD_CONFIG__.props.release === 'oem';
var LOGIN_ACCESS_ID = process.env.KAE_LOGIN_ACCESSID;
function createInstance(options) {
  var tK3rd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var request = axios.create(options);
  if (!isServerRendering()) {
    if (!options.clear) {
      request.addInjector(csrftoken);
      tK3rd && request.addInjector(proxy2K3rd);
    }
    request.addInjector(exception, Message, {
      exclude: function exclude(error) {
        return slientList.some(function (regex) {
          return regex.test(get(error, 'response.request.responseURL', ''));
        });
      }
    });
    request.addInjector(login, function () {
      if (!globalData.unLoginRedirect) {
        return;
      }
      var url = "".concat(ACCOUNT, "?cb=").concat(encodeURIComponent(window.location.href));
      if (LOGIN_ACCESS_ID) {
        url = "".concat(ACCOUNT, "?accessid=").concat(LOGIN_ACCESS_ID, "&cb=").concat(encodeURIComponent(window.location.href));
      }
      window.location.replace(url);
    });
    request.interceptors.request.use(function (config) {
      // 如果存在自定义 path，则加入拦截器，根据当前域名以及自定义的 path 拼接请求的 baseURL
      if (window.$ksoui_customProxyPath) {
        var baseURL = config.baseURL;
        var baseHost = baseURL.match(/(\w+)\.wps\.cn/)[1];
        config.baseURL = replaceLocHost("".concat(window.$ksoui_customProxyPath, "/").concat(baseHost));
      }
      return config;
    });
    if (envr$2) {
      request.interceptors.request.use(requestMockIntercept);
    }
  }

  /* ECIS start */
  /* @Description: 定制统一接口拦截 */
  var ecisFlag = request.interceptors.request.handlers && request.interceptors.request.handlers.find(function (item) {
    return item.fulfilled && item.fulfilled.ecisInterceptor;
  });
  if (!ecisFlag) {
    var ecisReqFn = function ecisReqInterceptor(config) {
      return plugctr.ask('request', config, config);
    };
    ecisReqFn.ecisInterceptor = true;
    var ecisUse = request.interceptors.request.use;
    request.interceptors.request.use = function () {
      var _this = this;
      var ecisFn = null;
      if (request.interceptors.request && request.interceptors.request.handlers && request.interceptors.request.handlers.length > 0) {
        var ecisIdx = request.interceptors.request.handlers.findIndex(function (t) {
          return t.fulfilled && t.fulfilled.ecisInterceptor;
        });
        if (ecisIdx > -1) {
          ecisFn = request.interceptors.request.handlers.splice(ecisIdx, 1)[0];
        }
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var result = ecisUse.call.apply(ecisUse, [_this].concat(args));
      if (ecisFn && !(args && args[0] && args[0].ecisInterceptor)) {
        request.interceptors.request.handlers.push(ecisFn);
      }
      return result;
    };
    request.interceptors.request.use(ecisReqFn);
  }
  var ecisFlagRes = request.interceptors.response.handlers && request.interceptors.response.handlers.find(function (item) {
    return item.fulfilled && item.fulfilled.ecisInterceptor;
  });
  if (!ecisFlagRes) {
    var ecisResFn = function ecisResInterceptor(config) {
      return plugctr.ask('response', config, config);
    };
    ecisResFn.ecisInterceptor = true;
    request.interceptors.response.use(ecisResFn);
  }
  /* ECIS end */

  return request;
}
function requestMockIntercept(conf) {
  var release = window.__KD_ENCRYPTION_CONFIG__.release;
  if (release && !conf.$$mock) {
    var method = conf.method,
      params = conf.params,
      url = conf.url;
    var mockData = null;
    Object.keys(unsupportApis).forEach(function (appname) {
      var apis = Object.keys(unsupportApis[appname]);
      apis.forEach(function (api) {
        var _unsupportApis$appnam = unsupportApis[appname][api],
          methods = _unsupportApis$appnam.methods,
          version = _unsupportApis$appnam.version;
        if (version && ~version.indexOf(release) || version === undefined) {
          // 因为私有化会有gateway的path, 转换成正则
          Object.keys(methods).forEach(function (_method) {
            var getter = methods[_method];
            var reg = new RegExp(api.replace(new RegExp('/', 'g'), '\\/'));
            _method = _method.toLowerCase();
            if (method.toUpperCase() === _method.toUpperCase() && reg.test(url)) {
              var query = method === 'get' && params || conf.data || url.split('?')[1];
              mockData = getter(query);
            }
          });
        }
      });
    });
    if (mockData) {
      conf.adapter = function () {
        return new Promise(function (resolve, reject) {
          settle(resolve, reject, {
            status: 200,
            statusText: 'OK',
            data: mockData,
            config: conf,
            headers: {
              status: 200,
              statusText: 'OK'
            },
            request: {
              fromCache: true
            }
          });
        });
      };
      conf.xMocked = true;
    }
    conf.$$mock = true;
  }
  return conf;
}

function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var request$z = createInstance({
  baseURL: ACCOUNT,
  withCredentials: true,
  timeout: 30000
});

/**
 * @description 申请一次性授权自动登录URL
 * @param {String} cb
 */
var getAutoLoginUrl = function getAutoLoginUrl(_ref) {
  var cb = _ref.cb,
    sync_status = _ref.sync_status;
  return request$z.post('/p/session/redirect', {
    cb: cb,
    sync_status: sync_status
  }, {
    withCredentials: true
  });
};
var islogin = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$z.get('/api/v3/islogin');
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function islogin() {
    return _ref2.apply(this, arguments);
  };
}();
var authCheck = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$z.post('/p/auth/check');
        case 2:
          _yield$request$post = _context2.sent;
          data = _yield$request$post.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function authCheck() {
    return _ref3.apply(this, arguments);
  };
}();

// 获取联系人信息
var fetchMemberInfo = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var contactId, companyId, params, _yield$request$get2, info;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          contactId = _ref4.contactId, companyId = _ref4.companyId;
          params = {
            user_id: contactId
          };
          if (companyId) {
            params.company_id = companyId;
          }
          _context3.next = 5;
          return request$z.get('/api/contact/relation/info', {
            params: params
          });
        case 5:
          _yield$request$get2 = _context3.sent;
          info = _yield$request$get2.data.info;
          return _context3.abrupt("return", info);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function fetchMemberInfo(_x) {
    return _ref5.apply(this, arguments);
  };
}();

// 更新联系人信息
var updateMemberInfo = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref6) {
    var contactId, name, _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          contactId = _ref6.contactId, name = _ref6.name;
          _context4.next = 3;
          return request$z.post('/api/contact/relation/name/update', {
            user_id: contactId,
            name: name
          });
        case 3:
          _yield$request$post2 = _context4.sent;
          data = _yield$request$post2.data;
          return _context4.abrupt("return", data);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function updateMemberInfo(_x2) {
    return _ref7.apply(this, arguments);
  };
}();

// 删除联系人
var deleteMemberRelation = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(userId) {
    var _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$z["delete"]('/api/contact/relation', {
            data: {
              user_id: userId
            }
          });
        case 2:
          _yield$request$delete = _context5.sent;
          data = _yield$request$delete.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function deleteMemberRelation(_x3) {
    return _ref8.apply(this, arguments);
  };
}();

// 获取联系人列表
var fetchContacts = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$z.get('/api/contact/relation/list', _objectSpread$a({}, params));
        case 2:
          _yield$request$get3 = _context6.sent;
          data = _yield$request$get3.data;
          data.infos = data.infos || [];
          return _context6.abrupt("return", data);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function fetchContacts(_x4) {
    return _ref9.apply(this, arguments);
  };
}();

// 搜索联系人
var searchContacts = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return request$z.get('/api/contact/relation/search', _objectSpread$a({}, params));
        case 2:
          _yield$request$get4 = _context7.sent;
          data = _yield$request$get4.data;
          return _context7.abrupt("return", data);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function searchContacts(_x5) {
    return _ref10.apply(this, arguments);
  };
}();

// 搜索手机号联系人
var searchContactsByPhone = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
    var _yield$request$get5, data;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return request$z.get('/api/contact/user/search', _objectSpread$a({}, params));
        case 2:
          _yield$request$get5 = _context8.sent;
          data = _yield$request$get5.data;
          return _context8.abrupt("return", data);
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function searchContactsByPhone(_x6) {
    return _ref11.apply(this, arguments);
  };
}();

/**
 * @description 提交添加申请(邀请联系人)
 * @param {Number} type 必选，申请类型[0:添加联系人]
 * @param {Number} receiver_id 非必选，添加用户ID
 * @param {String} msg 非必选，邀请信息
 */
var fetchInviteContactLink = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
    var _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return request$z.post('/api/contact/apply/create', _objectSpread$a({}, params));
        case 2:
          _yield$request$post3 = _context9.sent;
          data = _yield$request$post3.data;
          return _context9.abrupt("return", data);
        case 5:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function fetchInviteContactLink(_x7) {
    return _ref12.apply(this, arguments);
  };
}();
var fetchUserBindStatus = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var _yield$request$get6, data;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return request$z.get('/p/bind/status');
        case 2:
          _yield$request$get6 = _context10.sent;
          data = _yield$request$get6.data;
          return _context10.abrupt("return", data);
        case 5:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function fetchUserBindStatus() {
    return _ref13.apply(this, arguments);
  };
}();

// 获取当前用户所有登录方式
var fetchUserBind = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var _yield$request$get7, data;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return request$z.get('/p/bind/status');
        case 2:
          _yield$request$get7 = _context11.sent;
          data = _yield$request$get7.data;
          return _context11.abrupt("return", data);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function fetchUserBind() {
    return _ref14.apply(this, arguments);
  };
}();

// 获取当前用户实名认证状态
var fetchUserCertification = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var _yield$request$get8, data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$z.get('/api/certification');
        case 2:
          _yield$request$get8 = _context12.sent;
          data = _yield$request$get8.data;
          return _context12.abrupt("return", data);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function fetchUserCertification() {
    return _ref15.apply(this, arguments);
  };
}();

// 获取获取最近联系人
var fetchRecentContacts = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
    var _yield$request$get9, infos;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return request$z.get('/api/contact/relation/last_list', params);
        case 2:
          _yield$request$get9 = _context13.sent;
          infos = _yield$request$get9.data.infos;
          return _context13.abrupt("return", infos);
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function fetchRecentContacts(_x8) {
    return _ref16.apply(this, arguments);
  };
}();

// 获取获取最近联系人
var fetchV2RecentContacts = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params, qs) {
    var search, _yield$request$get10, infos;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          search = mergeUrlQuery(qs);
          _context14.next = 3;
          return request$z.get("/api/contact/v2/relation/recent/list".concat(search), params);
        case 3:
          _yield$request$get10 = _context14.sent;
          infos = _yield$request$get10.data.infos;
          return _context14.abrupt("return", infos);
        case 6:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function fetchV2RecentContacts(_x9, _x10) {
    return _ref17.apply(this, arguments);
  };
}();

// 添加最近联系人
var addRecentContacts = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(params) {
    var _yield$request$post4, data;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return request$z.post('/api/contact/relation/last_add', params);
        case 2:
          _yield$request$post4 = _context15.sent;
          data = _yield$request$post4.data;
          return _context15.abrupt("return", data);
        case 5:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function addRecentContacts(_x11) {
    return _ref18.apply(this, arguments);
  };
}();

// 添加最近联系人
var addV2RecentContacts = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(params) {
    var _yield$request$post5, data;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return request$z.post('/api/contact/v2/relation/recent/contacts', params);
        case 2:
          _yield$request$post5 = _context16.sent;
          data = _yield$request$post5.data;
          return _context16.abrupt("return", data);
        case 5:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function addV2RecentContacts(_x12) {
    return _ref19.apply(this, arguments);
  };
}();

// 批量添加团队 / 临时群组至最近列表
var addV2RecentGroups = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(params) {
    var _yield$request$post6, data;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return request$z.post('/api/contact/v2/relation/recent/groups', params);
        case 2:
          _yield$request$post6 = _context17.sent;
          data = _yield$request$post6.data;
          return _context17.abrupt("return", data);
        case 5:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function addV2RecentGroups(_x13) {
    return _ref20.apply(this, arguments);
  };
}();

// 批量获取分组中的部分成员
var getContactGroupsMembersByIds = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
    var attrs,
      _yield$request$get11,
      data,
      _args18 = arguments;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          attrs = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {
            params: {
              sources: [],
              group_ids: [],
              count: 4
            }
          };
          attrs.params.sources = attrs.params.sources.join(',');
          attrs.params.group_ids = attrs.params.group_ids.join(',');
          _context18.next = 5;
          return request$z.get('/api/contact/group/users/bygroupids', attrs);
        case 5:
          _yield$request$get11 = _context18.sent;
          data = _yield$request$get11.data;
          return _context18.abrupt("return", data.data);
        case 8:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function getContactGroupsMembersByIds() {
    return _ref21.apply(this, arguments);
  };
}();

// 获取分组列表
var getContactGroups = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(params) {
    var _yield$request$get12, data;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return request$z.get('/api/contact/user/groups', params);
        case 2:
          _yield$request$get12 = _context19.sent;
          data = _yield$request$get12.data;
          return _context19.abrupt("return", data.data || []);
        case 5:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function getContactGroups(_x14) {
    return _ref22.apply(this, arguments);
  };
}();

// 获取分组列表，带上头像属性
var getContactGroupsWithAvatars = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    var _ref24,
      cancelToken,
      offset,
      count,
      source,
      groups,
      _groups$reduce,
      _groups$reduce2,
      sources,
      groupIds,
      avatars,
      _args20 = arguments;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _ref24 = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {}, cancelToken = _ref24.cancelToken, offset = _ref24.offset, count = _ref24.count, source = _ref24.source;
          _context20.next = 3;
          return getContactGroups({
            cancelToken: cancelToken,
            params: {
              offset: offset,
              count: count,
              source: source
            }
          });
        case 3:
          groups = _context20.sent;
          if (groups.length) {
            _context20.next = 6;
            break;
          }
          return _context20.abrupt("return", []);
        case 6:
          _groups$reduce = groups.reduce(function (acc, item) {
            acc[0].push(item.source);
            acc[1].push(item.id);
            return acc;
          }, [[], []]), _groups$reduce2 = _slicedToArray(_groups$reduce, 2), sources = _groups$reduce2[0], groupIds = _groups$reduce2[1]; // 批量获取分组的部分成员信息
          _context20.next = 9;
          return getContactGroupsMembersByIds({
            params: {
              sources: sources,
              group_ids: groupIds,
              count: 4
            },
            cancelToken: cancelToken
          });
        case 9:
          avatars = _context20.sent;
          // 拼接头像属性
          groups.forEach(function (r) {
            return r.avatar = avatars[r.id].map(function (u) {
              return u.avatar;
            });
          });
          return _context20.abrupt("return", groups);
        case 12:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return function getContactGroupsWithAvatars() {
    return _ref23.apply(this, arguments);
  };
}();

// 获取分组信息
var getContactGroupInfo = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(params) {
    var _yield$request$get13, data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return request$z.get('/api/contact/group/info', params);
        case 2:
          _yield$request$get13 = _context21.sent;
          data = _yield$request$get13.data;
          return _context21.abrupt("return", data);
        case 5:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function getContactGroupInfo(_x15) {
    return _ref25.apply(this, arguments);
  };
}();

// 获取分组中的成员
var getContactGroupMembers = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(params) {
    var _yield$request$get14, data;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return request$z.get('/api/contact/group/users', params);
        case 2:
          _yield$request$get14 = _context22.sent;
          data = _yield$request$get14.data;
          return _context22.abrupt("return", data);
        case 5:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return function getContactGroupMembers(_x16) {
    return _ref26.apply(this, arguments);
  };
}();
var fetchUserName = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(params) {
    var _yield$request$get15, data;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return request$z.get('/api/contact/relation/users/name', params);
        case 2:
          _yield$request$get15 = _context23.sent;
          data = _yield$request$get15.data;
          return _context23.abrupt("return", data);
        case 5:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return function fetchUserName(_x17) {
    return _ref27.apply(this, arguments);
  };
}();
// 发送验证安
var sendSms = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(params) {
    var _yield$request$post7, data;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return request$z.post('/p/sms', params);
        case 2:
          _yield$request$post7 = _context24.sent;
          data = _yield$request$post7.data;
          return _context24.abrupt("return", data);
        case 5:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return function sendSms(_x18) {
    return _ref28.apply(this, arguments);
  };
}();
// 检验验证码
var verifySms = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(params) {
    var _yield$request$post8, data;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return request$z.post('/api/v3/sms/verify', params);
        case 2:
          _yield$request$post8 = _context25.sent;
          data = _yield$request$post8.data;
          return _context25.abrupt("return", data);
        case 5:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return function verifySms(_x19) {
    return _ref29.apply(this, arguments);
  };
}();
var getContactMyTeams = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
    var _ref31,
      cancelToken,
      offset,
      count,
      type,
      corpid,
      source,
      data,
      avatarChunk,
      _args26 = arguments;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _ref31 = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : {}, cancelToken = _ref31.cancelToken, offset = _ref31.offset, count = _ref31.count, type = _ref31.type, corpid = _ref31.corpid, source = _ref31.source;
          _context26.next = 3;
          return getContactGroups({
            cancelToken: cancelToken,
            params: {
              count: count,
              offset: offset,
              company_id: type === 'corp' ? corpid : -1,
              group_type: 1,
              source: source
            }
          });
        case 3:
          data = _context26.sent;
          if (!data.length) {
            _context26.next = 9;
            break;
          }
          _context26.next = 7;
          return Promise.all(chunk(data, 50).map(function (data) {
            var _data$reduce = data.reduce(function (acc, item) {
                acc[0].push(item.source);
                acc[1].push(item.id);
                return acc;
              }, [[], []]),
              _data$reduce2 = _slicedToArray(_data$reduce, 2),
              sources = _data$reduce2[0],
              groupIds = _data$reduce2[1];
            return getContactGroupsMembersByIds({
              params: {
                sources: sources,
                group_ids: groupIds,
                count: 4
              },
              cancelToken: cancelToken
            });
          }));
        case 7:
          avatarChunk = _context26.sent;
          avatarChunk.forEach(function (avatars) {
            return data.forEach(function (r) {
              if (!avatars[r.id]) {
                return;
              }
              r.avatar = avatars[r.id].map(function (item) {
                return item.avatar;
              });
            });
          });
        case 9:
          return _context26.abrupt("return", data);
        case 10:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return function getContactMyTeams() {
    return _ref30.apply(this, arguments);
  };
}();
var getContactMyGroups = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
    var _ref33,
      cancelToken,
      offset,
      count,
      source,
      data,
      avatarChunk,
      _args27 = arguments;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _ref33 = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {}, cancelToken = _ref33.cancelToken, offset = _ref33.offset, count = _ref33.count, source = _ref33.source;
          _context27.next = 3;
          return getContactGroups({
            cancelToken: cancelToken,
            params: {
              count: count,
              offset: offset,
              source: source,
              group_type: 4
            }
          });
        case 3:
          data = _context27.sent;
          if (!data.length) {
            _context27.next = 9;
            break;
          }
          _context27.next = 7;
          return Promise.all(chunk(data, 50).map(function (data) {
            var _data$reduce3 = data.reduce(function (acc, item) {
                acc[0].push(item.source);
                acc[1].push(item.id);
                return acc;
              }, [[], []]),
              _data$reduce4 = _slicedToArray(_data$reduce3, 2),
              sources = _data$reduce4[0],
              groupIds = _data$reduce4[1];
            return getContactGroupsMembersByIds({
              params: {
                sources: sources,
                group_ids: groupIds,
                count: 4
              },
              cancelToken: cancelToken
            });
          }));
        case 7:
          avatarChunk = _context27.sent;
          avatarChunk.forEach(function (avatars) {
            return data.forEach(function (r) {
              if (!avatars[r.id]) {
                return;
              }
              r.avatar = avatars[r.id].map(function (item) {
                return item.avatar;
              });
            });
          });
        case 9:
          return _context27.abrupt("return", data);
        case 10:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return function getContactMyGroups() {
    return _ref32.apply(this, arguments);
  };
}();
var getSearchGroup = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(_ref34) {
    var key, source, offset, count, company_id, group_type, cancelToken, _yield$request$get16, data, avatarChunk;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          key = _ref34.key, source = _ref34.source, offset = _ref34.offset, count = _ref34.count, company_id = _ref34.company_id, group_type = _ref34.group_type, cancelToken = _ref34.cancelToken;
          _context28.next = 3;
          return request$z.get('/api/contact/v2/group/search', {
            params: {
              key: key,
              source: source,
              offset: offset,
              count: count,
              company_id: company_id,
              group_type: group_type
            },
            cancelToken: cancelToken
          });
        case 3:
          _yield$request$get16 = _context28.sent;
          data = _yield$request$get16.data.data;
          if (!data.length) {
            _context28.next = 10;
            break;
          }
          _context28.next = 8;
          return Promise.all(chunk(data, 50).map(function (data) {
            var _data$reduce5 = data.reduce(function (acc, item) {
                acc[0].push(item.source);
                acc[1].push(item.group_id);
                return acc;
              }, [[], []]),
              _data$reduce6 = _slicedToArray(_data$reduce5, 2),
              sources = _data$reduce6[0],
              groupIds = _data$reduce6[1];
            return getContactGroupsMembersByIds({
              params: {
                sources: sources,
                group_ids: groupIds,
                count: 4
              },
              cancelToken: cancelToken
            });
          }));
        case 8:
          avatarChunk = _context28.sent;
          avatarChunk.forEach(function (avatars) {
            return data.forEach(function (r) {
              if (!avatars[r.group_id]) {
                return;
              }
              r.avatar = avatars[r.group_id].map(function (item) {
                return item.avatar;
              });
            });
          });
        case 10:
          return _context28.abrupt("return", data);
        case 11:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return function getSearchGroup(_x20) {
    return _ref35.apply(this, arguments);
  };
}();
var webChangeLoginAccount = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(params) {
    var _yield$request$post9, data;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return request$z.post('/api/v3/login/web_change_login', params);
        case 2:
          _yield$request$post9 = _context29.sent;
          data = _yield$request$post9.data;
          return _context29.abrupt("return", data);
        case 5:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return function webChangeLoginAccount(_x21) {
    return _ref36.apply(this, arguments);
  };
}();
var appChangeLoginAccount = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(params) {
    var _yield$request$post10, data;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.next = 2;
          return request$z.post('/api/v3/login/app_change_login', params);
        case 2:
          _yield$request$post10 = _context30.sent;
          data = _yield$request$post10.data;
          return _context30.abrupt("return", data);
        case 5:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return function appChangeLoginAccount(_x22) {
    return _ref37.apply(this, arguments);
  };
}();
var fetchUserScore = /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
    var _yield$request$get17, data;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return request$z.get('/api/v3/account/score');
        case 2:
          _yield$request$get17 = _context31.sent;
          data = _yield$request$get17.data;
          return _context31.abrupt("return", data);
        case 5:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return function fetchUserScore() {
    return _ref38.apply(this, arguments);
  };
}();
var logout = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          _context32.next = 2;
          return request$z.post('/p/logout', {
            timestamp: new Date()
          });
        case 2:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return function logout() {
    return _ref39.apply(this, arguments);
  };
}();
// 检查第三方cookie 不能直接用kso/ui里已封装的request去发请求，因为会将.wps的域名转成.kdocs域名 无法正确检查第三方cookie
var checkThirdPartCookies = /*#__PURE__*/function () {
  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
    var axios$1, _yield$axios$get, data;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          axios$1 = axios.create({
            baseURL: ACCOUNT
          });
          axios$1.interceptors.response.use(function (response) {
            return response;
          }, function (error) {
            return error.response;
          });
          _context33.next = 4;
          return axios$1.get('/api/check/cdwc');
        case 4:
          _yield$axios$get = _context33.sent;
          data = _yield$axios$get.data;
          return _context33.abrupt("return", data && data.result === 'ok');
        case 7:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return function checkThirdPartCookies() {
    return _ref40.apply(this, arguments);
  };
}();
var getRelatedUsers = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(params) {
    var _yield$request$get18, data;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          _context34.next = 2;
          return request$z.get('/api/v3/related_users', {
            params: params
          });
        case 2:
          _yield$request$get18 = _context34.sent;
          data = _yield$request$get18.data;
          return _context34.abrupt("return", data);
        case 5:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return function getRelatedUsers(_x23) {
    return _ref41.apply(this, arguments);
  };
}();

// 获取合作方数据列表
var getPartnerInformationApi = /*#__PURE__*/function () {
  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(params) {
    var _yield$request$get19, data;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 2;
          return request$z.get('/api/v3/group', {
            params: params
          });
        case 2:
          _yield$request$get19 = _context35.sent;
          data = _yield$request$get19.data;
          return _context35.abrupt("return", data);
        case 5:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return function getPartnerInformationApi(_x24) {
    return _ref42.apply(this, arguments);
  };
}();

// 获取最新协议
var getLatestAgreement = /*#__PURE__*/function () {
  var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(names) {
    var _yield$request$get20, data;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          _context36.prev = 0;
          _context36.next = 3;
          return request$z.get('/api/agreement/latest', {
            params: {
              names: names
            }
          });
        case 3:
          _yield$request$get20 = _context36.sent;
          data = _yield$request$get20.data;
          return _context36.abrupt("return", data);
        case 8:
          _context36.prev = 8;
          _context36.t0 = _context36["catch"](0);
        case 10:
        case "end":
          return _context36.stop();
      }
    }, _callee36, null, [[0, 8]]);
  }));
  return function getLatestAgreement(_x25) {
    return _ref43.apply(this, arguments);
  };
}();

// 用户同意授权协议
var setUserAgreement = /*#__PURE__*/function () {
  var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(agreementids, from) {
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          _context37.prev = 0;
          _context37.next = 3;
          return request$z.post('/api/user/agreement', {
            agreementids: agreementids,
            from: from
          });
        case 3:
          _context37.next = 7;
          break;
        case 5:
          _context37.prev = 5;
          _context37.t0 = _context37["catch"](0);
        case 7:
        case "end":
          return _context37.stop();
      }
    }, _callee37, null, [[0, 5]]);
  }));
  return function setUserAgreement(_x26, _x27) {
    return _ref44.apply(this, arguments);
  };
}();

// 过滤出用户已授权的协议
var getUserAcceptedAgreement = /*#__PURE__*/function () {
  var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(agreementids, from) {
    var _yield$request$get21, data;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          _context38.prev = 0;
          _context38.next = 3;
          return request$z.get('/api/user/agreement/accepted', {
            params: {
              agreementids: agreementids,
              from: from
            }
          });
        case 3:
          _yield$request$get21 = _context38.sent;
          data = _yield$request$get21.data;
          return _context38.abrupt("return", data);
        case 8:
          _context38.prev = 8;
          _context38.t0 = _context38["catch"](0);
        case 10:
        case "end":
          return _context38.stop();
      }
    }, _callee38, null, [[0, 8]]);
  }));
  return function getUserAcceptedAgreement(_x28, _x29) {
    return _ref45.apply(this, arguments);
  };
}();

var request$y = createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});
var requestDrive$1 = createInstance({
  baseURL: DRIVE,
  withCredentials: true,
  timeout: 30000
});

// 获取文件申诉流程状态
var getAppealStatus = function getAppealStatus(params) {
  var _request$get = request$y.get("/api/kdocs/file/".concat(params.id, "/appeal/status"), {
      params: params
    }),
    data = _request$get.data;
  return data;
};

// 提交文件申诉请求
var postAppealContent = function postAppealContent(params) {
  var _request$post = request$y.post("/api/kdocs/fcheck/".concat(params.id, "/appeal"), {
      comment: params.comment,
      kind: params.kind
    }),
    data = _request$post.data;
  return data;
};

// 根据fileid获取申诉文件信息
var fetchAppealFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$y.get("/api/kdocs/sharefile/".concat(id, "/info"));
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data.data || data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchAppealFile(_x) {
    return _ref.apply(this, arguments);
  };
}();
var downloadFileWithFidGid = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fid, gid) {
    var _yield$requestDrive$g, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return requestDrive$1.get("/api/v3/groups/".concat(gid, "/files/").concat(fid, "/download"));
        case 2:
          _yield$requestDrive$g = _context2.sent;
          data = _yield$requestDrive$g.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function downloadFileWithFidGid(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var downloadFileWithOtl = function downloadFileWithOtl(fid, fver) {
  var otlFileDownloadStartTime = 0;
  return new Promise(function (resolve, reject) {
    var _fn = function fn() {
      // 获取导出结果
      request$y.post("/api/v3/office/outline/file/".concat(fid, "/version/").concat(fver, "/export/pdf/preload?appeal_mode=true"), {}).then(function (res) {
        var data = res.data;
        var result;
        if (data && data.status === 'Building') {
          if (!otlFileDownloadStartTime) {
            otlFileDownloadStartTime = new Date().getTime();
          }
          var nowTime = new Date().getTime();
          if (nowTime - otlFileDownloadStartTime <= 30 * 1000) {
            return setTimeout(_fn, 1000);
          } else {
            reject(null);
          }
        } else {
          otlFileDownloadStartTime = 0;
          result = data && data.url;
          return resolve(result);
        }
      })["catch"](function (e) {
        reject(e);
      });
    };
    // 启动进程
    _fn();
  });
};
var downloadFileToXlsx = function downloadFileToXlsx(fid, type) {
  return new Promise(function (resolve, reject) {
    var _fn2 = function fn() {
      // 获取导出结果
      request$y.get("/api/v3/office/file/".concat(fid, "/export/").concat(type, "/export-progress")).then(function (res) {
        var _res$data = res.data,
          result = _res$data.result,
          data = _res$data.data;
        // 导出url还未生成，继续查询
        if (result === 'inProgress') {
          return setTimeout(_fn2, 1000);
        }
        if (data && data.url) {
          return resolve(data.url);
        }
        throw res;
      })["catch"](function (e) {
        reject(e);
      });
    };
    // 启动进程
    request$y.post("/api/v3/office/file/".concat(fid, "/export/").concat(type, "/async-export"), {}).then(_fn2)["catch"](function (e) {
      reject(e);
    });
  });
};

var _excluded$5 = ["cid", "offset", "count"],
  _excluded2$3 = ["groupid"],
  _excluded3$2 = ["groupid"],
  _excluded4$1 = ["fid"],
  _excluded5 = ["cancel"],
  _excluded6 = ["cancel"];
function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CancelToken = axios.CancelToken;
var request$x = createInstance({
  baseURL: DRIVE,
  withCredentials: true
});
var requestDocs$2 = createInstance({
  baseURL: DOCS,
  withCredentials: true
});

// 获取所加入的企业
var fetchJoinedCompanies = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$request$get, companies;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$x.get('/api/v5/companies');
        case 2:
          _yield$request$get = _context.sent;
          companies = _yield$request$get.data.companies;
          return _context.abrupt("return", companies);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchJoinedCompanies() {
    return _ref.apply(this, arguments);
  };
}();
// 根据成员角色获取团队成员
var fetchTeamMembersByRoles = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, params, cancelToken) {
    var _yield$request$get2, members;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$x.get("/api/v3/groups/".concat(id, "/role_members"), {
            params: params,
            cancelToken: cancelToken
          });
        case 2:
          _yield$request$get2 = _context2.sent;
          members = _yield$request$get2.data.members;
          return _context2.abrupt("return", members);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchTeamMembersByRoles(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
// 搜索企业成员
var searchCompanyMembers = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cid, params) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$x.get("/api/v3/search/company/".concat(cid, "/members"), params);
        case 2:
          _yield$request$get3 = _context3.sent;
          data = _yield$request$get3.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function searchCompanyMembers(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
// 搜索团队成员
var searchTeamMembers = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tid, params) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$x.get("/api/v3/search/groups/".concat(tid, "/members"), params);
        case 2:
          _yield$request$get4 = _context4.sent;
          data = _yield$request$get4.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function searchTeamMembers(_x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();

// 获取用户基本信息
var fetchUserInfo = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var _yield$request$get5, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$x.get('api/v3/userinfo');
        case 2:
          _yield$request$get5 = _context5.sent;
          data = _yield$request$get5.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function fetchUserInfo() {
    return _ref5.apply(this, arguments);
  };
}();

// 获取自动上传文档
var fetchMyUpload = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var _yield$request$get6, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$x.get('api/v3/groups/tmp');
        case 2:
          _yield$request$get6 = _context6.sent;
          data = _yield$request$get6.data;
          return _context6.abrupt("return", data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function fetchMyUpload() {
    return _ref6.apply(this, arguments);
  };
}();

// 获取我的云文档
var fetchMyCloud = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var _yield$request$get7, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return request$x.get('/api/v3/groups/special');
        case 2:
          _yield$request$get7 = _context7.sent;
          data = _yield$request$get7.data;
          return _context7.abrupt("return", data);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function fetchMyCloud() {
    return _ref7.apply(this, arguments);
  };
}();
// 获取星标文件
var fetchFavors = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var _yield$request$get8, favorites;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return request$x.get('/api/v3/favorite');
        case 2:
          _yield$request$get8 = _context8.sent;
          favorites = _yield$request$get8.data.favorites;
          return _context8.abrupt("return", favorites);
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function fetchFavors() {
    return _ref8.apply(this, arguments);
  };
}();
// 获取用户所在团队文件
var fetchGroupFiles = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(gid) {
    var _yield$request$get9, data;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return request$x.get("api/v3/groups/".concat(gid));
        case 2:
          _yield$request$get9 = _context9.sent;
          data = _yield$request$get9.data;
          return _context9.abrupt("return", data);
        case 5:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function fetchGroupFiles(_x8) {
    return _ref9.apply(this, arguments);
  };
}();
// 获取漫游圈设备路径
var fetchDevicesPath = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(id) {
    var _yield$request$get10, data;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return request$x.get("/api/v5/groups/tmp/devices/".concat(id, "/path"));
        case 2:
          _yield$request$get10 = _context10.sent;
          data = _yield$request$get10.data;
          return _context10.abrupt("return", data);
        case 5:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function fetchDevicesPath(_x9) {
    return _ref10.apply(this, arguments);
  };
}();
// 获取列表文件数据
var fetchFilesByUrl = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(url, params) {
    var _yield$request$get11, data;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return request$x.get(url, params);
        case 2:
          _yield$request$get11 = _context11.sent;
          data = _yield$request$get11.data;
          return _context11.abrupt("return", data);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function fetchFilesByUrl(_x10, _x11) {
    return _ref11.apply(this, arguments);
  };
}();
// 获取文件目录的完整路径
var fetchFilePath = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(tid, fid) {
    var _yield$request$get12, data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$x.get("/api/v5/groups/".concat(tid, "/files/").concat(fid, "/path"));
        case 2:
          _yield$request$get12 = _context12.sent;
          data = _yield$request$get12.data;
          return _context12.abrupt("return", data);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function fetchFilePath(_x12, _x13) {
    return _ref12.apply(this, arguments);
  };
}();
// 加载单个文件的分享信息
var fetchFileShareInfo = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(fid, params) {
    var _yield$request$get13, data;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return request$x.get("/api/v3/links/".concat(fid), params);
        case 2:
          _yield$request$get13 = _context13.sent;
          data = _yield$request$get13.data;
          return _context13.abrupt("return", data);
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function fetchFileShareInfo(_x14, _x15) {
    return _ref13.apply(this, arguments);
  };
}();

// 加载单个文件的分享信息 V5
var fetchShareInfo = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(fid, params) {
    var _yield$request$get14, data;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return request$x.get("/api/v5/links/".concat(fid), params);
        case 2:
          _yield$request$get14 = _context14.sent;
          data = _yield$request$get14.data;
          return _context14.abrupt("return", data);
        case 5:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function fetchShareInfo(_x16, _x17) {
    return _ref14.apply(this, arguments);
  };
}();

// 加载单个文件的分享信息 V5
var fetchFileShareInfoV5 = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(fid, params) {
    var _yield$request$get15, data;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return request$x.get("/api/v5/links/".concat(fid), params);
        case 2:
          _yield$request$get15 = _context15.sent;
          data = _yield$request$get15.data;
          return _context15.abrupt("return", getFileInfoV5ToV3(data));
        case 5:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function fetchFileShareInfoV5(_x18, _x19) {
    return _ref15.apply(this, arguments);
  };
}();

// 获取上传信息
var putFileUploadCreateUpdate = function putFileUploadCreateUpdate(params) {
  return createInstance({
    withCredentials: true
  }).put("".concat(DRIVE, "/api/v5/files/upload/create_update"), params);
};
var getFileInfoV5ToV3 = function getFileInfoV5ToV3(data) {
  var _data$clink = data.clink,
    clink = _data$clink === void 0 ? {} : _data$clink,
    _data$linkinfo = data.linkinfo,
    linkinfo = _data$linkinfo === void 0 ? {} : _data$linkinfo,
    _data$fileinfo = data.fileinfo,
    fileinfo = _data$fileinfo === void 0 ? {} : _data$fileinfo,
    userExtPerm = data.user_ext_perm,
    userPermission = data.user_permission;
  var _ref16 = clink || {},
    groupCorpid = _ref16.group_corpid,
    linkPermission = _ref16.link_permission,
    linkUrl = _ref16.link_url,
    creator = _ref16.creator;
  var result = _objectSpread$9(_objectSpread$9({}, fileinfo), {}, {
    creator: creator || linkinfo.creator || {},
    extra: {
      is_corp_file: clink && clink.group_corpid || linkinfo && linkinfo.group_corpid || false
    },
    user_ext_perm: userExtPerm,
    user_permission: userPermission
  });
  // 兼容不返回link、clink情况
  if (data.linkinfo) {
    result = _objectSpread$9(_objectSpread$9({}, result), {}, {
      link: _objectSpread$9(_objectSpread$9({}, linkinfo), {}, {
        corp_id: linkinfo.group_corpid,
        permission: linkinfo.link_permission
      }),
      link_url: (linkinfo === null || linkinfo === void 0 ? void 0 : linkinfo.link_url) || ''
    });
  }
  if (data.clink) {
    result = _objectSpread$9(_objectSpread$9({}, result), {}, {
      clink: _objectSpread$9(_objectSpread$9({}, clink), {}, {
        corp_id: groupCorpid,
        permission: linkPermission
      }),
      clink_url: linkUrl
    });
  }
  return result;
};

// 设置/更换密码
var changeChkCode = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(sid, params) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return request$x.put("/api/v3/links/".concat(sid, "/chkcode"), params);
        case 2:
          _yield$request$put = _context16.sent;
          data = _yield$request$put.data;
          return _context16.abrupt("return", data);
        case 5:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function changeChkCode(_x20, _x21) {
    return _ref17.apply(this, arguments);
  };
}();

// 分享文件下载
var shareFileDownload = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(sid) {
    var _yield$request$get16, data;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return request$x.get("/api/v3/links/".concat(sid, "/download"), {
            params: {
              isblocks: false
            }
          });
        case 2:
          _yield$request$get16 = _context17.sent;
          data = _yield$request$get16.data;
          return _context17.abrupt("return", data);
        case 5:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function shareFileDownload(_x22) {
    return _ref18.apply(this, arguments);
  };
}();

// 文件批量操作任务进度接口
var fetchProgress = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(groupid, params) {
    var _yield$request$get17, data;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return request$x.get("/api/v3/groups/".concat(groupid, "/files/batch/progress"), params);
        case 2:
          _yield$request$get17 = _context18.sent;
          data = _yield$request$get17.data;
          return _context18.abrupt("return", data);
        case 5:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function fetchProgress(_x23, _x24) {
    return _ref19.apply(this, arguments);
  };
}();

// 普通文件夹转为共享文件夹
var setShareFolder = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(fid, params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return request$x.post("/api/v5/groups/special/folders/".concat(fid, "/share"), params);
        case 2:
          _yield$request$post = _context19.sent;
          data = _yield$request$post.data;
          return _context19.abrupt("return", data);
        case 5:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function setShareFolder(_x25, _x26) {
    return _ref20.apply(this, arguments);
  };
}();

// 获取文件历史记录列表
var fetchFileHistory = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(fid, params) {
    var _yield$request$get18, data;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return request$x.get("/api/v3/files/".concat(fid, "/histories"), {
            params: params
          });
        case 2:
          _yield$request$get18 = _context20.sent;
          data = _yield$request$get18.data;
          return _context20.abrupt("return", data);
        case 5:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return function fetchFileHistory(_x27, _x28) {
    return _ref21.apply(this, arguments);
  };
}();
var fetchFileMetadata = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(fid, params) {
    var _yield$request$get19, data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return request$x.get("/api/v5/files/".concat(fid, "/metadata"), {
            params: params
          });
        case 2:
          _yield$request$get19 = _context21.sent;
          data = _yield$request$get19.data;
          return _context21.abrupt("return", data);
        case 5:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function fetchFileMetadata(_x29, _x30) {
    return _ref22.apply(this, arguments);
  };
}();

// api/v5/links接口数据转换为之前api/v3/links接口数据
var getV3LinkInfo$1 = function getV3LinkInfo(data) {
  var linkinfo = data.linkinfo,
    fileinfo = data.fileinfo,
    user_permission = data.user_permission;
  var groupCorpid = linkinfo.group_corpid,
    linkUrl = linkinfo.link_url,
    linkPermission = linkinfo.link_permission,
    creator = linkinfo.creator;
  var v3Data = _objectSpread$9(_objectSpread$9({}, fileinfo), {}, {
    corpid: groupCorpid,
    link_url: linkUrl,
    user_permission: user_permission,
    link: _objectSpread$9(_objectSpread$9({}, linkinfo), {}, {
      corp_id: groupCorpid,
      permission: linkPermission,
      userid: creator.id
    })
  });
  return v3Data;
};
var fetchFileMetadataWithFolderLink = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(fid, fl, params) {
    var _yield$request$get20, data;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return request$x.get("/api/v5/folder_link_tree/".concat(fl, "/files/").concat(fid, "/metadata"), {
            params: params
          });
        case 2:
          _yield$request$get20 = _context22.sent;
          data = _yield$request$get20.data;
          return _context22.abrupt("return", data);
        case 5:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return function fetchFileMetadataWithFolderLink(_x31, _x32, _x33) {
    return _ref23.apply(this, arguments);
  };
}();
var fetchFolderLinkTreeFileDownloadInfo = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(fid, fl, params) {
    var _yield$request$get21, data;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return request$x.get("/api/v5/folder_link_tree/".concat(fl, "/files/").concat(fid, "/download"), {
            params: params
          });
        case 2:
          _yield$request$get21 = _context23.sent;
          data = _yield$request$get21.data;
          return _context23.abrupt("return", data);
        case 5:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return function fetchFolderLinkTreeFileDownloadInfo(_x34, _x35, _x36) {
    return _ref24.apply(this, arguments);
  };
}();
var fetchGroupFileDownloadInfo = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(gid, fid, params) {
    var newDownload, _yield$request$get22, data, _yield$requestDocs$ge, _data, taskId, taskType, wait, _query;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          newDownload = params.newDownload;
          if (newDownload) {
            _context25.next = 9;
            break;
          }
          _context25.next = 4;
          return request$x.get("/api/v5/groups/".concat(gid, "/files/").concat(fid, "/download"), {
            params: _objectSpread$9({
              isblocks: false,
              support_checksums: 'md5,sha1,sha224,sha256,sha384,sha512'
            }, params)
          });
        case 4:
          _yield$request$get22 = _context25.sent;
          data = _yield$request$get22.data;
          return _context25.abrupt("return", data.url ? {
            fileinfo: data
          } : data);
        case 9:
          _context25.next = 11;
          return requestDocs$2.get("/api/v3/office/file/".concat(fid, "/download"), {
            params: _objectSpread$9({
              isblocks: false,
              support_checksums: 'md5,sha1,sha224,sha256,sha384,sha512'
            }, params)
          });
        case 11:
          _yield$requestDocs$ge = _context25.sent;
          _data = _yield$requestDocs$ge.data;
          if (!(_data.task_id && _data.task_type)) {
            _context25.next = 23;
            break;
          }
          taskId = encodeURIComponent(_data.task_id);
          taskType = _data.task_type;
          wait = function wait(ms) {
            return new Promise(function (resolve) {
              setTimeout(resolve, ms);
            });
          };
          _query = /*#__PURE__*/function () {
            var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
              var _yield$requestDocs$ge2, resp;
              return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                while (1) switch (_context24.prev = _context24.next) {
                  case 0:
                    _context24.prev = 0;
                    _context24.next = 3;
                    return requestDocs$2.get("/api/v3/office/asynctasks/".concat(taskType, "?id=").concat(taskId));
                  case 3:
                    _yield$requestDocs$ge2 = _context24.sent;
                    resp = _yield$requestDocs$ge2.data;
                    if (!resp) {
                      _context24.next = 18;
                      break;
                    }
                    if (!(resp.status === 'running')) {
                      _context24.next = 12;
                      break;
                    }
                    _context24.next = 9;
                    return wait(1000);
                  case 9:
                    return _context24.abrupt("return", _query());
                  case 12:
                    if (!(resp.status === 'finished')) {
                      _context24.next = 18;
                      break;
                    }
                    if (!resp.data) {
                      _context24.next = 17;
                      break;
                    }
                    return _context24.abrupt("return", {
                      url: resp.data.url
                    });
                  case 17:
                    throw resp;
                  case 18:
                    throw new AsyncExportException();
                  case 21:
                    _context24.prev = 21;
                    _context24.t0 = _context24["catch"](0);
                    throw new AsyncExportException(_context24.t0);
                  case 24:
                  case "end":
                    return _context24.stop();
                }
              }, _callee24, null, [[0, 21]]);
            }));
            return function query() {
              return _ref26.apply(this, arguments);
            };
          }();
          _context25.next = 20;
          return wait(100);
        case 20:
          return _context25.abrupt("return", _query());
        case 23:
          if (!(_data.download_url || _data.url)) {
            _context25.next = 25;
            break;
          }
          return _context25.abrupt("return", {
            url: _data.download_url || _data.url
          });
        case 25:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return function fetchGroupFileDownloadInfo(_x37, _x38, _x39) {
    return _ref25.apply(this, arguments);
  };
}();

// 开启分享
var setFileShare = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(fid, params) {
    var _ref28, clink, _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _ref28 = params || {}, clink = _ref28.clink;
          _context26.next = 3;
          return request$x.post('/api/v5/links', {
            fileid: "".concat(fid),
            clink: clink
          });
        case 3:
          _yield$request$post2 = _context26.sent;
          data = _yield$request$post2.data;
          return _context26.abrupt("return", getV3LinkInfo$1(data));
        case 6:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return function setFileShare(_x40, _x41) {
    return _ref27.apply(this, arguments);
  };
}();

// 修改分享
var changeFileShare = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(params) {
    var _yield$request$put2, data;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return request$x.put("api/v3/links/".concat(params.sid), params);
        case 2:
          _yield$request$put2 = _context27.sent;
          data = _yield$request$put2.data;
          return _context27.abrupt("return", data);
        case 5:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return function changeFileShare(_x42) {
    return _ref29.apply(this, arguments);
  };
}();
// 搜索文件
var searchFinderFile = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(params) {
    var _yield$request$get23, files;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return request$x.get('api/v3/search/files', params);
        case 2:
          _yield$request$get23 = _context28.sent;
          files = _yield$request$get23.data.files;
          return _context28.abrupt("return", files);
        case 5:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return function searchFinderFile(_x43) {
    return _ref30.apply(this, arguments);
  };
}();
// 搜索团队
var searchFinderGroup = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(cropid, params) {
    var _yield$request$get24, groups;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return request$x.get("/api/v3/search/company/".concat(cropid, "/groups"), params);
        case 2:
          _yield$request$get24 = _context29.sent;
          groups = _yield$request$get24.data.groups;
          return _context29.abrupt("return", groups);
        case 5:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return function searchFinderGroup(_x44, _x45) {
    return _ref31.apply(this, arguments);
  };
}();

// 获取企业主页信息
var fetchCompanyPageHome = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(params) {
    var cid, _yield$request$get25, data;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          cid = params.cid;
          _context30.next = 3;
          return request$x.get('/api/v5/corpgroups/corpindex', {
            params: {
              corp_id: parseInt(cid)
            }
          });
        case 3:
          _yield$request$get25 = _context30.sent;
          data = _yield$request$get25.data;
          return _context30.abrupt("return", data);
        case 6:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return function fetchCompanyPageHome(_x46) {
    return _ref32.apply(this, arguments);
  };
}();
// 获取企业的团队列表
var fetchGroups = /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(params) {
    var cid, _params$offset, offset, _params$count, count, query, _yield$request$get26, groups;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          cid = params.cid, _params$offset = params.offset, offset = _params$offset === void 0 ? 0 : _params$offset, _params$count = params.count, count = _params$count === void 0 ? 20 : _params$count, query = _objectWithoutProperties(params, _excluded$5);
          _context31.next = 3;
          return request$x.get('/api/v5/groups', {
            params: Object.assign({
              companyid: cid,
              offset: offset,
              count: count
            }, query)
          });
        case 3:
          _yield$request$get26 = _context31.sent;
          groups = _yield$request$get26.data.groups;
          return _context31.abrupt("return", groups);
        case 6:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return function fetchGroups(_x47) {
    return _ref33.apply(this, arguments);
  };
}();
// 获取团队圈子的成员列表
var fetchMembers = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(params) {
    var groupid, options, _yield$request$get27, members;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          groupid = params.groupid, options = _objectWithoutProperties(params, _excluded2$3);
          _context32.next = 3;
          return request$x.get("/api/v3/groups/".concat(groupid, "/members"), {
            params: _objectSpread$9(_objectSpread$9({}, options), {}, {
              with_relation: true
            })
          });
        case 3:
          _yield$request$get27 = _context32.sent;
          members = _yield$request$get27.data.members;
          return _context32.abrupt("return", members);
        case 6:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return function fetchMembers(_x48) {
    return _ref34.apply(this, arguments);
  };
}();

// 获取当前文件(夹)的权限详情
/**
 *
 * @param {Number} groupid
 * @param {Array} fileids
 */
var fetchPermissonStatus = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(params) {
    var groupid, fileids, parentid, _yield$request$get28, data;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          groupid = params.groupid, fileids = params.fileids, parentid = params.parentid;
          _context33.next = 3;
          return request$x.get("/api/v3/groups/".concat(groupid, "/files/permission"), {
            params: {
              fileids: fileids,
              parentid: parentid,
              herit: true,
              all_user: true,
              range: true
            }
          });
        case 3:
          _yield$request$get28 = _context33.sent;
          data = _yield$request$get28.data;
          return _context33.abrupt("return", data);
        case 6:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return function fetchPermissonStatus(_x49) {
    return _ref35.apply(this, arguments);
  };
}();

// 文件权限范围更改接口
/**
 *
 * @param {Number} groupid
 * @param {Number} fileid
 * @param {String} read_range
 * @param {String} write_range
 */
var updataFileRangePermission = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(params) {
    var groupid, fileid, read_range, write_range, parentid, isfile, admins, _yield$request$put3, data;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          groupid = params.groupid, fileid = params.fileid, read_range = params.read_range, write_range = params.write_range, parentid = params.parentid, isfile = params.isfile, admins = params.admins;
          _context34.next = 3;
          return request$x.put("/api/v3/groups/".concat(groupid, "/files/").concat(fileid, "/permission/range"), {
            groupid: groupid,
            fileid: fileid,
            read_range: read_range,
            parentid: parentid,
            write_range: write_range,
            isfile: isfile,
            admins: admins
          });
        case 3:
          _yield$request$put3 = _context34.sent;
          data = _yield$request$put3.data;
          return _context34.abrupt("return", data);
        case 6:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return function updataFileRangePermission(_x50) {
    return _ref36.apply(this, arguments);
  };
}();

// 修改当前文件（夹）的权限
/**
 *
 * @param {Number} groupid
 * @param {Number} fileid
 * @param {String} op
 * @param {Array} ruser
 * @param {Array} wuser
 */
var updateFilePermisson = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(params) {
    var groupid, fileid, _yield$request$put4, data;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          groupid = params.groupid, fileid = params.fileid;
          _context35.next = 3;
          return request$x.put("api/v3/groups/".concat(groupid, "/files/").concat(fileid, "/permission"), params);
        case 3:
          _yield$request$put4 = _context35.sent;
          data = _yield$request$put4.data;
          return _context35.abrupt("return", data);
        case 6:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return function updateFilePermisson(_x51) {
    return _ref37.apply(this, arguments);
  };
}();

/**
 * 获取当前文件夹下文件或子文件夹权限范围
 */
var fetchSubFilePermission = /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(params) {
    var groupid, fileid, _yield$request$get29, data;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          groupid = params.groupid, fileid = params.fileid;
          _context36.next = 3;
          return request$x.get("/api/v3/groups/".concat(groupid, "/files/permission/path"), {
            params: {
              fileid: fileid
            }
          });
        case 3:
          _yield$request$get29 = _context36.sent;
          data = _yield$request$get29.data;
          return _context36.abrupt("return", data);
        case 6:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return function fetchSubFilePermission(_x52) {
    return _ref38.apply(this, arguments);
  };
}();

// 修改共享文件夹、团队成员权限
/**
 * @param {Number} groupid
 * @param {Number} id
 */
var updateFloderPermisson = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(params, id, gid) {
    var _yield$request$put5, data;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          _context37.next = 2;
          return request$x.put("/api/v3/groups/".concat(gid, "/members/").concat(id), params);
        case 2:
          _yield$request$put5 = _context37.sent;
          data = _yield$request$put5.data;
          return _context37.abrupt("return", data);
        case 5:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return function updateFloderPermisson(_x53, _x54, _x55) {
    return _ref39.apply(this, arguments);
  };
}();

// 移除共享文件夹、团队成员权限
var delFloderMember = /*#__PURE__*/function () {
  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(params) {
    var id, groupid, status, api, _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          id = params.id, groupid = params.groupid, status = params.status;
          api = status ? "/api/v3/groups/".concat(groupid, "/members/").concat(id) : "/api/v3/invite/groups/".concat(groupid, "/members/").concat(id);
          _context38.next = 4;
          return request$x["delete"](api);
        case 4:
          _yield$request$delete = _context38.sent;
          data = _yield$request$delete.data;
          return _context38.abrupt("return", data);
        case 7:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return function delFloderMember(_x56) {
    return _ref40.apply(this, arguments);
  };
}();

// 获取已邀请但未注册的成员
var getInviteMembers = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(gid) {
    var _yield$request$get30, data;
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          _context39.next = 2;
          return request$x.get("/api/v3/invite/groups/".concat(gid, "/members"));
        case 2:
          _yield$request$get30 = _context39.sent;
          data = _yield$request$get30.data;
          return _context39.abrupt("return", data);
        case 5:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return function getInviteMembers(_x57) {
    return _ref41.apply(this, arguments);
  };
}();

// 获取对应的共享文件夹id
var fetchLinkfolders = /*#__PURE__*/function () {
  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(gid) {
    var data;
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          _context40.next = 2;
          return request$x.get("/api/v5/groups/linkfolders?groupids=".concat(gid));
        case 2:
          data = _context40.sent;
          return _context40.abrupt("return", data);
        case 4:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return function fetchLinkfolders(_x58) {
    return _ref42.apply(this, arguments);
  };
}();
// 取消共享
function onCloseFolderLink(_x59) {
  return _onCloseFolderLink.apply(this, arguments);
}

// 获取邀请加入团队、共享文件夹链接信息
function _onCloseFolderLink() {
  _onCloseFolderLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102(fid) {
    var _yield$request$delete4, data;
    return _regeneratorRuntime.wrap(function _callee102$(_context102) {
      while (1) switch (_context102.prev = _context102.next) {
        case 0:
          _context102.next = 2;
          return request$x["delete"]("/api/v5/groups/special/folders/".concat(fid, "/share"));
        case 2:
          _yield$request$delete4 = _context102.sent;
          data = _yield$request$delete4.data;
          return _context102.abrupt("return", data);
        case 5:
        case "end":
          return _context102.stop();
      }
    }, _callee102);
  }));
  return _onCloseFolderLink.apply(this, arguments);
}
var fetchShareFolsderInviteInfo = /*#__PURE__*/function () {
  var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(gid) {
    var data;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          _context41.next = 2;
          return request$x.get("/api/v3/groups/".concat(gid, "/invite_info"));
        case 2:
          data = _context41.sent;
          return _context41.abrupt("return", data);
        case 4:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return function fetchShareFolsderInviteInfo(_x60) {
    return _ref43.apply(this, arguments);
  };
}();

// 获取团队设置
var fetchShareFolsderSetting = /*#__PURE__*/function () {
  var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(gid) {
    var _yield$request$get31, data;
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          _context42.next = 2;
          return request$x.get("/api/v5/groups/".concat(gid, "/settings"));
        case 2:
          _yield$request$get31 = _context42.sent;
          data = _yield$request$get31.data;
          return _context42.abrupt("return", data);
        case 5:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return function fetchShareFolsderSetting(_x61) {
    return _ref44.apply(this, arguments);
  };
}();
// 团队设置更改
var setShareFolsderSetting = /*#__PURE__*/function () {
  var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(gid, params) {
    var _yield$request$put6, data;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          _context43.next = 2;
          return request$x.put("/api/v5/groups/".concat(gid, "/settings"), params);
        case 2:
          _yield$request$put6 = _context43.sent;
          data = _yield$request$put6.data;
          return _context43.abrupt("return", data);
        case 5:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return function setShareFolsderSetting(_x62, _x63) {
    return _ref45.apply(this, arguments);
  };
}();

// 企业团队 是否开启文档所有权限给管理员（拥有者调用， body只支持传admin_file_perm）
var setAllFilesPermsToAdmin = /*#__PURE__*/function () {
  var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(gid, params) {
    var _yield$request$put7, data;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          _context44.next = 2;
          return request$x.put("/api/v5/groups/".concat(gid, "/new_settings"), params);
        case 2:
          _yield$request$put7 = _context44.sent;
          data = _yield$request$put7.data;
          return _context44.abrupt("return", data);
        case 5:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return function setAllFilesPermsToAdmin(_x64, _x65) {
    return _ref46.apply(this, arguments);
  };
}();

/**
 * 获取团队文件权限设置
 * @param {*} params
 */
var fetchFilePerSetting = /*#__PURE__*/function () {
  var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(params) {
    var groupid, _yield$request$get32, data;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          groupid = params.groupid;
          _context45.next = 3;
          return request$x.get("/api/v5/groups/".concat(groupid, "/permission"));
        case 3:
          _yield$request$get32 = _context45.sent;
          data = _yield$request$get32.data;
          return _context45.abrupt("return", data);
        case 6:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return function fetchFilePerSetting(_x66) {
    return _ref47.apply(this, arguments);
  };
}();

/**
 * 更新团队文件权限设置
 * @param {*} params
 */
var updateFilePerSetting = /*#__PURE__*/function () {
  var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(params) {
    var groupid, opt, _yield$request$put8, data;
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          groupid = params.groupid, opt = _objectWithoutProperties(params, _excluded3$2);
          _context46.next = 3;
          return request$x.put("/api/v5/groups/".concat(groupid, "/permission"), opt);
        case 3:
          _yield$request$put8 = _context46.sent;
          data = _yield$request$put8.data;
          return _context46.abrupt("return", data);
        case 6:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return function updateFilePerSetting(_x67) {
    return _ref48.apply(this, arguments);
  };
}();
var copyFile = function copyFile(params) {
  return request$x.post("/api/v3/groups/".concat(params.groupid, "/files/batch/copy"), params);
};
var copyFileWithQuery = function copyFileWithQuery() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$params = config.params,
    params = _config$params === void 0 ? {} : _config$params,
    _config$query = config.query,
    query = _config$query === void 0 ? {} : _config$query;
  return request$x.post("/api/v3/groups/".concat(params.groupid, "/files/batch/copy"), params, {
    params: query
  });
};
var saveAsFileWithQuery = function saveAsFileWithQuery() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$params2 = config.params,
    params = _config$params2 === void 0 ? {} : _config$params2,
    _config$query2 = config.query,
    query = _config$query2 === void 0 ? {} : _config$query2;
  return requestDocs$2.post("/kfc/batch/v1/files/save_as", params, {
    params: query
  });
};
var saveAsFile = function saveAsFile(params) {
  return request$x.post("/api/v5/files/".concat(params.fileids[0], "/save_as"), params);
};
var moveFile = function moveFile(params) {
  return request$x.post("/api/v3/groups/".concat(params.groupid, "/files/batch/move"), params);
};
var moveFileWithQuery = function moveFileWithQuery() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$params3 = config.params,
    params = _config$params3 === void 0 ? {} : _config$params3,
    _config$query3 = config.query,
    query = _config$query3 === void 0 ? {} : _config$query3;
  return request$x.post("/api/v3/groups/".concat(params.groupid, "/files/batch/move"), params, {
    params: query
  });
};

// 文件举报
var fileReport = /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(params) {
    var _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          _context47.next = 2;
          return request$x.post('/api/report', params);
        case 2:
          _yield$request$post3 = _context47.sent;
          data = _yield$request$post3.data;
          return _context47.abrupt("return", data);
        case 5:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return function fileReport(_x68) {
    return _ref49.apply(this, arguments);
  };
}();

// 文件举报(区分label+具体描述)
var fileReportNew = /*#__PURE__*/function () {
  var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(id, params) {
    var _yield$requestDocs$po, data;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          _context48.next = 2;
          return requestDocs$2.post("/api/kdocs/fcheck/".concat(id, "/report"), params);
        case 2:
          _yield$requestDocs$po = _context48.sent;
          data = _yield$requestDocs$po.data;
          return _context48.abrupt("return", data);
        case 5:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return function fileReportNew(_x69, _x70) {
    return _ref50.apply(this, arguments);
  };
}();

// AI生成举报
var AiReport = /*#__PURE__*/function () {
  var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
    var params,
      query,
      _yield$requestDocs$po2,
      data,
      _args49 = arguments;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          params = _args49.length > 0 && _args49[0] !== undefined ? _args49[0] : {};
          query = _args49.length > 1 && _args49[1] !== undefined ? _args49[1] : {};
          if (!query.client_type) {
            query.client_type = getClientType();
          }
          _context49.next = 5;
          return requestDocs$2.post("/api/v3/kai/aigc/feedback/http/proxy/session/message/".concat(params.message_id, "/feedback/appeal"), params, {
            params: query
          });
        case 5:
          _yield$requestDocs$po2 = _context49.sent;
          data = _yield$requestDocs$po2.data;
          return _context49.abrupt("return", data);
        case 8:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));
  return function AiReport() {
    return _ref51.apply(this, arguments);
  };
}();
function batchProgress(_x71, _x72) {
  return _batchProgress.apply(this, arguments);
}
function _batchProgress() {
  _batchProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(groupid, options) {
    var cancel, params, syncStatus, handle, result, _yield$request$get59, data;
    return _regeneratorRuntime.wrap(function _callee103$(_context103) {
      while (1) switch (_context103.prev = _context103.next) {
        case 0:
          cancel = options.cancel, params = _objectWithoutProperties(options, _excluded5);
          syncStatus = !params.taskid;
          result = null;
          cancel = cancel || function () {};
        case 4:
          if (syncStatus) {
            _context103.next = 18;
            break;
          }
          _context103.next = 7;
          return request$x.get("/api/v3/groups/".concat(groupid, "/files/batch/progress"), {
            baseURL: DRIVE,
            params: params,
            cancelToken: new CancelToken(function (c) {
              cancel(function () {
                clearTimeout(handle);
                c();
              });
            })
          });
        case 7:
          _yield$request$get59 = _context103.sent;
          data = _yield$request$get59.data;
          if (!data.done) {
            _context103.next = 14;
            break;
          }
          syncStatus = true;
          result = data;
          _context103.next = 16;
          break;
        case 14:
          _context103.next = 16;
          return new Promise(function (resolve, reject) {
            cancel(function () {
              clearTimeout(handle);
              reject(new Cancel('abort'));
            });
            handle = setTimeout(function () {
              return resolve(true);
            }, 1000);
          });
        case 16:
          _context103.next = 4;
          break;
        case 18:
          return _context103.abrupt("return", result);
        case 19:
        case "end":
          return _context103.stop();
      }
    }, _callee103);
  }));
  return _batchProgress.apply(this, arguments);
}
function batchProgressV2(_x73) {
  return _batchProgressV.apply(this, arguments);
}

//  获取个人共享文件夹
function _batchProgressV() {
  _batchProgressV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(options) {
    var cancel, params, syncStatus, result, handle, _data$data, _yield$requestDocs$ge3, data;
    return _regeneratorRuntime.wrap(function _callee104$(_context104) {
      while (1) switch (_context104.prev = _context104.next) {
        case 0:
          cancel = options.cancel, params = _objectWithoutProperties(options, _excluded6);
          syncStatus = !params.task_id;
          result = null;
          cancel = cancel || function () {};
        case 4:
          if (syncStatus) {
            _context104.next = 18;
            break;
          }
          _context104.next = 7;
          return requestDocs$2.get("/kfc/batch/v1/files/progress", {
            params: params,
            cancelToken: new CancelToken(function (c) {
              cancel(function () {
                clearTimeout(handle);
                c();
              });
            })
          });
        case 7:
          _yield$requestDocs$ge3 = _context104.sent;
          data = _yield$requestDocs$ge3.data;
          if (!(data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.done)) {
            _context104.next = 14;
            break;
          }
          syncStatus = true;
          result = data.data;
          _context104.next = 16;
          break;
        case 14:
          _context104.next = 16;
          return new Promise(function (resolve, reject) {
            cancel(function () {
              clearTimeout(handle);
              reject(new Cancel('abort'));
            });
            handle = setTimeout(function () {
              return resolve(true);
            }, 1000);
          });
        case 16:
          _context104.next = 4;
          break;
        case 18:
          return _context104.abrupt("return", result);
        case 19:
        case "end":
          return _context104.stop();
      }
    }, _callee104);
  }));
  return _batchProgressV.apply(this, arguments);
}
var fetchLinkFolder = /*#__PURE__*/function () {
  var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(params) {
    var offset, count, _yield$request$get33, data;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          offset = params.offset, count = params.count;
          _context50.next = 3;
          return request$x.get('/api/v5/groups/special/linkgroups', {
            params: {
              offset: offset,
              count: count
            }
          });
        case 3:
          _yield$request$get33 = _context50.sent;
          data = _yield$request$get33.data;
          return _context50.abrupt("return", data);
        case 6:
        case "end":
          return _context50.stop();
      }
    }, _callee50);
  }));
  return function fetchLinkFolder(_x74) {
    return _ref52.apply(this, arguments);
  };
}();
var importToPersonalTeam = /*#__PURE__*/function () {
  var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(params) {
    var data;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          _context51.prev = 0;
          _context51.next = 3;
          return request$x.post('/kdteam/api/v1/teams', params, {
            baseURL: TWPS
          });
        case 3:
          data = _context51.sent;
          return _context51.abrupt("return", data);
        case 7:
          _context51.prev = 7;
          _context51.t0 = _context51["catch"](0);
          // 由于报错格式不一致，所以需要特殊处理，把 result 的错误信息处理到 msg 中
          if (_context51.t0 && _context51.t0.response && _context51.t0.response.data && !_context51.t0.response.data.msg && _context51.t0.response.data.result) {
            _context51.t0.response.data.msg = _context51.t0.response.data.result;
          }
          throw _context51.t0;
        case 11:
        case "end":
          return _context51.stop();
      }
    }, _callee51, null, [[0, 7]]);
  }));
  return function importToPersonalTeam(_x75) {
    return _ref53.apply(this, arguments);
  };
}();

// 导入个人共享文件夹到企业
var importToCorp = /*#__PURE__*/function () {
  var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(params) {
    var corpid, linkgroupids, _params$approvers, approvers, applyReason, defaultReason, postParams, _yield$request$post4, data;
    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          corpid = params.corpid, linkgroupids = params.linkgroupids, _params$approvers = params.approvers, approvers = _params$approvers === void 0 ? [] : _params$approvers, applyReason = params.apply_reason, defaultReason = params.default_reason;
          postParams = {
            corpid: corpid,
            linkgroupids: linkgroupids.join(',')
          };
          postParams.version = 1;
          postParams.apply_reason = defaultReason || '';
          // 判断是否存在审批场景
          if (applyReason) {
            postParams.approvers = approvers.map(function (item) {
              return item.id;
            }); // 审批人列表
            postParams.apply_reason = applyReason; // 申请原因
          }
          if (!linkgroupids.length) {
            _context52.next = 11;
            break;
          }
          _context52.next = 8;
          return request$x.post('/api/v5/corpgroups/migrate', postParams);
        case 8:
          _yield$request$post4 = _context52.sent;
          data = _yield$request$post4.data;
          return _context52.abrupt("return", data);
        case 11:
          return _context52.abrupt("return", {});
        case 12:
        case "end":
          return _context52.stop();
      }
    }, _callee52);
  }));
  return function importToCorp(_x76) {
    return _ref54.apply(this, arguments);
  };
}();
// 获取文件权限可设置成员
var fetchFilePermMembers = /*#__PURE__*/function () {
  var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(gid, params) {
    var _yield$request$get34, data;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) switch (_context53.prev = _context53.next) {
        case 0:
          _context53.next = 2;
          return request$x.get("/api/v3/groups/".concat(gid, "/files/permission/validusers"), params);
        case 2:
          _yield$request$get34 = _context53.sent;
          data = _yield$request$get34.data;
          return _context53.abrupt("return", data);
        case 5:
        case "end":
          return _context53.stop();
      }
    }, _callee53);
  }));
  return function fetchFilePermMembers(_x77, _x78) {
    return _ref55.apply(this, arguments);
  };
}();

// 搜索文件权限可设置成员
var searchFilePermMembers = /*#__PURE__*/function () {
  var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(gid, params) {
    var _yield$request$get35, data;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) switch (_context54.prev = _context54.next) {
        case 0:
          _context54.next = 2;
          return request$x.get("/api/v3/search/groups/".concat(gid, "/fileperm/members"), params);
        case 2:
          _yield$request$get35 = _context54.sent;
          data = _yield$request$get35.data;
          return _context54.abrupt("return", data);
        case 5:
        case "end":
          return _context54.stop();
      }
    }, _callee54);
  }));
  return function searchFilePermMembers(_x79, _x80) {
    return _ref56.apply(this, arguments);
  };
}();
// 获取旧版联系人列表
var fetchContactList = /*#__PURE__*/function () {
  var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(params) {
    var _yield$request$get36, data;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) switch (_context55.prev = _context55.next) {
        case 0:
          _context55.next = 2;
          return request$x.get('/api/v5/contacts/list', params);
        case 2:
          _yield$request$get36 = _context55.sent;
          data = _yield$request$get36.data;
          return _context55.abrupt("return", data);
        case 5:
        case "end":
          return _context55.stop();
      }
    }, _callee55);
  }));
  return function fetchContactList(_x81) {
    return _ref57.apply(this, arguments);
  };
}();

// 获取分组信息
function fetchGroupsInfo(_x82) {
  return _fetchGroupsInfo.apply(this, arguments);
}

// 团队外成员获取分组信息
function _fetchGroupsInfo() {
  _fetchGroupsInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(gid) {
    var _yield$request$get60, data, status;
    return _regeneratorRuntime.wrap(function _callee105$(_context105) {
      while (1) switch (_context105.prev = _context105.next) {
        case 0:
          _context105.next = 2;
          return request$x.get("/api/v3/groups/".concat(gid, "?include=recent_members"));
        case 2:
          _yield$request$get60 = _context105.sent;
          data = _yield$request$get60.data;
          status = _yield$request$get60.status;
          return _context105.abrupt("return", _objectSpread$9(_objectSpread$9({}, data), {}, {
            status: status
          }));
        case 6:
        case "end":
          return _context105.stop();
      }
    }, _callee105);
  }));
  return _fetchGroupsInfo.apply(this, arguments);
}
var fetchOutOfGroupsInfo = /*#__PURE__*/function () {
  var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(params) {
    var _yield$request$get37, data;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) switch (_context56.prev = _context56.next) {
        case 0:
          _context56.next = 2;
          return request$x.get("/api/v5/files/".concat(params.link_id, "/group?link_id=").concat(params.link_id, "&group_id=").concat(params.group_id));
        case 2:
          _yield$request$get37 = _context56.sent;
          data = _yield$request$get37.data;
          return _context56.abrupt("return", data);
        case 5:
        case "end":
          return _context56.stop();
      }
    }, _callee56);
  }));
  return function fetchOutOfGroupsInfo(_x83) {
    return _ref58.apply(this, arguments);
  };
}();

// 获取团队成员
function fetchGroupMemberIds(_x84) {
  return _fetchGroupMemberIds.apply(this, arguments);
}

/*
 * 获取协作发送状态
 * userids: 1111,2222
 */
function _fetchGroupMemberIds() {
  _fetchGroupMemberIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(gid) {
    var _yield$request$get61, data;
    return _regeneratorRuntime.wrap(function _callee106$(_context106) {
      while (1) switch (_context106.prev = _context106.next) {
        case 0:
          _context106.next = 2;
          return request$x.get("/api/v3/groups/".concat(gid, "/members/all"));
        case 2:
          _yield$request$get61 = _context106.sent;
          data = _yield$request$get61.data;
          return _context106.abrupt("return", data);
        case 5:
        case "end":
          return _context106.stop();
      }
    }, _callee106);
  }));
  return _fetchGroupMemberIds.apply(this, arguments);
}
function getToConfirmCollaboration(_x85) {
  return _getToConfirmCollaboration.apply(this, arguments);
}

// 获取上传文件地址
function _getToConfirmCollaboration() {
  _getToConfirmCollaboration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(fileid) {
    var userids,
      _yield$request$get62,
      data,
      _args107 = arguments;
    return _regeneratorRuntime.wrap(function _callee107$(_context107) {
      while (1) switch (_context107.prev = _context107.next) {
        case 0:
          userids = _args107.length > 1 && _args107[1] !== undefined ? _args107[1] : '';
          _context107.next = 3;
          return request$x.get("/api/v5/links/collaborations/to_be_confirmed?fileid=".concat(fileid, "&userids=").concat(userids));
        case 3:
          _yield$request$get62 = _context107.sent;
          data = _yield$request$get62.data;
          return _context107.abrupt("return", data);
        case 6:
        case "end":
          return _context107.stop();
      }
    }, _callee107);
  }));
  return _getToConfirmCollaboration.apply(this, arguments);
}
var fetchUploadFileUrl = function fetchUploadFileUrl(query) {
  return request$x.get('/api/files/upload/request', {
    params: query
  })["catch"](function (err) {
    return err.response;
  });
};

// 上传文件
var setUploadFileCommitInfoDocs = function setUploadFileCommitInfoDocs(file) {
  return request$x.post("/api/v3/groups/".concat(file.groupid, "/files"), file)["catch"](function (err) {
    return err.response;
  });
};
var setUploadFileCommitInfo = function setUploadFileCommitInfo(file, isUpdate) {
  if (isUpdate) {
    return request$x.put('/api/v5/files/file', {
      fileid: file.fileid,
      size: file.size,
      sha1: file.sha1,
      store: file.store,
      etag: file.etag
    })["catch"](function (err) {
      return err.response;
    });
  } else {
    return request$x.post('/api/v5/files/file', file)["catch"](function (err) {
      return err.response;
    });
  }
};
var setDeviceFileCommitInfo = function setDeviceFileCommitInfo(file, isUpdate) {
  if (isUpdate) {
    // 设备目录更新历史版本还是走的file接口
    return request$x.put('/api/v5/files/file', {
      fileid: file.fileid,
      size: file.size,
      sha1: file.sha1,
      store: file.store,
      etag: file.etag
    })["catch"](function (err) {
      return err.response;
    });
  } else {
    return request$x.post('/api/v5/devices/files', file)["catch"](function (err) {
      return err.response;
    });
  }
};
// 获取文件路径
var loadFilePathNoUpdate = function loadFilePathNoUpdate(fileid) {
  return request$x.get("/api/files/".concat(fileid, "/path"))["catch"](function (err) {
    return err.response;
  });
};
var loadFilePathToUpdate = function loadFilePathToUpdate(_ref59) {
  var groupid = _ref59.groupid,
    fileid = _ref59.fileid;
  return request$x.get("/api/v3/groups/".concat(groupid, "/files/").concat(fileid))["catch"](function (err) {
    return err.response;
  });
};
var getFileInfo = function getFileInfo(_ref60) {
  var groupid = _ref60.groupid,
    _ref60$params = _ref60.params,
    params = _ref60$params === void 0 ? {} : _ref60$params;
  return request$x.get("/api/v3/groups/".concat(groupid), {
    params: params
  })["catch"](function (err) {
    return err.response;
  });
};
var getFileInfoAll = function getFileInfoAll(_ref61) {
  var groupid = _ref61.groupid,
    _ref61$params = _ref61.params,
    params = _ref61$params === void 0 ? {} : _ref61$params;
  return request$x.get("/api/v3/groups/".concat(groupid), {
    params: params
  });
};

// 获取文件路径
var getFilePath = /*#__PURE__*/function () {
  var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(gid, fid) {
    var params,
      _yield$request$get38,
      data,
      _args57 = arguments;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) switch (_context57.prev = _context57.next) {
        case 0:
          params = _args57.length > 2 && _args57[2] !== undefined ? _args57[2] : {};
          _context57.next = 3;
          return request$x.get("/api/v3/groups/".concat(gid, "/files/").concat(fid, "/path"), {
            params: params
          });
        case 3:
          _yield$request$get38 = _context57.sent;
          data = _yield$request$get38.data;
          return _context57.abrupt("return", data);
        case 6:
        case "end":
          return _context57.stop();
      }
    }, _callee57);
  }));
  return function getFilePath(_x86, _x87) {
    return _ref62.apply(this, arguments);
  };
}();
var checkFolderWritePermission = function checkFolderWritePermission(_ref63) {
  var groupID = _ref63.groupID,
    folderID = _ref63.folderID;
  return request$x.get("/api/v3/groups/".concat(groupID, "/files/permission/assert"), {
    params: {
      fileid: folderID,
      assert_perm: 'modify',
      parentid: '-1' // 传入parentid为-1,服务端会根据文件id重新获取一次该文件的父id,然后进行权限校验
    }
  })["catch"](function (err) {
    return err.response;
  });
};

// 获取漫游文件
var fetchRoaming = function fetchRoaming(params) {
  return request$x.get('/api/v3/roaming', params);
};

// 根据fileid获取漫游信息
var fetchRoamingInfo = /*#__PURE__*/function () {
  var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(fileid) {
    var _yield$request$get39, data;
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) switch (_context58.prev = _context58.next) {
        case 0:
          _context58.next = 2;
          return request$x.get("/api/files/".concat(fileid, "/roaminginfo"));
        case 2:
          _yield$request$get39 = _context58.sent;
          data = _yield$request$get39.data;
          return _context58.abrupt("return", data && data.roaminginfo);
        case 5:
        case "end":
          return _context58.stop();
      }
    }, _callee58);
  }));
  return function fetchRoamingInfo(_x88) {
    return _ref64.apply(this, arguments);
  };
}();

// 获取团队中的文件列表
var fetchGroupFileList = function fetchGroupFileList(gid, params) {
  return request$x.get("/api/v5/groups/".concat(gid, "/files"), params);
};

// 获取企业中的团队
var fetchCompanyGroups = function fetchCompanyGroups(params) {
  return request$x.get('/api/v5/groups', params);
};

// 获取与我共享列表
var fetchShare = function fetchShare(params) {
  return request$x.get('/api/v5/links', params);
};

// 创建团队
var createTeam = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(params) {
    var data;
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) switch (_context59.prev = _context59.next) {
        case 0:
          if (!params.corp_id) {
            _context59.next = 4;
            break;
          }
          return _context59.abrupt("return", request$x.post('/api/v3/groups', params));
        case 4:
          _context59.prev = 4;
          _context59.next = 7;
          return request$x.post('/kdteam/api/v1/teams', params, {
            baseURL: TWPS
          });
        case 7:
          data = _context59.sent;
          return _context59.abrupt("return", data);
        case 11:
          _context59.prev = 11;
          _context59.t0 = _context59["catch"](4);
          // 由于报错格式不一致，所以需要特殊处理，把 result 的错误信息处理到 msg 中
          if (_context59.t0 && _context59.t0.response && _context59.t0.response.data && !_context59.t0.response.data.msg && _context59.t0.response.data.result) {
            _context59.t0.response.data.msg = _context59.t0.response.data.result;
          }
          throw _context59.t0;
        case 15:
        case "end":
          return _context59.stop();
      }
    }, _callee59, null, [[4, 11]]);
  }));
  return function createTeam(_x89) {
    return _ref65.apply(this, arguments);
  };
}();

// 创建文件夹
var createFolder = /*#__PURE__*/function () {
  var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(params) {
    var _yield$request$post5, data;
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) switch (_context60.prev = _context60.next) {
        case 0:
          _context60.next = 2;
          return request$x.post('/api/v5/files/folder', params);
        case 2:
          _yield$request$post5 = _context60.sent;
          data = _yield$request$post5.data;
          return _context60.abrupt("return", data);
        case 5:
        case "end":
          return _context60.stop();
      }
    }, _callee60);
  }));
  return function createFolder(_x90) {
    return _ref66.apply(this, arguments);
  };
}();

// 添加成员到团队
var addMembersToTeam = /*#__PURE__*/function () {
  var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(_ref67) {
    var _ref67$role, role, users, tid, applyid, userInfo, contacts, _yield$request$post6, data, failList, failMsg, _failList$, name, result, msg;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) switch (_context61.prev = _context61.next) {
        case 0:
          _ref67$role = _ref67.role, role = _ref67$role === void 0 ? 'member' : _ref67$role, users = _ref67.users, tid = _ref67.tid, applyid = _ref67.applyid, userInfo = _ref67.userInfo;
          contacts = {};
          users.forEach(function (item) {
            var _from = item._from,
              _source = item._source;
            var userItemId = parseInt((item === null || item === void 0 ? void 0 : item._id) || (item === null || item === void 0 ? void 0 : item.userid) || (_source === null || _source === void 0 ? void 0 : _source.userid) || (_source === null || _source === void 0 ? void 0 : _source.id));
            var userItemCompanyId = parseInt((_source === null || _source === void 0 ? void 0 : _source.comp_id) || (_source === null || _source === void 0 ? void 0 : _source.company_id) || (item === null || item === void 0 ? void 0 : item.companyId) || 0);
            if (_from === 'latest') {
              if (_source && _source.recent_id) {
                if (!contacts.recent) {
                  contacts.recent = [];
                }
                contacts.recent.push(_source.recent_id);
              }
            } else if (_from === 'userTeamGroup') {
              /**
               * userTeamGroup 代表这个人来自群聊，群聊功能目前只有企业团队开启
               */
              contacts.company = contacts.company || [];
              var target = contacts.company.find(function (v) {
                return v.company_id === 0;
              });
              if (target) {
                target.user_ids.push(userItemId);
              } else {
                contacts.company.push({
                  company_id: userItemCompanyId,
                  user_ids: [userItemId]
                });
              }
            } else if (userInfo.companyid > 0) {
              /*
               * 其余情况为兼容外部联系人需求中/api/v5/groups/${groupid}/members接口的改动，修改成区分企业/个人账号环境下添加成员
               * 企业账号环境下添加企业成员时company_id传用户的companyid，企业账号环境下添加个人成员时也传用户的companyid(值为0)
               */
              if (!contacts.company) {
                contacts.company = [];
              }
              var _target = contacts.company.find(function (v) {
                return v.company_id === userItemCompanyId;
              });
              if (_target) {
                _target.user_ids.push(userItemId);
              } else {
                contacts.company.push({
                  company_id: userItemCompanyId,
                  user_ids: [userItemId]
                });
              }
            } else {
              /*
               * 其余情况为兼容外部联系人需求中/api/v5/groups/${groupid}/members接口的改动，修改成区分企业/个人账号环境下添加成员
               * 个人账号环境下添加企业成员时contacts传company属性，个人账号环境下添加个人成员时contacts传account属性
               */
              if (userItemCompanyId > 0) {
                if (!contacts.company) {
                  contacts.company = [];
                }
                contacts.company.push({
                  company_id: userItemCompanyId,
                  user_ids: [userItemId]
                });
              } else {
                if (!contacts.account) {
                  contacts.account = [];
                }
                contacts.account.push(userItemId);
              }
            }
          });
          _context61.next = 5;
          return request$x.post("/api/v5/groups/".concat(tid, "/members"), {
            contacts: contacts,
            role: role,
            applyid: applyid
          });
        case 5:
          _yield$request$post6 = _context61.sent;
          data = _yield$request$post6.data;
          failList = data.failList;
          failMsg = ''; // 判断是否有添加失败的成员,有则拼接错误信息
          if (failList && failList.length > 0) {
            _failList$ = failList[0], name = _failList$.name, result = _failList$.result, msg = _failList$.msg;
            failMsg = "".concat(name).concat(failList.length > 1 ? "".concat(t('request.drive.txt0')).concat(failList.length).concat(t('request.drive.txt1')) : '').concat(t('request.drive.txt2'));
            failMsg = "".concat(failMsg).concat(result === 'GroupMemberLimit' ? '，' + t('request.drive.txt3') : msg);
          }
          data.failMsg = failMsg;
          return _context61.abrupt("return", data);
        case 12:
        case "end":
          return _context61.stop();
      }
    }, _callee61);
  }));
  return function addMembersToTeam(_x91) {
    return _ref68.apply(this, arguments);
  };
}();
var setSecureTeam = function setSecureTeam(groupid) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // 参数拓展，兼容原有的单groupid入参模式
  var data = {
    groupid: groupid
  };
  if (params.applyid) {
    data.applyid = params.applyid;
  }
  return request$x.post('/api/v5/groups/secure', data);
};
var getSecureTeam = function getSecureTeam(groupid) {
  return request$x.get("/api/v5/groups/".concat(groupid, "/secure"));
};

// 批量更新团队成员权限
var updateFloderPermissonBatch = function updateFloderPermissonBatch(groupId, params) {
  return request$x.put("/api/v5/groups/".concat(groupId, "/members"), _objectSpread$9({}, params));
};

// 批量删除团队成员
var removeTeamMembers = function removeTeamMembers(groupid, params) {
  return request$x["delete"]("/api/v5/groups/".concat(groupid, "/members"), {
    data: _objectSpread$9({}, params)
  });
};

// 转让个人团队
var transferTeam = function transferTeam(groupid, userid) {
  return request$x.put("/api/v5/groups/".concat(groupid, "/normal/groupowner"), {
    new_owner: userid
  });
};

// 转让企业团队
var transferEntTeam = function transferEntTeam(groupid, userid) {
  return request$x.put("api/v5/corpgroups/".concat(groupid, "/owner"), {
    new_owner: userid
  });
};

// 转让共享文件夹
var transferShareFolder = function transferShareFolder(folderid, userid) {
  return request$x.put("/api/v5/sharefolders/".concat(folderid, "/owner"), {
    memberid: userid
  });
};

// 获取文件的缩略图
var getThumbnail = function getThumbnail(opts) {
  var params = opts.params;
  params.fileids = params.fileids.join(',');
  params.review = true;
  return request$x.get('/api/v5/files/pic/thumbnail', opts);
};

// 关闭加密保护
var secureClose = function secureClose(groupid) {
  return request$x.put("/api/v5/groups/".concat(groupid, "/secure/close"), {
    groupid: groupid
  });
};

// 重命名
var renameTeam = /*#__PURE__*/function () {
  var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(params) {
    var _yield$request$put9, data;
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) switch (_context62.prev = _context62.next) {
        case 0:
          _context62.next = 2;
          return request$x.put("/api/v3/groups/".concat(params.tid), params);
        case 2:
          _yield$request$put9 = _context62.sent;
          data = _yield$request$put9.data;
          return _context62.abrupt("return", data);
        case 5:
        case "end":
          return _context62.stop();
      }
    }, _callee62);
  }));
  return function renameTeam(_x92) {
    return _ref69.apply(this, arguments);
  };
}();
var getSecureStatus = /*#__PURE__*/function () {
  var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(groupid) {
    var fids,
      params,
      _yield$request$get40,
      data,
      _args63 = arguments;
    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) switch (_context63.prev = _context63.next) {
        case 0:
          fids = _args63.length > 1 && _args63[1] !== undefined ? _args63[1] : [];
          params = {
            fileids: fids.join(',')
          };
          _context63.next = 4;
          return request$x.get("/api/v5/groups/".concat(groupid, "/files/secure"), {
            params: params
          });
        case 4:
          _yield$request$get40 = _context63.sent;
          data = _yield$request$get40.data;
          return _context63.abrupt("return", data);
        case 7:
        case "end":
          return _context63.stop();
      }
    }, _callee63);
  }));
  return function getSecureStatus(_x93) {
    return _ref70.apply(this, arguments);
  };
}();
var checkteamCreator = /*#__PURE__*/function () {
  var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(groupid) {
    var _yield$request$get41, data;
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) switch (_context64.prev = _context64.next) {
        case 0:
          _context64.next = 2;
          return request$x.get("/api/v5/groups/".concat(groupid, "/members/check/owner"));
        case 2:
          _yield$request$get41 = _context64.sent;
          data = _yield$request$get41.data;
          return _context64.abrupt("return", data);
        case 5:
        case "end":
          return _context64.stop();
      }
    }, _callee64);
  }));
  return function checkteamCreator(_x94) {
    return _ref71.apply(this, arguments);
  };
}();
// 获取团队成员
var fetchTeamMembers = /*#__PURE__*/function () {
  var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(gid, options) {
    var _yield$request$get42, data;
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) switch (_context65.prev = _context65.next) {
        case 0:
          _context65.next = 2;
          return request$x.get("/api/v3/groups/".concat(gid, "/members"), options);
        case 2:
          _yield$request$get42 = _context65.sent;
          data = _yield$request$get42.data;
          return _context65.abrupt("return", data);
        case 5:
        case "end":
          return _context65.stop();
      }
    }, _callee65);
  }));
  return function fetchTeamMembers(_x95, _x96) {
    return _ref72.apply(this, arguments);
  };
}();

/**
 * 获取单个文件信息
 * @param id fid或者sid或cid
 * @returns {Promise<*>} 文件信息对象
 */
var fetchFile = /*#__PURE__*/function () {
  var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(id, sid) {
    var res, fileInfo, _yield$request$get43, data;
    return _regeneratorRuntime.wrap(function _callee66$(_context66) {
      while (1) switch (_context66.prev = _context66.next) {
        case 0:
          if (!/^\d+$/.test("".concat(id))) {
            _context66.next = 14;
            break;
          }
          if (!sid) {
            _context66.next = 7;
            break;
          }
          _context66.next = 4;
          return fetchFileMetadataWithFolderLink(id, sid);
        case 4:
          _context66.t0 = _context66.sent;
          _context66.next = 10;
          break;
        case 7:
          _context66.next = 9;
          return fetchFileMetadata(id);
        case 9:
          _context66.t0 = _context66.sent;
        case 10:
          res = _context66.t0;
          fileInfo = res.fileinfo;
          _context66.next = 19;
          break;
        case 14:
          _context66.next = 16;
          return request$x.get("/api/v5/links/".concat(id));
        case 16:
          _yield$request$get43 = _context66.sent;
          data = _yield$request$get43.data;
          fileInfo = data.fileinfo;
        case 19:
          return _context66.abrupt("return", fileInfo);
        case 20:
        case "end":
          return _context66.stop();
      }
    }, _callee66);
  }));
  return function fetchFile(_x97, _x98) {
    return _ref73.apply(this, arguments);
  };
}();

// 获取私密文件夹信息
var fetchSecretFolder = /*#__PURE__*/function () {
  var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67() {
    var _yield$request$get44, data;
    return _regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) switch (_context67.prev = _context67.next) {
        case 0:
          _context67.next = 2;
          return request$x.get('/api/v3/groups/secret');
        case 2:
          _yield$request$get44 = _context67.sent;
          data = _yield$request$get44.data;
          return _context67.abrupt("return", data);
        case 5:
        case "end":
          return _context67.stop();
      }
    }, _callee67);
  }));
  return function fetchSecretFolder() {
    return _ref74.apply(this, arguments);
  };
}();

// 解锁私密文件夹
var unLockSecretFolder = /*#__PURE__*/function () {
  var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(password) {
    var _yield$request$put10, data;
    return _regeneratorRuntime.wrap(function _callee68$(_context68) {
      while (1) switch (_context68.prev = _context68.next) {
        case 0:
          _context68.next = 2;
          return request$x.put('/api/v3/groups/secret/unlock', {
            password: password
          });
        case 2:
          _yield$request$put10 = _context68.sent;
          data = _yield$request$put10.data;
          return _context68.abrupt("return", data);
        case 5:
        case "end":
          return _context68.stop();
      }
    }, _callee68);
  }));
  return function unLockSecretFolder(_x99) {
    return _ref75.apply(this, arguments);
  };
}();

// 分享文件夹内文件另存至
var linkFolderSaveAs = /*#__PURE__*/function () {
  var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(sid, params) {
    var _yield$request$post7, data;
    return _regeneratorRuntime.wrap(function _callee69$(_context69) {
      while (1) switch (_context69.prev = _context69.next) {
        case 0:
          _context69.next = 2;
          return request$x.post("/api/v5/folder_link_tree/".concat(sid, "/files/save_as/batch"), params);
        case 2:
          _yield$request$post7 = _context69.sent;
          data = _yield$request$post7.data;
          return _context69.abrupt("return", data);
        case 5:
        case "end":
          return _context69.stop();
      }
    }, _callee69);
  }));
  return function linkFolderSaveAs(_x100, _x101) {
    return _ref76.apply(this, arguments);
  };
}();

// 获取私密文件夹的锁定状态
var getSecretFolderLockStatus = /*#__PURE__*/function () {
  var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70() {
    var _yield$request$get45, data;
    return _regeneratorRuntime.wrap(function _callee70$(_context70) {
      while (1) switch (_context70.prev = _context70.next) {
        case 0:
          _context70.next = 2;
          return request$x.get('/api/v3/groups/secret/lock');
        case 2:
          _yield$request$get45 = _context70.sent;
          data = _yield$request$get45.data;
          return _context70.abrupt("return", data);
        case 5:
        case "end":
          return _context70.stop();
      }
    }, _callee70);
  }));
  return function getSecretFolderLockStatus() {
    return _ref77.apply(this, arguments);
  };
}();

// 分享文件夹内文件另存至我的设备
var linkFolderSaveAsDevice = /*#__PURE__*/function () {
  var _ref78 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(sid, params) {
    var _yield$request$post8, data;
    return _regeneratorRuntime.wrap(function _callee71$(_context71) {
      while (1) switch (_context71.prev = _context71.next) {
        case 0:
          _context71.next = 2;
          return request$x.post("/api/v5/folder_link_tree/".concat(sid, "/files/devices/save_as"), params);
        case 2:
          _yield$request$post8 = _context71.sent;
          data = _yield$request$post8.data;
          return _context71.abrupt("return", data);
        case 5:
        case "end":
          return _context71.stop();
      }
    }, _callee71);
  }));
  return function linkFolderSaveAsDevice(_x102, _x103) {
    return _ref78.apply(this, arguments);
  };
}();

// 获取团队信息
var fetchTeamInfo = /*#__PURE__*/function () {
  var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(id, options) {
    var _yield$request$get46, data;
    return _regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) switch (_context72.prev = _context72.next) {
        case 0:
          _context72.next = 2;
          return request$x.get("/api/v3/groups/".concat(id), options);
        case 2:
          _yield$request$get46 = _context72.sent;
          data = _yield$request$get46.data;
          return _context72.abrupt("return", data);
        case 5:
        case "end":
          return _context72.stop();
      }
    }, _callee72);
  }));
  return function fetchTeamInfo(_x104, _x105) {
    return _ref79.apply(this, arguments);
  };
}();

// 查询文件的标签信息
var checkFileTag = /*#__PURE__*/function () {
  var _ref80 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(fileid) {
    var tagid, _yield$request$get47, data;
    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
      while (1) switch (_context73.prev = _context73.next) {
        case 0:
          tagid = 1; // 仅支持协作标记，值为1
          _context73.next = 3;
          return request$x.get("/api/v5/tags/files/".concat(fileid, "/tag/").concat(tagid));
        case 3:
          _yield$request$get47 = _context73.sent;
          data = _yield$request$get47.data;
          return _context73.abrupt("return", data);
        case 6:
        case "end":
          return _context73.stop();
      }
    }, _callee73);
  }));
  return function checkFileTag(_x106) {
    return _ref80.apply(this, arguments);
  };
}();

// 打标签
var setFileTag = /*#__PURE__*/function () {
  var _ref81 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(fileid) {
    var source,
      tagid,
      _args74 = arguments;
    return _regeneratorRuntime.wrap(function _callee74$(_context74) {
      while (1) switch (_context74.prev = _context74.next) {
        case 0:
          source = _args74.length > 1 && _args74[1] !== undefined ? _args74[1] : 36;
          tagid = 1; // 仅支持协作标记，值为1
          _context74.next = 4;
          return request$x.post("/api/v5/tags/files/".concat(fileid, "/tag/").concat(tagid), {
            source: source
          });
        case 4:
        case "end":
          return _context74.stop();
      }
    }, _callee74);
  }));
  return function setFileTag(_x107) {
    return _ref81.apply(this, arguments);
  };
}();

// 获取指定文件夹创建的文件收集消息
function getFileCollectTaskByFileId(_x108) {
  return _getFileCollectTaskByFileId.apply(this, arguments);
}

// 获取“自动备份”文件列表
function _getFileCollectTaskByFileId() {
  _getFileCollectTaskByFileId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108(fileId) {
    var _yield$request$get63, data;
    return _regeneratorRuntime.wrap(function _callee108$(_context108) {
      while (1) switch (_context108.prev = _context108.next) {
        case 0:
          _context108.next = 2;
          return request$x.get("/api/v5/files/collect/folder/".concat(fileId));
        case 2:
          _yield$request$get63 = _context108.sent;
          data = _yield$request$get63.data;
          return _context108.abrupt("return", data);
        case 5:
        case "end":
          return _context108.stop();
      }
    }, _callee108);
  }));
  return _getFileCollectTaskByFileId.apply(this, arguments);
}
var fetchCorpTmp = /*#__PURE__*/function () {
  var _ref82 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(cid, opts) {
    var _yield$request$get48, data;
    return _regeneratorRuntime.wrap(function _callee75$(_context75) {
      while (1) switch (_context75.prev = _context75.next) {
        case 0:
          _context75.next = 2;
          return request$x.get("/api/v5/groups/tmp/corp/".concat(cid, "/devices"), opts);
        case 2:
          _yield$request$get48 = _context75.sent;
          data = _yield$request$get48.data;
          return _context75.abrupt("return", data);
        case 5:
        case "end":
          return _context75.stop();
      }
    }, _callee75);
  }));
  return function fetchCorpTmp(_x109, _x110) {
    return _ref82.apply(this, arguments);
  };
}();

// 查询自定义标签
var fetchLabels = function fetchLabels() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request$x.post('/api/v5/search/utag/search_file_tag', params);
};

// 获取指定文件的标签
var fetchFileLabels = function fetchFileLabels() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request$x.post("".concat(DRIVE, "/api/v5/utags/objs/tags"), params);
};

// 创建自定义标签
var createLabels = function createLabels() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request$x.post('/api/v5/utags', params);
};

// 获取指定团队列表的数据信息
var fetchGroupsInfoV5 = function fetchGroupsInfoV5() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request$x.get('/api/v5/groups/infos', {
    params: params
  });
};

// 批量更新标签绑定文件
var batchUpdateLabels = function batchUpdateLabels() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request$x.post('/api/v5/utags/objs/batch', params);
};

// 获取安全文档信息
var fetchSecureFile = /*#__PURE__*/function () {
  var _ref83 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(groupid, fileid) {
    var _yield$request$get49, data;
    return _regeneratorRuntime.wrap(function _callee76$(_context76) {
      while (1) switch (_context76.prev = _context76.next) {
        case 0:
          _context76.next = 2;
          return request$x.get("/api/v5/groups/".concat(groupid, "/files/").concat(fileid, "/secure"));
        case 2:
          _yield$request$get49 = _context76.sent;
          data = _yield$request$get49.data;
          return _context76.abrupt("return", data);
        case 5:
        case "end":
          return _context76.stop();
      }
    }, _callee76);
  }));
  return function fetchSecureFile(_x111, _x112) {
    return _ref83.apply(this, arguments);
  };
}();

// 向指定历史版本打标签
var setHistoriesTag = /*#__PURE__*/function () {
  var _ref85 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(_ref84) {
    var fid, data;
    return _regeneratorRuntime.wrap(function _callee77$(_context77) {
      while (1) switch (_context77.prev = _context77.next) {
        case 0:
          fid = _ref84.fid, data = _objectWithoutProperties(_ref84, _excluded4$1);
          _context77.next = 3;
          return request$x.post("/api/v5/files/".concat(fid, "/histories/tag"), data);
        case 3:
        case "end":
          return _context77.stop();
      }
    }, _callee77);
  }));
  return function setHistoriesTag(_x113) {
    return _ref85.apply(this, arguments);
  };
}();

// 个人团队开通普通应用
var openApps = function openApps(params) {
  return request$x.post('kdteam/api/v1/openapps', params, {
    baseURL: TWPS
  });
};

// 个人团队开通自建应用
var openSelfBuiltApps = function openSelfBuiltApps(params) {
  return request$x.post('/api/datacenter/v1/applications', params, {
    baseURL: DC
  });
};
// 批量修改协作成员权限
var setCollaboratorsPermission = /*#__PURE__*/function () {
  var _ref86 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(sid, permission, memberIds) {
    var params, _yield$request$put11, data;
    return _regeneratorRuntime.wrap(function _callee78$(_context78) {
      while (1) switch (_context78.prev = _context78.next) {
        case 0:
          params = {
            permission: permission,
            sid: sid,
            member_ids: memberIds
          };
          if (permission === 'comment') {
            params.ext_perm_list = ['comment'];
            params.permission = 'read';
          }
          _context78.next = 4;
          return request$x.put("/api/v5/links/".concat(sid, "/collaborators"), params);
        case 4:
          _yield$request$put11 = _context78.sent;
          data = _yield$request$put11.data;
          return _context78.abrupt("return", data);
        case 7:
        case "end":
          return _context78.stop();
      }
    }, _callee78);
  }));
  return function setCollaboratorsPermission(_x114, _x115, _x116) {
    return _ref86.apply(this, arguments);
  };
}();

// 批量删除协作成员权限
var deleteCollaborators = /*#__PURE__*/function () {
  var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(sid, memberIds) {
    var _yield$request$delete2, data;
    return _regeneratorRuntime.wrap(function _callee79$(_context79) {
      while (1) switch (_context79.prev = _context79.next) {
        case 0:
          _context79.next = 2;
          return request$x["delete"]("/api/v5/links/".concat(sid, "/collaborators"), {
            data: {
              sid: sid,
              member_ids: memberIds
            }
          });
        case 2:
          _yield$request$delete2 = _context79.sent;
          data = _yield$request$delete2.data;
          return _context79.abrupt("return", data);
        case 5:
        case "end":
          return _context79.stop();
      }
    }, _callee79);
  }));
  return function deleteCollaborators(_x117, _x118) {
    return _ref87.apply(this, arguments);
  };
}();

// 转让文档所有者
var transferFileOwner = /*#__PURE__*/function () {
  var _ref88 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(fid, userid) {
    var _yield$request$put12, data;
    return _regeneratorRuntime.wrap(function _callee80$(_context80) {
      while (1) switch (_context80.prev = _context80.next) {
        case 0:
          _context80.next = 2;
          return request$x.put("/api/v5/files/".concat(fid, "/owner"), {
            userid: userid
          });
        case 2:
          _yield$request$put12 = _context80.sent;
          data = _yield$request$put12.data;
          return _context80.abrupt("return", data);
        case 5:
        case "end":
          return _context80.stop();
      }
    }, _callee80);
  }));
  return function transferFileOwner(_x119, _x120) {
    return _ref88.apply(this, arguments);
  };
}();
var hasTag = /*#__PURE__*/function () {
  var _ref89 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(tagKey, fid) {
    var _yield$request$get50, data;
    return _regeneratorRuntime.wrap(function _callee81$(_context81) {
      while (1) switch (_context81.prev = _context81.next) {
        case 0:
          _context81.next = 2;
          return request$x.get("/api/v3/tags/".concat(tagKey, "/files"), {
            params: {
              fileids: fid
            }
          });
        case 2:
          _yield$request$get50 = _context81.sent;
          data = _yield$request$get50.data;
          return _context81.abrupt("return", data && data.item_map && !!data.item_map[fid]);
        case 5:
        case "end":
          return _context81.stop();
      }
    }, _callee81);
  }));
  return function hasTag(_x121, _x122) {
    return _ref89.apply(this, arguments);
  };
}();
var addTag = function addTag(tagKey, fid, groupid) {
  return request$x.post("api/v3/tags/".concat(tagKey, "/items"), {
    fileid: fid,
    tagid: tagKey,
    groupid: groupid,
    source: 'file'
  });
};
var getFavorDestination = /*#__PURE__*/function () {
  var _ref90 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(fid) {
    var _yield$request$get51, favorites, i, favorFile;
    return _regeneratorRuntime.wrap(function _callee82$(_context82) {
      while (1) switch (_context82.prev = _context82.next) {
        case 0:
          _context82.next = 2;
          return request$x.get('/api/v3/favorite');
        case 2:
          _yield$request$get51 = _context82.sent;
          favorites = _yield$request$get51.data.favorites;
          if (!(!favorites || favorites.length === 0)) {
            _context82.next = 6;
            break;
          }
          return _context82.abrupt("return");
        case 6:
          i = 0;
        case 7:
          if (!(i < favorites.length)) {
            _context82.next = 14;
            break;
          }
          favorFile = favorites[i];
          if (!(favorFile.fileid === fid)) {
            _context82.next = 11;
            break;
          }
          return _context82.abrupt("return", "".concat(i === 0 ? 0 : favorites[i - 1].id, ",").concat(i === favorites.length - 1 ? 0 : favorites[i + 1].id));
        case 11:
          i++;
          _context82.next = 7;
          break;
        case 14:
        case "end":
          return _context82.stop();
      }
    }, _callee82);
  }));
  return function getFavorDestination(_x123) {
    return _ref90.apply(this, arguments);
  };
}();
var addFavorFile = /*#__PURE__*/function () {
  var _ref91 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83(params) {
    return _regeneratorRuntime.wrap(function _callee83$(_context83) {
      while (1) switch (_context83.prev = _context83.next) {
        case 0:
          _context83.next = 2;
          return request$x.post('/api/v3/favorite', params);
        case 2:
          return _context83.abrupt("return", _context83.sent);
        case 3:
        case "end":
          return _context83.stop();
      }
    }, _callee83);
  }));
  return function addFavorFile(_x124) {
    return _ref91.apply(this, arguments);
  };
}();

// 打开团队文件在线标签
var openTeamMultiEditTag = /*#__PURE__*/function () {
  var _ref92 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(groupId, tagId, source) {
    var _yield$request$post9, data;
    return _regeneratorRuntime.wrap(function _callee84$(_context84) {
      while (1) switch (_context84.prev = _context84.next) {
        case 0:
          _context84.next = 2;
          return request$x.post("/api/v5/tags/groups/".concat(groupId, "/tag/").concat(tagId), source);
        case 2:
          _yield$request$post9 = _context84.sent;
          data = _yield$request$post9.data;
          return _context84.abrupt("return", data);
        case 5:
        case "end":
          return _context84.stop();
      }
    }, _callee84);
  }));
  return function openTeamMultiEditTag(_x125, _x126, _x127) {
    return _ref92.apply(this, arguments);
  };
}();

// 关闭团队文件在线标签
var closeTeamMultiEditTag = /*#__PURE__*/function () {
  var _ref93 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(groupId, tagId, source) {
    var _yield$request$delete3, data;
    return _regeneratorRuntime.wrap(function _callee85$(_context85) {
      while (1) switch (_context85.prev = _context85.next) {
        case 0:
          _context85.next = 2;
          return request$x["delete"]("/api/v5/tags/groups/".concat(groupId, "/tag/").concat(tagId), {
            data: source
          });
        case 2:
          _yield$request$delete3 = _context85.sent;
          data = _yield$request$delete3.data;
          return _context85.abrupt("return", data);
        case 5:
        case "end":
          return _context85.stop();
      }
    }, _callee85);
  }));
  return function closeTeamMultiEditTag(_x128, _x129, _x130) {
    return _ref93.apply(this, arguments);
  };
}();

// 查询单个团队的在线标签信息
var getTeamMultiEditTagInfo = /*#__PURE__*/function () {
  var _ref94 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(groupId, tagId) {
    var _yield$request$get52, data;
    return _regeneratorRuntime.wrap(function _callee86$(_context86) {
      while (1) switch (_context86.prev = _context86.next) {
        case 0:
          _context86.next = 2;
          return request$x.get("/api/v5/tags/groups/".concat(groupId, "/tag/").concat(tagId));
        case 2:
          _yield$request$get52 = _context86.sent;
          data = _yield$request$get52.data;
          return _context86.abrupt("return", data);
        case 5:
        case "end":
          return _context86.stop();
      }
    }, _callee86);
  }));
  return function getTeamMultiEditTagInfo(_x131, _x132) {
    return _ref94.apply(this, arguments);
  };
}();

// 另存为
var applications = /*#__PURE__*/function () {
  var _ref95 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(params) {
    var _yield$request$post10, data;
    return _regeneratorRuntime.wrap(function _callee87$(_context87) {
      while (1) switch (_context87.prev = _context87.next) {
        case 0:
          // 兼容评论权限
          if (params.permission === 'comment') {
            params.ext_perm_list = ['comment'];
            params.permission = 'read';
          }
          _context87.next = 3;
          return request$x.post('/api/v5/links/applications', params);
        case 3:
          _yield$request$post10 = _context87.sent;
          data = _yield$request$post10.data;
          return _context87.abrupt("return", data);
        case 6:
        case "end":
          return _context87.stop();
      }
    }, _callee87);
  }));
  return function applications(_x133) {
    return _ref95.apply(this, arguments);
  };
}();
var fetchEditorShowTang = /*#__PURE__*/function () {
  var _ref96 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(fileid, params) {
    var _yield$request$get53, data;
    return _regeneratorRuntime.wrap(function _callee88$(_context88) {
      while (1) switch (_context88.prev = _context88.next) {
        case 0:
          _context88.next = 2;
          return request$x.get("/api/v3/editor/showtang/".concat(fileid), {
            params: params
          });
        case 2:
          _yield$request$get53 = _context88.sent;
          data = _yield$request$get53.data;
          return _context88.abrupt("return", data);
        case 5:
        case "end":
          return _context88.stop();
      }
    }, _callee88);
  }));
  return function fetchEditorShowTang(_x134, _x135) {
    return _ref96.apply(this, arguments);
  };
}();
var createUserRedirect = /*#__PURE__*/function () {
  var _ref97 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(url) {
    var _yield$request$post11, data;
    return _regeneratorRuntime.wrap(function _callee89$(_context89) {
      while (1) switch (_context89.prev = _context89.next) {
        case 0:
          _context89.next = 2;
          return request$x.post('/api/users/redirect', {
            cb: url
          });
        case 2:
          _yield$request$post11 = _context89.sent;
          data = _yield$request$post11.data;
          return _context89.abrupt("return", data);
        case 5:
        case "end":
          return _context89.stop();
      }
    }, _callee89);
  }));
  return function createUserRedirect(_x136) {
    return _ref97.apply(this, arguments);
  };
}();
var batchFilesDownload = /*#__PURE__*/function () {
  var _ref98 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90(gid, target) {
    var _yield$request$post12, data;
    return _regeneratorRuntime.wrap(function _callee90$(_context90) {
      while (1) switch (_context90.prev = _context90.next) {
        case 0:
          _context90.next = 2;
          return request$x.post("/api/v3/groups/".concat(gid, "/files/batch/download"), {
            fileids: target
          });
        case 2:
          _yield$request$post12 = _context90.sent;
          data = _yield$request$post12.data;
          return _context90.abrupt("return", data);
        case 5:
        case "end":
          return _context90.stop();
      }
    }, _callee90);
  }));
  return function batchFilesDownload(_x137, _x138) {
    return _ref98.apply(this, arguments);
  };
}();
var createUsersRedirect = /*#__PURE__*/function () {
  var _ref99 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(url) {
    var _yield$request$post13, data;
    return _regeneratorRuntime.wrap(function _callee91$(_context91) {
      while (1) switch (_context91.prev = _context91.next) {
        case 0:
          _context91.next = 2;
          return request$x.post('/api/users/redirect', {
            cb: url
          });
        case 2:
          _yield$request$post13 = _context91.sent;
          data = _yield$request$post13.data;
          return _context91.abrupt("return", data);
        case 5:
        case "end":
          return _context91.stop();
      }
    }, _callee91);
  }));
  return function createUsersRedirect(_x139) {
    return _ref99.apply(this, arguments);
  };
}();

// 获取常用列表
var getFavors = function getFavors() {
  return request$x.get('/api/v3/favorite');
};
// 添加到常用
var postFavor = function postFavor(data) {
  return request$x.post('/api/v3/favorite', data);
};
// 从常用删除
var deleteFavor = function deleteFavor(favorId) {
  return request$x["delete"]("/api/v3/favorite/".concat(favorId));
};
// 创建标签
var createTag = function createTag(data) {
  return request$x.post("/api/v5/utags", data);
};

// 查询标签
var getTagListByPage = function getTagListByPage(params) {
  return request$x.get("/api/v5/utags", {
    params: params
  });
};

// 删除标签
var deleteTagById = function deleteTagById(tagId) {
  return request$x["delete"]("/api/v5/utags/".concat(tagId));
};

// 修改标签
var updateTagById = function updateTagById(tagId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request$x.put("/api/v5/utags/".concat(tagId), params);
};

// 创建或修改对象
var updateObjTag = function updateObjTag(tagId, objId) {
  var objType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var data = _objectSpread$9({
    obj_id: objId,
    obj_type: objType,
    tag_id: tagId
  }, params);
  return request$x.put("/api/v5/utags/".concat(tagId, "/objs"), data);
};
// 删除对象
var deleteObjTag = function deleteObjTag(tagId, objId) {
  var objType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var data = {
    obj_id: objId,
    obj_type: objType
  };
  return request$x["delete"]("/api/v5/utags/".concat(tagId, "/objs"), {
    data: data
  });
};

/**
 * 查询单个对象标签
 * @param objId 对象ID
 * @param objType 对象类型(1-文件,2-团队),默认"1-文件"
 * @returns {Promise<never>}
 */
var getTagsForObj = function getTagsForObj(objId) {
  var objType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var data = {
    objs: [{
      obj_id: objId,
      obj_type: objType
    }]
  };
  return request$x.post("/api/v5/utags/objs/tags", data);
};
var postAppealFile = function postAppealFile(params) {
  return requestDocs$2.post("/api/kdocs/fcheck/".concat(params.id, "/appeal"), params); // 兼容评论、文档、弹幕申诉
};

// 查询对象
var getOjbsByTagId = function getOjbsByTagId(tagId, params) {
  return request$x.get("/api/v5/utags/".concat(tagId, "/objs"), {
    params: params
  });
};

// （批量标记对应的历史版本，防止被合并，无权限校验）
var markHistories = function markHistories(data) {
  return request$x.post("/api/v5/developer/histories/tags", data);
};

// 创建对象
var createObjTag = function createObjTag() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request$x.put("/api/v5/utags/".concat(data.tag_id, "/objs"), data);
};

// 创建一个新的空文件
var createNewEmpty = function createNewEmpty() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request$x.post("/api/v3/groups/".concat(data.groupid, "/files/new_empty"), data);
};

// 获取快速访问标签文件列表
var getQuickTag = /*#__PURE__*/function () {
  var _ref100 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92() {
    var _yield$request$get54, data;
    return _regeneratorRuntime.wrap(function _callee92$(_context92) {
      while (1) switch (_context92.prev = _context92.next) {
        case 0:
          _context92.prev = 0;
          _context92.next = 3;
          return request$x.get('/api/v5/tags/qc/items');
        case 3:
          _yield$request$get54 = _context92.sent;
          data = _yield$request$get54.data;
          return _context92.abrupt("return", data && data.items.filter(function (item) {
            return ['group', 'file'].includes(item.type);
          }));
        case 8:
          _context92.prev = 8;
          _context92.t0 = _context92["catch"](0);
          return _context92.abrupt("return", null);
        case 11:
        case "end":
          return _context92.stop();
      }
    }, _callee92, null, [[0, 8]]);
  }));
  return function getQuickTag() {
    return _ref100.apply(this, arguments);
  };
}();

// 添加快速访问标签
var addQuickTag = /*#__PURE__*/function () {
  var _ref101 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(groupid, fileid) {
    var _yield$request$post14, data;
    return _regeneratorRuntime.wrap(function _callee93$(_context93) {
      while (1) switch (_context93.prev = _context93.next) {
        case 0:
          _context93.next = 2;
          return request$x.post('/api/v5/tags/qc/item', {
            dst: '0,1',
            type: 'file',
            fileid: fileid,
            groupid: groupid
          });
        case 2:
          _yield$request$post14 = _context93.sent;
          data = _yield$request$post14.data;
          return _context93.abrupt("return", data);
        case 5:
        case "end":
          return _context93.stop();
      }
    }, _callee93);
  }));
  return function addQuickTag(_x140, _x141) {
    return _ref101.apply(this, arguments);
  };
}();

// 删除快速访问标签
var deleteQuickTag = /*#__PURE__*/function () {
  var _ref102 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(id) {
    return _regeneratorRuntime.wrap(function _callee94$(_context94) {
      while (1) switch (_context94.prev = _context94.next) {
        case 0:
          _context94.next = 2;
          return request$x["delete"]("/api/v5/tags/qc/item/".concat(id));
        case 2:
        case "end":
          return _context94.stop();
      }
    }, _callee94);
  }));
  return function deleteQuickTag(_x142) {
    return _ref102.apply(this, arguments);
  };
}();

// 添加待处理标签
var addPendingTag = /*#__PURE__*/function () {
  var _ref103 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(groupid, fileid) {
    var _yield$request$post15, data;
    return _regeneratorRuntime.wrap(function _callee95$(_context95) {
      while (1) switch (_context95.prev = _context95.next) {
        case 0:
          _context95.next = 2;
          return request$x.post('api/v3/tags/2/items', {
            groupid: groupid,
            fileid: fileid,
            source: 'file'
          });
        case 2:
          _yield$request$post15 = _context95.sent;
          data = _yield$request$post15.data;
          return _context95.abrupt("return", data);
        case 5:
        case "end":
          return _context95.stop();
      }
    }, _callee95);
  }));
  return function addPendingTag(_x143, _x144) {
    return _ref103.apply(this, arguments);
  };
}();

// 移除待处理标签
var deletePendingTag = /*#__PURE__*/function () {
  var _ref104 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(id) {
    return _regeneratorRuntime.wrap(function _callee96$(_context96) {
      while (1) switch (_context96.prev = _context96.next) {
        case 0:
          _context96.next = 2;
          return request$x["delete"]("/api/v3/tags/items/".concat(id));
        case 2:
        case "end":
          return _context96.stop();
      }
    }, _callee96);
  }));
  return function deletePendingTag(_x145) {
    return _ref104.apply(this, arguments);
  };
}();

// 查询文档是否有待处理标签
var isHavePendingTag = /*#__PURE__*/function () {
  var _ref105 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97(fileid) {
    var _yield$request$get55, data;
    return _regeneratorRuntime.wrap(function _callee97$(_context97) {
      while (1) switch (_context97.prev = _context97.next) {
        case 0:
          _context97.next = 2;
          return request$x.get("/api/v3/tags/2/files?fileids=".concat(fileid));
        case 2:
          _yield$request$get55 = _context97.sent;
          data = _yield$request$get55.data;
          return _context97.abrupt("return", data);
        case 5:
        case "end":
          return _context97.stop();
      }
    }, _callee97);
  }));
  return function isHavePendingTag(_x146) {
    return _ref105.apply(this, arguments);
  };
}();

// 查询用户是否是待处理的存量用户
var isUserPendingTag = /*#__PURE__*/function () {
  var _ref106 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98() {
    var _yield$request$get56, data;
    return _regeneratorRuntime.wrap(function _callee98$(_context98) {
      while (1) switch (_context98.prev = _context98.next) {
        case 0:
          _context98.prev = 0;
          _context98.next = 3;
          return request$x.get('/api/v3/tags/2/items?source=group,folder,file,link_file');
        case 3:
          _yield$request$get56 = _context98.sent;
          data = _yield$request$get56.data;
          return _context98.abrupt("return", data);
        case 8:
          _context98.prev = 8;
          _context98.t0 = _context98["catch"](0);
          return _context98.abrupt("return", null);
        case 11:
        case "end":
          return _context98.stop();
      }
    }, _callee98, null, [[0, 8]]);
  }));
  return function isUserPendingTag() {
    return _ref106.apply(this, arguments);
  };
}();

// 查询关联账号下的共享文件夹列表
var getMineShareFolders = /*#__PURE__*/function () {
  var _ref107 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99(params) {
    var _yield$request$get57, data;
    return _regeneratorRuntime.wrap(function _callee99$(_context99) {
      while (1) switch (_context99.prev = _context99.next) {
        case 0:
          _context99.next = 2;
          return request$x.get('api/v5/links/mine/link_folders', {
            params: params
          });
        case 2:
          _yield$request$get57 = _context99.sent;
          data = _yield$request$get57.data;
          return _context99.abrupt("return", data);
        case 5:
        case "end":
          return _context99.stop();
      }
    }, _callee99);
  }));
  return function getMineShareFolders(_x147) {
    return _ref107.apply(this, arguments);
  };
}();

// 根据sid获取文件信息和所有者信息
var fetchApproveFileInfo = /*#__PURE__*/function () {
  var _ref108 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(sid, params) {
    var _yield$request$get58, _yield$request$get58$, approverInfo, fileinfo, _e$response, _e$response2, extra;
    return _regeneratorRuntime.wrap(function _callee100$(_context100) {
      while (1) switch (_context100.prev = _context100.next) {
        case 0:
          _context100.prev = 0;
          _context100.next = 3;
          return request$x.get("/api/v5/links/".concat(sid), params);
        case 3:
          _yield$request$get58 = _context100.sent;
          _yield$request$get58$ = _yield$request$get58.data;
          approverInfo = _yield$request$get58$.approver_info;
          fileinfo = _yield$request$get58$.fileinfo;
          return _context100.abrupt("return", {
            approverAvatar: approverInfo.approver_avatar,
            approverId: approverInfo.approver_id,
            approverNickname: approverInfo.approver_nickname,
            fileName: fileinfo.fname
          });
        case 10:
          _context100.prev = 10;
          _context100.t0 = _context100["catch"](0);
          if (!((_context100.t0 === null || _context100.t0 === void 0 || (_e$response = _context100.t0.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.result) === 'linkClosed' || (_context100.t0 === null || _context100.t0 === void 0 || (_e$response2 = _context100.t0.response) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.data) === null || _e$response2 === void 0 ? void 0 : _e$response2.result) === 'permissionDenied')) {
            _context100.next = 17;
            break;
          }
          extra = _context100.t0.response.data.extra;
          return _context100.abrupt("return", {
            approverAvatar: extra.approver_avatar,
            approverId: extra.approver_id,
            approverNickname: extra.approver_nickname,
            fileName: extra.file_name
          });
        case 17:
          throw _context100.t0;
        case 18:
        case "end":
          return _context100.stop();
      }
    }, _callee100, null, [[0, 10]]);
  }));
  return function fetchApproveFileInfo(_x148, _x149) {
    return _ref108.apply(this, arguments);
  };
}();

// 获取路径
var getFileFullPath = /*#__PURE__*/function () {
  var _ref109 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(gid, fid) {
    return _regeneratorRuntime.wrap(function _callee101$(_context101) {
      while (1) switch (_context101.prev = _context101.next) {
        case 0:
          _context101.next = 2;
          return request$x.get("/api/v3/groups/".concat(gid, "/files/").concat(fid, "/path"));
        case 2:
          return _context101.abrupt("return", _context101.sent);
        case 3:
        case "end":
          return _context101.stop();
      }
    }, _callee101);
  }));
  return function getFileFullPath(_x150, _x151) {
    return _ref109.apply(this, arguments);
  };
}();

// 获取云文档文件路径
function fetchConvertPageDirInfo(_x152) {
  return _fetchConvertPageDirInfo.apply(this, arguments);
}
function _fetchConvertPageDirInfo() {
  _fetchConvertPageDirInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109(_ref110) {
    var groupid, fid, filePath, _yield$getFileFullPat, data, _ref111, corpName, groupName, path;
    return _regeneratorRuntime.wrap(function _callee109$(_context109) {
      while (1) switch (_context109.prev = _context109.next) {
        case 0:
          groupid = _ref110.groupid, fid = _ref110.fid;
          filePath = [];
          _context109.prev = 2;
          _context109.next = 5;
          return getFileFullPath(groupid, fid);
        case 5:
          _yield$getFileFullPat = _context109.sent;
          data = _yield$getFileFullPat.data;
          _ref111 = data || {}, corpName = _ref111.corp_name, groupName = _ref111.group_name, path = _ref111.path;
          filePath = [corpName,
          // 企业名称
          groupName === '我的企业文档' ? t('logic.DocInfo.myCloudDocs') : groupName].concat(_toConsumableArray(path.map(function (_ref112) {
            var folderName = _ref112.folder_name;
            return folderName;
          }))).filter(function (pathName) {
            return pathName;
          }); // 过滤空字段（例：个人文件的企业名称就为空）
          _context109.next = 14;
          break;
        case 11:
          _context109.prev = 11;
          _context109.t0 = _context109["catch"](2);
          filePath = [];
        case 14:
          return _context109.abrupt("return", {
            dirList: filePath
          });
        case 15:
        case "end":
          return _context109.stop();
      }
    }, _callee109, null, [[2, 11]]);
  }));
  return _fetchConvertPageDirInfo.apply(this, arguments);
}

function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var request$w = createInstance({
  baseURL: PLUSSVR,
  withCredentials: true
});

// 获取当前层级所有部门信息
var fetchCurlevelDepts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
    var pid,
      opts,
      _yield$request$get,
      infos,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          pid = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
          opts = _args.length > 2 ? _args[2] : undefined;
          _context.next = 4;
          return request$w.get("/api/".concat(cid, "/department/curlevel"), _objectSpread$8({
            params: {
              comp_id: cid,
              parent_id: pid
            }
          }, opts));
        case 4:
          _yield$request$get = _context.sent;
          infos = _yield$request$get.data.infos;
          return _context.abrupt("return", infos || []);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchCurlevelDepts(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchCurDeptMembers = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid, params) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$w.get("/api/".concat(cid, "/dept/users"), params);
        case 2:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchCurDeptMembers(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

// 根据权限获取企业成员
var fetchCurDeptMembersByPermission = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cid, params) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$w.get("/svr/v1/u/companies/".concat(cid, "/users"), params);
        case 2:
          _yield$request$get3 = _context3.sent;
          data = _yield$request$get3.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function fetchCurDeptMembersByPermission(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
// 获取当前部门下的成员企业排序
var fetchCurDeptMembersOrder = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(compId, deptId, params) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$w.get("svr/v1/u/companies/".concat(compId, "/depts/").concat(deptId, "/users"), params);
        case 2:
          _yield$request$get4 = _context4.sent;
          data = _yield$request$get4.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function fetchCurDeptMembersOrder(_x6, _x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

// 获取当前根部门信息
var fetchDepartmentInfo = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(compId) {
    var _yield$request$get5, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$w.get("api/v1/companies/".concat(compId, "/department/org"));
        case 2:
          _yield$request$get5 = _context5.sent;
          data = _yield$request$get5.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function fetchDepartmentInfo(_x9) {
    return _ref5.apply(this, arguments);
  };
}();
var fetchGrowthPlan = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cid) {
    var _yield$request$get6, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$w.get("/compose/v1/adm/u/companies/".concat(cid, "/growth-plan/target"));
        case 2:
          _yield$request$get6 = _context6.sent;
          data = _yield$request$get6.data;
          return _context6.abrupt("return", data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function fetchGrowthPlan(_x10) {
    return _ref6.apply(this, arguments);
  };
}();
var applicateGrowthPlan = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(cid) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return request$w.post("/compose/v1/adm/companies/".concat(cid, "/growth-plan"));
        case 2:
          _yield$request$post = _context7.sent;
          data = _yield$request$post.data;
          return _context7.abrupt("return", data);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function applicateGrowthPlan(_x11) {
    return _ref7.apply(this, arguments);
  };
}();
// 获取企业行业
var fetchCompanyIndustry = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
    var cid, _yield$request$get7, data;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          cid = params.cid;
          _context8.next = 3;
          return request$w.get("/compose/api/v1/companies/".concat(cid, "/enterprise_info"));
        case 3:
          _yield$request$get7 = _context8.sent;
          data = _yield$request$get7.data;
          return _context8.abrupt("return", data);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function fetchCompanyIndustry(_x12) {
    return _ref8.apply(this, arguments);
  };
}();
// 获取企业具体信息
var fetchCompanyDetail = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
    var cid, _yield$request$get8, company;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          cid = params.cid;
          _context9.next = 3;
          return request$w.get("/api/company/".concat(cid, "/detail"));
        case 3:
          _yield$request$get8 = _context9.sent;
          company = _yield$request$get8.data.company;
          return _context9.abrupt("return", company);
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function fetchCompanyDetail(_x13) {
    return _ref9.apply(this, arguments);
  };
}();
// 获取某企业部门成员信息
var fetchCompanyUserInfo = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
    var cid, _yield$request$get9, userinfo;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          cid = params.cid;
          _context10.next = 3;
          return request$w.get('/api/user/userinfo', {
            params: {
              comp_id: cid
            }
          });
        case 3:
          _yield$request$get9 = _context10.sent;
          userinfo = _yield$request$get9.data.userinfo;
          return _context10.abrupt("return", userinfo);
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function fetchCompanyUserInfo(_x14) {
    return _ref10.apply(this, arguments);
  };
}();
// 查询当前用户所在的企业
var getCurCompany = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var _yield$request$get10, data;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return request$w.get('/api/company');
        case 2:
          _yield$request$get10 = _context11.sent;
          data = _yield$request$get10.data;
          return _context11.abrupt("return", data.companies);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getCurCompany() {
    return _ref11.apply(this, arguments);
  };
}();
// 获取企业邀请成员链接
var fetchCompanyInviteLink = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(cid, params) {
    var _yield$request$get11, data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$w.get("/api/".concat(cid, "/dept/invitelink"), params);
        case 2:
          _yield$request$get11 = _context12.sent;
          data = _yield$request$get11.data;
          return _context12.abrupt("return", data);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function fetchCompanyInviteLink(_x15, _x16) {
    return _ref12.apply(this, arguments);
  };
}();
// 发送企业成员邀请
var sendCompnayInvite = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(cid, params) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return request$w.post("/api/v1/company/".concat(cid, "/invitelink/send"), params);
        case 2:
          _yield$request$post2 = _context13.sent;
          data = _yield$request$post2.data;
          return _context13.abrupt("return", data);
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function sendCompnayInvite(_x17, _x18) {
    return _ref13.apply(this, arguments);
  };
}();
// 邀请成员至企业团队
var inviteToCompanyGroup = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(cid, params) {
    var _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return request$w.post("/api/v1/company/".concat(cid, "/invitation"), params);
        case 2:
          _yield$request$post3 = _context14.sent;
          data = _yield$request$post3.data;
          return _context14.abrupt("return", data);
        case 5:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function inviteToCompanyGroup(_x19, _x20) {
    return _ref14.apply(this, arguments);
  };
}();

// 通过企业团队邀请链接加入企业，并且加入团队-需要上报scene参数
var fetchEncsGroupLink = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(cid, params) {
    var data;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return request$w.post("/inv/v1/u/companies/".concat(cid, "/invitations/encs-group-link"), params);
        case 2:
          data = _context15.sent;
          return _context15.abrupt("return", data);
        case 4:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function fetchEncsGroupLink(_x21, _x22) {
    return _ref15.apply(this, arguments);
  };
}();

// 通过部门邀请链接加入企业部门
var fetchDeptLink = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(cid, params) {
    var data;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return request$w.post("/inv/v2/adm/companies/".concat(cid, "/invitations"), params);
        case 2:
          data = _context16.sent;
          return _context16.abrupt("return", data);
        case 4:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function fetchDeptLink(_x23, _x24) {
    return _ref16.apply(this, arguments);
  };
}();

// 获取企业配置
var fetchCompanyConfig = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(cid, name, params) {
    var _yield$request$get12, data;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return request$w.get("/inv/v1/companies/".concat(cid, "/configs/").concat(name), {
            params: params
          });
        case 2:
          _yield$request$get12 = _context17.sent;
          data = _yield$request$get12.data;
          return _context17.abrupt("return", JSON.parse(data.value)[name]);
        case 5:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function fetchCompanyConfig(_x25, _x26, _x27) {
    return _ref17.apply(this, arguments);
  };
}();

// 更新企业配置
var updateCompanyConfig = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(cid, name, value) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return request$w.put("/inv/v1/companies/".concat(cid, "/configs/").concat(name), {
            value: JSON.stringify(_defineProperty({}, name, value))
          });
        case 2:
          _yield$request$put = _context18.sent;
          data = _yield$request$put.data;
          return _context18.abrupt("return", data);
        case 5:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function updateCompanyConfig(_x28, _x29, _x30) {
    return _ref18.apply(this, arguments);
  };
}();

// 领取远程办公推广协作版
var getCooperation = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(cid) {
    var _yield$request$post4, data;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return request$w.post("/compose/v1/adm/companies/".concat(cid, "/cooperation"));
        case 2:
          _yield$request$post4 = _context19.sent;
          data = _yield$request$post4.data;
          return _context19.abrupt("return", data);
        case 5:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function getCooperation(_x31) {
    return _ref19.apply(this, arguments);
  };
}();
// 获取企业权益信息
var fetchCompanyPrivilege = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(cid) {
    var _yield$request$get13, data;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return request$w.get("/compose/v1/u/companies/".concat(cid, "/privilege"));
        case 2:
          _yield$request$get13 = _context20.sent;
          data = _yield$request$get13.data;
          return _context20.abrupt("return", data);
        case 5:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return function fetchCompanyPrivilege(_x32) {
    return _ref20.apply(this, arguments);
  };
}();

// 获取企业分享权益信息 (用于团队外链分享查看)
function getCompanySharePrivilege(_x33, _x34) {
  return _getCompanySharePrivilege.apply(this, arguments);
}

// 修改企业信息
function _getCompanySharePrivilege() {
  _getCompanySharePrivilege = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(cid, params) {
    var _yield$request$get35, data;
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) switch (_context64.prev = _context64.next) {
        case 0:
          _context64.next = 2;
          return request$w.get("/cmgr/v1/companies/".concat(cid, "/privileges"), {
            params: params
          });
        case 2:
          _yield$request$get35 = _context64.sent;
          data = _yield$request$get35.data;
          return _context64.abrupt("return", data);
        case 5:
        case "end":
          return _context64.stop();
      }
    }, _callee64);
  }));
  return _getCompanySharePrivilege.apply(this, arguments);
}
var updateCompanyData = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(params) {
    var _yield$request$post5, data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return request$w.post("/api/v1/company/".concat(params.compid, "/update"), params);
        case 2:
          _yield$request$post5 = _context21.sent;
          data = _yield$request$post5.data;
          return _context21.abrupt("return", data);
        case 5:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function updateCompanyData(_x35) {
    return _ref21.apply(this, arguments);
  };
}();
// 修改成员信息（如名字）
var updateEntMemberInfo = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(cid, payload) {
    var _yield$request$put2, data;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return request$w.put("/api/v1/companies/".concat(cid, "/user/changeuser"), payload);
        case 2:
          _yield$request$put2 = _context22.sent;
          data = _yield$request$put2.data;
          return _context22.abrupt("return", data);
        case 5:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return function updateEntMemberInfo(_x36, _x37) {
    return _ref22.apply(this, arguments);
  };
}();

/**
 *删除企业成员
 *  @payload
 *    comp_uids 删除的用户id
 *    dept_id 部门id
 *
 */
var deleteEntMember = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(cid, payload) {
    var _yield$request$put3, data;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return request$w.put("/api/v1/companies/".concat(cid, "/user/leave"), payload);
        case 2:
          _yield$request$put3 = _context23.sent;
          data = _yield$request$put3.data;
          return _context23.abrupt("return", data);
        case 5:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return function deleteEntMember(_x38, _x39) {
    return _ref23.apply(this, arguments);
  };
}();

// 获取企业成员审批列表
var fetchApplyList = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(cid) {
    var page,
      count,
      _yield$request$get14,
      data,
      _args24 = arguments;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          page = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : 1;
          count = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : 20;
          _context24.next = 4;
          return request$w.get("/inv/v1/companies/".concat(cid, "/applies"), {
            params: {
              page: page,
              count: count
            }
          });
        case 4:
          _yield$request$get14 = _context24.sent;
          data = _yield$request$get14.data;
          return _context24.abrupt("return", data);
        case 7:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return function fetchApplyList(_x40) {
    return _ref24.apply(this, arguments);
  };
}();

// 通过或拒绝企业成员申请
var processMemberApply = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(cid, params) {
    var _yield$request$put4, data;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return request$w.put("/inv/v1/adm/companies/".concat(cid, "/user-apply/approve"), params);
        case 2:
          _yield$request$put4 = _context25.sent;
          data = _yield$request$put4.data;
          return _context25.abrupt("return", data);
        case 5:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return function processMemberApply(_x41, _x42) {
    return _ref25.apply(this, arguments);
  };
}();

// 获取企业详细的信息(包括套餐权限信息)
var fetchCompanyDetailAll = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(ids) {
    var _yield$request$get15, data;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return request$w.get("/compose/v1/u/companies/batch/service-space?comp_ids=".concat(ids));
        case 2:
          _yield$request$get15 = _context26.sent;
          data = _yield$request$get15.data;
          return _context26.abrupt("return", data);
        case 5:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return function fetchCompanyDetailAll(_x43) {
    return _ref26.apply(this, arguments);
  };
}();

// 获取企业Logo(普通成员获取)
var fetchCompanyLogo = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
    var _yield$request$get16, data;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return request$w.get('/compose/v1/u/user-companies?fields=logo&status=active');
        case 2:
          _yield$request$get16 = _context27.sent;
          data = _yield$request$get16.data;
          return _context27.abrupt("return", data);
        case 5:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return function fetchCompanyLogo() {
    return _ref27.apply(this, arguments);
  };
}();

// 获取用户permission
var fetchUserPermission = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(compId, userid) {
    var _yield$request$get17, data;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return request$w.get("/plusadmin/api/v1/companies/".concat(compId, "/users/").concat(userid, "/permissions"));
        case 2:
          _yield$request$get17 = _context28.sent;
          data = _yield$request$get17.data;
          return _context28.abrupt("return", data);
        case 5:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return function fetchUserPermission(_x44, _x45) {
    return _ref28.apply(this, arguments);
  };
}();
// 查询公司超管
var fetchSuperadmin = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(cid) {
    var _yield$request$get18, data;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return request$w.get("/svr/v1/companies/".concat(cid, "/super-admin"));
        case 2:
          _yield$request$get18 = _context29.sent;
          data = _yield$request$get18.data;
          return _context29.abrupt("return", data);
        case 5:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return function fetchSuperadmin(_x46) {
    return _ref29.apply(this, arguments);
  };
}();
// 查询企业空间使用状态
var fetchGroupSpaces = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(cid, tid) {
    var _yield$request$get19, data;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.next = 2;
          return request$w.get("/spaces/v1/u/companies/".concat(cid, "/groups/").concat(tid, "/spaces"));
        case 2:
          _yield$request$get19 = _context30.sent;
          data = _yield$request$get19.data;
          return _context30.abrupt("return", data);
        case 5:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return function fetchGroupSpaces(_x47, _x48) {
    return _ref30.apply(this, arguments);
  };
}();
// 获取企业utm参数
var getCompanyUtmInfo = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
    var _yield$request$get20, _yield$request$get20$, data;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return request$w.get('/compose/v1/u/user-companies?fields=utm_medium&status=active');
        case 2:
          _yield$request$get20 = _context31.sent;
          _yield$request$get20$ = _yield$request$get20.data;
          data = _yield$request$get20$ === void 0 ? {} : _yield$request$get20$;
          return _context31.abrupt("return", data);
        case 6:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return function getCompanyUtmInfo() {
    return _ref31.apply(this, arguments);
  };
}();
// 查询公司超管
var getQuitCompanyCheck = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(companyId) {
    var _yield$request$post6, data;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          _context32.next = 2;
          return request$w.post("/compose/v1/companies/".concat(companyId, "/quit/check"));
        case 2:
          _yield$request$post6 = _context32.sent;
          data = _yield$request$post6.data;
          return _context32.abrupt("return", data);
        case 5:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return function getQuitCompanyCheck(_x49) {
    return _ref32.apply(this, arguments);
  };
}();

// 退出企业
var handleQuitCompany = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(_ref33) {
    var companyId, code, token, params, _yield$request$post7, data;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          companyId = _ref33.companyId, code = _ref33.code, token = _ref33.token;
          params = {
            code: code,
            token: token
          };
          _context33.next = 4;
          return request$w.post("/compose/v1/companies/".concat(companyId, "/quit"), params);
        case 4:
          _yield$request$post7 = _context33.sent;
          data = _yield$request$post7.data;
          return _context33.abrupt("return", data);
        case 7:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return function handleQuitCompany(_x50) {
    return _ref34.apply(this, arguments);
  };
}();

// 发送手机
var sendPhoneVerify = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(params) {
    var _yield$request$post8, data;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          _context34.next = 2;
          return request$w.post('/compose/v1/user/mobile/code', params);
        case 2:
          _yield$request$post8 = _context34.sent;
          data = _yield$request$post8.data;
          return _context34.abrupt("return", data);
        case 5:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return function sendPhoneVerify(_x51) {
    return _ref35.apply(this, arguments);
  };
}();

// 用于获取公司信息，是否为同步企业
var getCompanySettingsInfo = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(_ref36) {
    var companyId, names, params, _yield$request$post9, data;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          companyId = _ref36.companyId, names = _ref36.names;
          params = {
            names: names
          };
          _context35.next = 4;
          return request$w.post("/cmgr/v1/adm/companies/".concat(companyId, "/settings/batch"), params);
        case 4:
          _yield$request$post9 = _context35.sent;
          data = _yield$request$post9.data;
          return _context35.abrupt("return", data);
        case 7:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return function getCompanySettingsInfo(_x52) {
    return _ref37.apply(this, arguments);
  };
}();

// 权益: 水印
function getCompanyPrivileges(cid) {
  var privilegeIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['document_watermark'];
  return request$w.get("/cmgr/v1/companies/".concat(cid, "/privileges?privilege_ids=").concat(privilegeIds));
}

// 获取企业成员信息
var getCompanyMemberDetail = /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(compId) {
    var _yield$request$get21, data;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          _context36.next = 2;
          return request$w.get("/svr/v1/companies/".concat(compId, "/users/self"));
        case 2:
          _yield$request$get21 = _context36.sent;
          data = _yield$request$get21.data;
          return _context36.abrupt("return", data);
        case 5:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return function getCompanyMemberDetail(_x53) {
    return _ref38.apply(this, arguments);
  };
}();

// 创建企业管理员定向邀请链接
var sendAdminInvitations = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(params) {
    var compId, _yield$request$post10, data;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          compId = params.comp_id;
          _context37.next = 3;
          return request$w.post("/inv/v1/adm/companies/".concat(compId, "/invitations/admin-directed"), params);
        case 3:
          _yield$request$post10 = _context37.sent;
          data = _yield$request$post10.data;
          return _context37.abrupt("return", data);
        case 6:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return function sendAdminInvitations(_x54) {
    return _ref39.apply(this, arguments);
  };
}();

// 创建企业普通成员定向邀请链接
var sendUserInvitations = /*#__PURE__*/function () {
  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(params) {
    var compId, _yield$request$post11, data;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          compId = params.comp_id;
          _context38.next = 3;
          return request$w.post("/inv/v1/u/companies/".concat(compId, "/invitations/user-directed"), params);
        case 3:
          _yield$request$post11 = _context38.sent;
          data = _yield$request$post11.data;
          return _context38.abrupt("return", data);
        case 6:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return function sendUserInvitations(_x55) {
    return _ref40.apply(this, arguments);
  };
}();

// 企业管理员创建邀请链接
var createAdminInvitations = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(params) {
    var compId, _yield$request$post12, data;
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          compId = params.comp_id;
          _context39.next = 3;
          return request$w.post("/inv/v1/adm/companies/".concat(compId, "/invitations/admin"), params);
        case 3:
          _yield$request$post12 = _context39.sent;
          data = _yield$request$post12.data;
          return _context39.abrupt("return", data);
        case 6:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return function createAdminInvitations(_x56) {
    return _ref41.apply(this, arguments);
  };
}();

// 获取当前管理员的某个权限点的范围
var getPlusadminPermission = /*#__PURE__*/function () {
  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(params) {
    var compId, userId, permission, _yield$request$get22, data;
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          compId = params.comp_id, userId = params.user_id, permission = params.permission;
          _context40.next = 3;
          return request$w.get("".concat(PLUSSVR, "/plusadmin/api/v1/companies/").concat(compId, "/users/").concat(userId, "/permission/").concat(permission));
        case 3:
          _yield$request$get22 = _context40.sent;
          data = _yield$request$get22.data;
          return _context40.abrupt("return", data);
        case 6:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return function getPlusadminPermission(_x57) {
    return _ref42.apply(this, arguments);
  };
}();

/**
 * 获得企业名称
 * @param {*} keyword
 */
var getCompanyName = function getCompanyName(keyword) {
  return request$w.get('/compose/api/v1/enterprises/search', {
    params: {
      keyword: keyword
    }
  });
};

/**
 * 获取企业创建数限制
 */
var getCompanyNumLimit = function getCompanyNumLimit() {
  return request$w.get('/api/v1/company_num/detail');
};

/**
 * 检测企业名是否重复
 * @param {*} values
 */
var checkCompanyName = function checkCompanyName(data) {
  return request$w.post('/api/v1/company/0/update/check', data);
};

// 发送验证码
var sendSMSCode = function sendSMSCode(data) {
  return request$w.post('/api/company/0/verification_code/send', data);
};
/**
 * 检测验证码
 * @param {*} data
 */
var checkSMSCode = function checkSMSCode(data) {
  return request$w.post('/api/company/0/verification_code/verify', data);
};

/**
 * @desc 创建企业、发送验证码&验证码校验，都是使用此接口
 * @param data {Object} 入参
 * @param headers {Object} 请求头x-verifivations，发送信息或者验证码有效校验
 *  @desc 根据请求头 x-verifivations: Check-Code 发送验证莫，不支持自定义手机或者email发送验证码，支持默认的发送验证码渠道
 *  @desc 根据请求头 x-verifivations: Send-Code base64(code) 验证码校验&&创建企业，两者是一体的
 */
var createSemRegisterCompany = function createSemRegisterCompany(params) {
  var _ref43 = params || {},
    data = _ref43.data,
    headers = _ref43.headers;
  return request$w.post('/svr/v2/companies', data, headers);
};

/**
 * 创建企业
 * @param {*} values
 */
var registerCompany = function registerCompany(data) {
  return request$w.post('/api/company', data);
};

/**
 * @desc 个人文档分享时，转化成企业文档，并创建企业邀请链接
 * @param comp_id 公司ID
 * @param context 团队ID
 *  @param group_link_key 团队分享链接
 * @param credential 校验凭证
 *  @param encs_file_linkid 文件分享链接
 * @param source 来源
 *
 */
var createPersonalFileLink = function createPersonalFileLink(compId, data) {
  return request$w.post("/inv/v1/u/companies/".concat(compId, "/invitations/personal-file-link"), data);
};

/**
 * @desc 创建企业条件判断
 */
var getCreateCompanyCondition = function getCreateCompanyCondition() {
  return request$w.get('/svr/v2/companies/conditions-check');
};

/**
 * @desc 查询企业成员信息-限频 http://plus-docs.epy.wpsep.net/docs/plussvr#operation/v1_u_get_user
 * @params cid 公司id
 * @params uid 查询的用户id
 *
 */
var getCooperUserInfo = /*#__PURE__*/function () {
  var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(cid, uid) {
    var fields,
      _yield$request$get23,
      data,
      _args41 = arguments;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          fields = _args41.length > 2 && _args41[2] !== undefined ? _args41[2] : 'abs_path';
          _context41.next = 3;
          return request$w.get("/svr/v1/u/companies/".concat(cid, "/users/plain"), {
            params: {
              user_id: uid,
              status: 'active',
              dept_fields: fields
            }
          });
        case 3:
          _yield$request$get23 = _context41.sent;
          data = _yield$request$get23.data;
          return _context41.abrupt("return", data);
        case 6:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return function getCooperUserInfo(_x58, _x59) {
    return _ref44.apply(this, arguments);
  };
}();

/*
 * 获取企业指数
 */
function getGrades(compId) {
  return request$w.get("/compose/v1/adm/companies/".concat(compId, "/grades"));
}

/*
 * 检查当前用户是否有指定权限
 */
var checkUserPermission = /*#__PURE__*/function () {
  var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(_ref45) {
    var compId, userId, permissions, _yield$request$post13, data;
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          compId = _ref45.comp_id, userId = _ref45.user_id, permissions = _ref45.permissions;
          _context42.next = 3;
          return request$w.post("/plusadmin/api/v1/companies/".concat(compId, "/users/").concat(userId, "/permissions-check"), {
            permissions: permissions
          });
        case 3:
          _yield$request$post13 = _context42.sent;
          data = _yield$request$post13.data;
          return _context42.abrupt("return", data);
        case 6:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return function checkUserPermission(_x60) {
    return _ref46.apply(this, arguments);
  };
}();
var getSysRoles = /*#__PURE__*/function () {
  var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(_ref47) {
    var compId, sys_role_type, _yield$request$get24, data;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          compId = _ref47.comp_id, sys_role_type = _ref47.sys_role_type;
          _context43.next = 3;
          return request$w.get("/plusadmin/api/v1/companies/".concat(compId, "/sys-roles"), {
            params: {
              sys_role_type: sys_role_type
            }
          });
        case 3:
          _yield$request$get24 = _context43.sent;
          data = _yield$request$get24.data;
          return _context43.abrupt("return", data);
        case 6:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return function getSysRoles(_x61) {
    return _ref48.apply(this, arguments);
  };
}();
var getApplymentStatus = /*#__PURE__*/function () {
  var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(_ref49) {
    var compId, userId, roleId, _yield$request$get25, data;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          compId = _ref49.comp_id, userId = _ref49.user_id, roleId = _ref49.role_id;
          _context44.next = 3;
          return request$w.get("/plusadmin/api/v1/companies/".concat(compId, "/users/").concat(userId, "/role-applications/").concat(roleId));
        case 3:
          _yield$request$get25 = _context44.sent;
          data = _yield$request$get25.data;
          return _context44.abrupt("return", data);
        case 6:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return function getApplymentStatus(_x62) {
    return _ref50.apply(this, arguments);
  };
}();
var createOrderApplyment = /*#__PURE__*/function () {
  var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(_ref51) {
    var compId, userId, role_id, remark, _yield$request$post14, data;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          compId = _ref51.comp_id, userId = _ref51.user_id, role_id = _ref51.role_id, remark = _ref51.remark;
          _context45.next = 3;
          return request$w.post("/plusadmin/api/v1/companies/".concat(compId, "/users/").concat(userId, "/role-application"), {
            remark: remark,
            role_id: role_id
          });
        case 3:
          _yield$request$post14 = _context45.sent;
          data = _yield$request$post14.data;
          return _context45.abrupt("return", data);
        case 6:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return function createOrderApplyment(_x63) {
    return _ref52.apply(this, arguments);
  };
}();
var sendApproveEvent = /*#__PURE__*/function () {
  var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(_ref53) {
    var compId, userId, role_id, remark, _yield$request$post15, data;
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          compId = _ref53.comp_id, userId = _ref53.user_id, role_id = _ref53.role_id, remark = _ref53.remark;
          _context46.next = 3;
          return request$w.post("/plusadmin/api/v1/companies/".concat(compId, "/users/").concat(userId, "/role-application"), {
            remark: remark,
            role_id: role_id
          });
        case 3:
          _yield$request$post15 = _context46.sent;
          data = _yield$request$post15.data;
          return _context46.abrupt("return", data);
        case 6:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return function sendApproveEvent(_x64) {
    return _ref54.apply(this, arguments);
  };
}();
var getSwitchEnv = /*#__PURE__*/function () {
  var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(companyid) {
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          _context47.next = 2;
          return request$w.get("/cmgr/v1/companies/".concat(companyid, "/settings/switchenv"));
        case 2:
          return _context47.abrupt("return", _context47.sent);
        case 3:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return function getSwitchEnv(_x65) {
    return _ref55.apply(this, arguments);
  };
}();
var getSelfWorkSpace = /*#__PURE__*/function () {
  var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(params) {
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          _context48.next = 2;
          return request$w.get('/compose/v1/users/self/workspaces', params);
        case 2:
          return _context48.abrupt("return", _context48.sent);
        case 3:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return function getSelfWorkSpace(_x66) {
    return _ref56.apply(this, arguments);
  };
}();
var setWorkSpace = /*#__PURE__*/function () {
  var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(params) {
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          _context49.next = 2;
          return request$w.put('/compose/v1/users/self/workspaces', params);
        case 2:
          return _context49.abrupt("return", _context49.sent);
        case 3:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));
  return function setWorkSpace(_x67) {
    return _ref57.apply(this, arguments);
  };
}();
var authConfirms = /*#__PURE__*/function () {
  var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(companyid, params) {
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          _context50.next = 2;
          return request$w.get("/oauth/v1/u/companies/".concat(companyid, "/auth_confirms"), params);
        case 2:
          return _context50.abrupt("return", _context50.sent);
        case 3:
        case "end":
          return _context50.stop();
      }
    }, _callee50);
  }));
  return function authConfirms(_x68, _x69) {
    return _ref58.apply(this, arguments);
  };
}();
/**
 * 获取企业迁移状态 0 未迁移； 1 已迁移；2 新建企业
 *
 */
var getCompanyMigrationStatus = /*#__PURE__*/function () {
  var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(companyid) {
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          _context51.next = 2;
          return request$w.get("svr/v1/companies/".concat(companyid, "/migration-status")).then(function (res) {
            return res.data.status;
          });
        case 2:
          return _context51.abrupt("return", _context51.sent);
        case 3:
        case "end":
          return _context51.stop();
      }
    }, _callee51);
  }));
  return function getCompanyMigrationStatus(_x70) {
    return _ref59.apply(this, arguments);
  };
}();
/**
 * 获取个人账号下所有的绑定企业
 * @returns
 */
var relatedUsers = /*#__PURE__*/function () {
  var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          _context52.next = 2;
          return request$w.get("/compose/v1/u/related_users?role_ids=0&role_ids=1&role_ids=2&role_ids=3&mode=all_bind");
        case 2:
          return _context52.abrupt("return", _context52.sent);
        case 3:
        case "end":
          return _context52.stop();
      }
    }, _callee52);
  }));
  return function relatedUsers() {
    return _ref60.apply(this, arguments);
  };
}();
/**
 * 获取企微签名配置
 *
 */
var getWxWorkShareConfig = /*#__PURE__*/function () {
  var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(companyid) {
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) switch (_context53.prev = _context53.next) {
        case 0:
          _context53.next = 2;
          return request$w.get("sap/v1/u/companies/".concat(companyid, "/wx_work/share/info/config?url=").concat(location.href.split('#')[0]));
        case 2:
          return _context53.abrupt("return", _context53.sent);
        case 3:
        case "end":
          return _context53.stop();
      }
    }, _callee53);
  }));
  return function getWxWorkShareConfig(_x71) {
    return _ref61.apply(this, arguments);
  };
}();
/**
 * 获取用户所在企业的登录设置
 * @params companyid 用户所属企业的id
 */
var getUserCompanyLoginSetting = /*#__PURE__*/function () {
  var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(companyid) {
    var _yield$request$get26, data;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) switch (_context54.prev = _context54.next) {
        case 0:
          _context54.next = 2;
          return request$w.get("/cmgr/v1/u/companies/".concat(companyid, "/login-configs/bind-login"));
        case 2:
          _yield$request$get26 = _context54.sent;
          data = _yield$request$get26.data;
          return _context54.abrupt("return", data);
        case 5:
        case "end":
          return _context54.stop();
      }
    }, _callee54);
  }));
  return function getUserCompanyLoginSetting(_x72) {
    return _ref62.apply(this, arguments);
  };
}();

/**
 * 获取外部联系人
 */
var getExternalList = /*#__PURE__*/function () {
  var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(params) {
    var _yield$request$get27, data;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) switch (_context55.prev = _context55.next) {
        case 0:
          _context55.next = 2;
          return request$w.get("/svr/v1/u/self/external-contact-collaborators/users", params);
        case 2:
          _yield$request$get27 = _context55.sent;
          data = _yield$request$get27.data;
          return _context55.abrupt("return", data);
        case 5:
        case "end":
          return _context55.stop();
      }
    }, _callee55);
  }));
  return function getExternalList(_x73) {
    return _ref63.apply(this, arguments);
  };
}();

/**
 * 搜索外部联系人
 */
var searchExternalList = /*#__PURE__*/function () {
  var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(params) {
    var _yield$request$get28, data;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) switch (_context56.prev = _context56.next) {
        case 0:
          _context56.next = 2;
          return request$w.get("/svr/v1/u/self/external-contact-collaborators/users/search", params);
        case 2:
          _yield$request$get28 = _context56.sent;
          data = _yield$request$get28.data;
          return _context56.abrupt("return", data);
        case 5:
        case "end":
          return _context56.stop();
      }
    }, _callee56);
  }));
  return function searchExternalList(_x74) {
    return _ref64.apply(this, arguments);
  };
}();

/**
 * 删除外部联系人（协作者）
 */
var deleteExternal = function deleteExternal(userId, params) {
  return request$w["delete"]("/svr/v1/u/self/external-contact-collaborators/users/".concat(userId), params);
};

/**
 * 删除外部联系人（企业）
 */
var deleteExternalV2 = function deleteExternalV2(compId, params) {
  return request$w["delete"]("/svr/v1/u/self/external-contact-collaborators/companies/".concat(compId), params);
};

/**
 * 查询外部联系人协作关系的用户
 */
var getExternalCooperates = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(compId, params) {
    var _yield$request$get29, data;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) switch (_context57.prev = _context57.next) {
        case 0:
          _context57.next = 2;
          return request$w.get("/svr/v1/u/self/external-contact-collaborators/companies/".concat(compId, "/users"), params);
        case 2:
          _yield$request$get29 = _context57.sent;
          data = _yield$request$get29.data;
          return _context57.abrupt("return", data);
        case 5:
        case "end":
          return _context57.stop();
      }
    }, _callee57);
  }));
  return function getExternalCooperates(_x75, _x76) {
    return _ref65.apply(this, arguments);
  };
}();

/**
 * 获取添加外部联系人链接
 */
var getInvitationLinkService = /*#__PURE__*/function () {
  var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(compId, params) {
    var _yield$request$get30, data;
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) switch (_context58.prev = _context58.next) {
        case 0:
          _context58.next = 2;
          return request$w.get("/inv/v1/u/companies/".concat(compId, "/external-contacts/invitation"), params);
        case 2:
          _yield$request$get30 = _context58.sent;
          data = _yield$request$get30.data;
          return _context58.abrupt("return", data);
        case 5:
        case "end":
          return _context58.stop();
      }
    }, _callee58);
  }));
  return function getInvitationLinkService(_x77, _x78) {
    return _ref66.apply(this, arguments);
  };
}();

/**
 * 查询企业的sso类型
 */
var getCompanySSOType = /*#__PURE__*/function () {
  var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(companyId) {
    var _yield$request$get31, data;
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) switch (_context59.prev = _context59.next) {
        case 0:
          _context59.next = 2;
          return request$w.get("/inv/v1/u/companies/".concat(companyId, "/sso/configs"));
        case 2:
          _yield$request$get31 = _context59.sent;
          data = _yield$request$get31.data;
          return _context59.abrupt("return", data);
        case 5:
        case "end":
          return _context59.stop();
      }
    }, _callee59);
  }));
  return function getCompanySSOType(_x79) {
    return _ref67.apply(this, arguments);
  };
}();

/**
 * 获取自定义域名配置
 */
var getCustomDomainConfig = /*#__PURE__*/function () {
  var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(compId) {
    var _yield$request$get32, data;
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) switch (_context60.prev = _context60.next) {
        case 0:
          _context60.next = 2;
          return request$w.get("/cmgr/v1/u/companies/".concat(compId, "/services-config"));
        case 2:
          _yield$request$get32 = _context60.sent;
          data = _yield$request$get32.data;
          return _context60.abrupt("return", data);
        case 5:
        case "end":
          return _context60.stop();
      }
    }, _callee60);
  }));
  return function getCustomDomainConfig(_x80) {
    return _ref68.apply(this, arguments);
  };
}();

/**
 * 企业成员创建邀请链接
 */
var getCompanyInviteLink = /*#__PURE__*/function () {
  var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(compId, source) {
    var _yield$request$post16, data;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) switch (_context61.prev = _context61.next) {
        case 0:
          source = typeof source === 'string' ? source : JSON.stringify(source);
          _context61.next = 3;
          return request$w.post("/inv/v1/u/companies/".concat(compId, "/invitations"), {
            source: source
          });
        case 3:
          _yield$request$post16 = _context61.sent;
          data = _yield$request$post16.data;
          return _context61.abrupt("return", data);
        case 6:
        case "end":
          return _context61.stop();
      }
    }, _callee61);
  }));
  return function getCompanyInviteLink(_x81, _x82) {
    return _ref69.apply(this, arguments);
  };
}();

/**
 * 判断邀请入口是否显示
 */
var checkInviteJoinVisible = /*#__PURE__*/function () {
  var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(compId) {
    var _yield$request$get33, data;
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) switch (_context62.prev = _context62.next) {
        case 0:
          _context62.next = 2;
          return request$w.get("/inv/v1/u/companies/".concat(compId, "/check/invite-colleague"));
        case 2:
          _yield$request$get33 = _context62.sent;
          data = _yield$request$get33.data;
          return _context62.abrupt("return", data);
        case 5:
        case "end":
          return _context62.stop();
      }
    }, _callee62);
  }));
  return function checkInviteJoinVisible(_x83) {
    return _ref70.apply(this, arguments);
  };
}();
var getCompanyUserInfo = /*#__PURE__*/function () {
  var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(companyId, params) {
    var _yield$request$get34, data;
    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) switch (_context63.prev = _context63.next) {
        case 0:
          _context63.next = 2;
          return request$w.get("/svr/v1/u/companies/".concat(companyId, "/users/batch?t=").concat(new Date().getTime()), {
            params: params
          });
        case 2:
          _yield$request$get34 = _context63.sent;
          data = _yield$request$get34.data;
          return _context63.abrupt("return", data);
        case 5:
        case "end":
          return _context63.stop();
      }
    }, _callee63);
  }));
  return function getCompanyUserInfo(_x84, _x85) {
    return _ref71.apply(this, arguments);
  };
}();

var _excluded$4 = ["cid"],
  _excluded2$2 = ["cid"],
  _excluded3$1 = ["company_id", "group_id", "file_id"];
function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var request$v = createInstance({
  baseURL: PLUS,
  withCredentials: true
});

// 获取部门团队拥有者候选人
var fetchOwnercandidates = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var cid, gid, count, url, _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cid = _ref.cid, gid = _ref.gid, count = _ref.count, url = _ref.url;
          _context.next = 3;
          return request$v.get(url || "/app/job/v1/syncuser/companies/".concat(cid, "/deptgroups/").concat(gid, "/ownercandidates?limit=").concat(count));
        case 3:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchOwnercandidates(_x) {
    return _ref2.apply(this, arguments);
  };
}();

// 获取帮助动图指南类别列表
var getVideoPosition = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var _ref3$offset, offset, _ref3$limit, limit, _ref3$group, group, newgroup, ua, _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref3$offset = _ref3.offset, offset = _ref3$offset === void 0 ? 0 : _ref3$offset, _ref3$limit = _ref3.limit, limit = _ref3$limit === void 0 ? 15 : _ref3$limit, _ref3$group = _ref3.group, group = _ref3$group === void 0 ? 'web' : _ref3$group;
          newgroup = group; // PC新首页内嵌金山文档改动
          ua = getUA(navigator.userAgent);
          if (ua.wpsDocumentEmbed) {
            newgroup = 'wps365';
          }
          _context2.next = 6;
          return request$v.get("/sysadmin/strategy/v1/sys/me/guides/positions?offset=".concat(offset, "&limit=").concat(limit, "&group=").concat(newgroup));
        case 6:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getVideoPosition(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

// 获取帮助动图获取指南列表
var getVideoDetail = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var _ref5$catelogId, catelogId, params, _iterator, _step, i, _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _ref5$catelogId = _ref5.catelogId, catelogId = _ref5$catelogId === void 0 ? [] : _ref5$catelogId;
          params = '';
          _iterator = _createForOfIteratorHelper(catelogId);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              i = _step.value;
              params += '&positions=' + i;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _context3.next = 6;
          return request$v.get('/sysadmin/strategy/v1/sys/me/guides?' + params.slice(1));
        case 6:
          _yield$request$get3 = _context3.sent;
          data = _yield$request$get3.data;
          return _context3.abrupt("return", data);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getVideoDetail(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

// 新建团队接口
var createGuideTeam = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$v.post('/app/groupext/v1/groups', params);
        case 2:
          _yield$request$post = _context4.sent;
          data = _yield$request$post.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function createGuideTeam(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
// 应用模板到团队
var applyTemplate = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, params) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$v.post("/app/groupext/v1/group/templates/".concat(id, "/apply"), params);
        case 2:
          _yield$request$post2 = _context5.sent;
          data = _yield$request$post2.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function applyTemplate(_x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}();

// 团队模板分类信息查询
var getTemplateInfo = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ids) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$v.get("/app/groupext/v1/group/template-categories?ids=".concat(ids));
        case 2:
          _yield$request$get4 = _context6.sent;
          data = _yield$request$get4.data;
          return _context6.abrupt("return", data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getTemplateInfo(_x7) {
    return _ref9.apply(this, arguments);
  };
}();

// 团队模板信息查询
var getGroupTemplateInfo = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ids) {
    var _yield$request$get5, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return request$v.get("/app/groupext/v1/group/templates?ids=".concat(ids));
        case 2:
          _yield$request$get5 = _context7.sent;
          data = _yield$request$get5.data;
          return _context7.abrupt("return", data);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getGroupTemplateInfo(_x8) {
    return _ref10.apply(this, arguments);
  };
}();

// 策略查询v1
var gainGuidePolicy = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(param) {
    var url, _yield$request$get6, data;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          url = "/ops/opsd/api/v1/policy?window_key=".concat(param.window_key);
          if (param.company_id) {
            url = "".concat(url, "&company_id=").concat(param.company_id);
          }
          _context8.next = 4;
          return request$v.get(url);
        case 4:
          _yield$request$get6 = _context8.sent;
          data = _yield$request$get6.data;
          return _context8.abrupt("return", data);
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function gainGuidePolicy(_x9) {
    return _ref11.apply(this, arguments);
  };
}();

// 策略接口(新)
var getPolicy = function getPolicy(params) {
  // PC新首页内嵌金山文档改动
  var newParams = params;
  if (!Vue.prototype.$isServer) {
    var ua = getUA(navigator.userAgent);
    var windowKeyArr = ['web_group_conduct_top', 'web_newbie_guide', 'web_privatedomain_top', 'web_privatedomain', 'web_jinxiaomeng_menu', 'web_newbie_task', 'web_newbie_invite', 'web_found_first_team', 'web_newbie_document', 'web_activity_popup_two'];
    if (ua.wpsDocumentEmbed && windowKeyArr.includes(params.window_key)) {
      newParams = _objectSpread$7(_objectSpread$7({}, params), {}, {
        utm_source: 'WPS365_PC'
      });
    }
  }
  return request$v.get('/ops/opsd/api/v1/policy', {
    params: newParams
  });
};

// 团队AI策略查询
var getPolicyV3 = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(param) {
    var _yield$request$get7, data;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return request$v.get('ops/opsd/api/v3/policy', {
            params: _objectSpread$7({}, param)
          });
        case 2:
          _yield$request$get7 = _context9.sent;
          data = _yield$request$get7.data;
          return _context9.abrupt("return", data);
        case 5:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function getPolicyV3(_x10) {
    return _ref12.apply(this, arguments);
  };
}();

// 设置团队模板
var setTeamTemplate = function setTeamTemplate(_ref13) {
  var id = _ref13.id,
    tid = _ref13.tid,
    source = _ref13.source,
    scene = _ref13.scene,
    entrance = _ref13.entrance,
    applyid = _ref13.applyid,
    company_id = _ref13.company_id;
  var data = {
    group_id: tid,
    source: source,
    scene: scene,
    entrance: entrance,
    company_id: company_id
  };
  if (applyid) {
    data.apply_id = applyid;
  }
  return request$v.post("/app/groupext/v1/group/templates/".concat(id, "/apply"), data);
};

// 获取团队发布设置企业范围可选策略
var getTeamWikiPublishPolicyConfig = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(companyid, keys) {
    var _yield$request$get8, data;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return request$v.get("/app/job/v1/syncuser/companies/".concat(companyid, "/config"), {
            params: {
              keys: keys
            }
          });
        case 2:
          _yield$request$get8 = _context10.sent;
          data = _yield$request$get8.data;
          return _context10.abrupt("return", data);
        case 5:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function getTeamWikiPublishPolicyConfig(_x11, _x12) {
    return _ref14.apply(this, arguments);
  };
}();

// 获取预设模板
var fetchTemplates = function fetchTemplates() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var categoryIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return request$v.get("/app/groupext/v1/group/templates?ids=".concat(ids, "&category_ids=").concat(categoryIds));
};

// 获取团队置顶内容
var getTeamTopAreaNotice = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(groupid) {
    var _yield$request$get9, data;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return request$v.get("/app/groupext/v1/pin/groups/".concat(groupid, "/notice?t=").concat(Date.now()));
        case 2:
          _yield$request$get9 = _context11.sent;
          data = _yield$request$get9.data;
          return _context11.abrupt("return", data);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getTeamTopAreaNotice(_x13) {
    return _ref15.apply(this, arguments);
  };
}();

// 更新团队置顶内容
var updateTeamTopAreaNotice = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(groupid, content) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$v.put("/app/groupext/v1/pin/groups/".concat(groupid, "/notice"), {
            content: content
          });
        case 2:
          _yield$request$put = _context12.sent;
          data = _yield$request$put.data;
          return _context12.abrupt("return", data);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function updateTeamTopAreaNotice(_x14, _x15) {
    return _ref16.apply(this, arguments);
  };
}();

// 上报【新建团队模板弹框】展示行为数据
var postTemplateShown = function postTemplateShown(ids) {
  return request$v.post('/app/groupext/v1/group/templates/shown', {
    ids: ids
  });
};

// 获取关键字搜索
var getKeyWordsList = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
    var _yield$request$get10, data;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return request$v.get('/app/assistant/v1/u/contents/search', {
            params: params
          });
        case 2:
          _yield$request$get10 = _context13.sent;
          data = _yield$request$get10.data;
          return _context13.abrupt("return", data);
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function getKeyWordsList(_x16) {
    return _ref17.apply(this, arguments);
  };
}();

// 获取企业助手内容
var getCompanyHelpContent = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
    var _yield$request$get11, data;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return request$v.get('/app/assistant/v1/u/contents', {
            params: params
          });
        case 2:
          _yield$request$get11 = _context14.sent;
          data = _yield$request$get11.data;
          return _context14.abrupt("return", data);
        case 5:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function getCompanyHelpContent(_x17) {
    return _ref18.apply(this, arguments);
  };
}();
var readCompanyHelp = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(params) {
    var _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return request$v.post('/app/assistant/v1/u/contents/read/update', params);
        case 2:
          _yield$request$post3 = _context15.sent;
          data = _yield$request$post3.data;
          return _context15.abrupt("return", data);
        case 5:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function readCompanyHelp(_x18) {
    return _ref19.apply(this, arguments);
  };
}();

// 获取企业助手订阅信息
var getCompanyHelpSubscribe = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var _yield$request$get12, data;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return request$v.get('/app/assistant/v1/u/contents/types/subscribe');
        case 2:
          _yield$request$get12 = _context16.sent;
          data = _yield$request$get12.data;
          return _context16.abrupt("return", data);
        case 5:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function getCompanyHelpSubscribe() {
    return _ref20.apply(this, arguments);
  };
}();

// 设置企业助手订阅信息
var setCompanyHelpSubscribe = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(params) {
    var _yield$request$post4, data;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return request$v.post('/app/assistant/v1/u/contents/types/subscribe', params);
        case 2:
          _yield$request$post4 = _context17.sent;
          data = _yield$request$post4.data;
          return _context17.abrupt("return", data);
        case 5:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function setCompanyHelpSubscribe(_x19) {
    return _ref21.apply(this, arguments);
  };
}();

/**
 * 获取活动列表
 * @params
 *
 */
var getActivitiesList = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(params) {
    var _yield$request$get13, data;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return request$v.get('/ops/activity/api/v1/u/company/growth/activities', {
            params: params
          });
        case 2:
          _yield$request$get13 = _context18.sent;
          data = _yield$request$get13.data;
          return _context18.abrupt("return", data);
        case 5:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function getActivitiesList(_x20) {
    return _ref22.apply(this, arguments);
  };
}();
/**
 * 领取奖励
 * @params
 *
 */
var getActivitiesReceive = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(params) {
    var _yield$request$post5, data;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return request$v.post('/ops/activity/api/v1/activities/awards/receive', params);
        case 2:
          _yield$request$post5 = _context19.sent;
          data = _yield$request$post5.data;
          return _context19.abrupt("return", data);
        case 5:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function getActivitiesReceive(_x21) {
    return _ref23.apply(this, arguments);
  };
}();

// 查询订单是否所有免费
var checkOrderFree = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(cid) {
    var _yield$request$get14, data;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return request$v.get("xstore/api/v1/companies/".concat(cid, "/all/orders/free/check"));
        case 2:
          _yield$request$get14 = _context20.sent;
          data = _yield$request$get14.data;
          return _context20.abrupt("return", data);
        case 5:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return function checkOrderFree(_x22) {
    return _ref24.apply(this, arguments);
  };
}();

// 查询企业详情信息
var getCompanyPackageDetail = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(cid) {
    var _yield$request$get15, data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return request$v.get("xstore/api/v2/companies/".concat(cid, "/service"));
        case 2:
          _yield$request$get15 = _context21.sent;
          data = _yield$request$get15.data;
          return _context21.abrupt("return", data);
        case 5:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function getCompanyPackageDetail(_x23) {
    return _ref25.apply(this, arguments);
  };
}();
var getCompanyPaidType = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(id) {
    var _yield$request$get16, data;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return request$v.get("/xstore/api/v1/companies/".concat(id, "/paid_type"));
        case 2:
          _yield$request$get16 = _context22.sent;
          data = _yield$request$get16.data;
          return _context22.abrupt("return", data);
        case 5:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return function getCompanyPaidType(_x24) {
    return _ref26.apply(this, arguments);
  };
}();

// 获取自动备份目录列表
var fetchBackupsSettingList = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
    var _yield$request$get17, data;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return request$v.get('/groups/v1/users/self/groups/backup');
        case 2:
          _yield$request$get17 = _context23.sent;
          data = _yield$request$get17.data;
          return _context23.abrupt("return", data);
        case 5:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return function fetchBackupsSettingList() {
    return _ref27.apply(this, arguments);
  };
}();

// 设置当前⽤户的⾃动备份位置
var setBackup = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(groupId) {
    var _yield$request$put2, data;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return request$v.put('/groups/v1/users/self/groups/backup/current_tmp', {
            group_id: groupId
          });
        case 2:
          _yield$request$put2 = _context24.sent;
          data = _yield$request$put2.data;
          return _context24.abrupt("return", data);
        case 5:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return function setBackup(_x25) {
    return _ref28.apply(this, arguments);
  };
}();

// 获取当前用户的默认目录
var fetchDefaultBackup = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
    var _yield$request$get18, data;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return request$v.get('/groups/v1/users/self/groups/backup/current_tmp');
        case 2:
          _yield$request$get18 = _context25.sent;
          data = _yield$request$get18.data;
          return _context25.abrupt("return", data);
        case 5:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return function fetchDefaultBackup() {
    return _ref29.apply(this, arguments);
  };
}();
// 接口层：消息埋点
var postEvents = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(params) {
    var _yield$request$post6, data;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return request$v.post('/ops/events-ship/api/v1/events', params);
        case 2:
          _yield$request$post6 = _context26.sent;
          data = _yield$request$post6.data;
          return _context26.abrupt("return", data);
        case 5:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return function postEvents(_x26) {
    return _ref30.apply(this, arguments);
  };
}();

// 接口层：新消息埋点
var postActivitytyEvents = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(params) {
    var _yield$request$post7, data;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return request$v.post('/ops/events-ship/api/v2/events', params);
        case 2:
          _yield$request$post7 = _context27.sent;
          data = _yield$request$post7.data;
          return _context27.abrupt("return", data);
        case 5:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return function postActivitytyEvents(_x27) {
    return _ref31.apply(this, arguments);
  };
}();

// 查询企业的云文档和自动备份
var getCompanyPrivate = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(cid) {
    var _yield$request$get19, data;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return request$v.get("/groups/v1/companies/".concat(cid, "/users/self/groups/private"));
        case 2:
          _yield$request$get19 = _context28.sent;
          data = _yield$request$get19.data;
          return _context28.abrupt("return", data && data.groups);
        case 5:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return function getCompanyPrivate(_x28) {
    return _ref32.apply(this, arguments);
  };
}();

// 获取文件的分享管控
var fetchCorpShareRanges = /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(gid) {
    var params,
      version,
      _yield$request$get20,
      data,
      _args29 = arguments;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          params = _args29.length > 1 && _args29[1] !== undefined ? _args29[1] : {};
          version = _args29.length > 2 && _args29[2] !== undefined ? _args29[2] : 'v2';
          _context29.next = 4;
          return request$v.get("/drive/".concat(version, "/groups/").concat(gid, "/links/ranges/sum"), {
            params: params
          });
        case 4:
          _yield$request$get20 = _context29.sent;
          data = _yield$request$get20.data;
          return _context29.abrupt("return", data);
        case 7:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return function fetchCorpShareRanges(_x29) {
    return _ref33.apply(this, arguments);
  };
}();

// 获取是否允许流转
var getSpreadControl = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(cid) {
    var params, _yield$request$get21, data;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          params = {
            company_id: cid
          };
          _context30.next = 3;
          return request$v.get('/drive/v1/user/companies/file/strategy/spread/control', {
            params: params
          });
        case 3:
          _yield$request$get21 = _context30.sent;
          data = _yield$request$get21.data;
          return _context30.abrupt("return", data);
        case 6:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return function getSpreadControl(_x30) {
    return _ref34.apply(this, arguments);
  };
}();
var updateGroupTemplate = function updateGroupTemplate(templateId, groupId) {
  return request$v.patch("".concat(PLUS, "/app/groupext/v1/group/templates/").concat(templateId, "/apply"), {
    group_id: groupId
  });
};

// 获取特定团队的链接权限范围
var fetchShareRanges = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(tid) {
    var _yield$request$get22, data;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return request$v.get("drive/v1/groups/".concat(tid, "/links/ranges?with_company_range=true"));
        case 2:
          _yield$request$get22 = _context31.sent;
          data = _yield$request$get22.data;
          return _context31.abrupt("return", data);
        case 5:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return function fetchShareRanges(_x31) {
    return _ref35.apply(this, arguments);
  };
}();

// 获取特定团队的链接权限范围
var setShareRanges = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(tid, value) {
    var reclaim,
      range,
      _yield$request$put3,
      data,
      _args32 = arguments;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          reclaim = _args32.length > 2 && _args32[2] !== undefined ? _args32[2] : false;
          // value为对象的时候，直接一整个传给range
          range = _typeof(value) === 'object' && Object.keys(value).length !== 0 ? value : {
            value: value
          };
          _context32.next = 4;
          return request$v.put("drive/v2/groups/".concat(tid, "/links/ranges"), {
            range: range,
            reclaim: reclaim
          });
        case 4:
          _yield$request$put3 = _context32.sent;
          data = _yield$request$put3.data;
          return _context32.abrupt("return", data);
        case 7:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return function setShareRanges(_x32, _x33) {
    return _ref36.apply(this, arguments);
  };
}();

// 获取权限回收任务转态 "not_exist" "fiting" "finish"
var fetchShareRangesTaskinfo = function () {
  try {
    var statusMap = {
      not_exist: undefined,
      fiting: true,
      finish: false
    };
    return /*#__PURE__*/function () {
      var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(groupId) {
        var _yield$request$get23, data;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return request$v.get("/drive/v1/admin/groups/".concat(groupId, "/fit/taskinfo"));
            case 2:
              _yield$request$get23 = _context33.sent;
              data = _yield$request$get23.data;
              return _context33.abrupt("return", statusMap[data.status] || statusMap.finish);
            case 5:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }));
      return function (_x34) {
        return _ref37.apply(this, arguments);
      };
    }();
  } catch (e) {
    return false;
  }
}();

// 创建团队，提交设审批
var submitGroupsApply = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(_ref38) {
    var cid, params, _yield$request$post8, data;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          cid = _ref38.cid, params = _objectWithoutProperties(_ref38, _excluded$4);
          _context34.next = 3;
          return request$v.post("/groups/v1/users/companies/".concat(cid, "/group/apply"), params);
        case 3:
          _yield$request$post8 = _context34.sent;
          data = _yield$request$post8.data;
          return _context34.abrupt("return", data || {});
        case 6:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return function submitGroupsApply(_x35) {
    return _ref39.apply(this, arguments);
  };
}();

// 创建团队，获取审批人列表
var getGroupApprovedBy = /*#__PURE__*/function () {
  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(cid) {
    var _yield$request$get24, _yield$request$get24$, data;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 2;
          return request$v.get("/groups/v1/users/companies/".concat(cid, "/group/apply/approvers"));
        case 2:
          _yield$request$get24 = _context35.sent;
          _yield$request$get24$ = _yield$request$get24.data;
          data = _yield$request$get24$ === void 0 ? {} : _yield$request$get24$;
          return _context35.abrupt("return", data);
        case 6:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return function getGroupApprovedBy(_x36) {
    return _ref40.apply(this, arguments);
  };
}();

// 获取团队申请审批列表
var getGroupApplyList = /*#__PURE__*/function () {
  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(_ref41) {
    var cid, params, _yield$request$get25, _yield$request$get25$, data;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          cid = _ref41.cid, params = _objectWithoutProperties(_ref41, _excluded2$2);
          params._t = Date.now();
          _context36.next = 4;
          return request$v.get("/groups/v1/users/companies/".concat(cid, "/group/apply"), {
            params: params
          });
        case 4:
          _yield$request$get25 = _context36.sent;
          _yield$request$get25$ = _yield$request$get25.data;
          data = _yield$request$get25$ === void 0 ? {} : _yield$request$get25$;
          return _context36.abrupt("return", data);
        case 8:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return function getGroupApplyList(_x37) {
    return _ref42.apply(this, arguments);
  };
}();

// 团队审批：撤销申请
var revertGroupApply = /*#__PURE__*/function () {
  var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(_ref43) {
    var cid, applyId, _yield$request$put4, data;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          cid = _ref43.cid, applyId = _ref43.applyId;
          _context37.next = 3;
          return request$v.put("/groups/v1/users/companies/".concat(cid, "/group/apply/").concat(applyId, "/revert"));
        case 3:
          _yield$request$put4 = _context37.sent;
          data = _yield$request$put4.data;
          return _context37.abrupt("return", data);
        case 6:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return function revertGroupApply(_x38) {
    return _ref44.apply(this, arguments);
  };
}();

// 团队审批：删除申请
function delGroupApply(_x39) {
  return _delGroupApply.apply(this, arguments);
}

// 团队审批：获取申请详情
function _delGroupApply() {
  _delGroupApply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(_ref45) {
    var cid, applyId, _yield$request$delete3, data;
    return _regeneratorRuntime.wrap(function _callee105$(_context105) {
      while (1) switch (_context105.prev = _context105.next) {
        case 0:
          cid = _ref45.cid, applyId = _ref45.applyId;
          _context105.next = 3;
          return request$v["delete"]("/groups/v1/users/companies/".concat(cid, "/group/apply/").concat(applyId));
        case 3:
          _yield$request$delete3 = _context105.sent;
          data = _yield$request$delete3.data;
          return _context105.abrupt("return", data);
        case 6:
        case "end":
          return _context105.stop();
      }
    }, _callee105);
  }));
  return _delGroupApply.apply(this, arguments);
}
function getGroupApplyDetail(_x40) {
  return _getGroupApplyDetail.apply(this, arguments);
}

// 团队审批: 查看审批开关
function _getGroupApplyDetail() {
  _getGroupApplyDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(_ref46) {
    var cid, applyId, _yield$request$get54, data;
    return _regeneratorRuntime.wrap(function _callee106$(_context106) {
      while (1) switch (_context106.prev = _context106.next) {
        case 0:
          cid = _ref46.cid, applyId = _ref46.applyId;
          _context106.next = 3;
          return request$v.get("/groups/v1/users/companies/".concat(cid, "/group/apply/").concat(applyId));
        case 3:
          _yield$request$get54 = _context106.sent;
          data = _yield$request$get54.data;
          return _context106.abrupt("return", data);
        case 6:
        case "end":
          return _context106.stop();
      }
    }, _callee106);
  }));
  return _getGroupApplyDetail.apply(this, arguments);
}
function getEntApproveStatus(_x41) {
  return _getEntApproveStatus.apply(this, arguments);
}
function _getEntApproveStatus() {
  _getEntApproveStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(cid) {
    var _yield$request$get55, data;
    return _regeneratorRuntime.wrap(function _callee107$(_context107) {
      while (1) switch (_context107.prev = _context107.next) {
        case 0:
          _context107.next = 2;
          return request$v.get("/groups/v1/users/companies/".concat(cid, "/group/apply/setting?t=").concat(Date.now()));
        case 2:
          _yield$request$get55 = _context107.sent;
          data = _yield$request$get55.data;
          return _context107.abrupt("return", data);
        case 5:
        case "end":
          return _context107.stop();
      }
    }, _callee107);
  }));
  return _getEntApproveStatus.apply(this, arguments);
}
var getPositionList = /*#__PURE__*/function () {
  var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(cid, groupid, params) {
    var _yield$request$get26, data;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          _context38.next = 2;
          return request$v.get("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/position"), {
            params: params
          });
        case 2:
          _yield$request$get26 = _context38.sent;
          data = _yield$request$get26.data;
          return _context38.abrupt("return", data || {});
        case 5:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return function getPositionList(_x42, _x43, _x44) {
    return _ref47.apply(this, arguments);
  };
}();
var getPositionMembers = /*#__PURE__*/function () {
  var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(cid, groupid, positionid, params) {
    var _yield$request$get27, data;
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          _context39.next = 2;
          return request$v.get("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/position/").concat(positionid, "/user"), {
            params: params
          });
        case 2:
          _yield$request$get27 = _context39.sent;
          data = _yield$request$get27.data;
          return _context39.abrupt("return", data || {});
        case 5:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return function getPositionMembers(_x45, _x46, _x47, _x48) {
    return _ref48.apply(this, arguments);
  };
}();
var getTagList = /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(cid, groupid, params) {
    var _yield$request$get28, data;
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          _context40.next = 2;
          return request$v.get("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/tag"), {
            params: params
          });
        case 2:
          _yield$request$get28 = _context40.sent;
          data = _yield$request$get28.data;
          return _context40.abrupt("return", data || {});
        case 5:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return function getTagList(_x49, _x50, _x51) {
    return _ref49.apply(this, arguments);
  };
}();
var getTagMembers = /*#__PURE__*/function () {
  var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(cid, groupid, tagid, params) {
    var _yield$request$get29, data;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          _context41.next = 2;
          return request$v.get("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/tag/").concat(tagid, "/user"), {
            params: params
          });
        case 2:
          _yield$request$get29 = _context41.sent;
          data = _yield$request$get29.data;
          return _context41.abrupt("return", data || {});
        case 5:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return function getTagMembers(_x52, _x53, _x54, _x55) {
    return _ref50.apply(this, arguments);
  };
}();
var renameCustomizeGroup = /*#__PURE__*/function () {
  var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(cid, groupid, tagid, params) {
    var _yield$request$put5, data;
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          _context42.next = 2;
          return request$v.put("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/tag/").concat(tagid), params);
        case 2:
          _yield$request$put5 = _context42.sent;
          data = _yield$request$put5.data;
          return _context42.abrupt("return", data);
        case 5:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return function renameCustomizeGroup(_x56, _x57, _x58, _x59) {
    return _ref51.apply(this, arguments);
  };
}();

// 批量添加成员到自定义组
var addMembersToGroup = /*#__PURE__*/function () {
  var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(cid, groupid, tagid, params) {
    var _yield$request$post9, data;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          _context43.next = 2;
          return request$v.post("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/tag/").concat(tagid, "/user"), params);
        case 2:
          _yield$request$post9 = _context43.sent;
          data = _yield$request$post9.data;
          return _context43.abrupt("return", data);
        case 5:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return function addMembersToGroup(_x60, _x61, _x62, _x63) {
    return _ref52.apply(this, arguments);
  };
}();

// 批量删除自定义组成员
var deleteGroupMembers = /*#__PURE__*/function () {
  var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(cid, groupid, tagid, params) {
    var _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          _context44.next = 2;
          return request$v["delete"]("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/tag/").concat(tagid, "/user"), {
            data: params
          });
        case 2:
          _yield$request$delete = _context44.sent;
          data = _yield$request$delete.data;
          return _context44.abrupt("return", data);
        case 5:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return function deleteGroupMembers(_x64, _x65, _x66, _x67) {
    return _ref53.apply(this, arguments);
  };
}();
var getFilePermissionList = /*#__PURE__*/function () {
  var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(groupid, params) {
    var _yield$request$get30, data;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          _context45.next = 2;
          return request$v.get("/drive/v1/admin/groups/".concat(groupid, "/compound/permissions"), params);
        case 2:
          _yield$request$get30 = _context45.sent;
          data = _yield$request$get30.data;
          return _context45.abrupt("return", data);
        case 5:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return function getFilePermissionList(_x68, _x69) {
    return _ref54.apply(this, arguments);
  };
}();

// 创建自定义组
var createCustomizeGroup = /*#__PURE__*/function () {
  var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(cid, groupid, params) {
    var _yield$request$post10, data;
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          _context46.next = 2;
          return request$v.post("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/tag"), params);
        case 2:
          _yield$request$post10 = _context46.sent;
          data = _yield$request$post10.data;
          return _context46.abrupt("return", data);
        case 5:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return function createCustomizeGroup(_x70, _x71, _x72) {
    return _ref55.apply(this, arguments);
  };
}();

// 删除自定义组
var deleteCustomizeGroup = /*#__PURE__*/function () {
  var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(cid, groupid, tagid) {
    var _yield$request$delete2, data;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          _context47.next = 2;
          return request$v["delete"]("/groups/v1/user/companies/".concat(cid, "/groups/").concat(groupid, "/tag/").concat(tagid));
        case 2:
          _yield$request$delete2 = _context47.sent;
          data = _yield$request$delete2.data;
          return _context47.abrupt("return", data);
        case 5:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return function deleteCustomizeGroup(_x73, _x74, _x75) {
    return _ref56.apply(this, arguments);
  };
}();
var getDepId = /*#__PURE__*/function () {
  var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(cid, groupid) {
    var _yield$request$get31, data;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          _context48.next = 2;
          return request$v.get("/app/job/v1/syncuser/companies/".concat(cid, "/deptgroups/").concat(groupid));
        case 2:
          _yield$request$get31 = _context48.sent;
          data = _yield$request$get31.data;
          return _context48.abrupt("return", data);
        case 5:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return function getDepId(_x76, _x77) {
    return _ref57.apply(this, arguments);
  };
}();

// 获取文件上传信息
var postFilesUploadCreate = /*#__PURE__*/function () {
  var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(params) {
    var _yield$request$post11, data;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          _context49.next = 2;
          return request$v.post('/app/groupext/v1/files/upload/create', params);
        case 2:
          _yield$request$post11 = _context49.sent;
          data = _yield$request$post11.data;
          return _context49.abrupt("return", data);
        case 5:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));
  return function postFilesUploadCreate(_x78) {
    return _ref58.apply(this, arguments);
  };
}();

// 奖励校验
var checkAwards = /*#__PURE__*/function () {
  var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(params) {
    var _yield$request$post12, data;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          _context50.next = 2;
          return request$v.post('/ops/activity/api/v1/awards/check', params);
        case 2:
          _yield$request$post12 = _context50.sent;
          data = _yield$request$post12.data;
          return _context50.abrupt("return", data);
        case 5:
        case "end":
          return _context50.stop();
      }
    }, _callee50);
  }));
  return function checkAwards(_x79) {
    return _ref59.apply(this, arguments);
  };
}();

// 领取奖励
var getAwards = /*#__PURE__*/function () {
  var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(params) {
    var _yield$request$post13, data;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          _context51.next = 2;
          return request$v.post('/ops/activity/api/v1/awards/receive', params);
        case 2:
          _yield$request$post13 = _context51.sent;
          data = _yield$request$post13.data;
          return _context51.abrupt("return", data);
        case 5:
        case "end":
          return _context51.stop();
      }
    }, _callee51);
  }));
  return function getAwards(_x80) {
    return _ref60.apply(this, arguments);
  };
}();

// 判断权益
var getUpgradeablePkg = /*#__PURE__*/function () {
  var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(params) {
    var _yield$request$get32, data;
    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          _context52.next = 2;
          return request$v.get('/privilege/api/v1/spackages/upgradable', {
            params: params
          });
        case 2:
          _yield$request$get32 = _context52.sent;
          data = _yield$request$get32.data;
          return _context52.abrupt("return", data);
        case 5:
        case "end":
          return _context52.stop();
      }
    }, _callee52);
  }));
  return function getUpgradeablePkg(_x81) {
    return _ref61.apply(this, arguments);
  };
}();

// 判断批量权益是否同等级
var checkBatchPrivilege = /*#__PURE__*/function () {
  var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(params) {
    var data;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) switch (_context53.prev = _context53.next) {
        case 0:
          _context53.next = 2;
          return request$v.post('/privilege/api/v2/spackages/priv/exists/batch', params);
        case 2:
          data = _context53.sent;
          return _context53.abrupt("return", data);
        case 4:
        case "end":
          return _context53.stop();
      }
    }, _callee53);
  }));
  return function checkBatchPrivilege(_x82) {
    return _ref62.apply(this, arguments);
  };
}();
var getPrivilegeInfo = /*#__PURE__*/function () {
  var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(spackageName, privilegeName) {
    var _yield$request$get33, data;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) switch (_context54.prev = _context54.next) {
        case 0:
          _context54.next = 2;
          return request$v.get("/privilege/api/v1/spackages/".concat(spackageName, "/privs/").concat(privilegeName, "/config"));
        case 2:
          _yield$request$get33 = _context54.sent;
          data = _yield$request$get33.data;
          return _context54.abrupt("return", data);
        case 5:
        case "end":
          return _context54.stop();
      }
    }, _callee54);
  }));
  return function getPrivilegeInfo(_x83, _x84) {
    return _ref63.apply(this, arguments);
  };
}();

// 获取推荐套餐
var getWaterMarkUpgradablePkg = /*#__PURE__*/function () {
  var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
    var _yield$request$get34, data;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) switch (_context55.prev = _context55.next) {
        case 0:
          _context55.next = 2;
          return request$v.get('/privilege/api/v1/spackages/watermark/upgradable');
        case 2:
          _yield$request$get34 = _context55.sent;
          data = _yield$request$get34.data;
          return _context55.abrupt("return", data);
        case 5:
        case "end":
          return _context55.stop();
      }
    }, _callee55);
  }));
  return function getWaterMarkUpgradablePkg() {
    return _ref64.apply(this, arguments);
  };
}();
var getSharedTeamCounts = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(companyId, groupId) {
    var _yield$request$get35, data;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) switch (_context56.prev = _context56.next) {
        case 0:
          _context56.next = 2;
          return request$v.get("/drive/v1/companies/".concat(companyId, "/groups/").concat(groupId, "/link/setting/count"));
        case 2:
          _yield$request$get35 = _context56.sent;
          data = _yield$request$get35.data;
          return _context56.abrupt("return", data);
        case 5:
        case "end":
          return _context56.stop();
      }
    }, _callee56);
  }));
  return function getSharedTeamCounts(_x85, _x86) {
    return _ref65.apply(this, arguments);
  };
}();

/**
 * @desc 文件复制到新团队并分享: 将用户文件复制到一个新建的团队内并生成文件的分享链接和团队的邀请链接
 * @param company_id 公司ID
 * @param group_id 团队ID
 * @param file_id 文件ID
 * @param other 其他
 *  @param group_name 团队名称
 *
 */
var createCopyFilesAndShare = /*#__PURE__*/function () {
  var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(params) {
    var companyId, groupId, fileId, other, _yield$request$post14, data;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) switch (_context57.prev = _context57.next) {
        case 0:
          companyId = params.company_id, groupId = params.group_id, fileId = params.file_id, other = _objectWithoutProperties(params, _excluded3$1);
          _context57.next = 3;
          return request$v.post("groups/v1/companies/".concat(companyId, "/groups/").concat(groupId, "/files/").concat(fileId, "/copy"), other);
        case 3:
          _yield$request$post14 = _context57.sent;
          data = _yield$request$post14.data;
          return _context57.abrupt("return", data);
        case 6:
        case "end":
          return _context57.stop();
      }
    }, _callee57);
  }));
  return function createCopyFilesAndShare(_x87) {
    return _ref66.apply(this, arguments);
  };
}();
var getGroupCount = /*#__PURE__*/function () {
  var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(companyId, type) {
    var _yield$request$get36, data;
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) switch (_context58.prev = _context58.next) {
        case 0:
          _context58.next = 2;
          return request$v.get("groups/v1/companies/".concat(companyId, "/groups/num"), {
            params: {
              type: type
            }
          });
        case 2:
          _yield$request$get36 = _context58.sent;
          data = _yield$request$get36.data;
          return _context58.abrupt("return", data);
        case 5:
        case "end":
          return _context58.stop();
      }
    }, _callee58);
  }));
  return function getGroupCount(_x88, _x89) {
    return _ref67.apply(this, arguments);
  };
}();
/**
 * 获取成长计划活动列表
 * @params
 *
 */
var getGrowthActivitiesList = /*#__PURE__*/function () {
  var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(companyId) {
    var _yield$request$get37, data;
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) switch (_context59.prev = _context59.next) {
        case 0:
          _context59.next = 2;
          return request$v.get("/ops/activity/api/v2/growth/levels?company_id=".concat(companyId));
        case 2:
          _yield$request$get37 = _context59.sent;
          data = _yield$request$get37.data;
          return _context59.abrupt("return", data);
        case 5:
        case "end":
          return _context59.stop();
      }
    }, _callee59);
  }));
  return function getGrowthActivitiesList(_x90) {
    return _ref68.apply(this, arguments);
  };
}();

/**
 * 成长计划：领取权益
 * @params
 *
 */
var receiveGrowthActivity = /*#__PURE__*/function () {
  var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(companyId, level) {
    var _yield$request$post15, data;
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) switch (_context60.prev = _context60.next) {
        case 0:
          _context60.next = 2;
          return request$v.post('/ops/activity/api/v2/growth/awards/receive', {
            company_id: companyId,
            level: level
          });
        case 2:
          _yield$request$post15 = _context60.sent;
          data = _yield$request$post15.data;
          return _context60.abrupt("return", data);
        case 5:
        case "end":
          return _context60.stop();
      }
    }, _callee60);
  }));
  return function receiveGrowthActivity(_x91, _x92) {
    return _ref69.apply(this, arguments);
  };
}();
var getOnsalePackages = /*#__PURE__*/function () {
  var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(qfields) {
    var _yield$request$get38, data;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) switch (_context61.prev = _context61.next) {
        case 0:
          _context61.next = 2;
          return request$v.get('/privilege/api/v1/spackages', {
            params: qfields
          });
        case 2:
          _yield$request$get38 = _context61.sent;
          data = _yield$request$get38.data;
          return _context61.abrupt("return", data);
        case 5:
        case "end":
          return _context61.stop();
      }
    }, _callee61);
  }));
  return function getOnsalePackages(_x93) {
    return _ref70.apply(this, arguments);
  };
}();

// 团队外链管理入口策略
var getTeamLinkPolicy = /*#__PURE__*/function () {
  var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(companyId, key) {
    var _yield$request$get39, data;
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) switch (_context62.prev = _context62.next) {
        case 0:
          _context62.next = 2;
          return request$v.get("/ops/opsd/api/v1/policy?window_key=".concat(key, "&company_id=").concat(companyId));
        case 2:
          _yield$request$get39 = _context62.sent;
          data = _yield$request$get39.data;
          return _context62.abrupt("return", data);
        case 5:
        case "end":
          return _context62.stop();
      }
    }, _callee62);
  }));
  return function getTeamLinkPolicy(_x94, _x95) {
    return _ref71.apply(this, arguments);
  };
}();

/**
 * @desc 统一协议记录接口
 * @params {Object}
 * @param agreements {array} {link: string, name: string}[]
 *
 */
var reportAgreeLicense = /*#__PURE__*/function () {
  var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(params) {
    var _yield$request$post16, data;
    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) switch (_context63.prev = _context63.next) {
        case 0:
          _context63.next = 2;
          return request$v.post('/ops/events-ship/api/v1/agreements', params);
        case 2:
          _yield$request$post16 = _context63.sent;
          data = _yield$request$post16.data;
          return _context63.abrupt("return", data);
        case 5:
        case "end":
          return _context63.stop();
      }
    }, _callee63);
  }));
  return function reportAgreeLicense(_x96) {
    return _ref72.apply(this, arguments);
  };
}();

// 新手任务进度查询
var getNewcomerTask = /*#__PURE__*/function () {
  var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(companyId, source) {
    var _yield$request$get40, data;
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) switch (_context64.prev = _context64.next) {
        case 0:
          _context64.next = 2;
          return request$v.get("/ops/activity/api/v1/newcomer-tasks?company_id=".concat(companyId, "&source=").concat(source));
        case 2:
          _yield$request$get40 = _context64.sent;
          data = _yield$request$get40.data;
          return _context64.abrupt("return", data);
        case 5:
        case "end":
          return _context64.stop();
      }
    }, _callee64);
  }));
  return function getNewcomerTask(_x97, _x98) {
    return _ref73.apply(this, arguments);
  };
}();

/**
 * 公共领奖入口
 * @params
 *
 */
var fetchActivityReceive = /*#__PURE__*/function () {
  var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(params) {
    var _yield$request$post17, data;
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) switch (_context65.prev = _context65.next) {
        case 0:
          _context65.next = 2;
          return request$v.post('/ops/activity/api/v1/awards/receive', params);
        case 2:
          _yield$request$post17 = _context65.sent;
          data = _yield$request$post17.data;
          return _context65.abrupt("return", data);
        case 5:
        case "end":
          return _context65.stop();
      }
    }, _callee65);
  }));
  return function fetchActivityReceive(_x99) {
    return _ref74.apply(this, arguments);
  };
}();

// 获得团队相关的配置
var getTeamConfig = /*#__PURE__*/function () {
  var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(companyId) {
    var _yield$request$get41, data;
    return _regeneratorRuntime.wrap(function _callee66$(_context66) {
      while (1) switch (_context66.prev = _context66.next) {
        case 0:
          _context66.next = 2;
          return request$v.get("/app/job/v1/syncuser/companies/".concat(companyId, "/config"));
        case 2:
          _yield$request$get41 = _context66.sent;
          data = _yield$request$get41.data;
          return _context66.abrupt("return", data);
        case 5:
        case "end":
          return _context66.stop();
      }
    }, _callee66);
  }));
  return function getTeamConfig(_x100) {
    return _ref75.apply(this, arguments);
  };
}();

// 活动管理平台---完成任务
var complateMission = /*#__PURE__*/function () {
  var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(params) {
    var activityId, missionId, _yield$request$post18, data;
    return _regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) switch (_context67.prev = _context67.next) {
        case 0:
          activityId = params.activity_id, missionId = params.mission_id;
          _context67.next = 3;
          return request$v.post("/ops/activity/api/v1/activities/".concat(activityId, "/missions/").concat(missionId, "/conditions"), params);
        case 3:
          _yield$request$post18 = _context67.sent;
          data = _yield$request$post18.data;
          return _context67.abrupt("return", data);
        case 6:
        case "end":
          return _context67.stop();
      }
    }, _callee67);
  }));
  return function complateMission(_x101) {
    return _ref76.apply(this, arguments);
  };
}();

// 活动管理平台---查询任务情况
var checkMission = /*#__PURE__*/function () {
  var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(params) {
    var activityId, missionId, _yield$request$get42, data;
    return _regeneratorRuntime.wrap(function _callee68$(_context68) {
      while (1) switch (_context68.prev = _context68.next) {
        case 0:
          activityId = params.activity_id, missionId = params.mission_id;
          _context68.next = 3;
          return request$v.get("/ops/activity/api/v1/activities/".concat(activityId, "/missions/").concat(missionId), {
            params: params
          });
        case 3:
          _yield$request$get42 = _context68.sent;
          data = _yield$request$get42.data;
          return _context68.abrupt("return", data);
        case 6:
        case "end":
          return _context68.stop();
      }
    }, _callee68);
  }));
  return function checkMission(_x102) {
    return _ref77.apply(this, arguments);
  };
}();

// 活动管理平台---领取奖励
var receiveMission = /*#__PURE__*/function () {
  var _ref78 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(params) {
    var activityId, missionId, _yield$request$post19, data;
    return _regeneratorRuntime.wrap(function _callee69$(_context69) {
      while (1) switch (_context69.prev = _context69.next) {
        case 0:
          activityId = params.activity_id, missionId = params.mission_id;
          _context69.next = 3;
          return request$v.post("/ops/activity/api/v1/activities/".concat(activityId, "/missions/").concat(missionId, "/awards"), params);
        case 3:
          _yield$request$post19 = _context69.sent;
          data = _yield$request$post19.data;
          return _context69.abrupt("return", data);
        case 6:
        case "end":
          return _context69.stop();
      }
    }, _callee69);
  }));
  return function receiveMission(_x103) {
    return _ref78.apply(this, arguments);
  };
}();
// 活动管理平台---领取最终奖励
var receiveMissionFinal = /*#__PURE__*/function () {
  var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(params) {
    var activityId, _yield$request$post20, data;
    return _regeneratorRuntime.wrap(function _callee70$(_context70) {
      while (1) switch (_context70.prev = _context70.next) {
        case 0:
          activityId = params.activity_id;
          _context70.next = 3;
          return request$v.post("/ops/activity/api/v1/activities/".concat(activityId, "/final-awards"), params);
        case 3:
          _yield$request$post20 = _context70.sent;
          data = _yield$request$post20.data;
          return _context70.abrupt("return", data);
        case 6:
        case "end":
          return _context70.stop();
      }
    }, _callee70);
  }));
  return function receiveMissionFinal(_x104) {
    return _ref79.apply(this, arguments);
  };
}();

// 查看是否企业权益是否充足
var checkGqlPrivilege = /*#__PURE__*/function () {
  var _ref80 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(key, cid, gid) {
    var _yield$request$post21, data;
    return _regeneratorRuntime.wrap(function _callee71$(_context71) {
      while (1) switch (_context71.prev = _context71.next) {
        case 0:
          _context71.prev = 0;
          _context71.next = 3;
          return request$v.post('/gql', {
            query: "{\n        privileges {\n          getPrivilege(companyID: ".concat(cid, ", keys: ").concat(key, ", ").concat(gid ? "groupID: ".concat(gid) : '', ") {\n            key\n            status\n            total\n            used\n          }\n        }\n      }")
          });
        case 3:
          _yield$request$post21 = _context71.sent;
          data = _yield$request$post21.data;
          return _context71.abrupt("return", data.data.privileges.getPrivilege[0]);
        case 8:
          _context71.prev = 8;
          _context71.t0 = _context71["catch"](0);
        case 10:
        case "end":
          return _context71.stop();
      }
    }, _callee71, null, [[0, 8]]);
  }));
  return function checkGqlPrivilege(_x105, _x106, _x107) {
    return _ref80.apply(this, arguments);
  };
}();

// 查看企业多个权益是否充足
var checkGqlPrivileges = /*#__PURE__*/function () {
  var _ref81 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(keys, cid, gid) {
    var _yield$request$post22, data;
    return _regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) switch (_context72.prev = _context72.next) {
        case 0:
          _context72.next = 2;
          return request$v.post('/gql', {
            query: "{\n      privileges {\n        getPrivilege(companyID: ".concat(cid, ", keys: [").concat(keys, "], ").concat(gid ? "groupID: ".concat(gid) : '', ") {\n          key\n          status\n          total\n          used\n        }\n      }\n    }")
          });
        case 2:
          _yield$request$post22 = _context72.sent;
          data = _yield$request$post22.data;
          return _context72.abrupt("return", data.data.privileges.getPrivilege);
        case 5:
        case "end":
          return _context72.stop();
      }
    }, _callee72);
  }));
  return function checkGqlPrivileges(_x108, _x109, _x110) {
    return _ref81.apply(this, arguments);
  };
}();

// 查看企业是否有资格获取叠加包包
var checkCanReceiveAwards = /*#__PURE__*/function () {
  var _ref83 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(_ref82) {
    var cid, activityKey, activitySubKey, windowKey, checkType, _yield$request$post23, data;
    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
      while (1) switch (_context73.prev = _context73.next) {
        case 0:
          cid = _ref82.cid, activityKey = _ref82.activityKey, activitySubKey = _ref82.activitySubKey, windowKey = _ref82.windowKey, checkType = _ref82.checkType;
          _context73.next = 3;
          return request$v.post('/gql', {
            query: "{\n      awards {\n        checkAwardsInfo(activityKey: \"".concat(activityKey, "\", companyID: ").concat(cid, ",windowKey: \"").concat(windowKey, "\",checkType:").concat(checkType, ", activitySubKey: \"").concat(activitySubKey, "\") {\n          key\n          status\n          code,\n          record {\n            award_key\n            award_name\n            end_at\n            id\n            start_at\n            validTerm\n          }\n        }\n      }\n    }")
          });
        case 3:
          _yield$request$post23 = _context73.sent;
          data = _yield$request$post23.data;
          return _context73.abrupt("return", data.data.awards.checkAwardsInfo);
        case 6:
        case "end":
          return _context73.stop();
      }
    }, _callee73);
  }));
  return function checkCanReceiveAwards(_x111) {
    return _ref83.apply(this, arguments);
  };
}();
function getCompanyRevokeSetting(cid) {
  return request$v.get("/orderadm/api/v1/adm/companies/".concat(cid, "/service/revoke/setting")).then(function (res) {
    return {
      user_type: res.data.company_user_type.user_type,
      revoke_buffer_time: res.data.revoke_buffer_time
    };
  });
}
var confirmRevokeQueue = /*#__PURE__*/function () {
  var _ref84 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(cid) {
    var _yield$request$post$t, data;
    return _regeneratorRuntime.wrap(function _callee74$(_context74) {
      while (1) switch (_context74.prev = _context74.next) {
        case 0:
          _context74.next = 2;
          return request$v.post("/orderadm/api/v1/adm/companies/".concat(cid, "/service/revoke/queue")).then(function (res) {
            return res.data;
          });
        case 2:
          _yield$request$post$t = _context74.sent;
          data = _yield$request$post$t.data;
          return _context74.abrupt("return", data);
        case 5:
        case "end":
          return _context74.stop();
      }
    }, _callee74);
  }));
  return function confirmRevokeQueue(_x112) {
    return _ref84.apply(this, arguments);
  };
}();

// 获取团队banner的卡片状态
var getGroupsBannerStatus = /*#__PURE__*/function () {
  var _ref85 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(params) {
    return _regeneratorRuntime.wrap(function _callee75$(_context75) {
      while (1) switch (_context75.prev = _context75.next) {
        case 0:
          _context75.next = 2;
          return request$v.post('/ops/activity/api/v1/activities/group-train/cards/states', params);
        case 2:
          return _context75.abrupt("return", _context75.sent);
        case 3:
        case "end":
          return _context75.stop();
      }
    }, _callee75);
  }));
  return function getGroupsBannerStatus(_x113) {
    return _ref85.apply(this, arguments);
  };
}();

// 设置团队banner的卡片状态
var setGroupsBannerStatus = /*#__PURE__*/function () {
  var _ref86 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(params) {
    return _regeneratorRuntime.wrap(function _callee76$(_context76) {
      while (1) switch (_context76.prev = _context76.next) {
        case 0:
          _context76.next = 2;
          return request$v.post('/ops/activity/api/v1/activities/group-train/cards/state', params);
        case 2:
          return _context76.abrupt("return", _context76.sent);
        case 3:
        case "end":
          return _context76.stop();
      }
    }, _callee76);
  }));
  return function setGroupsBannerStatus(_x114) {
    return _ref86.apply(this, arguments);
  };
}();

// 卡夫卡埋点
var serverDw = /*#__PURE__*/function () {
  var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(params) {
    return _regeneratorRuntime.wrap(function _callee77$(_context77) {
      while (1) switch (_context77.prev = _context77.next) {
        case 0:
          _context77.next = 2;
          return request$v.post('/ops/events-ship/api/v1/events/web', params);
        case 2:
          return _context77.abrupt("return", _context77.sent);
        case 3:
        case "end":
          return _context77.stop();
      }
    }, _callee77);
  }));
  return function serverDw(_x115) {
    return _ref87.apply(this, arguments);
  };
}();

// 申请目录权限
var applyCatalogPermission = /*#__PURE__*/function () {
  var _ref88 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(params) {
    return _regeneratorRuntime.wrap(function _callee78$(_context78) {
      while (1) switch (_context78.prev = _context78.next) {
        case 0:
          _context78.next = 2;
          return request$v.post('/drive/v2/user/group/file/permission/apply', params);
        case 2:
          return _context78.abrupt("return", _context78.sent);
        case 3:
        case "end":
          return _context78.stop();
      }
    }, _callee78);
  }));
  return function applyCatalogPermission(_x116) {
    return _ref88.apply(this, arguments);
  };
}();

// 申请目录权限审批者
var applyCatalogApprover = /*#__PURE__*/function () {
  var _ref89 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(cid) {
    return _regeneratorRuntime.wrap(function _callee79$(_context79) {
      while (1) switch (_context79.prev = _context79.next) {
        case 0:
          _context79.next = 2;
          return request$v.get("/drive/v2/user/group/file/permission/approver/list?cid=".concat(cid));
        case 2:
          return _context79.abrupt("return", _context79.sent);
        case 3:
        case "end":
          return _context79.stop();
      }
    }, _callee79);
  }));
  return function applyCatalogApprover(_x117) {
    return _ref89.apply(this, arguments);
  };
}();

// 获取账号列表的文件流转企业级控制状态
var getAccountListWithSpread = function getAccountListWithSpread(params) {
  return request$v.get('/drive/v1/user/accounts/companies/file/strategy/spread/control', params);
};

// 获取权益分配推荐用户
var getVipAllocationUsers = /*#__PURE__*/function () {
  var _ref90 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(params) {
    var companyId, _yield$request$get43, data;
    return _regeneratorRuntime.wrap(function _callee80$(_context80) {
      while (1) switch (_context80.prev = _context80.next) {
        case 0:
          companyId = params.company_id;
          _context80.next = 3;
          return request$v.get("/ops/activity/api/v1/activitis/promote1to3/companies/".concat(companyId, "/users"), {
            params: params
          });
        case 3:
          _yield$request$get43 = _context80.sent;
          data = _yield$request$get43.data;
          return _context80.abrupt("return", data);
        case 6:
        case "end":
          return _context80.stop();
      }
    }, _callee80);
  }));
  return function getVipAllocationUsers(_x118) {
    return _ref90.apply(this, arguments);
  };
}();

// 给用户分配权益
var applyVipAllocationUsers = /*#__PURE__*/function () {
  var _ref91 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(params) {
    var companyId, _yield$request$post24, data;
    return _regeneratorRuntime.wrap(function _callee81$(_context81) {
      while (1) switch (_context81.prev = _context81.next) {
        case 0:
          companyId = params.company_id;
          _context81.next = 3;
          return request$v.post("/ops/activity/api/v1/activitis/promote1to3/companies/".concat(companyId, "/priv/allocate"), params);
        case 3:
          _yield$request$post24 = _context81.sent;
          data = _yield$request$post24.data;
          return _context81.abrupt("return", data);
        case 6:
        case "end":
          return _context81.stop();
      }
    }, _callee81);
  }));
  return function applyVipAllocationUsers(_x119) {
    return _ref91.apply(this, arguments);
  };
}();

// 动态获取付费文案
var getPayText = /*#__PURE__*/function () {
  var _ref92 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(cid, params) {
    var _yield$request$get44, data;
    return _regeneratorRuntime.wrap(function _callee82$(_context82) {
      while (1) switch (_context82.prev = _context82.next) {
        case 0:
          _context82.next = 2;
          return request$v.get("/orderadm/api/v2/buy/companies/".concat(cid, "/setting/tips"), {
            params: params
          });
        case 2:
          _yield$request$get44 = _context82.sent;
          data = _yield$request$get44.data;
          return _context82.abrupt("return", data);
        case 5:
        case "end":
          return _context82.stop();
      }
    }, _callee82);
  }));
  return function getPayText(_x120, _x121) {
    return _ref92.apply(this, arguments);
  };
}();

// 动态获取付费文案
var fetchCompanyPayConfig = /*#__PURE__*/function () {
  var _ref93 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83(cid, params) {
    var _yield$request$get45, data;
    return _regeneratorRuntime.wrap(function _callee83$(_context83) {
      while (1) switch (_context83.prev = _context83.next) {
        case 0:
          _context83.next = 2;
          return request$v.get("/orderadm/api/v1/buy/companies/".concat(cid, "/setting/tips"), {
            params: params
          });
        case 2:
          _yield$request$get45 = _context83.sent;
          data = _yield$request$get45.data;
          return _context83.abrupt("return", data);
        case 5:
        case "end":
          return _context83.stop();
      }
    }, _callee83);
  }));
  return function fetchCompanyPayConfig(_x122, _x123) {
    return _ref93.apply(this, arguments);
  };
}();

// 弹窗popup打标签
var popUpDialogTag = /*#__PURE__*/function () {
  var _ref94 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(cid) {
    var tagType,
      _yield$request$post25,
      data,
      _args84 = arguments;
    return _regeneratorRuntime.wrap(function _callee84$(_context84) {
      while (1) switch (_context84.prev = _context84.next) {
        case 0:
          tagType = _args84.length > 1 && _args84[1] !== undefined ? _args84[1] : 'revoke';
          _context84.next = 3;
          return request$v.post("/orderadm/api/v1/adm/companies/".concat(cid, "/").concat(tagType, "/popup"));
        case 3:
          _yield$request$post25 = _context84.sent;
          data = _yield$request$post25.data;
          return _context84.abrupt("return", data);
        case 6:
        case "end":
          return _context84.stop();
      }
    }, _callee84);
  }));
  return function popUpDialogTag(_x124) {
    return _ref94.apply(this, arguments);
  };
}();

// 信息收集
var postCollections = /*#__PURE__*/function () {
  var _ref95 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(params) {
    var _yield$request$post26, data;
    return _regeneratorRuntime.wrap(function _callee85$(_context85) {
      while (1) switch (_context85.prev = _context85.next) {
        case 0:
          _context85.next = 2;
          return request$v.post('/ops/events-ship/api/v1/collections', params);
        case 2:
          _yield$request$post26 = _context85.sent;
          data = _yield$request$post26.data;
          return _context85.abrupt("return", data);
        case 5:
        case "end":
          return _context85.stop();
      }
    }, _callee85);
  }));
  return function postCollections(_x125) {
    return _ref95.apply(this, arguments);
  };
}();
var getTeamSpaceInfo = /*#__PURE__*/function () {
  var _ref96 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(options) {
    var _yield$request$get46, data;
    return _regeneratorRuntime.wrap(function _callee86$(_context86) {
      while (1) switch (_context86.prev = _context86.next) {
        case 0:
          _context86.next = 2;
          return request$v.get("/groups/v1/team/convert-group/status", options);
        case 2:
          _yield$request$get46 = _context86.sent;
          data = _yield$request$get46.data;
          return _context86.abrupt("return", data);
        case 5:
        case "end":
          return _context86.stop();
      }
    }, _callee86);
  }));
  return function getTeamSpaceInfo(_x126) {
    return _ref96.apply(this, arguments);
  };
}();
var upgradeGroupToTeamspace = /*#__PURE__*/function () {
  var _ref97 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(id) {
    var dt,
      _yield$request$post27,
      data,
      _args87 = arguments;
    return _regeneratorRuntime.wrap(function _callee87$(_context87) {
      while (1) switch (_context87.prev = _context87.next) {
        case 0:
          dt = _args87.length > 1 && _args87[1] !== undefined ? _args87[1] : {};
          _context87.next = 3;
          return request$v.post('/groups/v1/team/convert-group/corpgroup', Object.assign({
            group_id: id
          }, dt));
        case 3:
          _yield$request$post27 = _context87.sent;
          data = _yield$request$post27.data;
          return _context87.abrupt("return", data);
        case 6:
        case "end":
          return _context87.stop();
      }
    }, _callee87);
  }));
  return function upgradeGroupToTeamspace(_x127) {
    return _ref97.apply(this, arguments);
  };
}();
// 申请开通协作空间
var sendApplyNotice = /*#__PURE__*/function () {
  var _ref98 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(id) {
    return _regeneratorRuntime.wrap(function _callee88$(_context88) {
      while (1) switch (_context88.prev = _context88.next) {
        case 0:
          _context88.next = 2;
          return request$v.post("/groups/v1/team/groups/".concat(id, "/apply"));
        case 2:
          return _context88.abrupt("return", _context88.sent);
        case 3:
        case "end":
          return _context88.stop();
      }
    }, _callee88);
  }));
  return function sendApplyNotice(_x128) {
    return _ref98.apply(this, arguments);
  };
}();

/**
 * 获取企业付费文案
 */
var getCompPaidText = /*#__PURE__*/function () {
  var _ref99 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(companyID) {
    var _yield$request$get47, data;
    return _regeneratorRuntime.wrap(function _callee89$(_context89) {
      while (1) switch (_context89.prev = _context89.next) {
        case 0:
          _context89.next = 2;
          return request$v.get("orderadm/api/v1/buy/companies/".concat(companyID, "/svc/ordertype/allowed"));
        case 2:
          _yield$request$get47 = _context89.sent;
          data = _yield$request$get47.data;
          return _context89.abrupt("return", data);
        case 5:
        case "end":
          return _context89.stop();
      }
    }, _callee89);
  }));
  return function getCompPaidText(_x129) {
    return _ref99.apply(this, arguments);
  };
}();

// 获取“允许文件创建者管理自己创建的文件”开关配置
var getCreatorManageStatus = /*#__PURE__*/function () {
  var _ref100 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90(groupId) {
    var params;
    return _regeneratorRuntime.wrap(function _callee90$(_context90) {
      while (1) switch (_context90.prev = _context90.next) {
        case 0:
          params = {
            setting_type: 'FileOwnerManageFile'
          };
          _context90.next = 3;
          return request$v.get("/drive/v1/admin/groups/".concat(groupId, "/perm/setting"), {
            params: params
          });
        case 3:
          return _context90.abrupt("return", _context90.sent);
        case 4:
        case "end":
          return _context90.stop();
      }
    }, _callee90);
  }));
  return function getCreatorManageStatus(_x130) {
    return _ref100.apply(this, arguments);
  };
}();

// 允许文件创建者管理自己创建的文件- 开关
var putCreatorManageStatus = /*#__PURE__*/function () {
  var _ref102 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(_ref101) {
    var groupId, allow, params;
    return _regeneratorRuntime.wrap(function _callee91$(_context91) {
      while (1) switch (_context91.prev = _context91.next) {
        case 0:
          groupId = _ref101.group_id, allow = _ref101.allow;
          params = {
            setting_type: 'FileOwnerManageFile',
            allow: allow
          };
          _context91.next = 4;
          return request$v.put("/drive/v1/admin/groups/".concat(groupId, "/perm/setting"), params);
        case 4:
          return _context91.abrupt("return", _context91.sent);
        case 5:
        case "end":
          return _context91.stop();
      }
    }, _callee91);
  }));
  return function putCreatorManageStatus(_x131) {
    return _ref102.apply(this, arguments);
  };
}();

// 获取企业的分享范围
var getCompanyShareRange = /*#__PURE__*/function () {
  var _ref103 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92(companyId) {
    var _yield$request$get48, data;
    return _regeneratorRuntime.wrap(function _callee92$(_context92) {
      while (1) switch (_context92.prev = _context92.next) {
        case 0:
          _context92.next = 2;
          return request$v.get("/drive/v1/user/companies/".concat(companyId, "/links/ranges"));
        case 2:
          _yield$request$get48 = _context92.sent;
          data = _yield$request$get48.data;
          return _context92.abrupt("return", data);
        case 5:
        case "end":
          return _context92.stop();
      }
    }, _callee92);
  }));
  return function getCompanyShareRange(_x132) {
    return _ref103.apply(this, arguments);
  };
}();

// 批量权限设置
var putBatchRangePerm = /*#__PURE__*/function () {
  var _ref105 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(_ref104) {
    var rangeType, permId, fileIds, groupId;
    return _regeneratorRuntime.wrap(function _callee93$(_context93) {
      while (1) switch (_context93.prev = _context93.next) {
        case 0:
          rangeType = _ref104.rangeType, permId = _ref104.permId, fileIds = _ref104.fileIds, groupId = _ref104.groupId;
          _context93.next = 3;
          return request$v.put("drive/v1/admin/groups/".concat(groupId, "/range/perm/batch"), {
            compound_id: permId,
            range_id: rangeType,
            file_ids: fileIds
          });
        case 3:
          return _context93.abrupt("return", _context93.sent);
        case 4:
        case "end":
          return _context93.stop();
      }
    }, _callee93);
  }));
  return function putBatchRangePerm(_x133) {
    return _ref105.apply(this, arguments);
  };
}();

// 返回企业用户管理后台未读消息
var getUnReadMessage = /*#__PURE__*/function () {
  var _ref106 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94() {
    var _yield$request$get49, data;
    return _regeneratorRuntime.wrap(function _callee94$(_context94) {
      while (1) switch (_context94.prev = _context94.next) {
        case 0:
          _context94.prev = 0;
          _context94.next = 3;
          return request$v.get("/app/plusmsg/api/v1/p/message/unread?app_id=1&terminal=7&_t=".concat(Date.now()));
        case 3:
          _yield$request$get49 = _context94.sent;
          data = _yield$request$get49.data;
          return _context94.abrupt("return", data.messages || []);
        case 8:
          _context94.prev = 8;
          _context94.t0 = _context94["catch"](0);
          return _context94.abrupt("return", []);
        case 11:
        case "end":
          return _context94.stop();
      }
    }, _callee94, null, [[0, 8]]);
  }));
  return function getUnReadMessage() {
    return _ref106.apply(this, arguments);
  };
}();

// 未读消息标记为已读接口
var setRendMessage = /*#__PURE__*/function () {
  var _ref107 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(msgId) {
    return _regeneratorRuntime.wrap(function _callee95$(_context95) {
      while (1) switch (_context95.prev = _context95.next) {
        case 0:
          _context95.prev = 0;
          _context95.next = 3;
          return request$v.post('/app/plusmsg/api/v1/p/message/mark_read', {
            app_id: 1,
            terminal: 7,
            mesg_id: msgId
          });
        case 3:
          _context95.next = 7;
          break;
        case 5:
          _context95.prev = 5;
          _context95.t0 = _context95["catch"](0);
        case 7:
        case "end":
          return _context95.stop();
      }
    }, _callee95, null, [[0, 5]]);
  }));
  return function setRendMessage(_x134) {
    return _ref107.apply(this, arguments);
  };
}();

/**
 * [协作关系] 创建企业管理员定向邀请链接
 * 该接口与plussvr.js/sendAdminInvitations区别主要额外的记录是否已发送邀请链接，用于业务标识过滤处理 接口负责人@方汉斌
 *
 */
var sendCollaborationAdminInvitations = /*#__PURE__*/function () {
  var _ref108 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(params) {
    var compId, _yield$request$post28, data;
    return _regeneratorRuntime.wrap(function _callee96$(_context96) {
      while (1) switch (_context96.prev = _context96.next) {
        case 0:
          compId = params.comp_id;
          _context96.next = 3;
          return request$v.post("/sops/v1/collaboration/".concat(compId, "/invitations/admin-directed"), params);
        case 3:
          _yield$request$post28 = _context96.sent;
          data = _yield$request$post28.data;
          return _context96.abrupt("return", data);
        case 6:
        case "end":
          return _context96.stop();
      }
    }, _callee96);
  }));
  return function sendCollaborationAdminInvitations(_x135) {
    return _ref108.apply(this, arguments);
  };
}();

/**
 *
 * @param {*} linkId 压缩包文件的link_id
 * @returns {
 *    progress: String // 解压进度 0 至 1,
 *    data: {
 *      files: {
 *        file_name: String
 *        preview_url: String
 *        size: Number
 *        ftype: "folder" | "file"
 *        children: []
 *      }[] // 预览文件列表
 *    }
 *    status: string // 状态 "progress" | "success"
 * }
 */
var getArchiveFileData = function getArchiveFileData(linkId) {
  return new Promise(function (resolve, reject) {
    request$v.post('/tpdoc/v1/compression/preview', {
      share_id: linkId
    }).then(function (res) {
      resolve(res.data);
    })["catch"](function (err) {
      reject(err.response);
    });
  });
};
/**
 *
 * @param {
 *    share_id: string // 分享ID
 *    source: string // 来源
 *    group_id: Number // 目标团队
 *    parent_id: Number // 文件目标路径ID
 * } params
 * @returns {
 *    progress: String // 解压进度 0 至 1,
 *    data: {
 *      files: {
 *        file_name: String
 *        preview_url: String
 *        size: Number
 *        ftype: "folder" | "file"
 *        children: []
 *      }[] // 预览文件列表
 *    }
 *    status: string // 状态 "progress" | "success"
 * }
 *
 */
var extractArchiveFile = /*#__PURE__*/function () {
  var _ref109 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97() {
    var params,
      res,
      _args97 = arguments;
    return _regeneratorRuntime.wrap(function _callee97$(_context97) {
      while (1) switch (_context97.prev = _context97.next) {
        case 0:
          params = _args97.length > 0 && _args97[0] !== undefined ? _args97[0] : {};
          _context97.next = 3;
          return request$v.post('/tpdoc/v1/compression/files', params);
        case 3:
          res = _context97.sent;
          return _context97.abrupt("return", res.data);
        case 5:
        case "end":
          return _context97.stop();
      }
    }, _callee97);
  }));
  return function extractArchiveFile() {
    return _ref109.apply(this, arguments);
  };
}();
// 获取特定团队的分享范围
var getGroupShareRange = /*#__PURE__*/function () {
  var _ref110 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98(groupId) {
    return _regeneratorRuntime.wrap(function _callee98$(_context98) {
      while (1) switch (_context98.prev = _context98.next) {
        case 0:
          _context98.next = 2;
          return request$v.get("/drive/v2/groups/".concat(groupId, "/links/ranges/sum"));
        case 2:
          return _context98.abrupt("return", _context98.sent);
        case 3:
        case "end":
          return _context98.stop();
      }
    }, _callee98);
  }));
  return function getGroupShareRange(_x136) {
    return _ref110.apply(this, arguments);
  };
}();

// 获取用户所在企业的全员团队id
var getIndexGroupIdApi = /*#__PURE__*/function () {
  var _ref111 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99(corpId) {
    return _regeneratorRuntime.wrap(function _callee99$(_context99) {
      while (1) switch (_context99.prev = _context99.next) {
        case 0:
          _context99.next = 2;
          return request$v.get("/app/job/v1/syncuser/companies/".concat(corpId, "/deptgroups/index"));
        case 2:
          return _context99.abrupt("return", _context99.sent);
        case 3:
        case "end":
          return _context99.stop();
      }
    }, _callee99);
  }));
  return function getIndexGroupIdApi(_x137) {
    return _ref111.apply(this, arguments);
  };
}();

// 获取企业套餐提示
var getCompPkgSpec = /*#__PURE__*/function () {
  var _ref112 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(needTime) {
    var _yield$request$get50, data;
    return _regeneratorRuntime.wrap(function _callee100$(_context100) {
      while (1) switch (_context100.prev = _context100.next) {
        case 0:
          _context100.next = 2;
          return request$v.get("orderadm/api/v1/companies/init_service/tips", {
            params: {
              need_time: needTime
            }
          });
        case 2:
          _yield$request$get50 = _context100.sent;
          data = _yield$request$get50.data;
          return _context100.abrupt("return", data);
        case 5:
        case "end":
          return _context100.stop();
      }
    }, _callee100);
  }));
  return function getCompPkgSpec(_x138) {
    return _ref112.apply(this, arguments);
  };
}();

// [企业周报] 查询未使用用户列表
var getCompUnuseduser = /*#__PURE__*/function () {
  var _ref113 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(companyid) {
    var _yield$request$get51, data;
    return _regeneratorRuntime.wrap(function _callee101$(_context101) {
      while (1) switch (_context101.prev = _context101.next) {
        case 0:
          _context101.next = 2;
          return request$v.get("/sops/v1/company/weekly/".concat(companyid, "/unused/users"));
        case 2:
          _yield$request$get51 = _context101.sent;
          data = _yield$request$get51.data;
          return _context101.abrupt("return", data);
        case 5:
        case "end":
          return _context101.stop();
      }
    }, _callee101);
  }));
  return function getCompUnuseduser(_x139) {
    return _ref113.apply(this, arguments);
  };
}();

// [企业周报] 管理员主动发送消息通知
var sendCompUnuseduser = /*#__PURE__*/function () {
  var _ref114 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102(params) {
    var _yield$request$post29, data;
    return _regeneratorRuntime.wrap(function _callee102$(_context102) {
      while (1) switch (_context102.prev = _context102.next) {
        case 0:
          _context102.next = 2;
          return request$v.post("/sops/v1/company/weekly/notify", params);
        case 2:
          _yield$request$post29 = _context102.sent;
          data = _yield$request$post29.data;
          return _context102.abrupt("return", data);
        case 5:
        case "end":
          return _context102.stop();
      }
    }, _callee102);
  }));
  return function sendCompUnuseduser(_x140) {
    return _ref114.apply(this, arguments);
  };
}();

// 获取团队
var getCorpGroups = /*#__PURE__*/function () {
  var _ref115 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(companyid, params) {
    var _yield$request$get52, data;
    return _regeneratorRuntime.wrap(function _callee103$(_context103) {
      while (1) switch (_context103.prev = _context103.next) {
        case 0:
          console.log('params', params);
          _context103.next = 3;
          return request$v.get("/app/job/v1/adm/companies/".concat(companyid, "/corpgroups"), {
            params: params
          });
        case 3:
          _yield$request$get52 = _context103.sent;
          data = _yield$request$get52.data;
          return _context103.abrupt("return", data);
        case 6:
        case "end":
          return _context103.stop();
      }
    }, _callee103);
  }));
  return function getCorpGroups(_x141, _x142) {
    return _ref115.apply(this, arguments);
  };
}();

// 查询企业权益
var getCompEffectiveServices = /*#__PURE__*/function () {
  var _ref116 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104() {
    var _yield$request$get53, data;
    return _regeneratorRuntime.wrap(function _callee104$(_context104) {
      while (1) switch (_context104.prev = _context104.next) {
        case 0:
          _context104.next = 2;
          return request$v.get("/privilege/api/v1/users/effective/services");
        case 2:
          _yield$request$get53 = _context104.sent;
          data = _yield$request$get53.data;
          return _context104.abrupt("return", data);
        case 5:
        case "end":
          return _context104.stop();
      }
    }, _callee104);
  }));
  return function getCompEffectiveServices() {
    return _ref116.apply(this, arguments);
  };
}();

var request$u = createInstance({
  baseURL: PLUS,
  withCredentials: true,
  notTransformBaseUrl: false
});

/**
 * 获取分享文件的团队权限列表 - 支持权限组合新特性
 *
 * @param fileId
 * @param groupId
 * @returns {Promise<*>}
 */
var getGroupPermList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(groupId) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$u.get("drive/v1/admin/groups/".concat(groupId, "/compound/permissions"), {
            t: new Date()
          });
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getGroupPermList(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 获取分享信息 - 支持权限组合新特性
 *
 * @param fileId
 * @param groupId
 * @returns {Promise<*>}
 */
var getShareInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fileId, groupId) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$u.get("drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/link/range/permission"));
        case 2:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getShareInfo(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * 修改分享权限 - 支持权限组合新特性
 *
 * @param fileId
 * @param groupId
 * @param params
 * @returns {Promise<*>}
 */
var updateSharePerm = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fileId, groupId, params) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$u.put("drive/v2/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permission"), params);
        case 2:
          _yield$request$put = _context3.sent;
          data = _yield$request$put.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function updateSharePerm(_x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * 开启分享 - 支持权限组合新特性
 *
 * @param fileId
 * @param groupId
 * @param params
 * @returns {Promise<*>}
 */
var openShareRequest = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(fileId, groupId, params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$u.post("drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/link"), params);
        case 2:
          _yield$request$post = _context4.sent;
          data = _yield$request$post.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function openShareRequest(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * 关闭分享 - 支持权限组合新特性
 *
 * @param fileId
 * @param groupId
 * @returns {Promise<*>}
 */
var closeShareRequest = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(fileId, groupId) {
    var _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$u["delete"]("drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/link"));
        case 2:
          _yield$request$delete = _context5.sent;
          data = _yield$request$delete.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function closeShareRequest(_x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();

var _excluded$3 = ["folderinfo", "linkinfo"];
function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import axios from '@kso/axios'

// const CancelToken = axios.CancelToken
var request$t = createInstance({
  baseURL: DRIVE,
  withCredentials: true
});

// 根据 sid 获取分享链接的信息
function getLinkInfoFromSid(_x) {
  return _getLinkInfoFromSid.apply(this, arguments);
}
// 重置链接邀请分享链接
function _getLinkInfoFromSid() {
  _getLinkInfoFromSid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var sid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sid = _ref.sid;
          _context.next = 3;
          return request$t.get("/api/v5/links/".concat(sid));
        case 3:
          return _context.abrupt("return", _context.sent);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getLinkInfoFromSid.apply(this, arguments);
}
function reOpenEditLink(_x2) {
  return _reOpenEditLink.apply(this, arguments);
}
// 获取邀请分享链接
function _reOpenEditLink() {
  _reOpenEditLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fid) {
    var formdata,
      _yield$request$put,
      data,
      status,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          formdata = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          _context2.next = 3;
          return request$t.put("/api/v5/links/reset_invite_edit_link/".concat(fid), _objectSpread$6(_objectSpread$6({}, formdata), {}, {
            fileid: fid
          }));
        case 3:
          _yield$request$put = _context2.sent;
          data = _yield$request$put.data;
          status = _yield$request$put.status;
          return _context2.abrupt("return", _objectSpread$6(_objectSpread$6({}, data), {}, {
            status: status
          }));
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _reOpenEditLink.apply(this, arguments);
}
function createEditLink(_x3, _x4) {
  return _createEditLink.apply(this, arguments);
}
function _createEditLink() {
  _createEditLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fid, gid) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$t.post('/api/v5/links/create_invite_edit_link', {
            groupid: gid,
            fileid: fid
          });
        case 2:
          _yield$request$post = _context3.sent;
          data = _yield$request$post.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _createEditLink.apply(this, arguments);
}
function onCloseEditLink(_x5, _x6) {
  return _onCloseEditLink.apply(this, arguments);
}

// 更新分享链接信息
function _onCloseEditLink() {
  _onCloseEditLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(gid, fid) {
    var _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$t["delete"]("/api/v5/links/invite_edit_link/".concat(gid, "/").concat(fid));
        case 2:
          _yield$request$delete = _context4.sent;
          data = _yield$request$delete.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _onCloseEditLink.apply(this, arguments);
}
function updateLink(_x7) {
  return _updateLink.apply(this, arguments);
}

// 更新分享链接信息V5
function _updateLink() {
  _updateLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sid) {
    var formdata,
      params,
      _yield$request$put2,
      data,
      _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          formdata = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
          params = _objectSpread$6(_objectSpread$6({}, formdata), {}, {
            sid: sid
          });
          if (params.permission === 'comment') {
            params.ext_perm_list = ['comment'];
            params.permission = 'read';
          }
          _context5.next = 5;
          return request$t.put("/api/v3/links/".concat(sid), params);
        case 5:
          _yield$request$put2 = _context5.sent;
          data = _yield$request$put2.data;
          return _context5.abrupt("return", data);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _updateLink.apply(this, arguments);
}
function updateLinkV5(_x8) {
  return _updateLinkV.apply(this, arguments);
}

// api/v5/links接口数据转换为之前api/v3/links接口数据
function _updateLinkV() {
  _updateLinkV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(sid) {
    var formdata,
      params,
      _yield$request$put3,
      data,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          formdata = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
          params = _objectSpread$6(_objectSpread$6({}, formdata), {}, {
            sid: sid
          });
          if (params.permission === 'comment') {
            params.ext_perm_list = ['comment'];
            params.permission = 'read';
          }
          _context6.next = 5;
          return request$t.put("/api/v5/links/".concat(sid), params);
        case 5:
          _yield$request$put3 = _context6.sent;
          data = _yield$request$put3.data;
          return _context6.abrupt("return", data);
        case 8:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _updateLinkV.apply(this, arguments);
}
var getV3LinkInfo = function getV3LinkInfo(data) {
  var linkinfo = data.linkinfo,
    fileinfo = data.fileinfo,
    user_permission = data.user_permission;
  var _ref2 = linkinfo || {},
    groupCorpid = _ref2.group_corpid,
    linkUrl = _ref2.link_url,
    linkPermission = _ref2.link_permission,
    _ref2$creator = _ref2.creator,
    creator = _ref2$creator === void 0 ? {} : _ref2$creator;
  var v3Data = _objectSpread$6(_objectSpread$6({}, fileinfo), {}, {
    corpid: groupCorpid,
    link_url: linkUrl,
    user_permission: user_permission,
    link: _objectSpread$6(_objectSpread$6({}, linkinfo), {}, {
      corp_id: groupCorpid,
      permission: linkPermission,
      userid: creator.id
    })
  });
  return v3Data;
};

// 重新开启分享 重置链接
function createLink(_x9) {
  return _createLink.apply(this, arguments);
}

// 关闭链接 (关闭免登录)
function _createLink() {
  _createLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(fid) {
    var ext,
      params,
      _yield$request$post2,
      data,
      _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          ext = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
          params = _objectSpread$6(_objectSpread$6({}, ext), {}, {
            fileid: fid
          });
          if (params.permission === 'comment') {
            params.ext_perm_list = ['comment'];
            params.permission = 'read';
          }
          _context7.next = 5;
          return request$t.post('/api/v5/links', params);
        case 5:
          _yield$request$post2 = _context7.sent;
          data = _yield$request$post2.data;
          return _context7.abrupt("return", getV3LinkInfo(data));
        case 8:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _createLink.apply(this, arguments);
}
function onCloseLink(_x10) {
  return _onCloseLink.apply(this, arguments);
}

// 批量关闭分享链接 (批量关闭免登录)
function _onCloseLink() {
  _onCloseLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(fid) {
    var clink,
      _yield$request$delete2,
      data,
      _args8 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          clink = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : false;
          _context8.next = 3;
          return request$t["delete"]("/api/v3/links/".concat(fid, "?clink=").concat(clink));
        case 3:
          _yield$request$delete2 = _context8.sent;
          data = _yield$request$delete2.data;
          return _context8.abrupt("return", data);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _onCloseLink.apply(this, arguments);
}
function onCloseLinkByBatch(_x11) {
  return _onCloseLinkByBatch.apply(this, arguments);
}

// 取消共享（删除分享)
function _onCloseLinkByBatch() {
  _onCloseLinkByBatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
    var _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return request$t.post('/api/v5/links/batch/close', params);
        case 2:
          _yield$request$post3 = _context9.sent;
          data = _yield$request$post3.data;
          return _context9.abrupt("return", data);
        case 5:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _onCloseLinkByBatch.apply(this, arguments);
}
function deleteLink(_x12, _x13) {
  return _deleteLink.apply(this, arguments);
}

// 批量取消共享（批量删除分享链接 包括文件和文件夹）
function _deleteLink() {
  _deleteLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(gid, fileid) {
    var _yield$request$delete3, data;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return request$t["delete"]("/api/v5/groups/".concat(gid, "/files/").concat(fileid, "/share"));
        case 2:
          _yield$request$delete3 = _context10.sent;
          data = _yield$request$delete3.data;
          return _context10.abrupt("return", data);
        case 5:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _deleteLink.apply(this, arguments);
}
function deleteLinkByBatch(_x14) {
  return _deleteLinkByBatch.apply(this, arguments);
}

// 批量修改文件分享链接权限或有效期
function _deleteLinkByBatch() {
  _deleteLinkByBatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
    var _yield$request$post4, data;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return request$t.post('/api/v5/links/batch/delete', params);
        case 2:
          _yield$request$post4 = _context11.sent;
          data = _yield$request$post4.data;
          return _context11.abrupt("return", data);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _deleteLinkByBatch.apply(this, arguments);
}
function updateFileLinkByBatch(_x15) {
  return _updateFileLinkByBatch.apply(this, arguments);
}

// 批量修改文件夹分享链接权限或有效期
function _updateFileLinkByBatch() {
  _updateFileLinkByBatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
    var _yield$request$put4, data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$t.put('/api/v5/links/batch/update', params);
        case 2:
          _yield$request$put4 = _context12.sent;
          data = _yield$request$put4.data;
          return _context12.abrupt("return", data);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _updateFileLinkByBatch.apply(this, arguments);
}
function updateFolderLinkByBatch(_x16) {
  return _updateFolderLinkByBatch.apply(this, arguments);
}

// 获取个人发出的分享信息列表
function _updateFolderLinkByBatch() {
  _updateFolderLinkByBatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
    var _yield$request$put5, data;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return request$t.put('/api/v5/folder_links/batch/update', params);
        case 2:
          _yield$request$put5 = _context13.sent;
          data = _yield$request$put5.data;
          return _context13.abrupt("return", data);
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _updateFolderLinkByBatch.apply(this, arguments);
}
function getPerShareInfoList(_x17) {
  return _getPerShareInfoList.apply(this, arguments);
}

// 删除协作组协作成员
function _getPerShareInfoList() {
  _getPerShareInfoList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
    var _yield$request$post5, data;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return request$t.post('/api/v5/search/corp/links', params);
        case 2:
          _yield$request$post5 = _context14.sent;
          data = _yield$request$post5.data;
          return _context14.abrupt("return", data);
        case 5:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _getPerShareInfoList.apply(this, arguments);
}
function delLinkDept(_x18) {
  return _delLinkDept.apply(this, arguments);
}
// 添加协作组
function _delLinkDept() {
  _delLinkDept = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref3) {
    var sid, team_id, team_type, _yield$request$delete4, data;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          sid = _ref3.sid, team_id = _ref3.team_id, team_type = _ref3.team_type;
          _context15.next = 3;
          return request$t["delete"]('/api/v5/links/team_collaborators', {
            data: {
              sid: sid,
              team_id: team_id,
              team_type: team_type
            }
          });
        case 3:
          _yield$request$delete4 = _context15.sent;
          data = _yield$request$delete4.data;
          return _context15.abrupt("return", data);
        case 6:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _delLinkDept.apply(this, arguments);
}
function updateLinkDept(_x19) {
  return _updateLinkDept.apply(this, arguments);
}
// 修改协作组 权限
function _updateLinkDept() {
  _updateLinkDept = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref4) {
    var sid, permission, team_id, team_type, contacts, extPermList, _yield$request$post6, data;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          sid = _ref4.sid, permission = _ref4.permission, team_id = _ref4.team_id, team_type = _ref4.team_type, contacts = _ref4.contacts, extPermList = _ref4.ext_perm_list;
          _context16.next = 3;
          return request$t.post('/api/v5/links/team_collaborators', {
            sid: sid,
            permission: permission,
            team_id: team_id,
            team_type: team_type,
            contacts: contacts,
            ext_perm_list: extPermList
          });
        case 3:
          _yield$request$post6 = _context16.sent;
          data = _yield$request$post6.data;
          return _context16.abrupt("return", data);
        case 6:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _updateLinkDept.apply(this, arguments);
}
function changeLinkDept(_x20) {
  return _changeLinkDept.apply(this, arguments);
}

// 添加协作成员
function _changeLinkDept() {
  _changeLinkDept = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref5) {
    var sid, permission, team_id, team_type, contacts, params, _yield$request$put6, data;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          sid = _ref5.sid, permission = _ref5.permission, team_id = _ref5.team_id, team_type = _ref5.team_type, contacts = _ref5.contacts;
          params = {
            sid: sid,
            permission: permission,
            team_id: team_id,
            team_type: team_type,
            contacts: contacts
          };
          if (permission === 'comment') {
            params.permission = 'read';
            params.ext_perm_list = ['comment'];
          }
          _context17.next = 5;
          return request$t.put('/api/v5/links/team_collaborators', params);
        case 5:
          _yield$request$put6 = _context17.sent;
          data = _yield$request$put6.data;
          return _context17.abrupt("return", data);
        case 8:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _changeLinkDept.apply(this, arguments);
}
function addLinkMember(_x21) {
  return _addLinkMember.apply(this, arguments);
}
function _addLinkMember() {
  _addLinkMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref6) {
    var sid, permission, contacts, extPermList, _ref6$without_send_me, withoutSendMessage, params, _yield$request$post7, data;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          sid = _ref6.sid, permission = _ref6.permission, contacts = _ref6.contacts, extPermList = _ref6.ext_perm_list, _ref6$without_send_me = _ref6.without_send_message, withoutSendMessage = _ref6$without_send_me === void 0 ? false : _ref6$without_send_me;
          params = {
            sid: sid,
            permission: permission,
            ext_perm_list: extPermList,
            contacts: contacts,
            without_send_message: withoutSendMessage
          };
          if (permission === 'comment') {
            params.permission = 'read';
            params.ext_perm_list = ['comment'];
          }
          _context18.next = 5;
          return request$t.post('/api/v5/links/collaborators', params);
        case 5:
          _yield$request$post7 = _context18.sent;
          data = _yield$request$post7.data;
          return _context18.abrupt("return", data);
        case 8:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _addLinkMember.apply(this, arguments);
}
function updateLinkMember(_x22) {
  return _updateLinkMember.apply(this, arguments);
}
function _updateLinkMember() {
  _updateLinkMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref7) {
    var sid, id, permission, params, _yield$request$put7, data;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          sid = _ref7.sid, id = _ref7.id, permission = _ref7.permission;
          params = {
            sid: sid,
            memberid: id,
            permission: permission
          };
          if (params.permission === 'comment') {
            params.permission = 'read';
            params.ext_perm_list = ['comment'];
          }
          _context19.next = 5;
          return request$t.put("/api/v3/links/".concat(sid, "/members/").concat(id), params);
        case 5:
          _yield$request$put7 = _context19.sent;
          data = _yield$request$put7.data;
          return _context19.abrupt("return", data);
        case 8:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _updateLinkMember.apply(this, arguments);
}
function delLinkMember(_x23) {
  return _delLinkMember.apply(this, arguments);
}
function _delLinkMember() {
  _delLinkMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref8) {
    var sid, id, _yield$request$delete5, data;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          sid = _ref8.sid, id = _ref8.id;
          _context20.next = 3;
          return request$t["delete"]("/api/v3/links/".concat(sid, "/members/").concat(id));
        case 3:
          _yield$request$delete5 = _context20.sent;
          data = _yield$request$delete5.data;
          return _context20.abrupt("return", data);
        case 6:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _delLinkMember.apply(this, arguments);
}
function delInviteLinkMember(_x24) {
  return _delInviteLinkMember.apply(this, arguments);
}
function _delInviteLinkMember() {
  _delInviteLinkMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref9) {
    var sid, id, _yield$request$delete6, data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          sid = _ref9.sid, id = _ref9.id;
          _context21.next = 3;
          return request$t["delete"]("/api/v3/invite/links/".concat(sid, "/members/").concat(id));
        case 3:
          _yield$request$delete6 = _context21.sent;
          data = _yield$request$delete6.data;
          return _context21.abrupt("return", data);
        case 6:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _delInviteLinkMember.apply(this, arguments);
}
function getInviteLinkMember(_x25) {
  return _getInviteLinkMember.apply(this, arguments);
}
function _getInviteLinkMember() {
  _getInviteLinkMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(sid) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return request$t.get("/api/v3/invite/links/".concat(sid, "/members"));
        case 2:
          _yield$request$get = _context22.sent;
          data = _yield$request$get.data;
          return _context22.abrupt("return", data);
        case 5:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _getInviteLinkMember.apply(this, arguments);
}
function addMemberToCoop(_x26) {
  return _addMemberToCoop.apply(this, arguments);
}
// 协作成员列表
function _addMemberToCoop() {
  _addMemberToCoop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(_ref10) {
    var sid, userids, _ref10$permission, permission, _yield$request$post8, data;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          sid = _ref10.sid, userids = _ref10.userids, _ref10$permission = _ref10.permission, permission = _ref10$permission === void 0 ? 'write' : _ref10$permission;
          _context23.next = 3;
          return request$t.post("/api/v5/links/".concat(sid, "/members"), {
            sid: sid,
            userids: userids,
            permission: permission
          });
        case 3:
          _yield$request$post8 = _context23.sent;
          data = _yield$request$post8.data;
          return _context23.abrupt("return", data);
        case 6:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _addMemberToCoop.apply(this, arguments);
}
function getCoopMember(_x27, _x28) {
  return _getCoopMember.apply(this, arguments);
}

/**
 * @param {string} sid
 * @param {object} params
 * @param {boolean} params.is_visit
 * @link TODO 待补充接口文档
 */
function _getCoopMember() {
  _getCoopMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(sid, offset) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return request$t.get("/api/v5/links/".concat(sid, "/collaborators?with_team_member=true&with_clink_member_flag=true&offset=").concat(offset));
        case 2:
          _yield$request$get2 = _context24.sent;
          data = _yield$request$get2.data;
          return _context24.abrupt("return", data);
        case 5:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _getCoopMember.apply(this, arguments);
}
function getCoopNumber(_x29, _x30) {
  return _getCoopNumber.apply(this, arguments);
}

/**
 * @param {string} sid
 * @param {object} params
 * @param {boolean} params.is_visit
 * @link TODO 待补充接口文档
 */
function _getCoopNumber() {
  _getCoopNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(sid, params) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return request$t.get("/api/v5/links/".concat(sid, "/collaborators/count?with_team_member=true"), {
            params: params
          });
        case 2:
          _yield$request$get3 = _context25.sent;
          data = _yield$request$get3.data;
          return _context25.abrupt("return", data);
        case 5:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _getCoopNumber.apply(this, arguments);
}
function getCoopNumberWithoutTeamMember(_x31, _x32) {
  return _getCoopNumberWithoutTeamMember.apply(this, arguments);
}
/**
 * 全员修改权限接口 （全选模式下调用）
 * sid 分享码,使用slink来处理
 * permission 要修改的权限类型 write/read
 * excludeIds 全员操作要排除的用户列表, 不超过100个
 */
function _getCoopNumberWithoutTeamMember() {
  _getCoopNumberWithoutTeamMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(sid, params) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return request$t.get("/api/v5/links/".concat(sid, "/collaborators/count?with_team_member=false"), {
            params: params
          });
        case 2:
          _yield$request$get4 = _context26.sent;
          data = _yield$request$get4.data;
          return _context26.abrupt("return", data);
        case 5:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _getCoopNumberWithoutTeamMember.apply(this, arguments);
}
function updateCollaboratorsPermission(_x33, _x34) {
  return _updateCollaboratorsPermission.apply(this, arguments);
}

// 全员移除接口（全选模式下调用）
function _updateCollaboratorsPermission() {
  _updateCollaboratorsPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(sid, permission) {
    var excludeIds,
      params,
      _yield$request$put8,
      data,
      _args27 = arguments;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          excludeIds = _args27.length > 2 && _args27[2] !== undefined ? _args27[2] : '';
          params = {
            permission: permission,
            exclude_ids: excludeIds
          };
          if (permission === 'comment') {
            params.permission = 'read';
            params.ext_perm_list = ['comment'];
          }
          _context27.next = 5;
          return request$t.put("/api/v5/links/".concat(sid, "/all_collaborators"), params);
        case 5:
          _yield$request$put8 = _context27.sent;
          data = _yield$request$put8.data;
          return _context27.abrupt("return", data);
        case 8:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _updateCollaboratorsPermission.apply(this, arguments);
}
function removeCollaborators(_x35) {
  return _removeCollaborators.apply(this, arguments);
}

/**
 * 添加协作区分来源
 * 因为原来旧的添加成员接口要加限频了。单用户单文件1分钟只能调用6次了。如果添加联系人和企业成员还是用旧的，就会被影响到。
 */
function _removeCollaborators() {
  _removeCollaborators = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(sid) {
    var excludeIds,
      _yield$request$delete7,
      data,
      _args28 = arguments;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          excludeIds = _args28.length > 1 && _args28[1] !== undefined ? _args28[1] : '';
          _context28.next = 3;
          return request$t["delete"]("/api/v5/links/".concat(sid, "/all_collaborators"), {
            data: {
              exclude_ids: excludeIds
            }
          });
        case 3:
          _yield$request$delete7 = _context28.sent;
          data = _yield$request$delete7.data;
          return _context28.abrupt("return", data);
        case 6:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _removeCollaborators.apply(this, arguments);
}
function addContactToCoop(_x36) {
  return _addContactToCoop.apply(this, arguments);
}
function _addContactToCoop() {
  _addContactToCoop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(_ref11) {
    var sid, _ref11$users, users, _ref11$permission, permission, _ref11$without_send_m, withoutSendMessage, accountList, companyList, params, _yield$request$post9, data;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          sid = _ref11.sid, _ref11$users = _ref11.users, users = _ref11$users === void 0 ? [] : _ref11$users, _ref11$permission = _ref11.permission, permission = _ref11$permission === void 0 ? 'write' : _ref11$permission, _ref11$without_send_m = _ref11.without_send_message, withoutSendMessage = _ref11$without_send_m === void 0 ? false : _ref11$without_send_m;
          accountList = users.filter(function (u) {
            return !u.comp_id;
          }).map(function (u) {
            return u.id || u.userid || parseInt(u.contact_id);
          });
          companyList = users.filter(function (u) {
            return !!u.comp_id;
          }).map(function (u) {
            return {
              userid: u.userid || u.id,
              companyid: u.comp_id
            };
          });
          params = {
            sid: sid,
            contacts: {
              account: accountList,
              company: companyList
            },
            permission: permission,
            without_send_message: withoutSendMessage
          };
          if (permission === 'comment') {
            params.ext_perm_list = ['comment'];
            params.permission = 'read';
          }
          _context29.next = 7;
          return request$t.post('/api/v5/links/collaborators', params);
        case 7:
          _yield$request$post9 = _context29.sent;
          data = _yield$request$post9.data;
          return _context29.abrupt("return", data);
        case 10:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _addContactToCoop.apply(this, arguments);
}
function addNotContactToCoop(_x37) {
  return _addNotContactToCoop.apply(this, arguments);
}

/** folder link */
function _addNotContactToCoop() {
  _addNotContactToCoop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(_ref12) {
    var sid, userids, _ref12$permission, permission, params, _yield$request$post10, data;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          sid = _ref12.sid, userids = _ref12.userids, _ref12$permission = _ref12.permission, permission = _ref12$permission === void 0 ? 'write' : _ref12$permission;
          params = {
            sid: sid,
            userids: userids,
            permission: permission
          };
          if (permission === 'comment') {
            params.permission = 'read';
            params.ext_perm_list = ['comment'];
          }
          _context30.next = 5;
          return request$t.post('/api/v5/links/collaborations/invite', params);
        case 5:
          _yield$request$post10 = _context30.sent;
          data = _yield$request$post10.data;
          return _context30.abrupt("return", data);
        case 8:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _addNotContactToCoop.apply(this, arguments);
}
var flinkFormat = function flinkFormat(data) {
  var folderinfo = data.folderinfo,
    linkinfo = data.linkinfo,
    extraData = _objectWithoutProperties(data, _excluded$3);
  return _objectSpread$6(_objectSpread$6(_objectSpread$6({}, extraData), folderinfo), {}, {
    link: _objectSpread$6({}, linkinfo)
  });
};
function getFolderLink(_x38) {
  return _getFolderLink.apply(this, arguments);
}
// 创建/开启/重置分享链接
function _getFolderLink() {
  _getFolderLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(folderid) {
    var isFlinkFormat,
      _yield$request$get5,
      data,
      _args31 = arguments;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          isFlinkFormat = _args31.length > 1 && _args31[1] !== undefined ? _args31[1] : true;
          _context31.next = 3;
          return request$t.get("/api/v5/folder_links/".concat(folderid));
        case 3:
          _yield$request$get5 = _context31.sent;
          data = _yield$request$get5.data;
          return _context31.abrupt("return", isFlinkFormat ? flinkFormat(data) : data);
        case 6:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _getFolderLink.apply(this, arguments);
}
function createOrOpenFolderLink(_x39) {
  return _createOrOpenFolderLink.apply(this, arguments);
}
// 更改链接设置
function _createOrOpenFolderLink() {
  _createOrOpenFolderLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(params) {
    var isFlinkFormat,
      _yield$request$post11,
      data,
      _args32 = arguments;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          isFlinkFormat = _args32.length > 1 && _args32[1] !== undefined ? _args32[1] : true;
          _context32.next = 3;
          return request$t.post('/api/v5/folder_links', params);
        case 3:
          _yield$request$post11 = _context32.sent;
          data = _yield$request$post11.data;
          return _context32.abrupt("return", isFlinkFormat ? flinkFormat(data) : data);
        case 6:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _createOrOpenFolderLink.apply(this, arguments);
}
function updateFolderLink(_x40, _x41) {
  return _updateFolderLink.apply(this, arguments);
}
// 关闭文件夹分享链接
function _updateFolderLink() {
  _updateFolderLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(sid, params) {
    var _yield$request$put9, data;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 2;
          return request$t.put("/api/v5/folder_links/".concat(sid), params);
        case 2:
          _yield$request$put9 = _context33.sent;
          data = _yield$request$put9.data;
          return _context33.abrupt("return", flinkFormat(data));
        case 5:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _updateFolderLink.apply(this, arguments);
}
function deleteFolderLink(_x42) {
  return _deleteFolderLink.apply(this, arguments);
}

// 获取团队成员+协作成员中文件可读/可写/可查看或可编辑的人数
function _deleteFolderLink() {
  _deleteFolderLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(fileid) {
    var _yield$request$delete8, data;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          _context34.next = 2;
          return request$t["delete"]("/api/v5/folder_links/".concat(fileid));
        case 2:
          _yield$request$delete8 = _context34.sent;
          data = _yield$request$delete8.data;
          return _context34.abrupt("return", data);
        case 5:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _deleteFolderLink.apply(this, arguments);
}
function getRwMembers(_x43) {
  return _getRwMembers.apply(this, arguments);
}

// 获取团队成员中文件可读可写的人数
function _getRwMembers() {
  _getRwMembers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(params) {
    var _yield$request$get6, data;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 2;
          return request$t.get("/api/v5/files/".concat(params.fileid, "/visitors"), {
            params: params
          });
        case 2:
          _yield$request$get6 = _context35.sent;
          data = _yield$request$get6.data;
          return _context35.abrupt("return", data);
        case 5:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _getRwMembers.apply(this, arguments);
}
function getTeamRwMembers(_x44) {
  return _getTeamRwMembers.apply(this, arguments);
}
function _getTeamRwMembers() {
  _getTeamRwMembers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(fileid) {
    var _yield$request$get7, data;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          _context36.next = 2;
          return request$t.get("/api/v5/files/".concat(fileid, "/groupmembers/perm"));
        case 2:
          _yield$request$get7 = _context36.sent;
          data = _yield$request$get7.data;
          return _context36.abrupt("return", data);
        case 5:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return _getTeamRwMembers.apply(this, arguments);
}
function batchUpdateLinks(_x45) {
  return _batchUpdateLinks.apply(this, arguments);
}
function _batchUpdateLinks() {
  _batchUpdateLinks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(params) {
    var _yield$request$put10, data;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          _context37.next = 2;
          return request$t.put('/api/v5/links/batch/update', params);
        case 2:
          _yield$request$put10 = _context37.sent;
          data = _yield$request$put10.data;
          return _context37.abrupt("return", data);
        case 5:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return _batchUpdateLinks.apply(this, arguments);
}
function batchUpdateFolderLinks(_x46) {
  return _batchUpdateFolderLinks.apply(this, arguments);
}
function _batchUpdateFolderLinks() {
  _batchUpdateFolderLinks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(params) {
    var _yield$request$put11, data;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          _context38.next = 2;
          return request$t.put('/api/v5/folder_links/batch/update', params);
        case 2:
          _yield$request$put11 = _context38.sent;
          data = _yield$request$put11.data;
          return _context38.abrupt("return", data);
        case 5:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return _batchUpdateFolderLinks.apply(this, arguments);
}
function batchCloseBatch(_x47) {
  return _batchCloseBatch.apply(this, arguments);
}

/**
 * @link https://drive-docs.wps.cn/doc?url=/public/yamls/beta/link_swagger.yml#operation/batch_delete_collaborators
 * @param {string} sid
 * @param {object} params
 * @param {string} params.sid
 * @param {string} params.member_ids
 */
function _batchCloseBatch() {
  _batchCloseBatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(params) {
    var _yield$request$post12, data;
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          _context39.next = 2;
          return request$t.post('/api/v5/links/batch/close', params);
        case 2:
          _yield$request$post12 = _context39.sent;
          data = _yield$request$post12.data;
          return _context39.abrupt("return", data);
        case 5:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return _batchCloseBatch.apply(this, arguments);
}
function batchRemoveCollaborators(sid, params) {
  return request$t["delete"]("/api/v5/links/".concat(sid, "/collaborators"), {
    data: params
  });
}

var target$1 = typeof window === 'undefined' ? global : window;
var envr$1 = target$1 && target$1.__KD_CONFIG__ && target$1.__KD_CONFIG__.props && target$1.__KD_CONFIG__.props.release === 'oem';
var request$s = createInstance({
  baseURL: DRIVE,
  withCredentials: true
});
var requestDocs$1 = createInstance({
  baseURL: DOCS,
  withCredentials: true
});

// 文件夹分享文件下载信息
function getFLDownloadFile(_x, _x2) {
  return _getFLDownloadFile.apply(this, arguments);
}

// 私人文件下载信息
function _getFLDownloadFile() {
  _getFLDownloadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, folderLink) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$s.get("/api/v5/folder_link_tree/".concat(folderLink, "/files/").concat(id, "/download"));
        case 2:
          _yield$request$get = _context5.sent;
          data = _yield$request$get.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getFLDownloadFile.apply(this, arguments);
}
function getPrivateDownloadFile(_x3, _x4) {
  return _getPrivateDownloadFile.apply(this, arguments);
}
// wo导出xlsx文档接口
function _getPrivateDownloadFile() {
  _getPrivateDownloadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(groupid, id) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$s.get("/api/v5/groups/".concat(groupid, "/files/").concat(id, "/download"), {
            params: {
              support_checksums: 'md5,sha1,sha224,sha256,sha384,sha512'
            }
          });
        case 2:
          _yield$request$get2 = _context6.sent;
          data = _yield$request$get2.data;
          return _context6.abrupt("return", data.url ? {
            fileinfo: data
          } : data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getPrivateDownloadFile.apply(this, arguments);
}
var exportFileInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, params) {
    var _yield$requestDocs$po, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return requestDocs$1.post("/api/v3/office/file/".concat(id, "/export"), params);
        case 2:
          _yield$requestDocs$po = _context.sent;
          data = _yield$requestDocs$po.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function exportFileInfo(_x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 【金山文档】 文件列表下载和导出接口替换，https://kdocs.cn/l/cgtq9ODnZlyf 
 * 本次修改只针对文字、传统表格的下载/导出接口替换，所以新增 newDownload 参数以兼容现有场景
 */
var asyncExport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, params, newDownload) {
    var res, _yield$requestDocs$ge, data, _yield$requestDocs$po2, _data, taskId, taskType, wait, _query;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          res = null;
          if (!newDownload) {
            _context3.next = 10;
            break;
          }
          _context3.next = 5;
          return requestDocs$1.get("/api/v3/office/file/".concat(id, "/download"), {
            params: params
          });
        case 5:
          _yield$requestDocs$ge = _context3.sent;
          data = _yield$requestDocs$ge.data;
          res = data;
          _context3.next = 15;
          break;
        case 10:
          _context3.next = 12;
          return requestDocs$1.post("/api/v3/office/file/".concat(id, "/async-export"), params);
        case 12:
          _yield$requestDocs$po2 = _context3.sent;
          _data = _yield$requestDocs$po2.data;
          res = _data;
        case 15:
          if (!(res.task_id && res.task_type)) {
            _context3.next = 25;
            break;
          }
          taskId = encodeURIComponent(res.task_id);
          taskType = res.task_type;
          wait = function wait(ms) {
            return new Promise(function (resolve) {
              setTimeout(resolve, ms);
            });
          };
          _query = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var _yield$requestDocs$ge2, resp;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return requestDocs$1.get("/api/v3/office/asynctasks/".concat(taskType, "?id=").concat(taskId));
                  case 3:
                    _yield$requestDocs$ge2 = _context2.sent;
                    resp = _yield$requestDocs$ge2.data;
                    if (!resp) {
                      _context2.next = 18;
                      break;
                    }
                    if (!(resp.status === 'running')) {
                      _context2.next = 12;
                      break;
                    }
                    _context2.next = 9;
                    return wait(1000);
                  case 9:
                    return _context2.abrupt("return", _query());
                  case 12:
                    if (!(resp.status === 'finished')) {
                      _context2.next = 18;
                      break;
                    }
                    if (!resp.data) {
                      _context2.next = 17;
                      break;
                    }
                    return _context2.abrupt("return", {
                      url: resp.data.url
                    });
                  case 17:
                    throw resp;
                  case 18:
                    throw new AsyncExportException();
                  case 21:
                    _context2.prev = 21;
                    _context2.t0 = _context2["catch"](0);
                    throw new AsyncExportException(_context2.t0);
                  case 24:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[0, 21]]);
            }));
            return function query() {
              return _ref3.apply(this, arguments);
            };
          }();
          _context3.next = 22;
          return wait(100);
        case 22:
          return _context3.abrupt("return", _query());
        case 25:
          if (!(res.download_url || res.url)) {
            _context3.next = 27;
            break;
          }
          return _context3.abrupt("return", {
            url: res.download_url || res.url
          });
        case 27:
          throw new AsyncExportException();
        case 30:
          _context3.prev = 30;
          _context3.t0 = _context3["catch"](0);
          throw new AsyncExportException(_context3.t0);
        case 33:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 30]]);
  }));
  return function asyncExport(_x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();

// 分享文件下载信息
function getLinkDownloadFile(_x10) {
  return _getLinkDownloadFile.apply(this, arguments);
}
// 分享文件c链接下载信息
function _getLinkDownloadFile() {
  _getLinkDownloadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return request$s.get("/api/v3/links/".concat(id, "/download"));
        case 2:
          _yield$request$get3 = _context7.sent;
          data = _yield$request$get3.data;
          return _context7.abrupt("return", data);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getLinkDownloadFile.apply(this, arguments);
}
function getCLinkDownloadFile(_x11) {
  return _getCLinkDownloadFile.apply(this, arguments);
}

// 获取ksheet导出Excel url
function _getCLinkDownloadFile() {
  _getCLinkDownloadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return request$s.get("/api/office/file/".concat(id, "/download"), {
            baseURL: envr$1 ? WEBOFFICE : DOCS
          });
        case 2:
          _yield$request$get4 = _context8.sent;
          data = _yield$request$get4.data;
          return _context8.abrupt("return", data);
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _getCLinkDownloadFile.apply(this, arguments);
}
var exportKsheetBySid = function exportKsheetBySid(id) {
  return new Promise(function (resolve, reject) {
    var _fn = function fn() {
      // 获取导出结果
      requestDocs$1.get("/api/v3/office/file/".concat(id, "/export/ksheet/export-progress")).then(function (res) {
        var _res$data = res.data,
          result = _res$data.result,
          data = _res$data.data;
        if (result === 'inProgress') {
          return setTimeout(_fn, 1000);
        }
        if (data && data.url) {
          return resolve(data.url);
        }
        throw res;
      })["catch"](reject);
    };
    // 启动进程
    requestDocs$1.post("/api/v3/office/file/".concat(id, "/export/ksheet/async-export")).then(_fn)["catch"](reject);
  });
};

/**
 * 检测文档是否有云附件
 * @param {String} id 文件id
 * @returns {Boolean} hasAttachment
 */
var checkDocHasAttachment = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
    var _yield$requestDocs$ge3, _yield$requestDocs$ge4, _yield$requestDocs$ge5, _yield$requestDocs$ge6, hasAttachement;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return requestDocs$1.get("/api/v3/office/file/".concat(id, "/attachment/check"));
        case 3:
          _yield$requestDocs$ge3 = _context4.sent;
          _yield$requestDocs$ge4 = _yield$requestDocs$ge3.data;
          _yield$requestDocs$ge5 = _yield$requestDocs$ge4 === void 0 ? {} : _yield$requestDocs$ge4;
          _yield$requestDocs$ge6 = _yield$requestDocs$ge5.has_attachment;
          hasAttachement = _yield$requestDocs$ge6 === void 0 ? false : _yield$requestDocs$ge6;
          return _context4.abrupt("return", hasAttachement);
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          return _context4.abrupt("return", false);
        case 14:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  }));
  return function checkDocHasAttachment(_x12) {
    return _ref4.apply(this, arguments);
  };
}();

function __formatQuery(str, obj) {
  var keyArr = Object.keys(obj) || [];
  var valueArr = Object.values(obj) || [];
  keyArr.forEach(function (item, index) {
    str += (str.indexOf('?') === -1 ? '?' : '&') + item + '=' + valueArr[index];
  });
  return str;
}
function getCookie(name) {
  var rawcookie = {};
  if (typeof document !== 'undefined') {
    if (document && document.cookie) {
      rawcookie = cookie.parse(document.cookie);
      return rawcookie[name] || null;
    }
  }
  return null;
}
var csrfToken = getCookie('csrf') || csrfToken$1();
function httpRequestQing() {
  return _httpRequestQing.apply(this, arguments);
}

// 普通 HTTP 请求
function _httpRequestQing() {
  _httpRequestQing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var url,
      method,
      data,
      header,
      timeout,
      result,
      options,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
          method = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'get';
          data = _args.length > 2 ? _args[2] : undefined;
          header = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
          timeout = _args.length > 4 ? _args[4] : undefined;
          result = {
            code: -1,
            data: {}
          };
          options = {
            method: method,
            url: url
          };
          if (timeout) {
            options.timeout = timeout;
          }
          data = injectCsrfToken(data, method, header);
          if (method === 'get' || method === 'delete') {
            options.url = __formatQuery(url, data);
          } else if (method === 'post' || method === 'put') {
            options.content_type = 'application/json';
            options.header = JSON.stringify(header);
            options.data = JSON.stringify(data || {});
          }
          console.log('options:', options);
          _context.next = 13;
          return network.httpRequestQing(options).then(function (res) {
            console.log('httpRequestQing', res, url, options);
            if (res.data) {
              result = res;
            }
          })["catch"](function (err) {
            result.code = 4322;
            console.log('error', err);
          });
        case 13:
          return _context.abrupt("return", result);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _httpRequestQing.apply(this, arguments);
}
function httpRequest() {
  return _httpRequest.apply(this, arguments);
}
function _httpRequest() {
  _httpRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var url,
      method,
      data,
      header,
      cookie,
      result,
      options,
      userinfo,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
          method = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'get';
          data = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          header = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
          cookie = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : {};
          result = {
            code: -1,
            data: {}
          };
          options = {
            url: url,
            type: method
          };
          _context2.next = 9;
          return account$1.getUserInfo();
        case 9:
          userinfo = _context2.sent;
          // todo：先临时设置cookie，后面再封装方法优化
          cookie['wps_sid'] = userinfo && userinfo.wpssid || '';
          cookie['wps_sids'] = userinfo && userinfo.wpssids || '';
          injectCsrfToken(cookie, method, header);
          options.header = header;
          options.cookie = cookie;
          if (method === 'get') {
            options.url = __formatQuery(url, data);
          } else if (method === 'post' || method === 'put') {
            options.data = JSON.stringify(data);
          }
          _context2.next = 18;
          return network.httpRequest(options).then(function (res) {
            console.log('httpRequest', res);
            if (res.data) {
              result = res;
            }
          })["catch"](function (err) {
            console.log('httpRequest error', err);
          });
        case 18:
          return _context2.abrupt("return", result);
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _httpRequest.apply(this, arguments);
}
function injectCsrfToken() {
  var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 ? arguments[1] : undefined;
  var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var token = csrfToken;
  console.log('csrfToken:', csrfToken);
  if (~['post', 'put', 'delete'].indexOf(method) && token) {
    cookie['csrf'] = token;
    header['X-CSRFToken'] = token;
  }

  /*
   * POST PUT DELETE
   * if (~['post', 'put', 'delete'].indexOf(method) && token) {
   *   if (isPlainObject(data)) {
   *     data.csrfmiddlewaretoken = token
   *   } else if (data instanceof ((typeof FormData !== 'undefined' && FormData) || Def)) {
   *     header['X-CSRFToken'] = token
   *   } else if (!data) {
   *     data = { csrfmiddlewaretoken: token }
   *   }
   *   header['X-CSRFToken'] = token
   * }
   */
}

var _excluded$2 = ["project", "cardType"],
  _excluded2$1 = ["fid"],
  _excluded3 = ["fid"],
  _excluded4 = ["companyId"];
function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var target = typeof window === 'undefined' ? global : window;
var envr = target && target.__KD_CONFIG__ && target.__KD_CONFIG__.props && target.__KD_CONFIG__.props.release === 'oem';
var localProtocol = typeof window !== 'undefined' && location.protocol === 'file:';
var request$r = createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});

// BFF聚合接口，fetchUserCertification && authCheck
var fetchUserCertAndInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$r.get('/api/v3/bff/share_layout/account/sessions/current');
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchUserCertAndInfo() {
    return _ref.apply(this, arguments);
  };
}();

// 获取metadata && link
var fetchMetadataAndLink = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fid) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$r.get("/api/v3/bff/share_layout/file/".concat(fid, "/meta?link_check_collaboration=false&link_with_clink=true"));
        case 2:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchMetadataAndLink(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getUserConfig = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var t, _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          t = new Date().getTime();
          _context3.next = 3;
          return request$r.get("/kd/api/user/config?key=".concat(params, "&t=").concat(t));
        case 3:
          _yield$request$get3 = _context3.sent;
          data = _yield$request$get3.data;
          return _context3.abrupt("return", data);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getUserConfig(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var setUserConfig = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$r.post('/kd/api/user/config', params);
        case 2:
          _yield$request$post = _context4.sent;
          data = _yield$request$post.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function setUserConfig(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var getJinxiaomenghello = function getJinxiaomenghello() {
  return request$r.get('/kd/api/user/config?key=jinxiaomenghello');
};
var getOnlineParameterByKeys = function getOnlineParameterByKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return request$r.get("/kdg/api/v1/params/baseOperation/sub_keys?subKeys=".concat(keys));
};
var setJinxiaomenghello = function setJinxiaomenghello() {
  return request$r.post('/kd/api/user/config', {
    key: 'jinxiaomenghello',
    value: 1
  });
};
var getWenjuan = function getWenjuan() {
  return request$r.get('/kd/api/wenjuan/user');
};
var setWenjuan = function setWenjuan(id) {
  return request$r.post('/kd/api/user/config', {
    key: id,
    value: 1
  });
};
var enhanceError = function enhanceError(request) {
  var successCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var data,
      error,
      _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request.apply(void 0, _args5);
        case 2:
          data = _context5.sent;
          if (!(data.code !== successCode)) {
            _context5.next = 7;
            break;
          }
          error = new Error();
          error.code = data.code;
          throw error;
        case 7:
          return _context5.abrupt("return", data);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
};
var getDownload = function getDownload() {
  return request$r.get('/kdg/api/v1/configure?idList=appOfficial');
};
/**
 * 获取广告位卡片信息
 * @param queryParams [卡片接口参数] : Object<filterListArr [过滤卡片id] : Array<string>, groupid [当前分组] : string>
 * @param platform [当前平台] : string
 * @param project [当前使用的项目] : string  用来区分使用的项目，默认public
 * @param cardType [卡片类型] : string 移动端首页运营位第二卡片类型 type===2
 * @return <null | cardInfo>
 */
var getAdvertisementCard = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6) {
    var project, cardType, queryParams, axiosRequest, mobileApi, _yield$request$get4, data, result, _yield$request$get5, _data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          project = _ref6.project, cardType = _ref6.cardType, queryParams = _objectWithoutProperties(_ref6, _excluded$2);
          axiosRequest = {
            params: queryParams,
            headers: {
              platform: webPlatform()
            }
          };
          if (!(project === 'mobile')) {
            _context6.next = 13;
            break;
          }
          mobileApi = '/kdg/api/v1/cards/mp-index';
          _context6.next = 6;
          return request$r.get(mobileApi, axiosRequest);
        case 6:
          _yield$request$get4 = _context6.sent;
          data = _yield$request$get4.data.data;
          result = cardType === '2' ? data && data['topCard'] : data && data['listCard'];
          result && !result.config && (result.config = {}); // 处理返回没有 config 属性的情况
          return _context6.abrupt("return", result || null);
        case 13:
          _context6.next = 15;
          return request$r.get('/kd/api/cooperator/card', axiosRequest);
        case 15:
          _yield$request$get5 = _context6.sent;
          _data = _yield$request$get5.data.data;
          return _context6.abrupt("return", _data.card || null);
        case 18:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getAdvertisementCard(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * 关闭广告位上报 only public
 * @param cardId [卡片id] : string
 */
var closeAdvertisementCard = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(cardId) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return request$r.put("/kd/api/cooperator/card/".concat(cardId), {
            closeTime: Date.now()
          });
        case 2:
          return _context7.abrupt("return", _context7.sent);
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function closeAdvertisementCard(_x5) {
    return _ref8.apply(this, arguments);
  };
}();

// 分享-打标签开关
var fileTagSwitch = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return request$r.get('/kdg/api/v1/configure?idList=shareFileTag');
        case 2:
          return _context8.abrupt("return", _context8.sent);
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function fileTagSwitch() {
    return _ref9.apply(this, arguments);
  };
}();
// 金小萌图片配置
var jinxiaomengPicConfig = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return request$r.get('/kdg/api/v1/cards/king-skin', {
            headers: {
              platform: webPlatform()
            }
          });
        case 2:
          return _context9.abrupt("return", _context9.sent);
        case 3:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function jinxiaomengPicConfig() {
    return _ref10.apply(this, arguments);
  };
}();
var fetchMyTeams = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
    var _yield$request$get6, data;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return request$r.get('/kdteam/api/v1/teams', _objectSpread$5(_objectSpread$5({}, params), {}, {
            baseURL: TWPS
          }));
        case 2:
          _yield$request$get6 = _context10.sent;
          data = _yield$request$get6.data;
          return _context10.abrupt("return", data.data);
        case 5:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function fetchMyTeams(_x6) {
    return _ref11.apply(this, arguments);
  };
}();
var getMyTeamsDetail = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(id) {
    var _yield$request$get7, data;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return request$r.get("/kdteam/api/v1/team/".concat(id), {
            baseURL: TWPS
          });
        case 2:
          _yield$request$get7 = _context11.sent;
          data = _yield$request$get7.data;
          return _context11.abrupt("return", data);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getMyTeamsDetail(_x7) {
    return _ref12.apply(this, arguments);
  };
}();

// 取用户配置
var getUserSetting = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$r.get('/kdg/api/v1/user/setting');
        case 2:
          return _context12.abrupt("return", _context12.sent);
        case 3:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function getUserSetting() {
    return _ref13.apply(this, arguments);
  };
}();

// 修改用户配置
var updateSetting = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(data) {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return request$r.put('/kdg/api/v1/user/setting', data);
        case 2:
          return _context13.abrupt("return", _context13.sent);
        case 3:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function updateSetting(_x8) {
    return _ref14.apply(this, arguments);
  };
}();

// 获取功能列表
var getConfigure = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return request$r.get('/kdg/api/v1/configure', {
            params: params
          });
        case 2:
          return _context14.abrupt("return", _context14.sent);
        case 3:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function getConfigure(_x9) {
    return _ref15.apply(this, arguments);
  };
}();

// 查询或创建xxx开关接口
var getSwitch = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref16) {
    var fid, params;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          fid = _ref16.fid, params = _objectWithoutProperties(_ref16, _excluded2$1);
          _context15.next = 3;
          return request$r.get("/kdteam/api/v1/switch/".concat(fid), {
            params: params
          });
        case 3:
          return _context15.abrupt("return", _context15.sent);
        case 4:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function getSwitch(_x10) {
    return _ref17.apply(this, arguments);
  };
}();
// 更新xxx开关的状态
var updateSwitch = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref18) {
    var fid, data;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          fid = _ref18.fid, data = _objectWithoutProperties(_ref18, _excluded3);
          _context16.next = 3;
          return request$r.put("/kdteam/api/v1/switch/".concat(fid), data);
        case 3:
          return _context16.abrupt("return", _context16.sent);
        case 4:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function updateSwitch(_x11) {
    return _ref19.apply(this, arguments);
  };
}();
var getTeamAppsList = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(id) {
    var _yield$request$get8, data;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          if (!envr) {
            _context17.next = 2;
            break;
          }
          return _context17.abrupt("return");
        case 2:
          _context17.next = 4;
          return request$r.get("kdteam/api/v1/apps/".concat(id), {
            baseURL: TWPS
          });
        case 4:
          _yield$request$get8 = _context17.sent;
          data = _yield$request$get8.data;
          return _context17.abrupt("return", data);
        case 7:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function getTeamAppsList(_x12) {
    return _ref20.apply(this, arguments);
  };
}();
var openTeamApps = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref21) {
    var appId, teamId, _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          appId = _ref21.appId, teamId = _ref21.teamId;
          _context18.next = 3;
          return request$r.post("kdteam/api/v1/apps/".concat(appId), {
            teamId: teamId
          }, {
            baseURL: TWPS
          });
        case 3:
          _yield$request$post2 = _context18.sent;
          data = _yield$request$post2.data;
          return _context18.abrupt("return", data);
        case 6:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function openTeamApps(_x13) {
    return _ref22.apply(this, arguments);
  };
}();
var closeTeamApps = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref23) {
    var appId, teamId, _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          appId = _ref23.appId, teamId = _ref23.teamId;
          _context19.next = 3;
          return request$r["delete"]("kdteam/api/v1/app/".concat(appId), {
            data: {
              teamId: teamId
            },
            baseURL: TWPS
          });
        case 3:
          _yield$request$delete = _context19.sent;
          data = _yield$request$delete.data;
          return _context19.abrupt("return", data);
        case 6:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function closeTeamApps(_x14) {
    return _ref24.apply(this, arguments);
  };
}();
var renameTeamApps = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref25) {
    var appId, teamId, name, _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          appId = _ref25.appId, teamId = _ref25.teamId, name = _ref25.name;
          _context20.next = 3;
          return request$r.put("kdteam/api/v1/app/".concat(appId, "/re_name"), {
            teamId: teamId,
            name: name
          }, {
            baseURL: TWPS
          });
        case 3:
          _yield$request$put = _context20.sent;
          data = _yield$request$put.data;
          return _context20.abrupt("return", data);
        case 6:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return function renameTeamApps(_x15) {
    return _ref26.apply(this, arguments);
  };
}();
var userMyTeamConf = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
    var _yield$request$get9, data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return request$r.get('/kdg/api/v1/configure', {
            params: {
              idList: 'personalTeamEnable'
            }
          });
        case 2:
          _yield$request$get9 = _context21.sent;
          data = _yield$request$get9.data;
          return _context21.abrupt("return", data.data);
        case 5:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function userMyTeamConf() {
    return _ref27.apply(this, arguments);
  };
}();
var getFileCreator = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(fid) {
    var _yield$request$get10, data;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return request$r.get("/kfc/miniprovider/v1/file/creator/".concat(fid));
        case 2:
          _yield$request$get10 = _context22.sent;
          data = _yield$request$get10.data;
          return _context22.abrupt("return", data.data);
        case 5:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return function getFileCreator(_x16) {
    return _ref28.apply(this, arguments);
  };
}();

/**
 * 分享面板 - 协作者列表 - 最近访问tab数据源
 * @param {*} fid
 * @returns
 */
var getFileRecentMembers = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(params) {
    var timeout,
      _yield$request$post3,
      data,
      _args23 = arguments;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          timeout = _args23.length > 1 && _args23[1] !== undefined ? _args23[1] : 30000;
          _context23.next = 3;
          return request$r.post('/kfc/miniprovider/v1/files/collaborator', params, {
            timeout: timeout
          });
        case 3:
          _yield$request$post3 = _context23.sent;
          data = _yield$request$post3.data;
          return _context23.abrupt("return", data.data);
        case 6:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return function getFileRecentMembers(_x17) {
    return _ref29.apply(this, arguments);
  };
}();

/**
 * 根据type获取卡片信息
 * http://docs.kdocs.cf/kdocs-go/v1/CARD.html
 *
 * @param {Object} params querystring中的参数，参考文档
 * @param {String} platform 当前平台
 * @param {Number} type 卡片类型
 * @returns
 */
var getCardInfo = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref30) {
    var params, platform, type, _yield$request$get11, data;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          params = _ref30.params, platform = _ref30.platform, type = _ref30.type;
          _context24.next = 3;
          return request$r.get("/kdg/api/v1/cards/type/".concat(type), {
            params: params,
            headers: {
              platform: platform
            }
          });
        case 3:
          _yield$request$get11 = _context24.sent;
          data = _yield$request$get11.data;
          return _context24.abrupt("return", data);
        case 6:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return function getCardInfo(_x18) {
    return _ref31.apply(this, arguments);
  };
}();

/**
 * 获取在线参数的内容
 * @param type: 场景
 * @param params： key值
 * @returns {Promise<{}|*>} value
 * @private
 */
var _getOnlineParams = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
    var params,
      type,
      _yield$request$get12,
      data,
      _args25 = arguments;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          params = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : {};
          type = _args25.length > 1 && _args25[1] !== undefined ? _args25[1] : 'square';
          _context25.prev = 2;
          _context25.next = 5;
          return request$r.get("/kdg/api/v1/params/".concat(type, "/sub_keys"), {
            params: params
          });
        case 5:
          _yield$request$get12 = _context25.sent;
          data = _yield$request$get12.data;
          return _context25.abrupt("return", data);
        case 10:
          _context25.prev = 10;
          _context25.t0 = _context25["catch"](2);
          return _context25.abrupt("return", null);
        case 13:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[2, 10]]);
  }));
  return function _getOnlineParams() {
    return _ref32.apply(this, arguments);
  };
}();

// 获取用户配置
var fetchUserSetting = /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
    var _yield$request$get13, _yield$request$get13$, data;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.prev = 0;
          _context26.next = 3;
          return request$r.get('/kdg/api/v1/user/setting');
        case 3:
          _yield$request$get13 = _context26.sent;
          _yield$request$get13$ = _yield$request$get13.data;
          data = _yield$request$get13$ === void 0 ? {
            data: {}
          } : _yield$request$get13$;
          return _context26.abrupt("return", data.data);
        case 9:
          _context26.prev = 9;
          _context26.t0 = _context26["catch"](0);
          return _context26.abrupt("return", {});
        case 12:
        case "end":
          return _context26.stop();
      }
    }, _callee26, null, [[0, 9]]);
  }));
  return function fetchUserSetting() {
    return _ref33.apply(this, arguments);
  };
}();

// 创建标签
var createDocTag = function createDocTag(data) {
  return request$r.post("/filetag/api/v5/utags", data);
};

// 查询标签
var getDocTags = function getDocTags(params) {
  return request$r.get("/filetag/api/v5/utags", {
    params: params
  });
};

// 创建或修改对象
var updateCurDocTag = function updateCurDocTag(tagId, objId) {
  var objType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var data = _objectSpread$5({
    obj_id: objId,
    obj_type: objType
  }, params);
  return request$r.put("/filetag/api/v5/utags/".concat(tagId, "/objs"), data);
};
// 删除对象
var deleteCurDocTag = function deleteCurDocTag(tagId, objId) {
  var objType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var data = {
    obj_id: objId,
    obj_type: objType
  };
  return request$r["delete"]("/filetag/api/v5/utags/".concat(tagId, "/objs"), {
    data: data
  });
};

/**
 * 查询单个对象标签
 * @param objId 对象ID
 * @param objType 对象类型(1-文件,2-团队),默认"1-文件"
 * @returns {Promise<never>}
 */
var getCurDocTags = function getCurDocTags(objId) {
  var objType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var data = {
    objs: [{
      obj_id: objId,
      obj_type: objType
    }]
  };
  return request$r.post("/filetag/api/v5/utags/objs/tags", data);
};

/**
 * 上报用户N天内不展示卡片
 * APIDOC: http://docs.kdocs.cf/kdocs-go/v1/CARD.html#%E4%B8%8A%E6%8A%A5%E7%94%A8%E6%88%B7n%E5%A4%A9%E5%86%85%E4%B8%8D%E5%B1%95%E7%A4%BA%E5%8D%A1%E7%89%87
 *
 * @param {*} params
 * @returns
 */
var createCloseCard = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(_ref34) {
    var id, timeout, _yield$request$post4, data;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          id = _ref34.id, timeout = _ref34.timeout;
          _context27.next = 3;
          return request$r.post("/kdg/api/v1/card/close/".concat(id), {
            timeout: timeout
          });
        case 3:
          _yield$request$post4 = _context27.sent;
          data = _yield$request$post4.data;
          return _context27.abrupt("return", data);
        case 6:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return function createCloseCard(_x19) {
    return _ref35.apply(this, arguments);
  };
}();

/**
 * et 保护工作簿，获取协作者删除，新建，重命名权限 - 分享，高级设置
 * @param {*} params
 */
var getLinkRenamePerm = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(id, params) {
    var _yield$request$get14, data;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return request$r.get("/api/v3/office/file/".concat(id, "/custom/attribute"), {
            params: params
          });
        case 2:
          _yield$request$get14 = _context28.sent;
          data = _yield$request$get14.data;
          return _context28.abrupt("return", data);
        case 5:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return function getLinkRenamePerm(_x20, _x21) {
    return _ref36.apply(this, arguments);
  };
}();

/**
 * et 保护工作簿，设置协作者删除，新建，重命名权限 - 分享，高级设置
 * @param {*} params
 */
var setLinkRenamePerm = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(id, params) {
    var _yield$request$put2, data;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return request$r.put("/api/v3/office/file/".concat(id, "/custom/attribute"), _objectSpread$5({}, params));
        case 2:
          _yield$request$put2 = _context29.sent;
          data = _yield$request$put2.data;
          return _context29.abrupt("return", data);
        case 5:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return function setLinkRenamePerm(_x22, _x23) {
    return _ref37.apply(this, arguments);
  };
}();

/**
 * 获取文档申请编辑权限的状态
 * @param {String} fid 文件id
 * @returns {Object} data
 * @returns {String} data.allow_apply_edit "0" 不可申请编辑权限 "1" 可申请编辑权限
 */
var getBlockEditApplyStatus = /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(fid) {
    var _yield$request$get15, data;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.next = 2;
          return request$r.get("/api/kdocs/file/".concat(fid, "/application/editing"));
        case 2:
          _yield$request$get15 = _context30.sent;
          data = _yield$request$get15.data;
          return _context30.abrupt("return", data);
        case 5:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return function getBlockEditApplyStatus(_x24) {
    return _ref38.apply(this, arguments);
  };
}();

/**
 * 设置文档申请编辑权限的状态
 * @param {String} fid 文件id
 * @param {Number} status 是否可申请编辑权限 0：否 1：是
 * @returns {Object} data
 * @returns {String} data.result "ok"成功
 */
var setBlockEditApplyStatus = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(fid, status) {
    var _yield$request$post5, data;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return request$r.post("/api/kdocs/file/".concat(fid, "/application/editing"), {
            allow_apply_edit: status
          });
        case 2:
          _yield$request$post5 = _context31.sent;
          data = _yield$request$post5.data;
          return _context31.abrupt("return", data);
        case 5:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return function setBlockEditApplyStatus(_x25, _x26) {
    return _ref39.apply(this, arguments);
  };
}();

// 创建通道并获取通道id
var createChannel = /*#__PURE__*/function () {
  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
    var _yield$request$post6, data;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          _context32.next = 2;
          return request$r.post("/kfc/miniprovider/v2/channel/realname/id");
        case 2:
          _yield$request$post6 = _context32.sent;
          data = _yield$request$post6.data;
          return _context32.abrupt("return", data);
        case 5:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return function createChannel() {
    return _ref40.apply(this, arguments);
  };
}();
/**
 * 根据通道id获取通道数据
 * @param {String} channelId 通道id
 * @returns {Object} data
 */
var getChannelDataById = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(channelId) {
    var _yield$request$get16, data;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 2;
          return request$r.get("/kfc/miniprovider/v1/channel/realname?id=".concat(channelId));
        case 2:
          _yield$request$get16 = _context33.sent;
          data = _yield$request$get16.data;
          return _context33.abrupt("return", data);
        case 5:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return function getChannelDataById(_x27) {
    return _ref41.apply(this, arguments);
  };
}();
/**
 * 设置通道数据
 * @param {String} channelId 通道id
 * @param {Object} channelData 通道数据
 * @returns {Object} data
 */
var setChannelData = /*#__PURE__*/function () {
  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(channelId, channelData) {
    var _yield$request$post7, data;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          _context34.next = 2;
          return request$r.post("/kfc/miniprovider/v1/channel/realname", {
            id: channelId,
            value: channelData
          });
        case 2:
          _yield$request$post7 = _context34.sent;
          data = _yield$request$post7.data;
          return _context34.abrupt("return", data);
        case 5:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return function setChannelData(_x28, _x29) {
    return _ref42.apply(this, arguments);
  };
}();

/**
 * 新分享-高级设置数
 * params:
 *  fid 文件id
 *  ext 组件类型
 */
var fetchSettingCounts = /*#__PURE__*/function () {
  var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(_ref43) {
    var fid, ext, _yield$request$get17, data;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          fid = _ref43.fid, ext = _ref43.ext;
          _context35.next = 3;
          return request$r.get("/kfc/miniprovider/v1/share/change?fid=".concat(fid, "&ext=").concat(ext));
        case 3:
          _yield$request$get17 = _context35.sent;
          data = _yield$request$get17.data;
          return _context35.abrupt("return", data);
        case 6:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return function fetchSettingCounts(_x30) {
    return _ref44.apply(this, arguments);
  };
}();

/**
 * 新分享-高级设置数
 * params:
 *  offset 偏移量
 *  sid 分享文件sid
 */
var fetchCollaboratorsAndCount = /*#__PURE__*/function () {
  var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(_ref45) {
    var offset, sid, _yield$request$get18, data;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          offset = _ref45.offset, sid = _ref45.sid;
          _context36.next = 3;
          return request$r.get("/kfc/miniprovider/v1/share/collaborators?offset=".concat(offset, "&sid=").concat(sid, "&withTeamMember=true"));
        case 3:
          _yield$request$get18 = _context36.sent;
          data = _yield$request$get18.data;
          return _context36.abrupt("return", data);
        case 6:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return function fetchCollaboratorsAndCount(_x31) {
    return _ref46.apply(this, arguments);
  };
}();

/**
 * 分享面板-搜索
 * params:
 *  cid, key, corp_id, group_id count
 */
var fetchSearchShareColls = /*#__PURE__*/function () {
  var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(params) {
    var searchParams, mark, key, _yield$request$get19, data;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          searchParams = '';
          mark = 0;
          for (key in params) {
            if (params[key] === undefined) {
              delete params[key];
            } else {
              searchParams += "".concat(mark ? '&' : '').concat(key, "=").concat(params[key]);
              mark = 1;
            }
          }
          _context37.next = 5;
          return request$r.get("/kfc/miniprovider/v1/share/collaborators/search?".concat(searchParams));
        case 5:
          _yield$request$get19 = _context37.sent;
          data = _yield$request$get19.data;
          return _context37.abrupt("return", data);
        case 8:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return function fetchSearchShareColls(_x32) {
    return _ref47.apply(this, arguments);
  };
}();

// 判断是否为广场文档
var isSquareFile = /*#__PURE__*/function () {
  var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(cid) {
    var _yield$request$get20, data;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          _context38.next = 2;
          return request$r.get("/kdg/api/v1/square/event/check/".concat(cid));
        case 2:
          _yield$request$get20 = _context38.sent;
          data = _yield$request$get20.data.data;
          return _context38.abrupt("return", data.isSquareDoc);
        case 5:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return function isSquareFile(_x33) {
    return _ref48.apply(this, arguments);
  };
}();

// 举报广场文件
var activeArticleReport = /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(params) {
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          _context39.next = 2;
          return request$r.post('/kdg/api/v1/square/report/article', params, {
            headers: {
              platform: webPlatform()
            }
          });
        case 2:
          return _context39.abrupt("return", _context39.sent);
        case 3:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return function activeArticleReport(_x34) {
    return _ref49.apply(this, arguments);
  };
}();

// 举报广场评论
var reportComment = /*#__PURE__*/function () {
  var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(params) {
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          _context40.next = 2;
          return request$r.post('/kdg/api/v1/square/report/article/comment', params, {
            headers: {
              platform: webPlatform()
            }
          });
        case 2:
          return _context40.abrupt("return", _context40.sent);
        case 3:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return function reportComment(_x35) {
    return _ref50.apply(this, arguments);
  };
}();
var getSpaceFull = /*#__PURE__*/function () {
  var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          _context41.next = 2;
          return request$r.get('/kd/api/user/config?key=spaceFull', {
            noCatch: true
          });
        case 2:
          return _context41.abrupt("return", _context41.sent);
        case 3:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return function getSpaceFull() {
    return _ref51.apply(this, arguments);
  };
}();
var setSpaceFullReddot = /*#__PURE__*/function () {
  var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(params) {
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          _context42.next = 2;
          return request$r.post('/kd/api/user/config', {
            key: 'spaceFull',
            value: params
          });
        case 2:
          return _context42.abrupt("return", _context42.sent);
        case 3:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return function setSpaceFullReddot(_x36) {
    return _ref52.apply(this, arguments);
  };
}();

/**
 * 高级设置-获取文件是否展示企业认证信息
 * 返回：auth_info、company_switch、file_switch
 */
var fetchCompanyShareMarkSwitch = /*#__PURE__*/function () {
  var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(_ref53) {
    var companyId, fid, _yield$request$get21, data;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          companyId = _ref53.companyId, fid = _ref53.fid;
          _context43.next = 3;
          return request$r.get("/kfc/miniprovider/v1/company/certification/share/".concat(companyId, "?fid=").concat(fid));
        case 3:
          _yield$request$get21 = _context43.sent;
          data = _yield$request$get21.data;
          return _context43.abrupt("return", data);
        case 6:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return function fetchCompanyShareMarkSwitch(_x37) {
    return _ref54.apply(this, arguments);
  };
}();

/**
 * 高级设置-设置文件是否展示企业认证信息
 * params: {
 *  companyId,
 *  fid,
 *  switch
 * }
 */
var setCompanyShareSwitch = /*#__PURE__*/function () {
  var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(_ref55) {
    var companyId, params;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          companyId = _ref55.companyId, params = _objectWithoutProperties(_ref55, _excluded4);
          _context44.next = 3;
          return request$r.post("/kfc/miniprovider/v1/company/certification/share/".concat(companyId), params);
        case 3:
          return _context44.abrupt("return", _context44.sent);
        case 4:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return function setCompanyShareSwitch(_x38) {
    return _ref56.apply(this, arguments);
  };
}();
function getAiProtocolInfo() {
  return _getAiProtocolInfo.apply(this, arguments);
}
function _getAiProtocolInfo() {
  _getAiProtocolInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
    var _yield$httpRequest4, data, _yield$request$get29, _data5;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) switch (_context56.prev = _context56.next) {
        case 0:
          if (!localProtocol) {
            _context56.next = 8;
            break;
          }
          _context56.next = 3;
          return httpRequest("".concat(KDOCS, "/kdg/api/v1/params/docs_wpsai_protocol"), 'get');
        case 3:
          _yield$httpRequest4 = _context56.sent;
          data = _yield$httpRequest4.data;
          return _context56.abrupt("return", data.data);
        case 8:
          _context56.next = 10;
          return request$r.get('/kdg/api/v1/params/docs_wpsai_protocol');
        case 10:
          _yield$request$get29 = _context56.sent;
          _data5 = _yield$request$get29.data;
          return _context56.abrupt("return", _data5.data);
        case 13:
        case "end":
          return _context56.stop();
      }
    }, _callee56);
  }));
  return _getAiProtocolInfo.apply(this, arguments);
}
function getAiProtocolAuth(_x39) {
  return _getAiProtocolAuth.apply(this, arguments);
}
function _getAiProtocolAuth() {
  _getAiProtocolAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(version) {
    var _yield$httpRequest5, data, _yield$request$get30, _data6;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) switch (_context57.prev = _context57.next) {
        case 0:
          if (!localProtocol) {
            _context57.next = 8;
            break;
          }
          _context57.next = 3;
          return httpRequest("".concat(KDOCS, "/kfc/miniprovider/v1/docs/ai/auth"), 'get', {
            version: version
          });
        case 3:
          _yield$httpRequest5 = _context57.sent;
          data = _yield$httpRequest5.data;
          return _context57.abrupt("return", data.data);
        case 8:
          _context57.next = 10;
          return request$r.get("/kfc/miniprovider/v1/docs/ai/auth?version=".concat(version));
        case 10:
          _yield$request$get30 = _context57.sent;
          _data6 = _yield$request$get30.data;
          return _context57.abrupt("return", _data6.data);
        case 13:
        case "end":
          return _context57.stop();
      }
    }, _callee57);
  }));
  return _getAiProtocolAuth.apply(this, arguments);
}
function setAiProtocolAuth(_x40) {
  return _setAiProtocolAuth.apply(this, arguments);
}

// 个人面板云空间梯度
function _setAiProtocolAuth() {
  _setAiProtocolAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(version) {
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) switch (_context58.prev = _context58.next) {
        case 0:
          if (!localProtocol) {
            _context58.next = 5;
            break;
          }
          _context58.next = 3;
          return httpRequest("".concat(KDOCS, "/kfc/miniprovider/v1/docs/ai/auth"), 'post', {
            version: version
          });
        case 3:
          _context58.next = 7;
          break;
        case 5:
          _context58.next = 7;
          return request$r.post('/kfc/miniprovider/v1/docs/ai/auth', {
            version: version
          });
        case 7:
        case "end":
          return _context58.stop();
      }
    }, _callee58);
  }));
  return _setAiProtocolAuth.apply(this, arguments);
}
var getYunSpaceSize = /*#__PURE__*/function () {
  var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
    var _yield$request$get22, data;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          _context45.prev = 0;
          _context45.next = 3;
          return request$r.get('/kdg/api/v1/configure?idList=YunSpaceSize', {
            headers: {
              platform: webPlatform()
            }
          });
        case 3:
          _yield$request$get22 = _context45.sent;
          data = _yield$request$get22.data.data;
          return _context45.abrupt("return", data);
        case 8:
          _context45.prev = 8;
          _context45.t0 = _context45["catch"](0);
          return _context45.abrupt("return", {});
        case 11:
        case "end":
          return _context45.stop();
      }
    }, _callee45, null, [[0, 8]]);
  }));
  return function getYunSpaceSize() {
    return _ref57.apply(this, arguments);
  };
}();
var getJxmOperateCard = /*#__PURE__*/function () {
  var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(params) {
    var _yield$request$get23, data;
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          _context46.prev = 0;
          _context46.next = 3;
          return request$r.get('/kdg/api/v1/cards/unauth/type/50', {
            params: params,
            headers: {
              platform: webPlatform()
            }
          });
        case 3:
          _yield$request$get23 = _context46.sent;
          data = _yield$request$get23.data.data;
          return _context46.abrupt("return", data ? data : []);
        case 8:
          _context46.prev = 8;
          _context46.t0 = _context46["catch"](0);
          return _context46.abrupt("return", []);
        case 11:
        case "end":
          return _context46.stop();
      }
    }, _callee46, null, [[0, 8]]);
  }));
  return function getJxmOperateCard(_x41) {
    return _ref58.apply(this, arguments);
  };
}();
var getUserSetKey = /*#__PURE__*/function () {
  var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(key) {
    var _yield$request$get24, data;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          _context47.prev = 0;
          _context47.next = 3;
          return request$r.get('/kdg/api/v1/user-set/key', {
            params: {
              key: key
            }
          });
        case 3:
          _yield$request$get24 = _context47.sent;
          data = _yield$request$get24.data;
          if (!(data && data.code === 0)) {
            _context47.next = 7;
            break;
          }
          return _context47.abrupt("return", data.data[key]);
        case 7:
          _context47.next = 12;
          break;
        case 9:
          _context47.prev = 9;
          _context47.t0 = _context47["catch"](0);
          return _context47.abrupt("return", '');
        case 12:
        case "end":
          return _context47.stop();
      }
    }, _callee47, null, [[0, 9]]);
  }));
  return function getUserSetKey(_x42) {
    return _ref59.apply(this, arguments);
  };
}();
var setUserSetKey = function setUserSetKey(data) {
  try {
    return request$r.put('/kdg/api/v1/user-set/key', {
      kvs: [data]
    });
  } catch (e) {}
};
var getNpsConfig = /*#__PURE__*/function () {
  var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(params) {
    var _yield$httpRequest, data, _yield$request$get25, _data2;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          if (!localProtocol) {
            _context48.next = 8;
            break;
          }
          _context48.next = 3;
          return httpRequest("".concat(KDOCS, "/api/kdocs/user/nps/config"), 'get', params);
        case 3:
          _yield$httpRequest = _context48.sent;
          data = _yield$httpRequest.data;
          return _context48.abrupt("return", data);
        case 8:
          _context48.next = 10;
          return request$r.get('/api/kdocs/user/nps/config', {
            params: params
          });
        case 10:
          _yield$request$get25 = _context48.sent;
          _data2 = _yield$request$get25.data;
          return _context48.abrupt("return", _data2);
        case 13:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return function getNpsConfig(_x43) {
    return _ref60.apply(this, arguments);
  };
}();
var reportNps = /*#__PURE__*/function () {
  var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(params) {
    var _yield$httpRequest2, data, _yield$request$post8, _data3;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          if (!localProtocol) {
            _context49.next = 8;
            break;
          }
          _context49.next = 3;
          return httpRequest("".concat(KDOCS, "/api/kdocs/user/nps/report"), 'post', params);
        case 3:
          _yield$httpRequest2 = _context49.sent;
          data = _yield$httpRequest2.data;
          return _context49.abrupt("return", data);
        case 8:
          _context49.next = 10;
          return request$r.post("/api/kdocs/user/nps/report", params);
        case 10:
          _yield$request$post8 = _context49.sent;
          _data3 = _yield$request$post8.data;
          return _context49.abrupt("return", _data3);
        case 13:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));
  return function reportNps(_x44) {
    return _ref61.apply(this, arguments);
  };
}();
var submitNpsResult = /*#__PURE__*/function () {
  var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(params) {
    var _yield$httpRequest3, data, _yield$request$post9, _data4;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          if (!localProtocol) {
            _context50.next = 8;
            break;
          }
          _context50.next = 3;
          return httpRequest("".concat(KDOCS, "/api/kdocs/user/nps/result"), 'post', params);
        case 3:
          _yield$httpRequest3 = _context50.sent;
          data = _yield$httpRequest3.data;
          return _context50.abrupt("return", data);
        case 8:
          _context50.next = 10;
          return request$r.post("/api/kdocs/user/nps/result", params);
        case 10:
          _yield$request$post9 = _context50.sent;
          _data4 = _yield$request$post9.data;
          return _context50.abrupt("return", _data4);
        case 13:
        case "end":
          return _context50.stop();
      }
    }, _callee50);
  }));
  return function submitNpsResult(_x45) {
    return _ref62.apply(this, arguments);
  };
}();
var getJxmPanelOperate = /*#__PURE__*/function () {
  var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(params) {
    var _yield$request$get26, data;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          _context51.prev = 0;
          _context51.next = 3;
          return request$r.get('/kdg/api/v1/cards/sub/51?isGetList=true', {
            params: params,
            headers: {
              platform: webPlatform()
            }
          });
        case 3:
          _yield$request$get26 = _context51.sent;
          data = _yield$request$get26.data.data;
          return _context51.abrupt("return", data ? data : []);
        case 8:
          _context51.prev = 8;
          _context51.t0 = _context51["catch"](0);
          return _context51.abrupt("return", []);
        case 11:
        case "end":
          return _context51.stop();
      }
    }, _callee51, null, [[0, 8]]);
  }));
  return function getJxmPanelOperate(_x46) {
    return _ref63.apply(this, arguments);
  };
}();
var getTcConfig = /*#__PURE__*/function () {
  var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(params) {
    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          _context52.next = 2;
          return request$r.post('/api/v3/kai/docer/proxy/market/activity', params);
        case 2:
          return _context52.abrupt("return", _context52.sent);
        case 3:
        case "end":
          return _context52.stop();
      }
    }, _callee52);
  }));
  return function getTcConfig(_x47) {
    return _ref64.apply(this, arguments);
  };
}();

// 下载客户端弹窗标签配置
var getDownloadPanelLabel = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
    var _yield$request$get27, data;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) switch (_context53.prev = _context53.next) {
        case 0:
          _context53.prev = 0;
          _context53.next = 3;
          return request$r.get('/kdg/api/v1/configure?idList=DownloadClient');
        case 3:
          _yield$request$get27 = _context53.sent;
          data = _yield$request$get27.data.data;
          return _context53.abrupt("return", data);
        case 8:
          _context53.prev = 8;
          _context53.t0 = _context53["catch"](0);
          return _context53.abrupt("return", {});
        case 11:
        case "end":
          return _context53.stop();
      }
    }, _callee53, null, [[0, 8]]);
  }));
  return function getDownloadPanelLabel() {
    return _ref65.apply(this, arguments);
  };
}();

// 下载客户端弹窗标签配置
var getJxmOneDayTimes = /*#__PURE__*/function () {
  var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
    var _yield$request$get28, data;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) switch (_context54.prev = _context54.next) {
        case 0:
          _context54.prev = 0;
          _context54.next = 3;
          return request$r.get('/kdg/api/v1/configure?idList=jxmGuideShowTimes');
        case 3:
          _yield$request$get28 = _context54.sent;
          data = _yield$request$get28.data.data;
          return _context54.abrupt("return", data.jxmGuideShowTimes || 1);
        case 8:
          _context54.prev = 8;
          _context54.t0 = _context54["catch"](0);
          return _context54.abrupt("return", 1);
        case 11:
        case "end":
          return _context54.stop();
      }
    }, _callee54, null, [[0, 8]]);
  }));
  return function getJxmOneDayTimes() {
    return _ref66.apply(this, arguments);
  };
}();

// 文档标题送审
var reviewTitle = /*#__PURE__*/function () {
  var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(fid, params) {
    var _yield$request$post10, data;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) switch (_context55.prev = _context55.next) {
        case 0:
          _context55.prev = 0;
          _context55.next = 3;
          return request$r.post("/api/v3/office/file/".concat(fid, "/qr_title/review"), params);
        case 3:
          _yield$request$post10 = _context55.sent;
          data = _yield$request$post10.data;
          return _context55.abrupt("return", data);
        case 8:
          _context55.prev = 8;
          _context55.t0 = _context55["catch"](0);
          return _context55.abrupt("return", {});
        case 11:
        case "end":
          return _context55.stop();
      }
    }, _callee55, null, [[0, 8]]);
  }));
  return function reviewTitle(_x48, _x49) {
    return _ref67.apply(this, arguments);
  };
}();

// 切换团队问答开关
function toggleGroupAIStatus(_x50, _x51) {
  return _toggleGroupAIStatus.apply(this, arguments);
}

// 获取团队问答开关状态
function _toggleGroupAIStatus() {
  _toggleGroupAIStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(groupId, isOpen) {
    var _yield$request$post11, data;
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) switch (_context59.prev = _context59.next) {
        case 0:
          _context59.next = 2;
          return request$r.post('/wiki/api/v1/doclib/ai/switch', {
            drive_id: String(groupId),
            status: isOpen ? 'open' : 'close'
          });
        case 2:
          _yield$request$post11 = _context59.sent;
          data = _yield$request$post11.data;
          return _context59.abrupt("return", data);
        case 5:
        case "end":
          return _context59.stop();
      }
    }, _callee59);
  }));
  return _toggleGroupAIStatus.apply(this, arguments);
}
function getGroupAIStatus(_x52) {
  return _getGroupAIStatus.apply(this, arguments);
}

// 团队设置-发布设置-查看知识视图设置
function _getGroupAIStatus() {
  _getGroupAIStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(groupId) {
    var _yield$request$get31, _yield$request$get31$, _yield$request$get31$2, status, totalFiles, percentage;
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) switch (_context60.prev = _context60.next) {
        case 0:
          _context60.next = 2;
          return request$r.get('/wiki/api/v1/doclib/ai/qa/status', {
            params: {
              drive_id: groupId
            }
          });
        case 2:
          _yield$request$get31 = _context60.sent;
          _yield$request$get31$ = _yield$request$get31.data.data;
          _yield$request$get31$2 = _yield$request$get31$ === void 0 ? {} : _yield$request$get31$;
          status = _yield$request$get31$2.status;
          totalFiles = _yield$request$get31$2.total_files;
          percentage = _yield$request$get31$2.process_percentage;
          return _context60.abrupt("return", {
            totalFiles: totalFiles,
            percentage: percentage,
            status: status,
            closed: status === 'close',
            processing: status === 'in_storage' && percentage !== 100,
            // 问答服务打开处理中
            opened: status === 'open' && percentage === 100 // / 已打开
          });
        case 9:
        case "end":
          return _context60.stop();
      }
    }, _callee60);
  }));
  return _getGroupAIStatus.apply(this, arguments);
}
function getGroupKmPulishInfo(_x53) {
  return _getGroupKmPulishInfo.apply(this, arguments);
}

/**
 * @desc 团队设置-发布设置-更新知识视图设置
 * @param cover_img 封面
 * @param desc 内容介绍，最大50字
 * @param group_id 团队id
 * @param status 0-关 1-团队可见 2-企业可见 3-企业可见提交中
 * @param reason 申请理由，发布为企业知识时必填
 */
function _getGroupKmPulishInfo() {
  _getGroupKmPulishInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(groupId) {
    var _yield$request$get32, data;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) switch (_context61.prev = _context61.next) {
        case 0:
          _context61.next = 2;
          return request$r.get('/wiki/api/km/group/knowledge_view', {
            params: {
              group_id: String(groupId)
            }
          });
        case 2:
          _yield$request$get32 = _context61.sent;
          data = _yield$request$get32.data;
          return _context61.abrupt("return", data);
        case 5:
        case "end":
          return _context61.stop();
      }
    }, _callee61);
  }));
  return _getGroupKmPulishInfo.apply(this, arguments);
}
function updateGroupKmPulishInfo(_x54) {
  return _updateGroupKmPulishInfo.apply(this, arguments);
}

// 团队设置-发布设置-关闭知识视图
function _updateGroupKmPulishInfo() {
  _updateGroupKmPulishInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(params) {
    var cover_img, desc, group_id, status, reason, _yield$request$post12, data;
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) switch (_context62.prev = _context62.next) {
        case 0:
          cover_img = params.cover_img, desc = params.desc, group_id = params.group_id, status = params.status, reason = params.reason;
          _context62.next = 3;
          return request$r.post('/wiki/api/km/group/knowledge_view', {
            cover_img: cover_img,
            desc: desc,
            group_id: String(group_id),
            status: status,
            reason: reason || undefined
          });
        case 3:
          _yield$request$post12 = _context62.sent;
          data = _yield$request$post12.data;
          return _context62.abrupt("return", data);
        case 6:
        case "end":
          return _context62.stop();
      }
    }, _callee62);
  }));
  return _updateGroupKmPulishInfo.apply(this, arguments);
}
function cancelGroupKmPublish(_x55) {
  return _cancelGroupKmPublish.apply(this, arguments);
}

// 团队设置-发布设置-获取默认封面
function _cancelGroupKmPublish() {
  _cancelGroupKmPublish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(groupId) {
    var _yield$request$post13, data;
    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) switch (_context63.prev = _context63.next) {
        case 0:
          _context63.next = 2;
          return request$r.post('/wiki/api/km/group/close_knowledge_view', {
            group_id: String(groupId)
          });
        case 2:
          _yield$request$post13 = _context63.sent;
          data = _yield$request$post13.data;
          return _context63.abrupt("return", data);
        case 5:
        case "end":
          return _context63.stop();
      }
    }, _callee63);
  }));
  return _cancelGroupKmPublish.apply(this, arguments);
}
function getGroupKmSpaceImgList() {
  return _getGroupKmSpaceImgList.apply(this, arguments);
}

// 团队设置-发布设置-获取设置
function _getGroupKmSpaceImgList() {
  _getGroupKmSpaceImgList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
    var _yield$request$get33, data;
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) switch (_context64.prev = _context64.next) {
        case 0:
          _context64.next = 2;
          return request$r.get('/wiki/api/km/space/img/list');
        case 2:
          _yield$request$get33 = _context64.sent;
          data = _yield$request$get33.data;
          return _context64.abrupt("return", data);
        case 5:
        case "end":
          return _context64.stop();
      }
    }, _callee64);
  }));
  return _getGroupKmSpaceImgList.apply(this, arguments);
}
function getGroupKmUploadService(_x56, _x57, _x58, _x59, _x60) {
  return _getGroupKmUploadService.apply(this, arguments);
}
function _getGroupKmUploadService() {
  _getGroupKmUploadService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(type, maxlength, name, category, img) {
    var _yield$request$post14, data;
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) switch (_context65.prev = _context65.next) {
        case 0:
          _context65.next = 2;
          return request$r.post('/wiki/api/km/upload/resource', {
            content_type: type,
            content_maxlength: maxlength,
            file_name: name,
            category: category
          });
        case 2:
          _yield$request$post14 = _context65.sent;
          data = _yield$request$post14.data;
          return _context65.abrupt("return", new Promise(function (resolve, reject) {
            var _data$data, _data$data2;
            var xhr = new XMLHttpRequest();
            xhr.open('PUT', data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.upload_url);
            Object.keys(data === null || data === void 0 || (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.head).forEach(function (head) {
              var _data$data3;
              xhr.setRequestHeader(head, "".concat(data === null || data === void 0 || (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.head[head]));
            });
            xhr.send(img);
            xhr.onload = function () {
              if (xhr.status === 200) {
                var _data$data4;
                resolve(data === null || data === void 0 || (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.url);
              } else {
                reject(new Error(xhr.statusText));
              }
            };
          }));
        case 5:
        case "end":
          return _context65.stop();
      }
    }, _callee65);
  }));
  return _getGroupKmUploadService.apply(this, arguments);
}

var request$q = createInstance({
  baseURL: STORE,
  withCredentials: true
});

// 获取上传图片权限
var getUploadAccess = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$q.post('/api/companyauth/upload/request', params);
        case 2:
          _yield$request$post = _context.sent;
          data = _yield$request$post.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getUploadAccess(_x) {
    return _ref.apply(this, arguments);
  };
}();

var request$p = createInstance({
  baseURL: ACCOUNT,
  withCredentials: true,
  timeout: 30000
}, false);
var authCheckNoK3rd = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$p.get('/api/check/cdwc');
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function authCheckNoK3rd() {
    return _ref.apply(this, arguments);
  };
}();

var request$o = createInstance({
  baseURL: WOA,
  withCredentials: true,
  timeout: 30000
});
var requestKdocs = createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});
var getKoaRecentContacts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opts) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$o.get('/api/v1/recent/contacts/mixed', opts);
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getKoaRecentContacts(_x) {
    return _ref.apply(this, arguments);
  };
}();
var cooperVerify = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid, uid) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$o.get("/api/v1/3rd/users/".concat(uid, "/verify"));
        case 2:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data.corp_ids.includes(cid));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function cooperVerify(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var sendFileToUser = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var _yield$requestKdocs$p, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return requestKdocs.post('/kfc/miniprovider/v1/developer/files/chats', params);
        case 2:
          _yield$requestKdocs$p = _context3.sent;
          data = _yield$requestKdocs$p.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function sendFileToUser(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
var sendFileToUserV2 = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var _yield$requestKdocs$p2, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return requestKdocs.post('/kfc/miniprovider/v1/files/chats', params);
        case 2:
          _yield$requestKdocs$p2 = _context4.sent;
          data = _yield$requestKdocs$p2.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function sendFileToUserV2(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
var verifyWoaUser = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(userid) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$o.get("/api/v1/3rd/users/".concat(userid, "/verify"));
        case 2:
          return _context5.abrupt("return", _context5.sent);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function verifyWoaUser(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

var request$n = createInstance({
  baseURL: FILECOLLECT,
  withCredentials: true
});
function createHeader$2(isPCoffice) {
  return {
    'Account-DeviceName': "wps+_".concat(isPCoffice ? 'pc' : 'web'),
    'Account-DeviceId': '0201',
    'Client-Type': isPCoffice ? 'pc' : 'web',
    'Client-Ver': '1.0'
  };
}
function createFileCollectTask(_x, _x2) {
  return _createFileCollectTask.apply(this, arguments);
}
function _createFileCollectTask() {
  _createFileCollectTask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, isPCoffice) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$n.post('/api/v1/tasks', params, {
            headers: createHeader$2(isPCoffice)
          });
        case 2:
          _yield$request$post = _context.sent;
          data = _yield$request$post.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createFileCollectTask.apply(this, arguments);
}
function getFileCollectTask(_x3, _x4) {
  return _getFileCollectTask.apply(this, arguments);
}
function _getFileCollectTask() {
  _getFileCollectTask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, isPCoffice) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$n.get("/api/v1/tasks/details?task_id=".concat(id), {
            headers: createHeader$2(isPCoffice)
          });
        case 2:
          _yield$request$get = _context2.sent;
          data = _yield$request$get.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getFileCollectTask.apply(this, arguments);
}

var request$m = createInstance({
  baseURL: SECURITYDOC,
  withCredentials: true
});

// 获取前端水印
var getWatermarkStatus = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(groupid, companyid) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$m.get("/api/v4/group-plainwatermark-status?group_id=".concat(groupid, "&sign_company_id=").concat(companyid));
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getWatermarkStatus(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/*
 * 获取后台管理水印开关
 * export const getAdminWatermarkStatus = async function (companyid) {
 *   const { data } = await request.get(`/admin/settings/plainwatermark?sign_company_id=${companyid}`)
 *   return data
 * }
 */

var changeWarkmarkStatus = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params, companyid) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$m.post("/api/v4/group-plainwatermark-status?sign_company_id=".concat(companyid), params);
        case 2:
          _yield$request$post = _context2.sent;
          data = _yield$request$post.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function changeWarkmarkStatus(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

// 获取水印路径
var getWatermarkInfo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(groupid, companyid) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$m.get("/api/v4/plainwatermark?version=1&group_id=".concat(groupid, "&sign_company_id=").concat(companyid, "&ignore_group=true"));
        case 2:
          _yield$request$get2 = _context3.sent;
          data = _yield$request$get2.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getWatermarkInfo(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

// 获取安全文档加密者id
var getEncrypterId = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(guid) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$m.get("/api/v4/share/".concat(guid, "/docinfo"));
        case 2:
          _yield$request$get3 = _context4.sent;
          data = _yield$request$get3.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getEncrypterId(_x7) {
    return _ref4.apply(this, arguments);
  };
}();

// 获取已使用水印团队数量
var getWatermarkUsedTeams = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$m.get('/api/v4/group-plainwatermark-count', {
            params: params
          });
        case 2:
          _yield$request$get4 = _context5.sent;
          data = _yield$request$get4.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getWatermarkUsedTeams(_x8) {
    return _ref5.apply(this, arguments);
  };
}();

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var request$l = createInstance({
  baseURL: PLUS,
  withCredentials: true
});
var requestDrive = createInstance({
  baseURL: DRIVE,
  withCredentials: true
});
var requestDocs = createInstance({
  baseURL: DOCS,
  withCredentials: true
});
var requestKDocs = createInstance({
  baseURL: KDOCS,
  withCredentials: true
});

/**
 * （admin）获取团队的权限组合
 * @param groupId
 * @param fileId 此参数只未合并权限新分享面板调用使用，文档权限弹窗不需要传递
 * @returns {Promise<*>}
 */
var getTeamPermissionList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(groupId) {
    var fileId,
      dynamicStr,
      _yield$request$get,
      data,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fileId = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
          dynamicStr = fileId ? "file_id=".concat(fileId, "&") : '';
          _context.next = 4;
          return request$l.get("/drive/v1/admin/groups/".concat(groupId, "/compound/permissions?").concat(dynamicStr, "t=").concat(Date.now()));
        case 4:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getTeamPermissionList(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 获取企业权限组合列表 dbt文件类型的时候调用
 * @param groupId
 * @param fileId
 * @returns {Promise<any>}
 */
var getEntCompoundPermissionList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(groupId) {
    var fileId,
      _yield$request$get2,
      data,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fileId = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
          _context2.next = 3;
          return request$l.get("/drive/v1/admin/groups/".concat(groupId, "/files/").concat(fileId, "/compound/perms?t=").concat(Date.now()));
        case 3:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getEntCompoundPermissionList(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * （admin）更新权限组合，包括预设权限
 * @param groupId
 * @param params
 * @returns {Promise<any>}
 */
var updatePermission = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(groupId, params) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$l.put("/drive/v1/admin/groups/".concat(groupId, "/compound/permissions"), params);
        case 2:
          _yield$request$put = _context3.sent;
          data = _yield$request$put.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function updatePermission(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * （admin）删除自设权限组合
 * @param groupId
 * @param cpId
 * @param params
 * @returns {Promise<*>}
 */
var deleteCustomizePermission = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, params) {
    var groupId, cpId, _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          groupId = _ref4.groupId, cpId = _ref4.cpId;
          _context4.next = 3;
          return request$l["delete"]("/drive/v1/admin/groups/".concat(groupId, "/compound/permissions/").concat(cpId), {
            params: params
          });
        case 3:
          _yield$request$delete = _context4.sent;
          data = _yield$request$delete.data;
          return _context4.abrupt("return", data);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function deleteCustomizePermission(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * (admin）获取文件权限
 * @param groupId
 * @param fileId
 * @param options
 * @returns {Promise<*>}
 */
var queryFilePermission = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(groupId, fileId, options) {
    var params, _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          params = _objectSpread$4(_objectSpread$4({}, options), {}, {
            with_user_source: true,
            with_relationship: true
          });
          _context5.next = 3;
          return request$l.get("/drive/v2/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permissions?t=").concat(Date.now()), {
            params: params
          });
        case 3:
          _yield$request$get3 = _context5.sent;
          data = _yield$request$get3.data;
          return _context5.abrupt("return", data);
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function queryFilePermission(_x7, _x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * （admin）添加文件权限 给主体(用户/角色/用户组/部门)添加文件权限
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<*>}
 */
var addFilePermission = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref7, params) {
    var groupId, fileId, _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          groupId = _ref7.groupId, fileId = _ref7.fileId;
          _context6.next = 3;
          return request$l.post("/drive/v2/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permissions"), params);
        case 3:
          _yield$request$post = _context6.sent;
          data = _yield$request$post.data;
          return _context6.abrupt("return", data);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function addFilePermission(_x10, _x11) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * （admin）删除文件权限 删除某主体的授权
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<*>}
 */
var deleteFilePermission = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref9, params) {
    var groupId, fileId, _yield$request$delete2, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          groupId = _ref9.groupId, fileId = _ref9.fileId;
          _context7.next = 3;
          return request$l["delete"]("/drive/v2/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permission"), {
            params: params
          });
        case 3:
          _yield$request$delete2 = _context7.sent;
          data = _yield$request$delete2.data;
          return _context7.abrupt("return", data);
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function deleteFilePermission(_x12, _x13) {
    return _ref10.apply(this, arguments);
  };
}();

/**
 * （user）获取文件权限个数(当前文件无权限，则会寻找父目录的权限)
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<*>}
 */
var queryFilePermissionCount = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref11, params) {
    var groupId, fileId, _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          groupId = _ref11.groupId, fileId = _ref11.fileId;
          _context8.next = 3;
          return request$l.get("/drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/permission/count"), {
            params: params
          });
        case 3:
          _yield$request$get4 = _context8.sent;
          data = _yield$request$get4.data;
          return _context8.abrupt("return", data);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function queryFilePermissionCount(_x14, _x15) {
    return _ref12.apply(this, arguments);
  };
}();

/**
 * （admin）批量删除文件权限 删除某主体的授权
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<*>}
 */
var deleteFilePermissionBatch = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref13, params) {
    var groupId, fileId, _yield$request$delete3, data;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          groupId = _ref13.groupId, fileId = _ref13.fileId;
          _context9.next = 3;
          return request$l["delete"]("/drive/v1/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permission/batch"), {
            data: params
          });
        case 3:
          _yield$request$delete3 = _context9.sent;
          data = _yield$request$delete3.data;
          return _context9.abrupt("return", data);
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function deleteFilePermissionBatch(_x16, _x17) {
    return _ref14.apply(this, arguments);
  };
}();

/**
 * （admin）批量 更新文件权限 更新某主体的授权
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<any>}
 */
var updateFilePermissionBatch = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref15, params) {
    var groupId, fileId, _yield$request$put2, data;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          groupId = _ref15.groupId, fileId = _ref15.fileId;
          _context10.next = 3;
          return request$l.put("/drive/v1/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permission/batch"), params);
        case 3:
          _yield$request$put2 = _context10.sent;
          data = _yield$request$put2.data;
          return _context10.abrupt("return", data);
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function updateFilePermissionBatch(_x18, _x19) {
    return _ref16.apply(this, arguments);
  };
}();

/**
 * （admin）更新文件权限 更新某主体的授权
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<any>}
 */
var updateFilePermission = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref17, params) {
    var groupId, fileId, _yield$request$put3, data;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          groupId = _ref17.groupId, fileId = _ref17.fileId;
          _context11.next = 3;
          return request$l.put("/drive/v2/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permission"), params);
        case 3:
          _yield$request$put3 = _context11.sent;
          data = _yield$request$put3.data;
          return _context11.abrupt("return", data);
        case 6:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function updateFilePermission(_x20, _x21) {
    return _ref18.apply(this, arguments);
  };
}();

/**
 * （admin）获取子文件权限
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<*>}
 */
var querySubFilePermission = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(groupId, fileId, params) {
    var _yield$request$get5, data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$l.get("/drive/v1/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permission/subfiles?t=").concat(Date.now()), {
            params: params
          });
        case 2:
          _yield$request$get5 = _context12.sent;
          data = _yield$request$get5.data;
          return _context12.abrupt("return", data);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function querySubFilePermission(_x22, _x23, _x24) {
    return _ref19.apply(this, arguments);
  };
}();

/**
 * 获取子文件权限 支持超时取消
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<*>}
 */
var querySubFilePermission2 = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(groupId, fileId, params) {
    var CancelToken, cancel, timeout, url, config, _yield$Promise$race, data;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          // 创建一个取消令牌控制请求取消
          CancelToken = axios.CancelToken;
          // 发送请求
          timeout = 3000; // 设置超时时间，单位为毫秒
          url = "/drive/v1/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permission/subfiles?t=").concat(Date.now());
          config = {
            params: params,
            cancelToken: new CancelToken(function executor(c) {
              // 分配取消令牌
              cancel = c;
            })
          };
          _context13.next = 6;
          return Promise.race([request$l.get(url, config), new Promise(function (_, reject) {
            return setTimeout(function () {
              if (typeof cancel === 'function') {
                cancel('timeout'); // 调用取消令牌，发出一个错误信息以取消请求
              }
              reject(new Error('timeout'));
            }, timeout);
          })]);
        case 6:
          _yield$Promise$race = _context13.sent;
          data = _yield$Promise$race.data;
          return _context13.abrupt("return", data);
        case 9:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function querySubFilePermission2(_x25, _x26, _x27) {
    return _ref20.apply(this, arguments);
  };
}();

/**
 * （admin）获取权限角色信息 获取目前团队权限角色信息，主要是id
 * @param groupId
 * @param fileId
 * @returns {Promise<*>}
 */
var getPermissionRoleList = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(groupId) {
    var fileId,
      dynamicStr,
      _yield$request$get6,
      data,
      _args14 = arguments;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          fileId = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : '';
          dynamicStr = fileId ? "file_id=".concat(fileId, "&") : '';
          _context14.next = 4;
          return request$l.get("/drive/v1/admin/groups/".concat(groupId, "/permission/roles?").concat(dynamicStr, "t=").concat(Date.now()));
        case 4:
          _yield$request$get6 = _context14.sent;
          data = _yield$request$get6.data;
          return _context14.abrupt("return", data);
        case 7:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function getPermissionRoleList(_x28) {
    return _ref21.apply(this, arguments);
  };
}();

/**
 * （user）检查用户文件权限
 * @param groupId
 * @param fileId
 * @returns {Promise<*>}
 */
var queryUserFilePermission = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(groupId, fileId) {
    var _yield$request$get7, data;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return request$l.get("/drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/permissions/check"));
        case 2:
          _yield$request$get7 = _context15.sent;
          data = _yield$request$get7.data;
          return _context15.abrupt("return", data);
        case 5:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function queryUserFilePermission(_x29, _x30) {
    return _ref22.apply(this, arguments);
  };
}();

/**
 * 查询文件默认权限
 * @param groupId
 * @param fileId
 * @param params
 * @returns {Promise<*>}
 */
var queryFileDefaultPermission = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(groupId, fileId, params) {
    var _yield$request$get8, data;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return request$l.get("/drive/v1/admin/groups/".concat(groupId, "/files/").concat(fileId, "/def/perms?t=").concat(Date.now()), {
            params: params
          });
        case 2:
          _yield$request$get8 = _context16.sent;
          data = _yield$request$get8.data;
          return _context16.abrupt("return", data);
        case 5:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function queryFileDefaultPermission(_x31, _x32, _x33) {
    return _ref23.apply(this, arguments);
  };
}();

/**
 * 恢复文件默认权限（重置操作）
 * @param groupId
 * @param fileId
 * @returns {Promise<*>}
 */
var resetFileDefaultPermission = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(groupId, fileId) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return request$l.post("/drive/v1/admin/groups/".concat(groupId, "/files/").concat(fileId, "/permission/reset"));
        case 2:
          _yield$request$post2 = _context17.sent;
          data = _yield$request$post2.data;
          return _context17.abrupt("return", data);
        case 5:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function resetFileDefaultPermission(_x34, _x35) {
    return _ref24.apply(this, arguments);
  };
}();

// 查询团队历史版本标签池管理权限
var queryManageGroupLabelPermission = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(groupId, operation) {
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return request$l.get("/drive/v1/user/groups/".concat(groupId, "/history/utag/check"), {
            params: {
              operation: operation
            }
          });
        case 2:
          return _context18.abrupt("return", _context18.sent);
        case 3:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function queryManageGroupLabelPermission(_x36, _x37) {
    return _ref25.apply(this, arguments);
  };
}();

// 查询文档历史版本标签操作权限
var queryCreateHistoryLabelPermission = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(groupId, historyIdsStr, operation) {
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return request$l.get("/drive/v1/user/groups/".concat(groupId, "/file/history/utag/check?operation=").concat(operation).concat(historyIdsStr));
        case 2:
          return _context19.abrupt("return", _context19.sent);
        case 3:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function queryCreateHistoryLabelPermission(_x38, _x39, _x40) {
    return _ref26.apply(this, arguments);
  };
}();

// 批量对多个文档的当前版本打标签操作鉴权
var queryCreateCurrentVersonLabelPermission = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(groupId, fileidsStr) {
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return request$l.get("/drive/v1/user/groups/".concat(groupId, "/file/utag/check/batch?").concat(fileidsStr));
        case 2:
          return _context20.abrupt("return", _context20.sent);
        case 3:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return function queryCreateCurrentVersonLabelPermission(_x41, _x42) {
    return _ref27.apply(this, arguments);
  };
}();

/**
 * 获取用户的文件协作权限（企业分享面板，用户无权限，列表展示接口）
 * @param groupId
 * @param fileId
 * @returns {Promise<*>}
 */
var queryUserCoopPerms = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(groupId, fileId) {
    var _yield$request$get9, data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return request$l.get("/drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/mine/permission"));
        case 2:
          _yield$request$get9 = _context21.sent;
          data = _yield$request$get9.data;
          return _context21.abrupt("return", data);
        case 5:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function queryUserCoopPerms(_x43, _x44) {
    return _ref28.apply(this, arguments);
  };
}();

/**
 * 查询文件range权限（企业分享面板，企业文档权限面板）
 * @param groupId
 * @param fileId
 * @returns {Promise<*>}
 */
var queryCurFileRangePerm = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(groupId, fileId) {
    var _yield$request$get10, data;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return request$l.get("/drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/link/range/permission"));
        case 2:
          _yield$request$get10 = _context22.sent;
          data = _yield$request$get10.data;
          return _context22.abrupt("return", data);
        case 5:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return function queryCurFileRangePerm(_x45, _x46) {
    return _ref29.apply(this, arguments);
  };
}();

/**
 * 搜索企业成员对象 (企业部门 > 我的联系人 > 企业联系人)
 * 企业权限列表面板、文件分享面板-搜索
 * @param params
 *  cid, key, corp_id, group_id count
 */
var searchEntMemberSubject = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(params) {
    var queryString, mark, key, _yield$request$get11, data;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          queryString = '';
          mark = 0;
          for (key in params) {
            if (params[key] === undefined) {
              delete params[key];
            } else {
              queryString += "".concat(mark ? '&' : '').concat(key, "=").concat(params[key]);
              mark = 1;
            }
          }
          _context23.next = 5;
          return request$l.get("/kfc/miniprovider/v1/share/collaborators/search?".concat(queryString));
        case 5:
          _yield$request$get11 = _context23.sent;
          data = _yield$request$get11.data;
          return _context23.abrupt("return", data);
        case 8:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return function searchEntMemberSubject(_x47) {
    return _ref30.apply(this, arguments);
  };
}();

/**
 * 打开文件分享调用DCM接口
 * 开启文件（权限合并业务新接口）
 * 此接口 = 打开分享 + 授权本企业可查看
 * @param groupId
 * @param fileId
 * @param params
 */
function openShareV2(groupId, fileId, params) {
  return request$l.post("/drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/link"), params);
}

/**
 * 打开文件夹分享调用云平台
 * 开启文件夹分享 （权限合并业务新接口）
 * 此接口 = 打开文件夹分享 + 授权本企业可查看 + 是否同步子文件
 * @param cid
 * @param params
 */
function openFolderShareV2(cid, params) {
  return requestDrive.post("/api/v6/links/share_folder_link/".concat(cid), params);
}

/**
 * 取消文件调用DCM接口，取消文件夹调用云平台
 * 取消文件分享 (权限合并业务新接口）
 * 此接口 = 取消分享
 * @param groupId
 * @param fileId
 * @param params  eg: { sub_files_cancel}
 */
function cancelShareV2(groupId, fileId, params) {
  return request$l["delete"]("/drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/link"), {
    params: params
  });
}

/**
 * 取消文件夹调用云平台
 * 取消文件夹分享 (权限合并业务新接口）
 * 此接口 = 取消文件夹分享 + 是否同步子文件
 * @param cid
 * @param params  eg: { sub_files_cancel}
 */
function cancelFolderShareV2(cid, params) {
  return requestDrive["delete"]("/api/v6/links/share_folder_link/".concat(cid), {
    params: params
  });
}

/**
 * 获取分享链接信息 （过期时间、linkId）
 * @param fileId
 */
function queryShareBaseInfo(fileId) {
  return requestDrive.get("/api/v6/links/base/".concat(fileId));
}

/**
 * 修改文件分享链接信息（过期时间）
 * @param fileId
 * @param params // { period: number }
 */
function updateShareValidDate(fileId, params) {
  return requestDrive.put("/api/v6/links/base/".concat(fileId), null, {
    params: params
  });
}

/**
 * 修改文件夹分享链接信息（过期时间）
 * @param cid
 * @param params // { period: number }
 */
function updateShareFolderValidDate(cid, params) {
  return requestDrive.put("/api/v6/links/share_folder_link/".concat(cid), params);
}

/**
 * 通过链接加入的人
 * @param {number} groupId
 * @param {number} fileId
 * @param {object} params
 * @param {string} params.next
 */
function queryJoinFromLink(groupId, fileId, params) {
  return request$l.get("/drive/v1/user/groups/".concat(groupId, "/files/").concat(fileId, "/link/collaborator"), {
    params: params
  });
}

/**
 * 搜索分享链接协作者 （权限列表搜索面板搜索使用）
 * @param params  eg：{ cid 必传, fild_id 必传, corp_id, group_id, key 必传, count 必传 }
 */
function searchShareLinkCollaborator(params) {
  return requestDocs.get("/kfc/miniprovider/v2/share/collaborators/search", {
    params: params
  });
}

/**
 * 批量粘贴文案搜索分享链接协作者 （权限列表搜索面板搜索使用）
 * @param params  eg：{ file_id 必传, group_id必传, keywords 必传, status 必传 }
 */
function searchShareLinkCollaboratorByPasted(params) {
  return requestDocs.post("/kfc/shortlink/v1/search/company-user/keyword", params);
}

/**
 * 企业开关「允许团队外的用户给文件(夹)添加协作成员」
 * @param params companyId
 */
function queryOutPermission(companyId) {
  return request$l.get("/drive/v1/admin/companies/".concat(companyId, "/perm/setting?setting_type=GuestShareFile"));
}

/**
 * 获取企业外成员文件权限
 * @param {number} groupId
 * @returns
 */
var getNonEntMemberFilePermissionName = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(groupId) {
    var _yield$request$get12, data;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return request$l.get("/drive/v1/admin/groups/".concat(groupId, "/non-employee/default/perm"));
        case 2:
          _yield$request$get12 = _context24.sent;
          data = _yield$request$get12.data;
          return _context24.abrupt("return", data);
        case 5:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return function getNonEntMemberFilePermissionName(_x48) {
    return _ref31.apply(this, arguments);
  };
}();

/**
 * 设置企业外成员文件权限
 * @param {number} groupId
 * @param {number} params
 * @returns
 */
var setNonEntMemberPermission = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(groupId, params) {
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return request$l.put("/drive/v1/admin/groups/".concat(groupId, "/non-employee/default/perm"), params);
        case 2:
          return _context25.abrupt("return", _context25.sent);
        case 3:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return function setNonEntMemberPermission(_x49, _x50) {
    return _ref32.apply(this, arguments);
  };
}();

/**
 * 分享首屏聚合接口
 * 1. 查询文件range权限
 * 2. 查询团队权限组合（包括dbt文件和非dbt文件）
 * 3. 查询团队分享范围管控
 * @param {number} groupId
 * @param {number} fileId
 * @param {boolean} file_perm dbt专用，获取文件权限
 * @param {boolean} with_link_range 是否获取链接权限范围，文件分享下传true
 * @returns {Promise<*>}
 */
var queryBffShareRangeAndCompoundPerm = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref33) {
    var groupId, fileId, file_perm, with_link_range, _yield$requestKDocs$g, data;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          groupId = _ref33.groupId, fileId = _ref33.fileId, file_perm = _ref33.file_perm, with_link_range = _ref33.with_link_range;
          _context26.next = 3;
          return requestKDocs.get("/api/v3/bff/share_layout/group/".concat(groupId, "/file/").concat(fileId, "/permissions"), {
            params: {
              file_perm: file_perm,
              with_link_range: with_link_range
            }
          });
        case 3:
          _yield$requestKDocs$g = _context26.sent;
          data = _yield$requestKDocs$g.data;
          return _context26.abrupt("return", data);
        case 6:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return function queryBffShareRangeAndCompoundPerm(_x51) {
    return _ref34.apply(this, arguments);
  };
}();

/**
 * 企业管控文件，申请外发文件
 * @param {*} params {
 *    template_type: 'ext_sharing',
 *    data: {
 *      "file_id": 0, // 文件ID
 *      "cid": 0, // 文件ID不为空时，无视cid, cid/fid两者必传一个
 *      "range": string, // 申请范围（任何人，指定企业外用户）
 *      "reason": string, // 申请理由
 *    }
 * }
 * @returns Promise
 */
var requestShareOutsideSubmit = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
    var data,
      _args27 = arguments;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          data = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {};
          _context27.next = 3;
          return request$l.post("/drive/v1/approvals/submit", {
            'template_type': 'ext_sharing',
            'data': data
          });
        case 3:
          return _context27.abrupt("return", _context27.sent);
        case 4:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return function requestShareOutsideSubmit() {
    return _ref35.apply(this, arguments);
  };
}();

/**
 * 获取团队关联的智能文档库的信息
 * @param {*} params {
 *    groupIds: string[], // 团队ID列表
 * }
 * @returns Promise
 */
var getGroupsWikiInfos = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(groupIds) {
    var _yield$requestDocs$po, data;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return requestDocs.post("/wiki/api/v1/doclibs", {
            group_ids: groupIds
          });
        case 2:
          _yield$requestDocs$po = _context28.sent;
          data = _yield$requestDocs$po.data;
          return _context28.abrupt("return", data);
        case 5:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return function getGroupsWikiInfos(_x52) {
    return _ref36.apply(this, arguments);
  };
}();

function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var request$k = createInstance({
  baseURL: PLUS,
  withCredentials: true,
  onUploadProgress: function onUploadProgress(p) {
    return 100 * (p.loaded / p.total);
  }
});
var getCategories = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$k.get("/app/file-template/v1/categories?t=".concat(new Date().getTime()), {
            params: params
          });
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCategories(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createTemplate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params, onProgressUpdate) {
    var _yield$postTemplate, task_id;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return postTemplate(params);
        case 2:
          _yield$postTemplate = _context2.sent;
          task_id = _yield$postTemplate.task_id;
          return _context2.abrupt("return", getTaskResult(task_id, onProgressUpdate, 1));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function createTemplate(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var createTemplateV2 = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params, onProgressUpdate) {
    var _yield$postTemplateV, task_id;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return postTemplateV2(params);
        case 2:
          _yield$postTemplateV = _context3.sent;
          task_id = _yield$postTemplateV.task_id;
          return _context3.abrupt("return", getTaskResult(task_id, onProgressUpdate, 1));
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function createTemplateV2(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
var postTemplate = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$k.post('/app/file-template/v1/templates', params);
        case 2:
          _yield$request$post = _context4.sent;
          data = _yield$request$post.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function postTemplate(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
var postTemplateV2 = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$k.post('/app/file-template/v2/templates', params);
        case 2:
          _yield$request$post2 = _context5.sent;
          data = _yield$request$post2.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function postTemplateV2(_x7) {
    return _ref5.apply(this, arguments);
  };
}();
var getTemplates = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$k.get("/app/file-template/v1/templates?t=".concat(new Date().getTime()), {
            params: params
          });
        case 2:
          _yield$request$get2 = _context6.sent;
          data = _yield$request$get2.data;
          return _context6.abrupt("return", data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getTemplates(_x8) {
    return _ref6.apply(this, arguments);
  };
}();
var renameTemplate = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(templateId, templateName) {
    var params, _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          params = {
            name: templateName
          };
          _context7.next = 3;
          return request$k.put("/app/file-template/v1/templates/".concat(templateId), params);
        case 3:
          _yield$request$put = _context7.sent;
          data = _yield$request$put.data;
          return _context7.abrupt("return", data);
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function renameTemplate(_x9, _x10) {
    return _ref7.apply(this, arguments);
  };
}();
var deleteTemplate = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(templateId) {
    var _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return request$k["delete"]("/app/file-template/v1/templates/".concat(templateId));
        case 2:
          _yield$request$delete = _context8.sent;
          data = _yield$request$delete.data;
          return _context8.abrupt("return", data);
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function deleteTemplate(_x11) {
    return _ref8.apply(this, arguments);
  };
}();
var updateTemplate = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(templateId, params, onProgressUpdate) {
    var _yield$request$put2, data, _ref10, task_id;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return request$k.put("/app/file-template/v1/templates/".concat(templateId, "/files"), params);
        case 2:
          _yield$request$put2 = _context9.sent;
          data = _yield$request$put2.data;
          _ref10 = data || {}, task_id = _ref10.task_id;
          return _context9.abrupt("return", getTaskResult(task_id, onProgressUpdate, 1));
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function updateTemplate(_x12, _x13, _x14) {
    return _ref9.apply(this, arguments);
  };
}();

// 修改模板顺序
var changeTemplateSort = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(templateID, params) {
    var _yield$request$put3, data;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return request$k.put("/app/file-template/v1/templates/".concat(templateID, "/sorts"), params);
        case 2:
          _yield$request$put3 = _context10.sent;
          data = _yield$request$put3.data;
          return _context10.abrupt("return", data);
        case 5:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function changeTemplateSort(_x15, _x16) {
    return _ref11.apply(this, arguments);
  };
}();
function getTaskResult(taskId, onProgressUpdate, count) {
  var wait = count * 200 >= 1000 ? 1000 : count * 200;
  return new Promise(function (resolve, reject) {
    setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var res, status, result;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return request$k.get("/app/file-template/v1/tasks/".concat(taskId, "?t=").concat(new Date().getTime()));
          case 3:
            res = _context11.sent;
            status = res.data.status;
            result = res.data.result;
            onProgressUpdate(res.data.progress);
            if (!(status !== 'success')) {
              _context11.next = 12;
              break;
            }
            count++;
            _context11.next = 11;
            return getTaskResult(taskId, onProgressUpdate, count);
          case 11:
            result = _context11.sent;
          case 12:
            resolve(result);
            _context11.next = 18;
            break;
          case 15:
            _context11.prev = 15;
            _context11.t0 = _context11["catch"](0);
            reject(_context11.t0);
          case 18:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[0, 15]]);
    })), wait);
  });
}
var uploadFileToThirdParty = function uploadFileToThirdParty(url, data, onUploadProgress) {
  var headers = {
    Accept: '*/*'
  };
  return createInstance({
    withCredentials: false,
    headers: headers,
    onUploadProgress: onUploadProgress
  }, false).post(url, data);
};
var uploadFileToThirdPartyNew = function uploadFileToThirdPartyNew(_ref13) {
  var url = _ref13.url,
    data = _ref13.data,
    onUploadProgress = _ref13.onUploadProgress,
    _ref13$method = _ref13.method,
    method = _ref13$method === void 0 ? 'post' : _ref13$method,
    headers = _ref13.headers;
  headers = _objectSpread$3(_objectSpread$3({}, headers || {}), {}, {
    Accept: '*/*'
  });
  return createInstance({
    withCredentials: false,
    headers: headers,
    onUploadProgress: onUploadProgress
  }, false)[method](url, data);
};
var getTemplateScopeAll = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(companyId, templateId) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$k.get("/app/file-template/v1/adm/companies/".concat(companyId, "/template-files/").concat(templateId, "/scopes/all?t=").concat(new Date().getTime()));
        case 2:
          _yield$request$get3 = _context12.sent;
          data = _yield$request$get3.data;
          return _context12.abrupt("return", data);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function getTemplateScopeAll(_x17, _x18) {
    return _ref14.apply(this, arguments);
  };
}();
var getTemplateScope = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(companyId, templateId, params) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return request$k.get("/app/file-template/v1/adm/companies/".concat(companyId, "/template-files/").concat(templateId, "/scopes?t=").concat(new Date().getTime()), {
            params: params
          });
        case 2:
          _yield$request$get4 = _context13.sent;
          data = _yield$request$get4.data;
          return _context13.abrupt("return", data);
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function getTemplateScope(_x19, _x20, _x21) {
    return _ref15.apply(this, arguments);
  };
}();
var editTemplate = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(companyId, templateId, params, onProgressUpdate) {
    var _yield$request$patch, data, _ref17, task_id;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return request$k.patch("/app/file-template/v1/adm/companies/".concat(companyId, "/template-files/").concat(templateId), params);
        case 2:
          _yield$request$patch = _context14.sent;
          data = _yield$request$patch.data;
          _ref17 = data || {}, task_id = _ref17.task_id;
          return _context14.abrupt("return", getTaskResult(task_id, onProgressUpdate, 1));
        case 6:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function editTemplate(_x22, _x23, _x24, _x25) {
    return _ref16.apply(this, arguments);
  };
}();

var request$j = createInstance({
  baseURL: TWPS,
  withCredentials: true,
  timeout: 30000
});
var fetchKdMyTeams = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$j.get('/kdteam/api/v1/teams', params);
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data.data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchKdMyTeams(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getKdMyTeamsDetail = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$j.get("/kdteam/api/v1/team/".concat(id));
        case 2:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getKdMyTeamsDetail(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var isMyTeam = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(groupid) {
    var _yield$getKdMyTeamsDe, data, _ref4, sources;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getKdMyTeamsDetail(groupid);
        case 2:
          _yield$getKdMyTeamsDe = _context3.sent;
          data = _yield$getKdMyTeamsDe.data;
          _ref4 = data || {}, sources = _ref4.sources;
          return _context3.abrupt("return", sources && sources.indexOf('kdocs') >= 0);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function isMyTeam(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var _excluded$1 = ["fid", "format"],
  _excluded2 = ["fid", "format"];
var request$i = createInstance({
  baseURL: KDOCS,
  withCredentials: true,
  timeout: 30000
});

/*
 * 获取用户头像
 * 由于部分头像被缓存导致canvas画布无法使用该头像（这些头像会重定向无法绕过）, 所以需要服务端提供支持
 * 将这部门头像转为base64格式
 */
var fetchUserAvatars = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tid) {
    var count,
      _yield$request$get,
      data,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          count = _args.length > 1 && _args[1] !== undefined ? _args[1] : 4;
          if (!powerConfig.get('isOem')) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.prev = 3;
          _context.next = 6;
          return request$i.get("/kdteam/api/v1/group/".concat(tid, "/avatar?count=").concat(count));
        case 6:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          if (!(!data || !data.data)) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return");
        case 10:
          return _context.abrupt("return", data.data.map(function (item) {
            if (item.avatarBase64) {
              return "data:image/png;base64,".concat(item.avatarBase64);
            } else {
              var ts = new Date().getTime();
              var url = item.avatarUrl;
              return ~url.indexOf('?') ? "".concat(url, "&t=").concat(ts) : "".concat(url, "?t=").concat(ts);
            }
          }));
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](3);
          console.error(_context.t0);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 13]]);
  }));
  return function fetchUserAvatars(_x) {
    return _ref.apply(this, arguments);
  };
}();

// 附件举报
var annexReport = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var id, params, _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          id = _ref2.id, params = _ref2.params;
          _context2.next = 3;
          return request$i.post("/api/kdocs/fcheck/".concat(id, "/appeal"), params);
        case 3:
          _yield$request$post = _context2.sent;
          data = _yield$request$post.data;
          return _context2.abrupt("return", data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function annexReport(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

// 获取第三方企业绑定的应用信息
var getCompanyBindInfo = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var scene, _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          scene = _ref4.scene;
          _context3.next = 3;
          return request$i.get("/kdg/api/v1/company/bind/app?scene=".concat(scene));
        case 3:
          _yield$request$get2 = _context3.sent;
          data = _yield$request$get2.data;
          return _context3.abrupt("return", data);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getCompanyBindInfo(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * 获取企业认证信息是否展示的状态
 * @param {String} corpid 企业id
 * @param {String} fid 文件id
 * @returns {Object} data
 * @returns {String} company_switch "true"后台系统开启展示 "false"不展示
 */
var getShowAuthenticationStatus = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(corpid, fid) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$i.get("/kfc/miniprovider/v1/company/certification/share/".concat(corpid, "?fid=").concat(fid));
        case 2:
          _yield$request$get3 = _context4.sent;
          data = _yield$request$get3.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getShowAuthenticationStatus(_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * 设置企业认证信息是否展示状态
 * @param {String} corpid 企业id
 * @param {String} fid 文件id
 * @param {Boolean} switch 是否开启
 */
var setShowAuthenticationStatus = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(corpid, fid, status) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$i.post("/kfc/miniprovider/v1/company/certification/share/".concat(corpid), {
            fid: fid,
            "switch": status
          });
        case 2:
          _yield$request$post2 = _context5.sent;
          data = _yield$request$post2.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function setShowAuthenticationStatus(_x6, _x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * 在线格式文档导出-fp db ksheet
 * @param {Number} fid 文档id
 * @param {String} format 导出格式
 * @param {Object} params 其他导出需要的参数
 */
var setOnelineFileDownload = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref8) {
    var fid, format, params, _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          fid = _ref8.fid, format = _ref8.format, params = _objectWithoutProperties(_ref8, _excluded$1);
          _context6.next = 3;
          return request$i.post("/api/v3/office/file/".concat(fid, "/export/").concat(format, "/preload"), params);
        case 3:
          _yield$request$post3 = _context6.sent;
          data = _yield$request$post3.data;
          return _context6.abrupt("return", data);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function setOnelineFileDownload(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * 导出结果接口-fp db ksheet
 * @param {Number} fid 文档id
 * @param {String} format 导出格式
 * @param {Object} params 其他导出需要的参数
 */
var getOnelineFileDownload = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref10) {
    var fid, format, params, _yield$request$post4, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          fid = _ref10.fid, format = _ref10.format, params = _objectWithoutProperties(_ref10, _excluded2);
          _context7.next = 3;
          return request$i.post("/api/v3/office/file/".concat(fid, "/export/").concat(format, "/result"), params);
        case 3:
          _yield$request$post4 = _context7.sent;
          data = _yield$request$post4.data;
          return _context7.abrupt("return", data);
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getOnelineFileDownload(_x10) {
    return _ref11.apply(this, arguments);
  };
}();

// PC客户端顶栏快捷新建
var getNewFileConfig = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return request$i.get('/kdg/api/v1/cards/sub/44?scenes=pcapp_top_quick_create', {
            headers: {
              platform: webPlatform()
            }
          });
        case 2:
          return _context8.abrupt("return", _context8.sent);
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function getNewFileConfig() {
    return _ref12.apply(this, arguments);
  };
}();

// 获取asl开关
var getAslSwitch = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var bool, _yield$request$get4, _yield$request$get4$d, _yield$request$get4$d2, aslSwitch;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          bool = false;
          _context9.prev = 1;
          _context9.next = 4;
          return request$i.get('/kdg/api/v1/configure?idList=aslSwitch', {
            headers: {
              platform: webPlatform()
            }
          });
        case 4:
          _yield$request$get4 = _context9.sent;
          _yield$request$get4$d = _yield$request$get4.data.data;
          _yield$request$get4$d2 = _yield$request$get4$d === void 0 ? {} : _yield$request$get4$d;
          aslSwitch = _yield$request$get4$d2.aslSwitch;
          bool = aslSwitch === '1';
          _context9.next = 13;
          break;
        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](1);
        case 13:
          return _context9.abrupt("return", bool);
        case 14:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[1, 11]]);
  }));
  return function getAslSwitch() {
    return _ref13.apply(this, arguments);
  };
}();

/**
 * 企业场景 查询知识库文档分享状态
 * @param {*} kuid string 云文档link_id或者知识库kuid
 * @param {*} settingType string = 'share_child' 分享子节点
 * @returns
 */
var getEnShareWikiSwitchStatus = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(kuid) {
    var settingType,
      _yield$request$get5,
      data,
      _args10 = arguments;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          settingType = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : 'share_child';
          _context10.next = 3;
          return request$i.get('/wiki/api/km/file/setting/status', {
            params: {
              kuid: kuid,
              setting_type: settingType
            }
          });
        case 3:
          _yield$request$get5 = _context10.sent;
          data = _yield$request$get5.data;
          return _context10.abrupt("return", data);
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function getEnShareWikiSwitchStatus(_x11) {
    return _ref14.apply(this, arguments);
  };
}();

/**
 * 企业场景 更改知识库文档分享状态
 * @param {*} action string close = 关闭分享 open = 开启分享
 * @param {*} kuid string 云文档link_id或者知识库kuid
 * @param {*} settingType string = 'share_child' 分享子节点
 * @returns
 */
var setEnShareWikiSwitchStatus = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref15) {
    var kuid,
      action,
      settingType,
      _yield$request$post5,
      data,
      _args11 = arguments;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          kuid = _ref15.kuid, action = _ref15.action;
          settingType = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : 'share_child';
          _context11.next = 4;
          return request$i.post('/wiki/api/km/file/setting/operate', {
            kuid: kuid,
            action: action,
            setting_type: settingType
          });
        case 4:
          _yield$request$post5 = _context11.sent;
          data = _yield$request$post5.data;
          return _context11.abrupt("return", data);
        case 7:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function setEnShareWikiSwitchStatus(_x12) {
    return _ref16.apply(this, arguments);
  };
}();

/**
 * 企业场景 判断企业是否开启邮箱服务、用户有无邮箱账号
 */
var getEntUserEmailServiceInfo = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var _yield$request$get6, data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return request$i.get('/api/v7/mailboxes');
        case 2:
          _yield$request$get6 = _context12.sent;
          data = _yield$request$get6.data;
          return _context12.abrupt("return", data);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function getEntUserEmailServiceInfo() {
    return _ref17.apply(this, arguments);
  };
}();

// const {getUA} = require('@kso/util')

var request$h = createInstance({
  baseURL: PUB,
  withCredentials: true,
  timeout: 30000
});
var requestYun = createInstance({
  baseURL: YUNAPI,
  withCredentials: true,
  timeout: 30000
});
function createHeader$1() {
  var yunFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return yunFlag ? {
    'appid': 'wps_new_share',
    'client-type': 'wps-web',
    'client-ver': window.navigator.userAgent
  } : {
    'appid': 'publish',
    'client-type': 'kdocs_pc',
    'client-ver': window.navigator.userAgent
  };
}

// 判断是否对文件有发布过
var checkShareExist = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$h.post('/publish/api/v1/checkshareexist', params, {
            headers: createHeader$1()
          });
        case 2:
          _yield$request$post = _context.sent;
          data = _yield$request$post.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function checkShareExist(_x) {
    return _ref.apply(this, arguments);
  };
}();

// 发布场景_创建文件分享
var createPublishShare = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$h.post('/publish/api/v1/createshare', params, {
            headers: createHeader$1()
          });
        case 2:
          _yield$request$post2 = _context2.sent;
          data = _yield$request$post2.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function createPublishShare(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

// 发布场景_创建文件分享
var delPublishShare = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$h["delete"]('/api/v1/share/deleteshare', {
            params: params,
            headers: createHeader$1()
          });
        case 2:
          _yield$request$delete = _context3.sent;
          data = _yield$request$delete.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function delPublishShare(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

// 发布场景_更新已分享的文件内容
var updatePublishShare = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$h.put('/publish/api/v1/updateshare', params, {
            headers: createHeader$1()
          });
        case 2:
          _yield$request$put = _context4.sent;
          data = _yield$request$put.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function updatePublishShare(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
// 发布场景_举报

var publishfileReport = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$h.post('/api/v1/share/report', params, {
            headers: createHeader$1()
          });
        case 2:
          _yield$request$post3 = _context5.sent;
          data = _yield$request$post3.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function publishfileReport(_x5) {
    return _ref5.apply(this, arguments);
  };
}();

// 新分享_举报
var newShareReport = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var _yield$requestYun$pos, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return requestYun.post('/api/v1/share/report', params, {
            headers: createHeader$1(true)
          });
        case 2:
          _yield$requestYun$pos = _context6.sent;
          data = _yield$requestYun$pos.data;
          return _context6.abrupt("return", data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function newShareReport(_x6) {
    return _ref6.apply(this, arguments);
  };
}();

// const {getUA} = require('@kso/util')

var request$g = createInstance({
  baseURL: PUB,
  withCredentials: true,
  timeout: 30000
});
function createHeader() {
  return {
    'appid': 'template',
    'client-type': 'kdocs_pc',
    'client-ver': window.navigator.userAgent
  };
}

// 判断是否对文件有发送过
var checkTemplateShareExist = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$g.post('/template/api/v1/checkshareexist', params, {
            headers: createHeader()
          });
        case 2:
          _yield$request$post = _context.sent;
          data = _yield$request$post.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function checkTemplateShareExist(_x) {
    return _ref.apply(this, arguments);
  };
}();

// 发送模板_创建文件分享
var createTemplateShare = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$g.post('/template/api/v1/createshare', params, {
            headers: createHeader()
          });
        case 2:
          _yield$request$post2 = _context2.sent;
          data = _yield$request$post2.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function createTemplateShare(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

// 发送模板_更新已分享的文件内容
var updateTemplateShare = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$g.put('/template/api/v1/updateshare', params, {
            headers: createHeader()
          });
        case 2:
          _yield$request$put = _context3.sent;
          data = _yield$request$put.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function updateTemplateShare(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

// 发送模板_检查更新已分享的文件内容
var checkupdateTemplateShare = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$g.get('/template/api/v1/checkupdate', {
            params: params,
            headers: createHeader()
          });
        case 2:
          _yield$request$get = _context4.sent;
          data = _yield$request$get.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function checkupdateTemplateShare(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

// 发布_检查更新已分享的文件内容
var checkupdatePublishFile = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$g.get('/publish/api/v1/checkupdate', {
            params: params,
            headers: createHeader()
          });
        case 2:
          _yield$request$get2 = _context5.sent;
          data = _yield$request$get2.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function checkupdatePublishFile(_x5) {
    return _ref5.apply(this, arguments);
  };
}();

// 发送模板_删除已分享的文件内容
var deleteTemplateShare = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$g["delete"]('/template/api/v1/deleteshare', {
            params: params,
            headers: createHeader()
          });
        case 2:
          _yield$request$delete = _context6.sent;
          data = _yield$request$delete.data;
          return _context6.abrupt("return", data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function deleteTemplateShare(_x6) {
    return _ref6.apply(this, arguments);
  };
}();

var request$f = createInstance({
  baseURL: RILI,
  withCredentials: true,
  timeout: 30000
});

// FP插入日程插件--获取最近的日程接口
var getRecentSchedule = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$f.get('/g-api/v2/recent_event2', {
            params: params
          });
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getRecentSchedule(_x) {
    return _ref.apply(this, arguments);
  };
}();

var request$e = createInstance({
  baseURL: WEBOFFICE,
  withCredentials: true
});

/**
 * 【金山文档】 文件操作服务-接口文档
 * https://kdocs.cn/l/cotTbKwfVMWL
 */
function pushNotificationPC(_x) {
  return _pushNotificationPC.apply(this, arguments);
}

/**
 * 文件上传行为追踪.
 *
 * @method postFileFrontAction
 * @param {String} fileId 文件id  必传
 * @param {String} createId 文件创建人id  非必传
 * @param {String} clientType 端类型  内置非必传  ("kdocs-client","kdocs-wpsdrive","kdocs-wxweb","kdocs-qqweb","kdocs-wxminiprogram","kdocs-qqminiprogram","kdocs-browser","kdocs-woa","kdocs-unknow")
 * @param {Number} ctime 文件创建时间（秒级时间戳） 非必传
 * @param {String} actionType 动作类型  必传  编辑：pedit、  打印：pprint、 分享：pshare、复制：pcopy、下载：pdownload、 导出：poutput、初次创建：pinit 发布文件：ppublish 、以模板发布：ppublish_template 、保存为模板：psave_template 、标签：plable、插入其他文件：pinsert_other_file、评论：pcomment、点赞：plike、另存为：psave_as 、收藏：pstarred
 */
function _pushNotificationPC() {
  _pushNotificationPC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$e.post('/api/v1', params, {
            headers: {
              'Client-Type': 'kdocs-web'
            }
          });
        case 2:
          _yield$request$post = _context.sent;
          data = _yield$request$post.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _pushNotificationPC.apply(this, arguments);
}
function postFileFrontAction(_x2) {
  return _postFileFrontAction.apply(this, arguments);
}
function _postFileFrontAction() {
  _postFileFrontAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var fileId, createId, ctime, actionType, clientType, params;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fileId = _ref.fileId, createId = _ref.createId, ctime = _ref.ctime, actionType = _ref.actionType;
          if (!powerConfig.get('isOem')) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          clientType = getClientType();
          params = {
            file_id: '' + fileId,
            client_type: clientType,
            action_type: actionType
          };
          if (createId) {
            params.create_id = '' + createId;
          }
          if (ctime) {
            params.c_time = ctime;
          }
          _context2.prev = 7;
          _context2.next = 10;
          return request$e.post("/edittrace/api/v1/front/action", params, {
            headers: {
              'Client-Type': clientType
            }
          });
        case 10:
          _context2.next = 14;
          break;
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](7);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[7, 12]]);
  }));
  return _postFileFrontAction.apply(this, arguments);
}

var request$d = createInstance({
  baseURL: MSGCENTER,
  withCredentials: true,
  timeout: 30000
});
// 获取消息中心登陆地址
function getMessageLoginUrl(_x) {
  return _getMessageLoginUrl.apply(this, arguments);
}
// 获取消息详情
function _getMessageLoginUrl() {
  _getMessageLoginUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opts) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$d.get('/api/v1/connectors?protocol=wss', opts);
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getMessageLoginUrl.apply(this, arguments);
}
function getMessage(_x2, _x3, _x4) {
  return _getMessage.apply(this, arguments);
}
// 标记已读
function _getMessage() {
  _getMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, terminal, opts) {
    var _yield$request$get2, data, _data$messages, messages, _messages, message;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$d.get("/p/message?app_id=1&terminal=".concat(terminal, "&mesg_id=").concat(id), opts);
        case 2:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          _data$messages = data.messages, messages = _data$messages === void 0 ? [] : _data$messages;
          _messages = _slicedToArray(messages, 1), message = _messages[0];
          return _context2.abrupt("return", message);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getMessage.apply(this, arguments);
}
function setMessagesRead(_x5, _x6, _x7, _x8, _x9) {
  return _setMessagesRead.apply(this, arguments);
}
function _setMessagesRead() {
  _setMessagesRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(category, id, APP_ID, terminal, opts) {
    var query, _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          query = id ? "&mesg_id=".concat(id) : '';
          _context3.next = 3;
          return request$d.put("/p/message/mark_read?app_id=".concat(APP_ID, "&terminal=").concat(terminal, "&category=").concat(category).concat(query), opts);
        case 3:
          _yield$request$put = _context3.sent;
          data = _yield$request$put.data;
          return _context3.abrupt("return", data);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _setMessagesRead.apply(this, arguments);
}
function commonRequest(_x10) {
  return _commonRequest.apply(this, arguments);
}
function _commonRequest() {
  _commonRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref) {
    var _method;
    var method, url, params, methodTypes;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          method = _ref.method, url = _ref.url, params = _ref.params;
          methodTypes = ['get', 'post', 'put', 'delete'];
          method = (_method = method) === null || _method === void 0 ? void 0 : _method.toLowerCase();
          if (!methodTypes.includes(method)) {
            _context4.next = 7;
            break;
          }
          _context4.next = 6;
          return request$d[method](url, method === 'get' ? {
            params: params
          } : params);
        case 6:
          return _context4.abrupt("return", _context4.sent);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _commonRequest.apply(this, arguments);
}

var request$c = createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});
var typeMap = {
  'mentioned': 'receive',
  'mention': 'source',
  'done': 'done'
};
// 获取inbox消息列表
function getInboxList(_x, _x2) {
  return _getInboxList.apply(this, arguments);
}
// 获取“提及我” 某个id到另一个id中间的消息列表
function _getInboxList() {
  _getInboxList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(msgType, lastID) {
    var limit,
      _yield$request$get2,
      data,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          limit = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 10;
          _context2.next = 3;
          return request$c.get('/kat/api/v1/inbox/msg', {
            params: {
              msgType: typeMap[msgType],
              lastID: lastID,
              limit: limit
            }
          });
        case 3:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getInboxList.apply(this, arguments);
}
function getInboxListById(_x3, _x4) {
  return _getInboxListById.apply(this, arguments);
}
// 获取未完成消息数量
function _getInboxListById() {
  _getInboxListById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(newID, lastID) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$c.get('/kat/api/v1/inbox/msg/new_list', {
            params: {
              newID: newID,
              lastID: lastID
            }
          });
        case 2:
          _yield$request$get3 = _context3.sent;
          data = _yield$request$get3.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getInboxListById.apply(this, arguments);
}
function getInboxUnCount(_x5) {
  return _getInboxUnCount.apply(this, arguments);
}

// 消息完成标记接口
function _getInboxUnCount() {
  _getInboxUnCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(msgType) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$c.get('/kat/api/v1/inbox/msg/count', {
            params: {
              msgType: typeMap[msgType]
            }
          });
        case 2:
          _yield$request$get4 = _context4.sent;
          data = _yield$request$get4.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getInboxUnCount.apply(this, arguments);
}
function updateInboxMark(_x6, _x7, _x8) {
  return _updateInboxMark.apply(this, arguments);
}
// 消息批量标记接口
function _updateInboxMark() {
  _updateInboxMark = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, doneStatus, msgType) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$c.put('/kat/api/v1/inbox/msg/mark', {
            idList: [id],
            doneStatus: doneStatus,
            msgType: typeMap[msgType]
          });
        case 2:
          _yield$request$put = _context5.sent;
          data = _yield$request$put.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _updateInboxMark.apply(this, arguments);
}
function updateInboxBatchMark(_x9, _x10) {
  return _updateInboxBatchMark.apply(this, arguments);
}
// 获取inbox消息详情
function _updateInboxBatchMark() {
  _updateInboxBatchMark = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(msgType, doneStatus) {
    var _yield$request$put2, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$c.put('/kat/api/v1/inbox/msg/batch/mark', {
            msgType: typeMap[msgType],
            doneStatus: doneStatus
          });
        case 2:
          _yield$request$put2 = _context6.sent;
          data = _yield$request$put2.data;
          return _context6.abrupt("return", data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _updateInboxBatchMark.apply(this, arguments);
}
function getInboxMsgById(_x11) {
  return _getInboxMsgById.apply(this, arguments);
}
// 在线配置开关
function _getInboxMsgById() {
  _getInboxMsgById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
    var _yield$request$get5, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return request$c.get("/kat/api/v1/inbox/msg/".concat(id));
        case 2:
          _yield$request$get5 = _context7.sent;
          data = _yield$request$get5.data;
          return _context7.abrupt("return", data);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getInboxMsgById.apply(this, arguments);
}
var getInboxConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return request$c.get('/kdg/api/v1/configure', {
            params: {
              idList: 'inbox'
            }
          });
        case 3:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          if (!(data && data.data)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", true);
        case 9:
          return _context.abrupt("return", false);
        case 10:
          _context.next = 15;
          break;
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", false);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return function getInboxConfig() {
    return _ref.apply(this, arguments);
  };
}();

var request$b = createInstance({
  baseURL: VIPAPI,
  withCredentials: true,
  timeout: 30000
});
var checkIsSubscribed = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _data$data;
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$b.get('/wx/user/subscribe?wx_app=kdocs', {
            baseURL: WXBMC
          });
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.is_subscribe);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function checkIsSubscribed() {
    return _ref.apply(this, arguments);
  };
}();

var _ref = typeof document !== 'undefined' ? document && cookie.parse(document.cookie) : {},
  deviceId = _ref.weboffice_device_id;
var request$a = createInstance({
  baseURL: WEBOFFICE,
  withCredentials: true,
  headers: {
    'Client-Type': 'kdocs-web',
    'Account-Deviceid': deviceId || ''
  },
  device_id: deviceId,
  timeout: 10000
});

// 获取文档访问信息
var getfileViewInfo = function getfileViewInfo(_ref2) {
  var file_id = _ref2.file_id,
    _ref2$op_type = _ref2.op_type,
    op_type = _ref2$op_type === void 0 ? 'open' : _ref2$op_type;
  return request$a.get('/tracefile/api/v1/data', {
    params: {
      file_id: file_id,
      op_type: op_type
    }
  }).then(function (res) {
    var _res$data;
    if (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 0) {
      return res.data.data;
    } else {
      throw new Error('getfileViewInfo error');
    }
  });
};

// 创建导出任务
var createExportTask = function createExportTask(fileId) {
  return request$a.post('/tracefile/api/v1/export/create', {
    file_id: fileId.toString()
  }).then(function (res) {
    var _res$data2;
    var code = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code;
    if (code === 0) {
      return res.data.data;
    } else {
      throw new Error('createExportTask error');
    }
  });
};

// 查询导出任务结果
var queryExportTask = function queryExportTask(taskId) {
  return request$a.get('/tracefile/api/v1/export/query', {
    params: {
      task_id: taskId
    }
  }).then(function (res) {
    var _res$data3;
    var code = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.code;
    if (code === 0) {
      return res.data.data;
    } else {
      throw new Error('queryExportTask error');
    }
  })["catch"](function (err) {
    var _err$response, _err$data;
    var error = new Error('queryExportTask error');
    var errCode = (err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.code) || (err === null || err === void 0 || (_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.code);
    if (errCode === 19014) {
      error.message = 'spaceFull';
    }
    throw error;
  });
};

// 取消导出任务
var cancelExportTask = function cancelExportTask(taskId) {
  return request$a.get('/tracefile/api/v1/cancel/task', {
    params: {
      task_id: taskId
    }
  })["catch"](function () {
    return {};
  });
};

// 获取访问文档需填写信息开关状态
var getFileSwitchStatus = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fileId) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$a.get("/tracefile/api/v1/switch/status?file_id=".concat(fileId));
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getFileSwitchStatus(_x) {
    return _ref3.apply(this, arguments);
  };
}();

// 查询文档已填写人数
var getFileFillCount = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fileId) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$a.get("/tracefile/api/v1/fill/count?file_id=".concat(fileId));
        case 2:
          _yield$request$get2 = _context2.sent;
          data = _yield$request$get2.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getFileFillCount(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

// 访问文档需填写信息开关
var setFileSwitchStatus = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var fileId, switchStatus, _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          fileId = _ref5.fileId, switchStatus = _ref5.switchStatus;
          _context3.next = 3;
          return request$a.post('/tracefile/api/v1/info/switch', {
            file_id: fileId,
            "switch": switchStatus
          });
        case 3:
          _yield$request$post = _context3.sent;
          data = _yield$request$post.data;
          return _context3.abrupt("return", data);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function setFileSwitchStatus(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var queryAccessInfo = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(fid) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$a.get("/tracefile/api/v1/info/query/login?file_id=".concat(fid));
        case 2:
          _yield$request$get3 = _context4.sent;
          data = _yield$request$get3.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function queryAccessInfo(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
var createAccessInfo = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref8) {
    var fid, name, phone, _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          fid = _ref8.fid, name = _ref8.name, phone = _ref8.phone;
          _context5.next = 3;
          return request$a.post('/tracefile/api/v1/info/create', {
            file_id: fid,
            name: name,
            phone: phone
          });
        case 3:
          _yield$request$post2 = _context5.sent;
          data = _yield$request$post2.data;
          return _context5.abrupt("return", data);
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function createAccessInfo(_x5) {
    return _ref9.apply(this, arguments);
  };
}();
// 获取微信群访问列表数据
var getWxGroupList = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(fid) {
    var more,
      _yield$request$get4,
      data,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          more = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 0;
          _context6.next = 3;
          return request$a.get("/tracefile/api/v2/wxgroup/data/list?file_id=".concat(fid, "&more=").concat(more));
        case 3:
          _yield$request$get4 = _context6.sent;
          data = _yield$request$get4.data;
          return _context6.abrupt("return", data);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getWxGroupList(_x6) {
    return _ref10.apply(this, arguments);
  };
}();

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var request$9 = createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});

// 获取当前的水印信息
var getWaterMarkInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$9.get("/kfc/miniprovider/v1/doc/watermark", {
            params: params
          });
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getWaterMarkInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();
// 修改文档水印
var setWaterMarkInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fid, params) {
    var _yield$request$put, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (params.water_mark) {
            params.water_mark = params.water_mark.slice(0, 25); // 接口不接受超过25的字符串，前端需要做一次截取
          }
          _context2.next = 3;
          return request$9.put("/kfc/miniprovider/v1/doc/".concat(fid, "/watermark"), _objectSpread$2({}, params));
        case 3:
          _yield$request$put = _context2.sent;
          data = _yield$request$put.data;
          return _context2.abrupt("return", data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function setWaterMarkInfo(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var request$8 = createInstance({
  baseURL: PAYCONFIGAPI,
  withCredentials: true
});
var fetchPayConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return request$8.get('/newdocs/v1/material/uc/list', {
            include: 'nopay_msg'
          });
        case 3:
          res = _context.sent;
          return _context.abrupt("return", res.data);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", {
            data: {}
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return function fetchPayConfig() {
    return _ref.apply(this, arguments);
  };
}();

var request$7 = createInstance({
  baseURL: PAYAPI,
  withCredentials: true
});
var fetchPay = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(hour) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return request$7.get('/pay_order/v1/client/user/order/list', {
            'offset': 0,
            'limit': 1,
            'status[]': 'scaned,unpay',
            'order': 'DESC',
            'ctime_from': Math.floor(Date.now() / 1000 - hour * 60 * 60),
            'ctime_to': Math.floor(Date.now() / 1000)
          });
        case 3:
          res = _context.sent;
          return _context.abrupt("return", res.data);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", {
            data: {}
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return function fetchPay(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * VAS于axios已配置双域名, 但是测试环境没有对应的wps.cn域名，所以在测试环境wps.cn域名下要测试VAS接口，只能写死为kdocs
 * const VAS = 'https://vas-api.kdocs.cn'
 */

var Vas = createInstance({
  baseURL: VAS,
  withCredentials: true,
  timeout: 5000
});
var setHtmlToFp = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fileType, params) {
    var _yield$Vas$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Vas.post("/html2fp/links/".concat(fileType), params);
        case 2:
          _yield$Vas$post = _context.sent;
          data = _yield$Vas$post.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function setHtmlToFp(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var postConvertCreate = function postConvertCreate(_ref2) {
  var url = _ref2.url,
    from = _ref2.from,
    extractURL = _ref2.extractURL,
    parentID = _ref2.parentID,
    groupID = _ref2.groupID,
    convertType = _ref2.convertType;
  return Vas.post("/html2fp/convert/create", {
    url: url,
    from: from,
    extractURL: extractURL,
    convertType: convertType,
    parentID: parentID,
    groupID: groupID
  });
};
var getConvertQuery = function getConvertQuery(_ref3) {
  var jobID = _ref3.jobID,
    from = _ref3.from;
  return Vas.get("/html2fp/convert/query?jobID=".concat(jobID, "&from=").concat(from));
};
var getSpaceFullConfig = function getSpaceFullConfig() {
  return Vas.get("/plugins-config/pay-breaking");
};
var getPayCounterConfig = function getPayCounterConfig() {
  return Vas.get("/plugins-config/pay-counter");
};

var request$6 = createInstance({
  baseURL: GEOACCOUNT,
  withCredentials: true,
  timeout: 30000
});
var getIpPlace = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$6.get('/myip');
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data.data;
          return _context.abrupt("return", data.province || data.country);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getIpPlace() {
    return _ref.apply(this, arguments);
  };
}();

var request$5 = createInstance({
  baseURL: getOrigin('vas2t'),
  withCredentials: true,
  timeout: 5000
});

// 获取团队额外信息
var getGroupExtraInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(originUserid, groupIds) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$5.post("team-migrate/api/v1/team/group_extra_info", {
            group_ids: groupIds,
            origin_userid: originUserid
          });
        case 2:
          _yield$request$post = _context.sent;
          data = _yield$request$post.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getGroupExtraInfo(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// 个人身份下预创建任务
var postPreCreateTask = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$5.post("team-migrate/api/v1/task/pre_create_task_v2", params);
        case 2:
          _yield$request$post2 = _context2.sent;
          data = _yield$request$post2.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function postPreCreateTask(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

// 创建批量导入任务
var createMigrateTask = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$5.post("team-migrate/api/v1/task/create_migrate_task", params);
        case 2:
          _yield$request$post3 = _context3.sent;
          data = _yield$request$post3.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function createMigrateTask(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

// 获取批量导入任务结果
var getMigrateTaskResult = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$5.get("team-migrate/api/v1/task/migrate_task_result", {
            params: params
          });
        case 2:
          _yield$request$get = _context4.sent;
          data = _yield$request$get.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getMigrateTaskResult(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

// 获取升级任务结果
var getUpgradeTaskResult = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(groupId) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$5.get("team-migrate/api/v1/task/upgrade_task_result", {
            params: {
              group_id: groupId
            }
          });
        case 2:
          _yield$request$get2 = _context5.sent;
          data = _yield$request$get2.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getUpgradeTaskResult(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

// 个人身份下检查是否能领取奖励
var postCheckReward = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var _yield$request$post4, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request$5.post("team-migrate/api/v1/reward/check_reward", params);
        case 2:
          _yield$request$post4 = _context6.sent;
          data = _yield$request$post4.data;
          return _context6.abrupt("return", data);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function postCheckReward(_x7) {
    return _ref6.apply(this, arguments);
  };
}();

// 个人身份下领取奖励
var postReceiveReward = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
    var _yield$request$post5, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return request$5.post("team-migrate/api/v1/reward/receive_reward", params);
        case 2:
          _yield$request$post5 = _context7.sent;
          data = _yield$request$post5.data;
          return _context7.abrupt("return", data);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function postReceiveReward(_x8) {
    return _ref7.apply(this, arguments);
  };
}();

// 获取个人团队/共享文件夹迁移目标信息
var getGroupMigratedRecord = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(groupId) {
    var _yield$request$get3, data;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return request$5.get("team-migrate/api/v1/task/upgrade_record", {
            params: {
              group_id: groupId
            }
          });
        case 2:
          _yield$request$get3 = _context8.sent;
          data = _yield$request$get3.data;
          return _context8.abrupt("return", data);
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function getGroupMigratedRecord(_x9) {
    return _ref8.apply(this, arguments);
  };
}();
var postGroupMigratedRecord = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(groupId) {
    var action,
      _yield$request$post6,
      data,
      _args9 = arguments;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          action = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : 'top';
          _context9.next = 3;
          return request$5.post("team-migrate/api/v1/task/upgrade_record_hide", {
            group_id: groupId,
            show: action
          });
        case 3:
          _yield$request$post6 = _context9.sent;
          data = _yield$request$post6.data;
          return _context9.abrupt("return", data);
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function postGroupMigratedRecord(_x10) {
    return _ref9.apply(this, arguments);
  };
}();

// 查询企业空间大小
var getCheckCompanySpace = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(userId, companyId) {
    var _yield$request$get4, data;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return request$5.get("team-migrate/api/v1/reward/check_company_space", {
            params: {
              dist_user_id: userId,
              dist_company_id: companyId
            }
          });
        case 2:
          _yield$request$get4 = _context10.sent;
          data = _yield$request$get4.data;
          return _context10.abrupt("return", data);
        case 5:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function getCheckCompanySpace(_x11, _x12) {
    return _ref10.apply(this, arguments);
  };
}();

var request$4 = createInstance({
  baseURL: WPSPLUS,
  withCredentials: true,
  timeout: 5000
});
var getCompanyGroupInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(inviteCode) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$4.get("3rd/drive/api/v3/mine/team/link/".concat(inviteCode), {
            params: {
              with_corp_name: true
            }
          });
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCompanyGroupInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();

var request$3 = createInstance({
  baseURL: DOCS,
  withCredentials: true,
  timeout: 30000
});

// 接口文档：https://www.kdocs.cn/l/cb76KmSmmgdP

// 生成or重置转让key expire接口默认24小时
function createTransferKey(_x) {
  return _createTransferKey.apply(this, arguments);
}

// 获取转让信息
function _createTransferKey() {
  _createTransferKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fildId) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$3.post("/kfc/shortlink/v1/transferfile/".concat(fildId));
        case 2:
          _yield$request$post = _context.sent;
          data = _yield$request$post.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createTransferKey.apply(this, arguments);
}
function getTransferInfo(_x2) {
  return _getTransferInfo.apply(this, arguments);
}

// 转让文档封装接口
function _getTransferInfo() {
  _getTransferInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fildId) {
    var transferId,
      _yield$request$get,
      data,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          transferId = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
          _context2.next = 3;
          return request$3.get("/kfc/shortlink/v1/transferfile/".concat(fildId, "/").concat(transferId));
        case 3:
          _yield$request$get = _context2.sent;
          data = _yield$request$get.data;
          return _context2.abrupt("return", data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getTransferInfo.apply(this, arguments);
}
function transferFile(_x3, _x4) {
  return _transferFile.apply(this, arguments);
}
// 接收转让文件
function _transferFile() {
  _transferFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fildId, userId) {
    var _yield$request$post2, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$3.post('/kfc/shortlink/v1/transferfile/owner', {
            user_id: userId,
            file_id: fildId
          });
        case 2:
          _yield$request$post2 = _context3.sent;
          data = _yield$request$post2.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _transferFile.apply(this, arguments);
}
function receiveTransferFile(_x5, _x6) {
  return _receiveTransferFile.apply(this, arguments);
}
// 接收转让文件
function _receiveTransferFile() {
  _receiveTransferFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(fildId, transfeId) {
    var _yield$request$post3, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$3.post('/kfc/shortlink/v1/transferfile/receiver', {
            transfer_id: transfeId,
            file_id: fildId
          });
        case 2:
          _yield$request$post3 = _context4.sent;
          data = _yield$request$post3.data;
          return _context4.abrupt("return", data);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _receiveTransferFile.apply(this, arguments);
}
function deleteReceiver(_x7, _x8) {
  return _deleteReceiver.apply(this, arguments);
}
function _deleteReceiver() {
  _deleteReceiver = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(fildId, userid) {
    var _yield$request$delete, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return request$3["delete"]("/kfc/shortlink/v1/transferfile/receiver/".concat(fildId, "/").concat(userid), {});
        case 2:
          _yield$request$delete = _context5.sent;
          data = _yield$request$delete.data;
          return _context5.abrupt("return", data);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _deleteReceiver.apply(this, arguments);
}

var _excluded = ["user_id", "avatar_url", "nickname", "permission", "hover", "last_view_time", "block_time"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var request$2 = createInstance({
  baseURL: KDOCS,
  withCredentials: true
});

/**
 * 获取管理协作者开关
 * @returns {boolean}开关的值
 */

var getCollaboratorsV2Show = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return request$2.get('/kdg/api/v1/configure?idList=isCollaboratorsV2Show');
        case 3:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          if (!(data && data.data.isCollaboratorsV2Show === '1')) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", true);
        case 9:
          return _context.abrupt("return", false);
        case 10:
          _context.next = 15;
          break;
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", false);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return function getCollaboratorsV2Show() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 获取协作者列表
 * @param {string} fileId - 文件 ID
 * @returns {Promise<any>} 管理员列表的 Promise 对象
 */
var getCollaborators = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, _ref2) {
    var fileId, _ref2$offset, offset, _ref2$limit, limit, key, _ref2$filter, filter, operator, lastViewTime;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fileId = _ref2.fileId, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? 0 : _ref2$offset, _ref2$limit = _ref2.limit, limit = _ref2$limit === void 0 ? 100 : _ref2$limit, key = _ref2.key, _ref2$filter = _ref2.filter, filter = _ref2$filter === void 0 ? [] : _ref2$filter, operator = _ref2.operator, lastViewTime = _ref2.lastViewTime;
          _context2.next = 3;
          return request$2.post("/api/kdocs/file/".concat(fileId, "/collaborators/").concat(type), {
            offset: offset,
            limit: limit,
            key: key,
            operator: operator,
            last_view_time: lastViewTime,
            permissions: filter
          });
        case 3:
          return _context2.abrupt("return", _context2.sent);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getCollaborators(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var translateServiceGroupTypeToBase = function translateServiceGroupTypeToBase(_ref4) {
  var offset = _ref4.next_offset,
    hasNext = _ref4.has_next,
    lastViewTime = _ref4.next_last_view_time;
  return {
    offset: offset,
    hasNext: hasNext,
    lastViewTime: lastViewTime
  };
};

/**
 * 获取列表总数量
 * @param {string} fileId -文件 ID
 * @returns {Promise<any>} 管理员列表的count数据
 */

var getCollaboratorsCount = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fileId) {
    var _yield$request$post, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request$2.post("/api/kdocs/file/".concat(fileId, "/collaborators/count"));
        case 2:
          _yield$request$post = _context3.sent;
          data = _yield$request$post.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getCollaboratorsCount(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * 清除授权记录
 * @param {string} fileId - 文件 ID
 * @returns {Promise<any>}
 */
var removeBlockHistory = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(fileId, removeAll, userIds) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return request$2["delete"]("/api/kdocs/file/".concat(fileId, "/collaborators/remove_block"), {
            data: {
              romove_all: removeAll,
              block_user_ids: userIds
            }
          });
        case 2:
          return _context4.abrupt("return", _context4.sent);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function removeBlockHistory(_x4, _x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();
var translateServiceCollaboratorTypeToBase = function translateServiceCollaboratorTypeToBase(_ref7) {
  var id = _ref7.user_id,
    avatar = _ref7.avatar_url,
    nickname = _ref7.nickname,
    permission = _ref7.permission,
    hover = _ref7.hover,
    lastViewTime = _ref7.last_view_time,
    blockTime = _ref7.block_time,
    rest = _objectWithoutProperties(_ref7, _excluded);
  return _objectSpread$1({
    id: id,
    avatar: avatar,
    nickname: nickname,
    permission: permission,
    hover: hover,
    // 这里服务端单位是毫秒，而前端时间格式化函数单位是秒，因此 / 1000
    lastViewTime: (lastViewTime !== null && lastViewTime !== void 0 ? lastViewTime : 0) / 1000,
    blockTime: (blockTime !== null && blockTime !== void 0 ? blockTime : 0) / 1000
  }, rest);
};

var request$1 = createInstance({
  baseURL: APIWPS,
  withCredentials: true
});

/**
 * 批量授权
 * @param {string} driveId - 文件 ID
 * @param {string} fileId - 文件 ID
 * @returns {Promise<any>} 管理员列表的 Promise 对象
 */
var setV7UsersPerm = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(driveId, fileId, overwrite, permissions, roleId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request$1.post("/v7/drives/".concat(driveId, "/files/").concat(fileId, "/permissions/batch_create"), {
            overwrite: overwrite,
            permissions: permissions,
            role_id: roleId
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function setV7UsersPerm(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 获取roleId
 * @param {string} driveId -约等于 groupId
 * @returns {Promise<any>} role ID
 */

var getV7RoleId = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(driveId) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request$1.get("/v7/drives/".concat(driveId, "/roles"));
        case 2:
          _yield$request$get = _context2.sent;
          data = _yield$request$get.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getV7RoleId(_x6) {
    return _ref2.apply(this, arguments);
  };
}();

var getAIHelpRecommend = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _data$data, axios$1, _yield$axios$post, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          // eslint-disable-next-line
          axios$1 = axios.create({
            baseURL: 'https://www.kdocs.cn'
          });
          axios$1.interceptors.response.use(function (response) {
            return response;
          }, function (error) {
            return error.response;
          });
          _context.next = 5;
          return axios$1.post('/office/v5/copilot/aihelper/recommend', params);
        case 5:
          _yield$axios$post = _context.sent;
          data = _yield$axios$post.data;
          if (!(data && data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.knowledges)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", data.data.knowledges);
        case 9:
          return _context.abrupt("return", []);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", []);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return function getAIHelpRecommend(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * x-verification token 存储方案
 * 统一存储到 X_VERIFICATION_TOKEN_STORAGE_KEY 下，保存值为一个对象
 * 该对象为请求的标识与 token 的键值对，如何计算请求标识？
 * 请求路径（不包括 url query）与方法组成
 * 如果请求路径与方法均相同，则认为是同一个请求
 */

function combineURL() {
  var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var relativeURL = arguments.length > 1 ? arguments[1] : undefined;
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
var KEY = {
  X_VERIFICATION_TOKEN: 'X_VERIFICATION_TOKEN'
};
/**
 * @param {{ url: string, baseURL: string, method: string}} config
 */
function getRequestId(config) {
  var _config$method = config.method,
    method = _config$method === void 0 ? '' : _config$method,
    baseURL = config.baseURL,
    url = config.url;
  // 目前使用的 axios 版本没有 getUri 方法
  var entireURL = isAbsoluteURL(url) ? url : combineURL(baseURL, url);
  var index = entireURL.indexOf('?');
  var filteredURL = index === -1 ? entireURL : entireURL.substring(0, index);
  return "".concat(method.toUpperCase(), ":").concat(filteredURL);
}

/**
 * @param {{ url: string, baseURL: string, method: string}} config
 * @returns {string | undefined}
 */
function getXVerificationToken(config) {
  var allTokens = JSON.parse(localStorage.getItem(KEY.X_VERIFICATION_TOKEN) || '{}');
  var requestId = getRequestId(config);
  return allTokens[requestId];
}

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var xVerificationHeaderName = 'X-Verifications';
var request = createInstance({
  baseURL: PLUS,
  withCredentials: true,
  timeout: 5000
});
var xVerificationRequest = createInstance({
  baseURL: PLUS,
  withCredentials: true,
  timeout: 5000
});
xVerificationRequest.interceptors.request.use(function (config) {
  var _ref = config.xVerifications || {},
    isXVerificationsEnabled = _ref.enabled;
  if (isXVerificationsEnabled && !config.headers[xVerificationHeaderName]) {
    var token = getXVerificationToken(config);
    var headerValue = "Check-Code ".concat(btoa("".concat(token, ":")));
    config.headers[xVerificationHeaderName] = headerValue;
  }
  return config;
});
// 查询企业安全功能开启状态
var getCompanySecureStatus = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(companyId) {
    var _yield$request$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request.get("/ord/api/v1/companies/".concat(companyId, "/secure/statues"));
        case 2:
          _yield$request$get = _context.sent;
          data = _yield$request$get.data;
          return _context.abrupt("return", data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCompanySecureStatus(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// 一键开启企业安全功能
var putCompanySecureStatus = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(companyId, settingParams) {
    var _yield$xVerificationR, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return xVerificationRequest.put("/ord/api/v1/companies/".concat(companyId, "/secure/statues"), _objectSpread({}, settingParams), {
            xVerifications: {
              enabled: true
            }
          });
        case 2:
          _yield$xVerificationR = _context2.sent;
          data = _yield$xVerificationR.data;
          return _context2.abrupt("return", data);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function putCompanySecureStatus(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

// 查询企业安全功能开启后的奖励状态
var getAwardStatus = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(companyId) {
    var _yield$request$get2, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return request.get("/ord/api/v1/companies/".concat(companyId, "/secure/award/status"));
        case 2:
          _yield$request$get2 = _context3.sent;
          data = _yield$request$get2.data;
          return _context3.abrupt("return", data);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getAwardStatus(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

export { AiReport, _getOnlineParams, activeArticleReport, addContactToCoop, addFavorFile, addFilePermission, addLinkMember, addMemberToCoop, addMembersToGroup, addMembersToTeam, addNotContactToCoop, addPendingTag, addQuickTag, addRecentContacts, addTag, addV2RecentContacts, addV2RecentGroups, annexReport, appChangeLoginAccount, applicateGrowthPlan, applications, applyCatalogApprover, applyCatalogPermission, applyTemplate, applyVipAllocationUsers, asyncExport, authCheck, authCheckNoK3rd, authConfirms, batchCloseBatch, batchFilesDownload, batchProgress, batchProgressV2, batchRemoveCollaborators, batchUpdateFolderLinks, batchUpdateLabels, batchUpdateLinks, cancelExportTask, cancelFolderShareV2, cancelGroupKmPublish, cancelShareV2, changeChkCode, changeFileShare, changeLinkDept, changeTemplateSort, changeWarkmarkStatus, checkAwards, checkBatchPrivilege, checkCanReceiveAwards, checkCompanyName, checkDocHasAttachment, checkFileTag, checkFolderWritePermission, checkGqlPrivilege, checkGqlPrivileges, checkInviteJoinVisible, checkIsSubscribed, checkMission, checkOrderFree, checkSMSCode, checkShareExist, checkTemplateShareExist, checkThirdPartCookies, checkUserPermission, checkteamCreator, checkupdatePublishFile, checkupdateTemplateShare, closeAdvertisementCard, closeShareRequest, closeTeamApps, closeTeamMultiEditTag, commonRequest, complateMission, confirmRevokeQueue, cooperVerify, copyFile, copyFileWithQuery, createAccessInfo, createAdminInvitations, createChannel, createCloseCard, createCopyFilesAndShare, createCustomizeGroup, createDocTag, createEditLink, createExportTask, createFileCollectTask, createFolder, createGuideTeam, createLabels, createLink, createMigrateTask, createNewEmpty, createObjTag, createOrOpenFolderLink, createOrderApplyment, createPersonalFileLink, createPublishShare, createSemRegisterCompany, createTag, createTeam, createTemplate, createTemplateShare, createTemplateV2, createTransferKey, createUserRedirect, createUsersRedirect, delFloderMember, delGroupApply, delInviteLinkMember, delLinkDept, delLinkMember, delPublishShare, deleteCollaborators, deleteCurDocTag, deleteCustomizeGroup, deleteCustomizePermission, deleteEntMember, deleteExternal, deleteExternalV2, deleteFavor, deleteFilePermission, deleteFilePermissionBatch, deleteFolderLink, deleteGroupMembers, deleteLink, deleteLinkByBatch, deleteMemberRelation, deleteObjTag, deletePendingTag, deleteQuickTag, deleteReceiver, deleteTagById, deleteTemplate, deleteTemplateShare, downloadFileToXlsx, downloadFileWithFidGid, downloadFileWithOtl, editTemplate, enhanceError, exportFileInfo, exportKsheetBySid, extractArchiveFile, fetchActivityReceive, fetchAppealFile, fetchApplyList, fetchApproveFileInfo, fetchBackupsSettingList, fetchCollaboratorsAndCount, fetchCompanyConfig, fetchCompanyDetail, fetchCompanyDetailAll, fetchCompanyGroups, fetchCompanyIndustry, fetchCompanyInviteLink, fetchCompanyLogo, fetchCompanyPageHome, fetchCompanyPayConfig, fetchCompanyPrivilege, fetchCompanyShareMarkSwitch, fetchCompanyUserInfo, fetchContactList, fetchContacts, fetchConvertPageDirInfo, fetchCorpShareRanges, fetchCorpTmp, fetchCurDeptMembers, fetchCurDeptMembersByPermission, fetchCurDeptMembersOrder, fetchCurlevelDepts, fetchDefaultBackup, fetchDepartmentInfo, fetchDeptLink, fetchDevicesPath, fetchEditorShowTang, fetchEncsGroupLink, fetchFavors, fetchFile, fetchFileHistory, fetchFileLabels, fetchFileMetadata, fetchFileMetadataWithFolderLink, fetchFilePath, fetchFilePerSetting, fetchFilePermMembers, fetchFileShareInfo, fetchFileShareInfoV5, fetchFilesByUrl, fetchFolderLinkTreeFileDownloadInfo, fetchGroupFileDownloadInfo, fetchGroupFileList, fetchGroupFiles, fetchGroupMemberIds, fetchGroupSpaces, fetchGroups, fetchGroupsInfo, fetchGroupsInfoV5, fetchGrowthPlan, fetchInviteContactLink, fetchJoinedCompanies, fetchKdMyTeams, fetchLabels, fetchLinkFolder, fetchLinkfolders, fetchMemberInfo, fetchMembers, fetchMetadataAndLink, fetchMyCloud, fetchMyTeams, fetchMyUpload, fetchOutOfGroupsInfo, fetchOwnercandidates, fetchPay, fetchPayConfig, fetchPermissonStatus, fetchProgress, fetchRecentContacts, fetchRoaming, fetchRoamingInfo, fetchSearchShareColls, fetchSecretFolder, fetchSecureFile, fetchSettingCounts, fetchShare, fetchShareFolsderInviteInfo, fetchShareFolsderSetting, fetchShareInfo, fetchShareRanges, fetchShareRangesTaskinfo, fetchSubFilePermission, fetchSuperadmin, fetchTeamInfo, fetchTeamMembers, fetchTeamMembersByRoles, fetchTemplates, fetchUploadFileUrl, fetchUserAvatars, fetchUserBind, fetchUserBindStatus, fetchUserCertAndInfo, fetchUserCertification, fetchUserInfo, fetchUserName, fetchUserPermission, fetchUserScore, fetchUserSetting, fetchV2RecentContacts, fileReport, fileReportNew, fileTagSwitch, gainGuidePolicy, getAIHelpRecommend, getAccountListWithSpread, getActivitiesList, getActivitiesReceive, getAdvertisementCard, getAiProtocolAuth, getAiProtocolInfo, getAppealStatus, getApplymentStatus, getArchiveFileData, getAslSwitch, getAutoLoginUrl, getAwardStatus, getAwards, getBlockEditApplyStatus, getCLinkDownloadFile, getCardInfo, getCategories, getChannelDataById, getCheckCompanySpace, getCollaborators, getCollaboratorsCount, getCollaboratorsV2Show, getCompEffectiveServices, getCompPaidText, getCompPkgSpec, getCompUnuseduser, getCompanyBindInfo, getCompanyGroupInfo, getCompanyHelpContent, getCompanyHelpSubscribe, getCompanyInviteLink, getCompanyMemberDetail, getCompanyMigrationStatus, getCompanyName, getCompanyNumLimit, getCompanyPackageDetail, getCompanyPaidType, getCompanyPrivate, getCompanyPrivileges, getCompanyRevokeSetting, getCompanySSOType, getCompanySecureStatus, getCompanySettingsInfo, getCompanySharePrivilege, getCompanyShareRange, getCompanyUserInfo, getCompanyUtmInfo, getConfigure, getContactGroupInfo, getContactGroupMembers, getContactGroups, getContactGroupsMembersByIds, getContactGroupsWithAvatars, getContactMyGroups, getContactMyTeams, getConvertQuery, getCoopMember, getCoopNumber, getCoopNumberWithoutTeamMember, getCooperUserInfo, getCooperation, getCorpGroups, getCreateCompanyCondition, getCreatorManageStatus, getCurCompany, getCurDocTags, getCustomDomainConfig, getDepId, getDocTags, getDownload, getDownloadPanelLabel, getEnShareWikiSwitchStatus, getEncrypterId, getEntApproveStatus, getEntCompoundPermissionList, getEntUserEmailServiceInfo, getExternalCooperates, getExternalList, getFLDownloadFile, getFavorDestination, getFavors, getFileCollectTask, getFileCollectTaskByFileId, getFileCreator, getFileFillCount, getFileFullPath, getFileInfo, getFileInfoAll, getFileInfoV5ToV3, getFilePath, getFilePermissionList, getFileRecentMembers, getFileSwitchStatus, getFolderLink, getGrades, getGroupAIStatus, getGroupApplyDetail, getGroupApplyList, getGroupApprovedBy, getGroupCount, getGroupExtraInfo, getGroupKmPulishInfo, getGroupKmSpaceImgList, getGroupKmUploadService, getGroupMigratedRecord, getGroupPermList, getGroupShareRange, getGroupTemplateInfo, getGroupsBannerStatus, getGroupsWikiInfos, getGrowthActivitiesList, getInboxConfig, getInboxList, getInboxListById, getInboxMsgById, getInboxUnCount, getIndexGroupIdApi, getInvitationLinkService, getInviteLinkMember, getInviteMembers, getIpPlace, getJinxiaomenghello, getJxmOneDayTimes, getJxmOperateCard, getJxmPanelOperate, getKdMyTeamsDetail, getKeyWordsList, getKoaRecentContacts, getLatestAgreement, getLinkDownloadFile, getLinkInfoFromSid, getLinkRenamePerm, getMessage, getMessageLoginUrl, getMigrateTaskResult, getMineShareFolders, getMyTeamsDetail, getNewFileConfig, getNewcomerTask, getNonEntMemberFilePermissionName, getNpsConfig, getOjbsByTagId, getOnelineFileDownload, getOnlineParameterByKeys, getOnsalePackages, getPartnerInformationApi, getPayCounterConfig, getPayText, getPerShareInfoList, getPermissionRoleList, getPlusadminPermission, getPolicy, getPolicyV3, getPositionList, getPositionMembers, getPrivateDownloadFile, getPrivilegeInfo, getQuickTag, getQuitCompanyCheck, getRecentSchedule, getRelatedUsers, getRwMembers, getSearchGroup, getSecretFolderLockStatus, getSecureStatus, getSecureTeam, getSelfWorkSpace, getShareInfo, getSharedTeamCounts, getShowAuthenticationStatus, getSpaceFull, getSpaceFullConfig, getSpreadControl, getSwitch, getSwitchEnv, getSysRoles, getTagList, getTagListByPage, getTagMembers, getTagsForObj, getTaskResult, getTcConfig, getTeamAppsList, getTeamConfig, getTeamLinkPolicy, getTeamMultiEditTagInfo, getTeamPermissionList, getTeamRwMembers, getTeamSpaceInfo, getTeamTopAreaNotice, getTeamWikiPublishPolicyConfig, getTemplateInfo, getTemplateScope, getTemplateScopeAll, getTemplates, getThumbnail, getToConfirmCollaboration, getTransferInfo, getUnReadMessage, getUpgradeTaskResult, getUpgradeablePkg, getUploadAccess, getUserAcceptedAgreement, getUserCompanyLoginSetting, getUserConfig, getUserSetKey, getUserSetting, getV7RoleId, getVideoDetail, getVideoPosition, getVipAllocationUsers, getWaterMarkInfo, getWaterMarkUpgradablePkg, getWatermarkInfo, getWatermarkStatus, getWatermarkUsedTeams, getWenjuan, getWxGroupList, getWxWorkShareConfig, getYunSpaceSize, getfileViewInfo, handleQuitCompany, hasTag, httpRequest, httpRequestQing, importToCorp, importToPersonalTeam, inviteToCompanyGroup, isHavePendingTag, isMyTeam, isSquareFile, isUserPendingTag, islogin, jinxiaomengPicConfig, linkFolderSaveAs, linkFolderSaveAsDevice, loadFilePathNoUpdate, loadFilePathToUpdate, logout, markHistories, moveFile, moveFileWithQuery, newShareReport, onCloseEditLink, onCloseFolderLink, onCloseLink, onCloseLinkByBatch, openApps, openFolderShareV2, openSelfBuiltApps, openShareRequest, openShareV2, openTeamApps, openTeamMultiEditTag, popUpDialogTag, postActivitytyEvents, postAppealContent, postAppealFile, postCheckReward, postCollections, postConvertCreate, postEvents, postFavor, postFileFrontAction, postFilesUploadCreate, postGroupMigratedRecord, postPreCreateTask, postReceiveReward, postTemplate, postTemplateShown, postTemplateV2, processMemberApply, publishfileReport, pushNotificationPC, putBatchRangePerm, putCompanySecureStatus, putCreatorManageStatus, putFileUploadCreateUpdate, queryAccessInfo, queryBffShareRangeAndCompoundPerm, queryCreateCurrentVersonLabelPermission, queryCreateHistoryLabelPermission, queryCurFileRangePerm, queryExportTask, queryFileDefaultPermission, queryFilePermission, queryFilePermissionCount, queryJoinFromLink, queryManageGroupLabelPermission, queryOutPermission, queryShareBaseInfo, querySubFilePermission, querySubFilePermission2, queryUserCoopPerms, queryUserFilePermission, reOpenEditLink, readCompanyHelp, receiveGrowthActivity, receiveMission, receiveMissionFinal, receiveTransferFile, registerCompany, relatedUsers, removeBlockHistory, removeCollaborators, removeTeamMembers, renameCustomizeGroup, renameTeam, renameTeamApps, renameTemplate, reportAgreeLicense, reportComment, reportNps, requestShareOutsideSubmit, resetFileDefaultPermission, revertGroupApply, reviewTitle, saveAsFile, saveAsFileWithQuery, searchCompanyMembers, searchContacts, searchContactsByPhone, searchEntMemberSubject, searchExternalList, searchFilePermMembers, searchFinderFile, searchFinderGroup, searchShareLinkCollaborator, searchShareLinkCollaboratorByPasted, searchTeamMembers, secureClose, sendAdminInvitations, sendApplyNotice, sendApproveEvent, sendCollaborationAdminInvitations, sendCompUnuseduser, sendCompnayInvite, sendFileToUser, sendFileToUserV2, sendPhoneVerify, sendSMSCode, sendSms, sendUserInvitations, serverDw, setAiProtocolAuth, setAllFilesPermsToAdmin, setBackup, setBlockEditApplyStatus, setChannelData, setCollaboratorsPermission, setCompanyHelpSubscribe, setCompanyShareSwitch, setDeviceFileCommitInfo, setEnShareWikiSwitchStatus, setFileShare, setFileSwitchStatus, setFileTag, setGroupsBannerStatus, setHistoriesTag, setHtmlToFp, setJinxiaomenghello, setLinkRenamePerm, setMessagesRead, setNonEntMemberPermission, setOnelineFileDownload, setRendMessage, setSecureTeam, setShareFolder, setShareFolsderSetting, setShareRanges, setShowAuthenticationStatus, setSpaceFullReddot, setTeamTemplate, setUploadFileCommitInfo, setUploadFileCommitInfoDocs, setUserAgreement, setUserConfig, setUserSetKey, setV7UsersPerm, setWaterMarkInfo, setWenjuan, setWorkSpace, shareFileDownload, submitGroupsApply, submitNpsResult, toggleGroupAIStatus, transferEntTeam, transferFile, transferFileOwner, transferShareFolder, transferTeam, translateServiceCollaboratorTypeToBase, translateServiceGroupTypeToBase, unLockSecretFolder, updataFileRangePermission, updateCollaboratorsPermission, updateCompanyConfig, updateCompanyData, updateCurDocTag, updateEntMemberInfo, updateFileLinkByBatch, updateFilePerSetting, updateFilePermission, updateFilePermissionBatch, updateFilePermisson, updateFloderPermisson, updateFloderPermissonBatch, updateFolderLink, updateFolderLinkByBatch, updateGroupKmPulishInfo, updateGroupTemplate, updateInboxBatchMark, updateInboxMark, updateLink, updateLinkDept, updateLinkMember, updateLinkV5, updateMemberInfo, updateObjTag, updatePermission, updatePublishShare, updateSetting, updateShareFolderValidDate, updateSharePerm, updateShareValidDate, updateSwitch, updateTagById, updateTeamTopAreaNotice, updateTemplate, updateTemplateShare, upgradeGroupToTeamspace, uploadFileToThirdParty, uploadFileToThirdPartyNew, userMyTeamConf, verifySms, verifyWoaUser, webChangeLoginAccount };
